import React, { useState, useEffect } from "react";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import axios from "axios";
import {
  Button,
  Col,
  FormLabel,
  Row,
  Table,
  FormControl,
} from "react-bootstrap";
import "reactjs-popup/dist/index.css";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import {
  DEFAULT_CUSTOMER_DELIVERY_CODE,
  DEMO_VALUE,
  NEW_ENTRY,
  DOCUMENT_CHANGED,
} from "../ds/App_Constants";
import { BaseBean, NodeData, RestReportBean } from "../ds/client_ds.js";
import CustomTable from "../gui_components/CustomTable.js";
import {
  AddressBean,
  BaseCustomerPaymentAgingHistoryBean,
  CustomerBean,
  CustomerSearchCriteria,
  FabricStyleBean,
  FabricStyleColorPriceInfo,
  FabricStyleImageBean,
  FabricStylePurchaseCostInputCriteriaBean,
  FabricStyleSalePriceInputCriteriaBean,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  MailInfoBean,
  PageListBean,
  PickTicketBean,
  PurchaseOrderSearchCriteria,
  ReasonBean,
  RestAddressBean,
  RestCustomerListRequest,
  RestEntityUnLockRequest,
  RestFabricStyleListBeanRequest,
  RestFabricStyleListRequest,
  RestGetFabricPriceAndCostRequest,
  RestPackingListMailRequest,
  RestPickTicket_v1Request,
  RestPurchaseorderForSalesOrderRequest,
  RestReadRequest,
  RestSalesOrderLineCancelRequest,
  RestSalesOrderListRequest,
  RestSalesOrderRequest,
  RestVendorListRequest,
  SalesOrderBean,
  SalesOrderCommissionBean,
  SalesOrderImageBean,
  SalesOrderLineAdjustmentBean,
  SalesOrderLineBean,
  SalesOrderLineSearchCriteria,
  SalesOrderModuleDependenciesBean,
  SalesOrderSearchCriteria,
  SkuBatchInventoryDataBean,
  SKUBatchInventorySearchCriteria,
  VendorSearchCriteria,
  SalesOrderDocumentBean,
  CustomerInvoiceInquiryCriteriaBean,
  CustomerShipToSearchCriteria,
  RestCustomerShipToListRequest,
  SalesOrderSampleRollLineBean,
  SalesOrderSampleInputBean,
  RestFabricStyleATSListRequest,
  AllFabricATSInquiryCriteriaBean,
  RestPageListBean,
  FabricStyleInventoryForLotBasedSearchCriteria,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import {
  AddIcon,
  CameraIcon,
  DeleteIcon,
  UploadDocIcon,
} from "../gui_components/Icons.js";
import {
  AddressComponent,
  AlertToolBox,
  BootstrapDataGrid,
  BootstrapDataGridColumnDefinition,
  CollapseComponent,
  DataGrid,
  DataGridColumnDefinition,
  DatePickerComponent,
  DatePickerComponent_adv,
  EditableDataGrid,
  InputCheckbox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ReasonCaptureComponent,
  ShortCutMenuPopup,
  ShowError,
  TimePickerComponent,
  ColumnDefinition,
  MailComponent,
  ShortCutMenuPopupV1,
  MessageBoxComponent,
} from "../gui_components/UIComponents.js";
import {
  downloadReportAsFile,
  downloadWithForcedName,
  isEmpty,
  isEmptyArray,
  isEmptyString,
  previewWithBlob,
  previewWithNamedBlob,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
  toFormattedDate_v1,
} from "../gui_components/Util.js";
import noImage from "../images/clicktoAdd.png";
import {
  PopupAtsInq,
  PopupCustomerCurrentAgingInq,
  PopupCustomerMostRecentFabricsInq,
  PopupCustomerSalesHistoryInq,
  PopupCustomerStatisticsInq,
  PopupCustomerTransactionsInq,
  PopupFabricInventoryPositionInq,
  PopupFabricPurchaseHistoryInq,
  PopupItemCurrentInventoryInq,
  PopupPurchaseAndSlesDetailsInq,
  PopupSalesPriceInq,
} from "../Inquiry/InquiryUtil.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { ShipToLookupHandler } from "../lookup/ShipToLookupHandler.js";
import { SalesOrderLookupHandler } from "../lookup/SalesOrderLookupHandler.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler";
import {
  PopupARModule,
  PopupCreditMemoModule,
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupInvoiceModule,
  PopupPickTicketModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { PickTicketService } from "../services/PickTicketService.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { ReportService } from "../services/ReportService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import { VendorService } from "../services/VendorService.js";
import { SalesOrderModuleToolBar } from "../toolBar/SalesOrderModuleToolBar.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import {
  LayoutList,
  DollarSign,
  FileText,
  Home,
  Globe,
  Image,
  Copy,
  ShoppingCart,
  Ticket,
  History,
  AlignStartVertical,
  FolderOpen,
  ImageIcon,
} from "lucide-react";
class SalesOrderList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.entryFormRef = React.createRef();
    this.soLineDetailDialogRef = React.createRef();
    this.fabricStyleCodeRef = React.createRef();
    this.fabricStyleColorCodeRef = React.createRef();
    this.lineOrderQuantityRef = React.createRef();
    this.cancelReasonDialogRef = React.createRef();
    this.unapproveReasonDialogRef = React.createRef();
    this.onHandQuantityDetailDialogRef = React.createRef();
    this.lineCancelReasonDialogRef = React.createRef();

    this.purchaseOrderNumberCreateRef = React.createRef();
    this.pickTicketNumberCreateRef = React.createRef();
    this.newCustomerRef = React.createRef();
    this.userInput = "";
    this.soLineDetailDialogStyles = {
      width: "80%",
      height: "100%",
      marginTop: "-200px",
      marginLeft: "-40%",
      overflowX: "none",
      top: "40%",
      overflowY: "scroll",
    };
    this.soLineDetailDialogTitleStyles = {
      backgroundColor: "#1f3159",
      color: "#fff",
      fontSize: "1.2rem",
      fontWeight: "bold",
      top: "0",
      marginTop: "0",
    };
    this.soLineDetailDialogCloseButtonStyle = {
      cursor: "pointer",
      position: "absolute",
      color: "#fff",
      backgroundColor: "#1f3159",
      fontSize: "1.8rem",
      right: "10px",
      fontWeight: "bold",
      top: "0",
      marginTop: "0",
    };
    this.onHandQuantityDetailDialogStyles = {
      width: "70%",
      height: "calc(40% - 90px)",
      marginTop: "-200px",
      marginLeft: "-40%",
      overflowX: "none",
      top: "50%",
      overflowY: "scroll",
    };
    this.state = {
      customerList: [],
      pageTitle: "SalesOrderMaintenance",
      customerData: new CustomerBean(),
      pageList: new PageListBean(),
      salesOrderCriteria: new SalesOrderSearchCriteria(),
      selectedNodeKey: "headerView",
      isLoading: false,
      isEntryFormOpen: false,
      isListFormOpen: true,
      salesOrderList: [],
      moduleCaption: "SalesOrder",
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      salesOrderData: new SalesOrderBean(),
      salesOrderLineData: new SalesOrderLineBean(),
      pickTicketBean: new PickTicketBean(),
      isCustomerDataLoding: [],
      isFabricStyleDataLoding: false,
      fabricStyleList: [],
      isDisableFields: false,
      fabricStyleData: new FabricStyleBean(),
      colorList: [],
      isShowBackButton: false,
      isCollapsible_open: true,
      salesOrderTypes: [],
      paymentTerms: [],
      paymentMethods: [],
      customerRepresentatives: [],
      freightMethods: [],
      shipVias: [],
      salesClerk: [],
      errorList: [],
      cityList: [],
      stateList: [],
      countryList: [],
      salesPersonList: [],
      locations: [],
      customerDeliveries: [],
      isShipToAddressFormOpened: false,
      isCommissionFormOpened: false,
      isDocumentsFormOpened: false,
      isNotesFormOpened: false,
      isPurchaseOrdersFormOpened: false,
      isPickTicketsandInvoicesFormOpened: false,
      isChangesHistoryFormOpened: false,
      isSalesLineDetailFormOpened: false,
      isWebOrderOpen: false,
      isShowNodes: false,
      nodeList: [],
      copySONum: "",
      salesCommissionData: new SalesOrderCommissionBean(),
      reasonData: new ReasonBean(),
      cancelReasons: [],
      unapprovalReasons: [],
      dependentPurchaseOrderList: [],
      dependenciesBean: new SalesOrderModuleDependenciesBean(),
      isShowApproveButton: false,
      isShowSpecialApproveButton: false,
      isShowUnApproveButton: false,
      isShowGeneratePickTicketButton: false,
      isShowGeneratePickTicketAdvButton: false,
      isShowGeneratePOButton: false,
      isShowProformaInvButton: false,
      isShowMailButton: false,
      isShowAddIcon: true,
      inventoryData: new SkuBatchInventoryDataBean(),
      shipTos: [],
      isListView: false,
      isResetModule: false,
      salesOrderLookupHandler: null,
      isShowPickTicketModule: false,
      moduleForPopup: [],
      isShowPopup: false,
      simplePopupContent: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowPopupAlert: false,
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      isShowSaveButton: true,
      imagePart: "",
      imageData: null,
      disabled: false,
      isResetView: true,
      isFocusPO: false,
      salesLineColorCodeLookupHandler: null,
      isFocusLookup: true,
      isShowColorLookup: false,
      isShowColorTextBox: true,
      isShowPickTicketAdvPopup: false,
      selectedSOLineList: [],
      summaryData: "",
      isShowPricePopup: false,
      priceBean: new FabricStyleColorPriceInfo(),
      isShowAdjustQtyPopup: false,
      adjustLineBean: new SalesOrderLineAdjustmentBean(),
      adjustmentLines: [],
      isShowOnHandQtyPopup: false,
      isShowOnHandLotQtyPopup: false,
      isShowGeneratePOPopup: false,
      selectedLineList: [],
      criteria: new PurchaseOrderSearchCriteria(),
      mailInfoBean: new MailInfoBean(),
      isShowMailPopup: false,
      isShowMailAlert: false,
      isShowFabricStyleModule: false,
      // isShowCustomerFabricSalesPopup: false,
      // isShowFabricCurrentInvPopup: false,
      // isShowFabricInventoryPosPopup: false,
      // isShowFabricPurchaseHistoryPopup: false,
      // isShowFabricAtsPopup: false,
      // isLocked: false,
      isLockRequired: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      customerPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      shipToPageListForAutoCompleteList: new Array(),
      shipViaPageListForAutoCompleteList: new Array(),
      paymentTermPageListForAutoCompleteList: new Array(),
      orderTypePageListForAutoCompleteList: new Array(),
      cSRPageListForAutoCompleteList: new Array(),
      salesClerkPageListForAutoCompleteList: new Array(),
      showAutoCompleteList: true,
      showAutoCompleteOrderTypeList: true,
      showAutoCompletePaymentTermList: true,
      showAutoCompleteShipToList: true,
      showAutoCompleteShipViaList: true,
      showAutoCompleteCSRList: true,
      showAutoCompleteSalesClerkList: true,
      showAutoCompleteCustomerList: true,
      showAutoCompleteFabricCodeList: true,
      showAutoCompleteColourList: true,
      shipToLookupHandler: null,
      isShowShipToLookup: false,
      isMaintenanceMode: true,
      isDisabledFields: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isAllowRead: false,
      isAllowReadColor: false,
      isDisablefabric: false,
      isDisableColor: true,
      salesPersonPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesPersonList: true,
      showAutoCompleteShipToNodeList: true,
      shipToNodePageListForAutoCompleteList: new Array(),
      isShowAddButton: false,
      vendor_List: [],
      showAutoCompleteVendorList: true,
      vendorPageListForAutoCompleteList: new Array(),
      showAutoCompleteLocationList: true,
      locationPageListForAutoCompleteList: new Array(),
      soAddressData: new AddressBean(),
      countryPageListForAutoCompleteList: new Array(),
      cityPageListForAutoCompleteList: new Array(),
      showAutoCompleteCityList: true,
      showAutoCompleteCountryList: true,
      showAutoCompleteStateList: true,
      statePageListForAutoCompleteList: new Array(),
      isShowCopySOPopup: false,
      isShowCopySOButton: false,
      is3PL: false,
      isShowPtAdvPopupAlert: false,
      imgUrl: "",
      docUrl: "",
      docName: "",
      imgData: null,
      docData: null,
      isShowCancelReasonPopup: false,
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowUnApproveReasonPopup: false,
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
      isShowLineCancelReasonPopup: false,
      isShowAlertLvl6: false,
      // addressCompData: new AddressBean(),
      isShowAddressPopup: false,
      showAutoCompleteCityList: false,
      cityPageListForAutoCompleteList: new Array(),
      // cityList: [],
      // stateList: [],
      // countryList: [],
      showAutoCompleteCityList: false,
      cityPageListForAutoCompleteList: new Array(),
      showAutoCompleteCountryList: false,
      countryPageListForAutoCompleteList: new Array(),
      salesOrderPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesOrderList: false,
      isShowCustomerSalesHistoryInq: false,
      isShowItemInventoryPositionInq: false,
      isShowItemCurrentInventoryInq: false,
      isShowFabricPurchaseHistoryInq: false,
      isShowAtsInq: false,
      isShowfabricAndCustomerSalesDetails: false,
      isShowCustomerOnOrderInq: false,
      isShowCustomerTransactionsInq: false,
      isShowCustomerStatisticsInq: false,
      isShowCustomerMostRecentFabricsInq: false,
      isCustomerCurrentAgingInq: false,
      isCustomerSalesAndPurchaseDetailsInq: false,
      order: "asc",
      sortField: "",
      isDeleteSoLine: false,
      isShowDocLabel: false,
      isReseted: false,
      isViewMode: false,
      fabricInventoryList: new Array(),
      isCustomerNotFound: false,
      isShowAutoCompleteDeliveryTypeList: false,
      deliveryTypePageListForAutoCompleteList: new Array(),

      isShowUomLookup: false,
      uoms: new Array(),
      uomPageListForAutoCompleteList: new Array(),
      showAutoCompleteUOMList: false,
      isTexco: false,
      images: [],
      preview_Url: [],
      isImageFormOpened: false,
      isDocumentsFormOpened: false,
      tempIndex: null,
      temp_OrderImages: [],

      documents: [],
      preview_Docs: [],

      isMultipleDocFormOpened: false,

      isLineLevelEditable: false,

      isShowItemSalesDetails: false,

      salesCommisionDeatils: "",

      isLineLevelDelete: false,
      isPurchaseNumberExist: false,
      isPickTicketNumberExist: false,

      isShowAddSampleRollButton: true,
      isShowSampleRollPopup: false,
      isShowSampleRollAlert: false,

      sampleFabricStyleCode: "",
      sampleFabricStyleName: "",
      sampleColorCode: "",
      showAutoCompleteSampleFabricList: false,
      sampleFabricAutoCompleteList: new Array(),
      sampleFabricLookUpHandler: null,
      grouped_sample: [],

      showAutoCompleteSampleColorCodeList: false,
      sampleColorCodeAutoCompleteList: new Array(),
      sampleColorCodeLookUpHandler: null,
      isShowSampleColorCodeLookUp: false,
      sampleColorCodeList: [],

      sampleSkuBatchRollLines: [],
      isShowChangeCustomerButton: false,
      isShowChangeCustomerPopup: false,

      changeCustomerBaseBean: new BaseBean(),
      isShowAutoCompleteNewCustomerList: false,
      newCustomerPageListForAutoCompleteList: new Array(),
      isShowWarningMsgPopup: false,
      warningMessage: "",
      isSavedWithWarning: false,
      isNewCustomerNotFound: false,
      isFabricCurrentATS: new Array(),
      skuInventoryList: [],
      inventoryLotData: [],
      lotOnHandQtyData: [],
      isInvoiceAvailable: false,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const session = JSON.parse(localStorage.getItem("session"));
    this.userCode = session.code;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.setState({
        is3PL: true,
      });
    }

    if (ConfigManager.isTexcoFabricKey()) {
      this.setState({
        isTexco: true,
      });
    }
    ModuleUtils.getSalesOrderStatusList();
    ModuleUtils.getPickTicketStatusList();
    ModuleUtils.getInvoiceStatusList();
    ModuleUtils.getSalesOrderLineStatusList();
    this.state.criteria = new SalesOrderSearchCriteria();
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;
    this.loadCacheDetails();
    //this.loadSalesOrders(); //Need to go to maintenance Mode
    this.initLookupHandlers();
    //set readOnly components using view Modes && disable toolbars
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      this.editSalesOrder(this.props.code);

      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        disableSalesOrderFormFields: true,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
    }
  }
  initLookupHandlers = () => {
    let salesOrderLookupHandler = new SalesOrderLookupHandler(
      this.companyCode,
      "SalesOrder",
    );
    this.setState({ salesOrderLookupHandler: salesOrderLookupHandler });
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  loadCacheDetails = () => {
    const attribute_cache = { ...this.cache };

    let salesOrderTypes = ModuleUtils.isActiveAttribute(
      attribute_cache.salesOrderTypes,
    );
    let paymentTerms = ModuleUtils.isActiveAttribute(
      attribute_cache.paymentTerms,
    );
    let paymentMethods = ModuleUtils.isActiveAttribute(
      attribute_cache.paymentMethods,
    );
    let customerRepresentatives = ModuleUtils.isActiveAttribute(
      attribute_cache.employees,
    );
    let salesClerks = ModuleUtils.isActiveAttribute(attribute_cache.employees);
    let shipVias = ModuleUtils.isActiveAttribute(attribute_cache.shipVias);
    let freightMethods = ModuleUtils.isActiveAttribute(
      attribute_cache.freightMethods,
    );
    let cityList = ModuleUtils.isActiveAttribute(attribute_cache.cities);
    let stateList = ModuleUtils.isActiveAttribute(attribute_cache.states);
    let countryList = ModuleUtils.isActiveAttribute(attribute_cache.countries);
    let salesPersonList = ModuleUtils.isActiveAttribute(
      attribute_cache.salesPersons,
    );
    let cancelReasons = ModuleUtils.isActiveAttribute(
      attribute_cache.salesOrderCancelReasons,
    );
    let unapprovalReasons = ModuleUtils.isActiveAttribute(
      attribute_cache.salesOrderUnApprovalReasons,
    );
    let locations = ModuleUtils.isActiveAttribute(attribute_cache.warehouses);
    let customerDeliveries = ModuleUtils.isActiveAttribute(
      attribute_cache.customerDeliveries,
    );
    this.setState({
      salesOrderTypes: salesOrderTypes,
      paymentTerms: paymentTerms,
      paymentMethods: paymentMethods,
      customerRepresentatives: customerRepresentatives,
      salesClerks: salesClerks,
      shipVias: shipVias,
      freightMethods: freightMethods,
      cityList: cityList,
      stateList: stateList,
      countryList: countryList,
      salesPersonList: salesPersonList,
      cancelReasons: cancelReasons,
      unapprovalReasons: unapprovalReasons,
      locations: locations,
      customerDeliveries: customerDeliveries,
    });
  };
  loadCustomerListResponse = (response) => {
    let customerList = [];
    if (
      response.data.customerPageList != null &&
      response.data.customerPageList.customers !== null
    ) {
      customerList = response.data.customerPageList.customers;
    }
    this.setState({
      customerList: customerList,
    });
  };
  loadCustomerListError = (error) => {
    ShowError("Error : " + error);
  };

  loadCustomerList = () => {
    let cust_criteria = new CustomerSearchCriteria();
    cust_criteria.companyCode = this.companyCode;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = cust_criteria;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.loadCustomerListResponse,
        this.loadCustomerListError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadFabricStyleListResponse = (response) => {
    let fabricStyleList = [];
    if (
      response.data.fabricStylePageList != null &&
      response.data.fabricStylePageList.fabricStyles !== null
    ) {
      fabricStyleList = response.data.fabricStylePageList.fabricStyles;
    }
    this.setState({
      fabricStyleList: fabricStyleList,
      iaFabricStyleDataLoding: false,
    });
  };
  loadFabricStyleListError = (error) => {
    ShowError("Error : ", error);
  };
  loadFabricStyleList = () => {
    let cust_criteria = new FabricStyleSearchCriteria();
    cust_criteria.companyCode = this.companyCode;

    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;

    let cust_requestInput = new RestFabricStyleListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = cust_criteria;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      FabricStyleService.getFabricStylePageList(
        cust_requestInput,
        this.loadFabricStyleListResponse,
        this.loadFabricStyleListError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadSalesOrdersResponse = (response) => {
    let salesOrderList = new Array();
    if (!isEmpty(response.data) && !isEmpty(response.data.salesOrderPageList)) {
      salesOrderList = response.data.salesOrderPageList.salesOrders;
      this.state.pageList.totalCount =
        response.data.salesOrderPageList.totalCount;
      this.state.pageList.currentPage =
        response.data.salesOrderPageList.currentPage;
    } else {
      salesOrderList = new Array();
    }
    let loading = this.state.isLoading;
    loading = false;
    this.setState({
      isLoading: loading,
      salesOrderList: salesOrderList,
    });
  };
  loadSalesOrdersError = (error) => {
    this.setState({ isLoading: false });
    ShowError("Error : ", error);
  };
  loadSalesOrders = () => {
    let requestInput = new RestSalesOrderListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.salesOrderCriteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.SalesOrderMaintenanceView_IsAccessible()) {
      SalesOrderService.getSalesOrderPageList(
        requestInput,
        this.loadSalesOrdersResponse,
        this.loadSalesOrdersError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  //#region OnHand Details
  readandSetOnHandQuantityResponse = (response) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    let invData = new SkuBatchInventoryDataBean();
    let soLine = this.state.salesOrderLineData;
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.batchInventoryDataResult) &&
      !isEmpty(response.data.batchInventoryDataResult.batchInventoryDataBean)
    ) {
      invData = response.data.batchInventoryDataResult.batchInventoryDataBean;

      soLine.onHandQuantity = invData.totalOnHandQuantity;
    } else {
      soLine.onHandQuantity = 0;
    }
    this.setState({ inventoryData: invData, salesOrderLineData: soLine });
  };
  readandSetOnHandQuantityError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };

  readandSetOnHandLotQuantity = (soLine) => {
    let input = new SKUBatchInventorySearchCriteria();
    input.companyCode = this.companyCode;
    input.fabricStyleCode = soLine.fabricStyleCode;
    input.colorCode = soLine.colorCode;
    input.skuNumber = soLine.skuNumber;
    input.locationCode = soLine.locationCode;
    input.vendorBatchNumber = soLine.lotNumber;
    input.isExcludeNonWarehouseInventory = true;
    InventoryService.getSKUBatchInventoriesForLotBasedSalesOrderDetails(
      input,
      this.readandSetOnHandLotQuantityResponse,
      this.readandSetOnHandLotQuantityError,
    );
  };
  readandSetOnHandLotQuantityResponse = (response) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    let invData = new SkuBatchInventoryDataBean();
    let soLine = this.state.salesOrderLineData;
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.batchInventoryDataResult) &&
      !isEmpty(response.data.batchInventoryDataResult.batchInventoryDataBean)
    ) {
      invData =
        response.data.batchInventoryDataResult.batchInventoryDataBean
          .inventoryDataDetails;

      // soLine.onHandQuantity = invData.totalOnHandQuantity;
    }
    // else {
    //   soLine.onHandQuantity = 0;
    // }
    this.setState({
      inventoryLotData: invData,
      // salesOrderLineData: soLine
    });
  };
  readandSetOnHandLotQuantityError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };

  readandSetOnHandQuantity = (soLine) => {
    let input = new SKUBatchInventorySearchCriteria();
    input.companyCode = this.companyCode;
    input.fabricStyleCode = soLine.fabricStyleCode;
    input.colorCode = soLine.colorCode;
    input.skuNumber = soLine.skuNumber;
    input.locationCode = soLine.locationCode;
    input.isExcludeNonWarehouseInventory = true;
    InventoryService.getSKUBatchInventoriesForRollBasedForSalesOrderOnHandQuantity(
      input,
      this.readandSetOnHandQuantityResponse,
      this.readandSetOnHandQuantityError,
    );
  };

  readOnHandQuantityResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.batchInventoryDataResult) &&
      !isEmpty(response.data.batchInventoryDataResult.batchInventoryDataBean)
    ) {
      let invData = new SkuBatchInventoryDataBean();
      invData = response.data.batchInventoryDataResult.batchInventoryDataBean;
      this.setState({ inventoryData: invData });
      this.openSOOnHandQuantityDetailDialog();
      this.setState({
        isShowProgressBarPopup: false,

        progressLoadingText: "",
      });
    } else {
      let errMsg = "No OnHandQuanties";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    }
  };
  readOnHandQuantityError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,

      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };
  readOnHandQuantity = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading OnHandQty",
    });
    let soLine = this.state.salesOrderLineData;
    let input = new SKUBatchInventorySearchCriteria();
    input.companyCode = this.companyCode;
    input.fabricStyleCode = soLine.fabricStyleCode;
    input.colorCode = soLine.colorCode;
    input.skuNumber = soLine.skuNumber;
    InventoryService.getSKUBatchInventoriesForRollBasedForSalesOrderOnHandQuantity(
      input,
      this.readOnHandQuantityResponse,
      this.readOnHandQuantityError,
    );
  };
  openSOOnHandQuantityDetailDialog() {
    this.setState({ isShowOnHandQtyPopup: true });
  }

  closeSOOnHandQuantityDetailDialog() {
    this.setState({ isShowOnHandQtyPopup: false });
  }
  executeAfterSOOnHandQuantityDetailDialogClose = () => { };
  //#endregion

  //#region SalesOrder Line Details

  openSOLineDetailDialog() {
    let salesOrderData = this.state.salesOrderData;

    // let fabricLookupHandler = new FabricStyleLookupHandler(
    //   this.companyCode,
    //   this.state.is3PL ? "Item" : "FabricStyle"
    // );
    // this.setState({ fabricLookupHandler: fabricLookupHandler });

    if (this.state.is3PL) {
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        "Item",
        salesOrderData.customerCode,
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    } else {
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        "Fabric",
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    }

    this.setState({
      isShowPopup: true,
      isShowColorLookup: false,
    });
    setTimeout(() => {
      if (this.fabricStyleCodeRef.current != null) {
        this.fabricStyleCodeRef.current.clear();
        this.fabricStyleCodeRef.current.focus();
      }
      if (this.fabricStyleColorCodeRef.current != null) {
        this.fabricStyleColorCodeRef.current.clear();
      }
    }, 300);

    if (this.soLineDetailDialogRef.current != null) {
      //this.soLineDetailDialogRef.current.show();
    }
    this.state.colorList = new Array();
    this.setState({ salesLineColorCodeLookupHandler: null });
  }

  // closeSOLineDetailDialog() {
  //   // if (this.soLineDetailDialogRef.current != null) {
  //   //   this.soLineDetailDialogRef.current.hide();
  //   // }

  //   this.setState({
  //     isShowPopup: false,
  //     fabricStyleData: new FabricStyleBean(),
  //     fabricInventoryList: new Array(),
  //   });
  //   this.state.colorList = new Array();
  //   this.state.fabricInventoryList = new Array();
  // }

  executeAfterSOLineDetailDialogClose = () => { };

  addNewSalesOrderLine = () => {
    if (!isEmptyString(this.state.salesOrderData.customerCode)) {
      this.state.showAutoCompleteFabricCodeList = false;
      let showAutoCompleteFabricCodeList =
        this.state.showAutoCompleteFabricCodeList;

      let soData = this.state.salesOrderData;
      let soLine = new SalesOrderLineBean();
      soLine.companyCode = this.companyCode;

      soLine.orderStartDate = soData.orderStartDate;
      soLine.orderStopDate = soData.orderStopDate;
      soLine.customerCode = soData.customerCode;
      soLine.customerName = soData.customerName;
      soLine.lineStatus = LogicConstants.SALES_ORDER_LINE_OPEN_STATUS;
      soLine.salesOrderLineNumber = NEW_ENTRY;
      this.state.isCollapsible_open = true;
      soLine.numberOfRollsPreferred = 0;
      this.setState({
        salesOrderLineData: soLine,
        colorList: new Array(),
        showAutoCompleteFabricCodeList: showAutoCompleteFabricCodeList,
        fabricPageListForAutoCompleteList: new Array(),
        isShowAddButton: true,
      });

      this.openSOLineDetailDialog();

      if (this.fabricStyleCodeRef.current != null) {
        this.fabricStyleCodeRef.current.clear();
        this.fabricStyleCodeRef.current.focus();
      }
      if (this.fabricStyleColorCodeRef.current != null) {
        this.fabricStyleColorCodeRef.current.clear();
      }
      this.setState({
        alertMessage: [],
        isDisablefabric: false,
        fabricStyleData: new FabricStyleBean(),
      });
    } else {
      let errMsg = "Customer Required!";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  saveSalesOrderLineCancelResponse = (response) => {
    this.setState({
      isLoading: false,
    });
    let success = this.handleResponse(response.data);
    if (success) {
      if (!isEmpty(response.data) && !isEmpty(response.data.salesOrder)) {
        let salesOrderData = response.data.salesOrder;
        this.setState({ salesOrderData: salesOrderData });
        // this.code = response.data.salesOrder.code;
        // this.unlockSalesOrder(response.data.salesOrder.code);
        if (this.isLocked) {
          this.code = response.data.salesOrder.code;
          this.unlockSalesOrder(response.data.salesOrder.code);
          // this.editSalesOrder(response.data.salesOrder.code);
        }
      }
    }
  };

  saveSalesOrderLineCancelError = (error) => {
    ShowError("Error cancel line: " + error);
  };
  reArrangeSoLineNumbers = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.salesOrderLineNumber = maxLineNumber;
    });
  };
  cancelSalesOrderLine = (soLine) => {
    let salesOrderData = this.state.salesOrderData;

    let existingLine = this.getSOLinebySKUNumber(soLine.salesOrderLineNumber);
    this.state.salesOrderLineData = { ...existingLine };
    if (!isEmpty(existingLine)) {
      if (!existingLine.isFetched) {
        const index = salesOrderData.lines.findIndex(
          (ln) => ln.salesOrderLineNumber === existingLine.salesOrderLineNumber,
        );
        if (index != -1) {
          salesOrderData.lines.splice(index, 1);
        }
        this.reArrangeSoLineNumbers(salesOrderData.lines);
        this.setState({ salesOrderData: salesOrderData });
      } else {
        this.openReasonCapture(3);
      }
    }
    this.calculateGrandTotal();
  };

  saveSalesOrderLineCancel = () => {
    let salesOrderData = this.state.salesOrderData;
    let soLine = this.state.salesOrderLineData;
    let input = new RestSalesOrderLineCancelRequest();

    let criteria = new SalesOrderLineSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = salesOrderData.customerCode;
    criteria.itemCode = soLine.fabricStyleCode;
    criteria.lineNumber = soLine.salesOrderLineNumber;
    criteria.lineStatus = soLine.lineStatus;
    criteria.toOrderStopDate = salesOrderData.orderStopDate;
    criteria.orderDate = salesOrderData.createdDate;
    criteria.orderStatus = salesOrderData.orderStatus;
    criteria.salesOrderNumber = salesOrderData.code;

    let updateHeaderStatusFlag = false;
    if (
      salesOrderData.orderStatus != LogicConstants.SALES_ORDER_UNAPPROVE_STATUS
    ) {
      updateHeaderStatusFlag = true;
    }
    input.companyCode = this.companyCode;
    input.searchCriteria = criteria;
    input.reasonBean = this.state.reasonData;
    input.updateHeaderStatusFlag = updateHeaderStatusFlag;
    if (SecurityAccessManager.SalesOrderMaintenanceCancel_IsAccessible()) {
      SalesOrderService.cancelSalesOrderLine(
        input,
        this.saveSalesOrderLineCancelResponse,
        this.saveSalesOrderLineCancelError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onLineChange = (e) => {
    let temp_salesOrderLineData = this.state.salesOrderLineData;
    temp_salesOrderLineData[e.target.name] = e.target.value;
    let fabricSyleCode = e.target.value;
    if (e.target.name == "orderQuantity") {
      this.onOrderQuantityChanges(temp_salesOrderLineData);
    }
    if (
      e.target.name == "price" ||
      e.target.name == "tariffPercentage" ||
      e.target.name == "discountPercentage"
    ) {
      this.calculateLineTotal(temp_salesOrderLineData);
    }
    if (e.target.name == "numberOfRollsPreferred") {
      let numberOfRollsPreferred = 0;
      if (!isEmptyString(e.target.value))
        numberOfRollsPreferred = parseInt(e.target.value);
      temp_salesOrderLineData[e.target.name] = numberOfRollsPreferred;
    }

    if (e.target.name == "lineOrderStartDate") {
      temp_salesOrderLineData["lineOrderStartDate"] = e.target.value;
    }
    if (e.target.name == "lineOrderStopDate") {
      temp_salesOrderLineData["lineOrderStopDate"] = e.target.value;
    }
    if (e.target.name === "fabricStyleCode") {
      temp_salesOrderLineData["fabricStyleCode"] = e.target.value;
    }
    if (e.target.name === "remarks") {
      temp_salesOrderLineData["remarks"] = e.target.value;
    }
    this.setState({
      salesOrderLineData: temp_salesOrderLineData,
      isAllowReadColor: true,
    });
  };
  onAtsChange = (e) => {
    let isFabricCurrentATS = this.state.isFabricCurrentATS;
    isFabricCurrentATS[e.target.name] = e.target.value;

    this.setState({ isFabricCurrentATS: isFabricCurrentATS });
  };

  readFabricColourBySearchString(searchString) {
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  onFabricCodeChange = (e) => {
    this.setState({
      fabricStyleCode: "",
      isAllowRead: false,
    });
    let fabricStyleCode = e.target.value.toUpperCase();
    let tempSalesOrderLineData = this.state.salesOrderLineData;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricCodeList = false;
      let showAutoCompleteFabricCodeList =
        this.state.showAutoCompleteFabricCodeList;
      let soLine = this.state.salesOrderLineData;
      soLine.fabricStyleCode = "";
      let suggestion = [];
      this.clearFabricStyleRelated();
      this.setState({
        showAutoCompleteFabricCodeList: showAutoCompleteFabricCodeList,
        salesOrderLineData: soLine,
        fabricPageListForAutoCompleteList: suggestion,
      });
    } else if (e.target.name == "fabricStyleCode" && fabricStyleCode !== "") {
      this.readFabricBySearchString(e.target.value);
      this.state.showAutoCompleteFabricCodeList = true;
      let showAutoCompleteFabricCodeList =
        this.state.showAutoCompleteFabricCodeList;
      this.setState({
        showAutoCompleteFabricCodeList: showAutoCompleteFabricCodeList,
      });
    }
    tempSalesOrderLineData[e.target.name] = e.target.value.toUpperCase();

    this.setState({
      salesOrderLineData: tempSalesOrderLineData,
      fabricStyleCode: fabricStyleCode,
      isAllowRead: false,
    });
  };
  onfabricBlur = (e) => {
    setTimeout(() => {
      if (this.state.isAllowRead == false && e.target.value != "") {
        this.readandsetFabricStyleDetail(this.state.fabricStyleCode);
      }
    }, 100);
    if (e.target.value == "") {
      this.state.salesOrderLineData.fabricStyleName = "";
      this.state.salesOrderLineData.widthCode = "";
      this.state.salesOrderLineData.colorCode = "";
      this.state.salesOrderLineData.orderUomCode = "";
      this.state.colorList = [];
      this.state.isShowColorLookup = false;
    }
  };
  onfabricKeyDown = (e) => {
    if (e.keyCode == 113 || e.keyCode == 27) {
      this.setState({
        isAllowRead: true,
      });
    }
  };
  onFabricColourCodeChange = (e) => {
    this.setState({
      fabricStyleColorCode: "",
      isAllowReadColor: false,
    });
    this.state.showAutoCompleteColourList = true;
    let colorCode = e.target.value.toUpperCase();
    let tempSalesOrderData = this.state.salesOrderLineData;
    let showAutoCompleteList = this.state.showAutoCompleteColourList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteColourList = false;
      let showAutoCompleteList = this.state.showAutoCompleteColourList;
      let soLine = this.state.salesOrderLineData;
      soLine.colorCode = "";
      soLine.onHandQuantity = 0;
      soLine.orderQuantity = 0;
      soLine.price = 0;
      let suggestion = [];
      this.setState({
        showAutoCompleteColourList: showAutoCompleteList,
        salesOrderLineData: soLine,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
    tempSalesOrderData[e.target.name] = e.target.value;
    this.setState({
      salesOrderLineData: tempSalesOrderData,
      fabricStyleColorCode: colorCode,
      isAllowReadColor: false,
    });
  };
  onfabricColorBlur = (e) => {
    setTimeout(() => {
      if (this.state.isAllowReadColor == false && e.target.value != "") {
        this.fabricStyleColorSelected(this.state.fabricStyleColorCode);
      }
    }, 100);
  };
  onfabricColorKeyDown = (e) => {
    if (e.keyCode == 113 || e.keyCode == 27) {
      this.setState({
        isAllowReadColor: true,
      });
    }
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.readByFabricCodeResponseError,
    );
  }
  readByFabricCodeResponse = (response) => {
    let salesOrderData = this.state.salesOrderData;
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData = fabricStyleData.filter((item) => item.isActive);
      fabricStyleData.map((fabricStyle) => {
        if (this.state.is3PL) {
          if (!isEmptyString(salesOrderData.customerCode)) {
            if (fabricStyle.customerCode == salesOrderData.customerCode) {
              let simpleItemBean = {
                code: fabricStyle.fabricStyleCode,
                description: fabricStyle.fabricStyleName,
              };
              simpleAutoCompleteList.push(simpleItemBean);
            }
          } else {
            let simpleItemBean = {
              code: fabricStyle.fabricStyleCode,
              description: fabricStyle.fabricStyleName,
            };
            simpleAutoCompleteList.push(simpleItemBean);
          }
        } else {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        }
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readByFabricCodeResponseError = (error) => {
    ShowError("Error : ", error);
  };
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleColorCode: fabricStyleColourCode,
      isAllowReadColor: false,
    });
  };
  fabricenterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricCodeList = false;
    let showAutoCompleteFabricCodeList =
      this.state.showAutoCompleteFabricCodeList;
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({
      fabricStyleCode: fabricStyleCode,
      fabricPageListForAutoCompleteList: new Array(),
      isDisableColor: false,
      showAutoCompleteFabricCodeList: showAutoCompleteFabricCodeList,
    });
  };
  onOrderQuantityChanges = (soLine) => {
    if (soLine.orderQuantity > 0) {
      if (
        soLine.orderQuantity <= 26 &&
        ConfigManager.isSpecialPriceCalculated()
      ) {
        soLine.price = soLine.originalPrice + 2;
      } else {
        soLine.price = soLine.originalPrice;
      }
    }
    this.calculateLineTotal(soLine);
  };
  lnkOnHandQuantityDetailsClick = (e, data) => {
    if (e.detail == 1) {
      if (!isEmptyString(data)) {
        this.readOnHandQuantity();
      }
    }
  };
  readAndSetFabricStyleImageResponse = (response) => {
    let fabricStyle = response.data.fabricStyle;
    let soLine = this.state.salesOrderLineData;
    if (!isEmpty(fabricStyle)) {
      this.state.fabricStyleData = fabricStyle;
      this.setState({ fabricStyleData: fabricStyle });

      this.fabricStyleSelected(fabricStyle);

      if (!this.state.salesOrderLineData.isFetched) {
        this.setState({
          isDisableColor: false,
        });
      }
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };

  readAndSetFabricStyleImage = (code) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = code;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyleForSoLine(
      input,
      this.readAndSetFabricStyleImageResponse,
      this.errorCallBack,
    );
  };

  readandsetFabricStyleDetailResponse = (response) => {
    let fabricStyle = response.data.fabricStyle;
    let soLine = this.state.salesOrderLineData;
    if (!isEmpty(fabricStyle)) {
      this.state.fabricStyleData = fabricStyle;
      this.setState({ fabricStyleData: fabricStyle });
      this.clearFabricStyleRelated();
      this.fabricStyleSelected(fabricStyle);

      if (!this.state.salesOrderLineData.isFetched) {
        this.setState({
          isDisableColor: false,
        });
      }
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  readandsetFabricStyleDetailError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : ", error);
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    // this.setState({
    //   isShowProgressBarPopup: true,
    //   progressLoadingText: "Reading Fabric Style ..",
    // });
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyleForSoLine(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.readandsetFabricStyleDetailError,
    );
  };

  clearFabricStyleRelated = () => {
    let soLine = this.state.salesOrderLineData;
    soLine.fabricStyleCode = "";
    soLine.fabricStyleName = "";
    soLine.colorCode = "";
    let colors = [];
    soLine.inventoryUomCode = "";
    soLine.orderUomCode = "";
    soLine.isItemTaxableFlag = "";
    soLine.uomConversionRate = 0;
    soLine.price = 0;
    soLine.productDivisionCode = "";
    soLine.widthCode = "";
    soLine.onHandQuantity = 0;
    soLine.orderQuantity = 0;
    this.setState({
      colorList: colors,
      salesOrderLineData: soLine,
      fabricPageListForAutoCompleteList: new Array(),
      isDisableColor: true,
      isShowColorLookup: false,
      colorList: [],
      fabricInventoryList: new Array(),
      uomLookupHandler: null,
      uoms: [],
      isShowUomLookup: false,
    });
    if (this.fabricStyleColorCodeRef.current != null) {
      this.fabricStyleColorCodeRef.current.clear();
    }
    if (this.fabricStyleCodeRef.current != null) {
      this.fabricStyleCodeRef.current.focus();
    }
  };
  fabricStyleSelected = (fabricStyle) => {
    this.state.showAutoCompleteFabricCodeList = false;
    let showAutoCompleteFabricCodeList =
      this.state.showAutoCompleteFabricCodeList;
    // let fabricStyle = this.state.fabricStyleData;
    let soLine = this.state.salesOrderLineData;
    let isShowColorLookup = true;
    let finalColorList = [];
    let salesLineColorCodeLookupHandler = null;
    let singleColorCode = null; // FIX: capture single color separately
    if (!isEmpty(fabricStyle) && !isEmpty(soLine)) {
      let colors = fabricStyle.colors;
      soLine.fabricStyleCode = fabricStyle.code;
      soLine.fabricStyleName = fabricStyle.description;
      if (!this.state.is3PL) soLine.widthCode = fabricStyle.width;
      soLine.inventoryUomCode = fabricStyle.inventoryUomCode;
      if (!this.state.is3PL) soLine.orderUomCode = fabricStyle.inventoryUomCode;
      soLine.isItemTaxableFlag = fabricStyle.salesTaxRequiredFlag;
      soLine.uomConversionRate = 1;
      soLine.productDivisionCode = fabricStyle.divisionCode;
      soLine.tariffPercentage = fabricStyle.tariffPercentage;
      if (this.fabricStyleColorCodeRef.current != null) {
        this.fabricStyleColorCodeRef.current.clear();
        this.fabricStyleColorCodeRef.current.focus();
      }
      //this.setState({ isShowUomLookup: false });

      if (!isEmpty(colors)) {
        if (colors.length == 1) {
          if (colors[0].isActive) {
            soLine.colorCode = colors[0].fabricStyleColorCode;
            singleColorCode = colors[0].fabricStyleColorCode; // FIX: just capture it
            // this.fabricStyleColorSelected(soLine.colorCode);
            isShowColorLookup = false;
          }
        } else {
          colors.map((ent) => {
            if (ent.isActive) {
              let colorBean = new BaseBean();
              colorBean.code = ent.fabricStyleColorCode;
              colorBean.description = ent.fabricStyleColorName;
              finalColorList.push(colorBean);
            }
          });
        }
      }

      if (finalColorList != null) {
        salesLineColorCodeLookupHandler = new GenericAttributeLookupHandler(
          finalColorList,
          "Color",
        );
      }
      this.getFabricStyleInventoryDetails(fabricStyle.code);
      //  this.loadFabricInventoryLotInquiryList(fabricStyle);
    }
    this.setState(
      {
        isShowColorLookup: isShowColorLookup,
        salesOrderLineData: soLine,
        salesLineColorCodeLookupHandler: salesLineColorCodeLookupHandler,
        colorList: finalColorList,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        isAllowRead: true,
      },
      () => {
        // FIX: call AFTER setState committed, so fabricStyleColorSelected
        // reads the correct soLine from state
        if (singleColorCode !== null) {
          this.fabricStyleColorSelected(singleColorCode);
        }
      },
    );
  };
  readFabricInventoryResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.result) &&
      !isEmptyArray(response.data.result.skuBatchInventoryDatas)
    ) {
      let fabricInventoryList = new Array();
      fabricInventoryList = response.data.result.skuBatchInventoryDatas;
      this.setState({
        fabricInventoryList: fabricInventoryList,
      });
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  getFabricStyleInventoryDetails = (code) => {
    this.setState({ isLoading: true, loadingText: "Loading" });
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = code;
    FabricStyleService.readFabricStyleWithInventoryDetailsForSalesOrder(
      request,
      this.readFabricInventoryResponse,
      this.errorCallBack,
    );
  };

  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = { ...this.state.fabricStyleData };
    let soLine = { ...this.state.salesOrderLineData };

    const matchedSku = fabricStyle.fabricStyleSkus.find(
      (sku) =>
        sku.fabricStyleCode?.trim() === soLine.fabricStyleCode?.trim() &&
        sku.fabricStyleColorCode?.trim() === colorCode.trim(),
    );

    const skuBean = matchedSku ?? new FabricStyleSKUBean();

    soLine.colorCode = colorCode;
    if (!isEmpty(skuBean)) {
      soLine.skuNumber = skuBean.skuNumber;
    }

    const uomList = (fabricStyle.sellingUoms || []).map((uom) => {
      const uomBean = new BaseBean();
      uomBean.code = uom.uomCode;
      uomBean.description = uom.uomCode?.toLowerCase();
      uomBean.conversionRate = uom.conversionRate;
      return uomBean;
    });

    let uomLookupHandler = null;
    let isShowUomLookup = true;

    if (!isEmptyArray(uomList)) {
      if (uomList.length === 1) {
        soLine.orderUomCode = uomList[0].code;
        soLine.uomConversionRate = uomList[0].conversionRate;
        isShowUomLookup = false;
      } else {
        uomLookupHandler = new GenericAttributeLookupHandler(uomList, "UOM");
      }
    }

    this.setState(
      {
        salesOrderLineData: soLine,
        uomLookupHandler: uomLookupHandler,
        uoms: uomList,
        isShowUomLookup: isShowUomLookup,
        isAllowReadColor: true,
      },
      () => {
        if (soLine.skuNumber > 0) {
          this.setitemCostAndPrice(soLine);

          // this.setitemCostAndPrice(soLine);
        }
        this.loadFabricInventoryLotInquiryList(fabricStyle);
        this.readAtsQuantity(soLine);
      },
    );
  };
  fabricStyleColorSelected_BKUP = (colorCode) => {
    // this.setState({
    //   isShowProgressBarPopup: true,
    //   progressLoadingText: "Loading Color Details",
    // });
    let fabricStyle = this.state.fabricStyleData;
    let soLine = this.state.salesOrderLineData;
    let skuBean = new FabricStyleSKUBean();

    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode?.trim() === soLine.fabricStyleCode?.trim() &&
        sku.fabricStyleColorCode?.trim() == colorCode.trim()
      ) {
        skuBean = sku;
      }
    });
    soLine.colorCode = colorCode;

    if (!isEmpty(skuBean)) {
      soLine.skuNumber = skuBean.skuNumber;
    }

    let uomList = new Array();
    let sellingUOM_List = new Array();
    sellingUOM_List = fabricStyle.sellingUoms;
    sellingUOM_List.map((uom) => {
      const uomBean = new BaseBean();
      uomBean.code = uom.uomCode;
      uomBean.description = uom.uomCode.toLowerCase();
      uomBean.conversionRate = uom.conversionRate;
      uomList.push(uomBean);
    });
    if (!isEmptyArray(uomList)) {
      if (uomList.length == 1) {
        soLine.orderUomCode = uomList[0].code;
        soLine.uomConversionRate = uomList[0].conversionRate;
        this.setState({
          isShowUomLookup: false,
          uoms: uomList,
          // isDisabledFields:true,
        });
      } else {
        let uomLookupHandler = new GenericAttributeLookupHandler(
          uomList,
          "UOM",
        );
        this.setState({
          uomLookupHandler: uomLookupHandler,
          uoms: uomList,
          isShowUomLookup: true,
        });
      }
    }
    this.state.salesOrderLineData = soLine;

    if (soLine.skuNumber > 0) {
      // this.setItemSalesPrice(soLine);
      this.setitemCostAndPrice(soLine);
    } else {
      // this.setState({
      //   isShowProgressBarPopup: false,
      //   progressLoadingText: "",
      // });
    }
    this.setState({
      salesOrderLineData: soLine,
      isAllowReadColor: true,
    });
  };

  getFabricPriceAndCostResponse = (response) => {
    let salesOrderLineData = this.state.salesOrderLineData;
    // let salesOrderLineData =  {...this.pendingSoLine}
    if (response.data != null) {
      if (response.data.priceResponse != null) {
        if (response.data.priceResponse.itemPrice != null) {
          salesOrderLineData.originalPrice =
            response.data.priceResponse.itemPrice;
          salesOrderLineData.price = response.data.priceResponse.itemPrice;
        }
      }
      if (response.data.costResponse != null) {
        if (response.data.costResponse.fabricStyleCost != null) {
          salesOrderLineData.cost = response.data.costResponse.fabricStyleCost;
        }
      }
      this.readandSetOnHandQuantity(salesOrderLineData);
      this.setState({
        salesOrderLineData: salesOrderLineData,
        isAllowReadColor: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error :", error);
  };
  setitemCostAndPrice = (soLine) => {
    // this.pendingSoLine = soLine;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      let soData = this.state.salesOrderData;
      let priceCriteria = new FabricStyleSalePriceInputCriteriaBean();
      priceCriteria.companyCode = this.companyCode;
      priceCriteria.customerCode = soData.customerCode;
      priceCriteria.customerTypeCode = soData.customerType;
      priceCriteria.customerShipToCode = soData.shipToCode;
      priceCriteria.fabricStyleCode = soLine.fabricStyleCode;
      priceCriteria.colorCode = soLine.colorCode;
      priceCriteria.skuNumber = soLine.skuNumber;
      priceCriteria.uomCode = soLine.orderUomCode;
      priceCriteria.widthCode = soLine.widthCode;
      priceCriteria.orderDate = soData.createdDate;
      priceCriteria.currencyCode = soData.salesOrderCurrencyCode;
      let costCriteria = new FabricStylePurchaseCostInputCriteriaBean();
      costCriteria.companyCode = this.companyCode;
      costCriteria.fabricStyleCode = soLine.fabricStyleCode;
      costCriteria.colorCode = soLine.colorCode;
      costCriteria.skuNumber = soLine.skuNumber;
      costCriteria.uomCode = soLine.orderUomCode;
      costCriteria.orderDate = soData.createdDate;
      costCriteria.currencyCode = soData.salesOrderCurrencyCode;
      let request = new RestGetFabricPriceAndCostRequest();
      request.costCriteria = costCriteria;
      request.priceCriteria = priceCriteria;
      FabricStyleService.getFabricStylePriceAndCost(
        request,
        this.getFabricPriceAndCostResponse,
        this.errorCallBack,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  calculateGrandTotal = () => {
    let soData = this.state.salesOrderData;
    if (!isEmpty(soData.lines)) {
      let subTotal = 0;
      let totalTariffAmount = 0;
      let totalTaxAmount = 0;
      soData.lines.map((line) => {
        this.calculateLineTotal(line);
        subTotal += Number(line.lineTotalAmount);
        totalTariffAmount += Number(line.tariffAmount);
        if (line.isItemTaxableFlag) totalTaxAmount += line.taxAmount;
      });
      soData.subTotalAmount = subTotal;
      soData.totalTariffAmount = totalTariffAmount.toFixed(2);
      soData.totalTaxAmount = totalTaxAmount;
      let shipmentChargesAmount = 0;
      shipmentChargesAmount = parseFloat(soData.shipmentChargesAmount);
      let extraChargesAmount = 0;
      extraChargesAmount = parseFloat(soData.extraChargesAmount);
      let grandTotalAmount = 0;
      grandTotalAmount += subTotal + totalTariffAmount;
      grandTotalAmount += shipmentChargesAmount;
      grandTotalAmount += extraChargesAmount;
      if (soData.taxRequiredFlag) {
        grandTotalAmount += soData.totalTaxAmount;
      }
      soData.grandTotalAmount = grandTotalAmount;
      this.setState({ salesOrderData: soData });
    }
  };
  calculateLineTotal = (soLine) => {
    let price = soLine.price;
    let orderQty = soLine.orderQuantity;
    let totalLineAmount = 0;
    let totalLineNetAmount = 0;

    totalLineAmount = Number(price * orderQty).toFixed(2);

    let discAmount = Number(
      totalLineAmount * soLine.discountPercentage * 0.01,
    ).toFixed(2);
    totalLineNetAmount = totalLineAmount;
    soLine.taxAmount = 0;
    if (soLine.isItemTaxableFlag) {
      let lineTaxAmount = (soLine.taxPercentage / 100) * totalLineAmount;
      soLine.taxAmount = lineTaxAmount;
      totalLineNetAmount += lineTaxAmount;
    }
    soLine.lineDiscountAmount = discAmount;
    totalLineNetAmount = Number(
      totalLineNetAmount - soLine.lineDiscountAmount + soLine.extraCharge,
    ).toFixed(2);
    soLine.lineTotalAmount = totalLineNetAmount;
    let tariffAmount = 0;
    tariffAmount = (soLine.tariffPercentage / 100) * totalLineNetAmount;
    soLine.tariffAmount = Number(tariffAmount).toFixed(2);
    soLine.lineNetAmount = Number(
      Number(totalLineNetAmount) + Number(tariffAmount),
    ).toFixed(2);
  };
  validateSOLine = (lineBean) => {
    let isValidSOLine = false;
    let err_list = [];
    let errorMessage = "";
    let salesOrderData = this.state.salesOrderData;
    if (lineBean == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(lineBean.fabricStyleCode)) {
        let errMsg = "FabricStyle is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(lineBean.fabricStyleName)) {
        let errMsg = "FabricStyleName is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(lineBean.colorCode)) {
        let errMsg = "ColorCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(lineBean.orderUomCode)) {
        let errMsg = "UOMCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (lineBean.skuNumber == 0) {
        let errMsg = "SkuNumber is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (!this.state.is3PL) {
        if (!ConfigManager.isSalesZeroPriceValidationRequried()) {
          if (lineBean.price == 0) {
            let errMsg = "Price is Required";
            errorMessage = errorMessage + errMsg;
            err_list.push(errMsg);
          }
        }
      }
      if (lineBean.orderQuantity == 0) {
        let errMsg = "OrderQuantity is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }

      if (lineBean.price < lineBean.cost) {
        let errMsg = "Price Invalid : Should Not Less Than The cost";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (ConfigManager.isSalesOrderOnHandQuantityValidationRequried())
        if (lineBean.onHandQuantity <= 0 && !this.state.is3PL) {
          let errMsg = "OnHandQuantity Must greater Than the 0";
          errorMessage = errorMessage + errMsg;
          err_list.push(errMsg);
        }
      if (salesOrderData.lines != null || !isEmptyArray(salesOrderData.lines)) {
        salesOrderData.lines.map((ln) => {
          if (
            lineBean.salesOrderLineNumber != ln.salesOrderLineNumber &&
            lineBean.fabricStyleCode == ln.fabricStyleCode &&
            lineBean.colorCode == ln.colorCode
          ) {
            let errMsg = "Invalid Line Entry Already Exist";
            errorMessage = errorMessage + errMsg;
            err_list.push(errMsg);
          }
        });
      }
    }
    if (err_list.length > 0) {
      isValidSOLine = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: false,
        isShowPopupAlert: true,
      });
    } else {
      isValidSOLine = true;
      this.setState({ isShowAlert: false, isShowPopupAlert: false });
    }
    return isValidSOLine;
  };
  // getSalesCommissionMaxLineNumber() {
  //   let maxLineNumber = 0;
  //   let commissions = this.state.salesOrderData.commissions;
  //   if (!isEmptyArray(commissions) && commissions.length > 0)
  //     commissions.map((line) => {
  //       if (line.lineNumber > maxLineNumber) {
  //         maxLineNumber = line.lineNumber;
  //       }
  //     });
  //   return maxLineNumber;
  // }
  // Max lineNumber across ALL rows (including deleted) — deleted rows still "own"
  // their lineNumber slot, so a new row must never reuse it.
  getSalesCommissionMaxLineNumber = () => {
    let maxLineNumber = 0;
    let salesOrderData = this.state.salesOrderData;
    if (!isEmpty(salesOrderData) && !isEmptyArray(salesOrderData.commissions)) {
      salesOrderData.commissions.forEach((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  };

  // Max displayLineNumber among VISIBLE (non-deleted) rows only — deleted rows'
  // stale displayLineNumber must not affect the next display slot.
  getMaxCommissionLineNumber = () => {
    let maxDisplayLineNumber = 0;
    let salesOrderData = this.state.salesOrderData;
    if (!isEmpty(salesOrderData) && !isEmptyArray(salesOrderData.commissions)) {
      salesOrderData.commissions.forEach((line) => {
        if (!line.isDeleted && line.displayLineNumber > maxDisplayLineNumber) {
          maxDisplayLineNumber = line.displayLineNumber;
        }
      });
    }
    return maxDisplayLineNumber;
  };
  getSOMaxLineNumber() {
    let maxLineNumber = 0;
    let soLines = this.state.salesOrderData.lines;
    if (soLines.length > 0)
      soLines.map((line) => {
        if (line.salesOrderLineNumber > maxLineNumber) {
          maxLineNumber = line.salesOrderLineNumber;
        }
      });
    return maxLineNumber;
  }
  getSOLinebySKUNumber = (salesOrderLineNumber) => {
    let soLine = null;
    if (this.state.salesOrderData === null) return soLine;
    else if (this.state.salesOrderData.lines === null) return soLine;
    else {
      this.state.salesOrderData.lines.map((line) => {
        if (line.salesOrderLineNumber === salesOrderLineNumber) {
          soLine = line;
          return soLine;
        }
      });
    }
    return soLine;
  };
  addorUpdateSOLine = (e) => {
    if (e.detail === 1) {
      let soLine = this.state.salesOrderLineData;
      if (this.state.is3PL) {
        soLine.widthCode = DEMO_VALUE;
      }
      let isValidLine = false;
      isValidLine = this.validateSOLine(soLine);
      if (isValidLine) {
        let salesOrderData = this.state.salesOrderData;
        let existingLine = this.getSOLinebySKUNumber(
          soLine.salesOrderLineNumber,
        );
        if (existingLine === null) {
          var lineNumber = this.getSOMaxLineNumber();
          soLine.salesOrderLineNumber = ++lineNumber;
          salesOrderData.lines.push(soLine);
        } else {
          const index = salesOrderData.lines.findIndex(
            (ln) =>
              ln.salesOrderLineNumber === existingLine.salesOrderLineNumber,
          );
          if (index != -1) {
            soLine.isFetched = existingLine.isFetched;
            soLine.salesOrderLineNumber = existingLine.salesOrderLineNumber;
            this.calculateLineTotal(soLine);
            salesOrderData.lines.splice(index, 1);
            salesOrderData.lines.push(soLine);
          }
        }
        this.setState({ salesOrderData: salesOrderData });
        this.calculateGrandTotal();
        // this.closeSOLineDetailDialog();
        this.closeAlertModalCallBack(false);
        this.clearLineValues();
      }
    }
  };

  addorUpdateMultipleSOLine = () => {
    // if (e.detail === 1) {
    let soLine = this.state.salesOrderLineData;
    let soData = this.state.salesOrderData;
    soLine.companyCode = this.companyCode;
    soLine.orderStartDate = soData.orderStartDate;
    soLine.orderStopDate = soData.orderStopDate;
    soLine.customerCode = soData.customerCode;
    soLine.customerName = soData.customerName;
    if (this.state.is3PL) {
      soLine.widthCode = DEMO_VALUE;
    }
    soLine.lineStatus = LogicConstants.SALES_ORDER_LINE_OPEN_STATUS;
    soLine.salesOrderLineNumber = NEW_ENTRY;
    let isValidLine = false;
    isValidLine = this.validateSOLine(soLine);
    if (isValidLine) {
      let salesOrderData = this.state.salesOrderData;
      let existingLine = this.getSOLinebySKUNumber(soLine.salesOrderLineNumber);
      if (existingLine === null) {
        var lineNumber = this.getSOMaxLineNumber();
        soLine.salesOrderLineNumber = ++lineNumber;
        salesOrderData.lines.push(soLine);
      } else {
        const index = salesOrderData.lines.findIndex(
          (ln) => ln.salesOrderLineNumber === existingLine.salesOrderLineNumber,
        );
        if (index != -1) {
          soLine.isFetched = existingLine.isFetched;
          soLine.salesOrderLineNumber = existingLine.salesOrderLineNumber;
          this.calculateLineTotal(soLine);

          salesOrderData.lines.splice(index, 1);
          salesOrderData.lines.push(soLine);
        }
      }
      this.setState({
        salesOrderData: salesOrderData,
        fabricStyleData: new FabricStyleBean(),
      });
      this.calculateGrandTotal();
      this.clearLineValues();
    }
    // }
  };
  clearLineValues = () => {
    // if (e.detail === 1) {
    this.setState({
      isAllowRead: true,
      isAllowReadColor: true,
      isShowUomLookup: false,
      uoms: new Array(),
    });
    let newLineBean = new SalesOrderLineBean();
    let soData = this.state.salesOrderData;
    if (soData.orderStatus == LogicConstants.SALES_ORDER_UNAPPROVE_STATUS) {
      if (this.fabricStyleCodeRef.current != null) {
        this.fabricStyleCodeRef.current.clear();
        this.fabricStyleCodeRef.current.focus();
      }
      if (this.fabricStyleColorCodeRef.current != null) {
        this.fabricStyleColorCodeRef.current.clear();
      }
      newLineBean.orderStartDate = soData.orderStartDate;
      newLineBean.orderStopDate = soData.orderStopDate;
      newLineBean.customerCode = soData.customerCode;
      newLineBean.customerName = soData.customerName;
      newLineBean.lineStatus = LogicConstants.SALES_ORDER_LINE_OPEN_STATUS;
      newLineBean.salesOrderLineNumber = NEW_ENTRY;
      this.setState({
        salesOrderLineData: newLineBean,
        isShowColorLookup: false,
        colorList: [],
        salesLineColorCodeLookupHandler: null,
        isAllowReadColor: true,
        fabricStyleData: new FabricStyleBean(),
        fabricInventoryList: new Array(),
        isFabricCurrentATS: new Array(),
        skuInventoryList: [],
      });
    }
    // }
  };
  getLineDetails = (rowData) => {
    let lineDetail = { ...rowData };
    if (rowData.isFetched == false) {
      this.setState({
        salesOrderLineData: lineDetail,
        isShowColorLookup: true,
        isShowPopup: true,
        isAllowRead: true,
        isDisablefabric: false,
        isDisableColor: false,
        isAllowReadColor: true,
        isShowAddButton: false,
      });
    } else {
      this.setState({
        salesOrderLineData: lineDetail,
        isShowColorLookup: true,
        isShowPopup: true,
        isAllowRead: true,
        isDisablefabric: true,
        isDisableColor: true,
        isAllowReadColor: true,
        isShowAddButton: false,
      });
    }
    setTimeout(() => {
      this.fabricStyleCodeRef.current.focus();
      this.state.showAutoCompleteFabricCodeList = false;
      let showAutoCompleteFabricCodeList =
        this.state.showAutoCompleteFabricCodeList;
      this.setState({
        showAutoCompleteFabricCodeList: showAutoCompleteFabricCodeList,
      });
    }, 180);
    this.readandSetOnHandQuantity(rowData);
    // this.readAtsQuantity(rowData);
    // this.loadFabricInventoryLotInquiryList(rowData);
  };
  loadFabricInventoryLotInquiryList = (rowData) => {
    let criteria = new FabricStyleInventoryForLotBasedSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = rowData.code;
    criteria.colorCode = this.state.salesOrderLineData.colorCode;
    criteria.isSummary = true;

    if (SecurityAccessManager.ItemMaintenance_IsAccessible()) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: this.props.is3PL ? "read Item" : "read Fabric",
      });

      InventoryService.getFabricStyleInventoryForLotBased(
        criteria,
        this.loadFabricInventoryLotPageResponse,
        this.loadFabricInventoryLotPageError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadFabricInventoryLotPageResponse = (response) => {
    let inquiryList = response.data.result;
    if (inquiryList != null) {
      let skuInventoryList = [];
      if (response.data.result.skuInventoryDataDetails != null) {
        skuInventoryList = response.data.result.skuInventoryDataDetails;
        this.setState({
          skuInventoryList: skuInventoryList,
          inventoryDataList: [],
        });
      }
    }
  };
  loadFabricInventoryLotPageError = (error) => {
    this.setState({ isShowProgressBarPopup: false, progressLoadingText: "" });
    ShowError("loadFabricInventoryLotPageError :" + error);
    this.setFocus();
  };
  readAtsQuantity = (soLine) => {
    let listRequest = new RestFabricStyleATSListRequest();
    let criteria = new AllFabricATSInquiryCriteriaBean();
    let pageInput = new RestPageListBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = soLine.fabricStyleCode;
    criteria.fabricStyleColorCode = soLine.colorCode;

    // listRequest.searchCriteria = criteria;
    // listRequest.pageInput = pageInput;
    // input.skuNumber = soLine.skuNumber;
    // input.locationCode = soLine.locationCode;
    // input.isExcludeNonWarehouseInventory = true;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "read Ats",
    });

    ReportService.getFabricInventoryAndSalesAndPurchaseActivity(
      criteria,
      this.readandSetOnAtsQuantityResponse,
      this.readandSetOnHandQuantityError,
    );
  };
  readandSetOnAtsQuantityResponse = (response) => {
    if (response.data != null && response.data.inquiryResult) {
      let fabricCurrentATS = new Array();

      fabricCurrentATS = response.data.inquiryResult.atsInfos;
      this.setState(
        {
          isFabricCurrentATS: fabricCurrentATS,
        },
        () => {
          this.setState({
            isShowProgressBarPopup: false,
          });
        },
      );
    }
  };
  // getLineDetails = (rowData) => {

  //   let lineDetail = { ...rowData };

  //   const commonState = {
  //     salesOrderLineData: lineDetail,
  //     isShowColorLookup: true,
  //     isShowPopup: true,
  //     isAllowRead: true,
  //     isAllowReadColor: true,
  //     isShowAddButton: false,
  //     showAutoCompleteFabricCodeList: false,
  //     showAutoCompleteColourList: false,  // âœ… add this too
  //   };

  //   if (rowData.isFetched == false) {
  //     this.setState(
  //       { ...commonState, isDisablefabric: false, isDisableColor: false },
  //       () => {

  //         setTimeout(() => {
  //           this.fabricStyleCodeRef.current.focus();
  //         }, 100);
  //       }
  //     );
  //   } else {
  //     this.setState(
  //       { ...commonState, isDisablefabric: true, isDisableColor: true },
  //       () => {

  //         setTimeout(() => {
  //           this.fabricStyleCodeRef.current.focus();
  //         }, 100);
  //       }
  //     );
  //   }

  //   this.readandSetOnHandQuantity(rowData);
  // };
  isFound = (data) => {
    var found = false;
    if (!data.isActive) {
      found = true;
    }
    return found;
  };
  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value.toUpperCase();
    this.state.showAutoCompleteCustomerList = true;
    let tempSalesOrderData = this.state.salesOrderData;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;

    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      const soData = this.state.salesOrderData;
      soData.customerCode = "";
      soData.customerName = "";
      soData.shipToCode = "";
      soData.paymentTermCode = "";
      soData.customerType = "";
      soData.lines = new Array();
      soData.commissions = [];
      let suggestion = [];
      soData.address = new AddressBean();
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        salesOrderLineData: soData,
        customerPageListForAutoCompleteList: suggestion,
        isShowShipToLookup: false,
        isCustomerNotFound: false,
        fabricInventoryList: new Array(),
        salesCommisionDeatils: "",
        isShowAlert: false,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempSalesOrderData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ salesOrderData: tempSalesOrderData });
    // this.readCustomer(customerCode);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomer(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  cSREnterKeyEventHandler = (e) => {
    let temp_salesOrderData = this.state.salesOrderData;
    temp_salesOrderData[e.target.name] = e.target.value;
    this.onCSRCodeChange(e.target.value);
    this.state.showAutoCompleteCSRList = false;
    let showAutoCompleteList = this.state.showAutoCompleteCSRList;
    this.setState({
      salesOrderData: temp_salesOrderData,
      cSRPageListForAutoCompleteList: new Array(),
    });
  };
  salesClerkEnterKeyEventHandler = (e) => {
    this.state.showAutoCompleteSalesClerkList = false;
    let showAutoCompleteList = this.state.showAutoCompleteSalesClerkList;
    let temp_salesOrderData = this.state.salesOrderData;
    temp_salesOrderData[e.target.name] = e.target.value;
    this.onSalesClerkCodeChange(e.target.value);
    this.setState({
      salesOrderData: temp_salesOrderData,
      salesClerkPageListForAutoCompleteList: new Array(),
    });
  };
  shipToEnterKeyEventHandler = (e) => {
    let temp_salesOrderData = this.state.salesOrderData;
    temp_salesOrderData[e.target.name] = e.target.value;
    this.onShipToCodeChange(e.target.value);
    this.setState({
      salesOrderData: temp_salesOrderData,
      shipToPageListForAutoCompleteList: new Array(),
    });
  };
  shipViaEnterKeyEventHandler = (e) => {
    this.state.showAutoCompleteShipViaList = false;
    let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
    let temp_salesOrderData = this.state.salesOrderData;
    temp_salesOrderData[e.target.name] = e.target.value;
    this.onShipViaCodeChange(e.target.value);
    this.setState({
      salesOrderData: temp_salesOrderData,
      shipViaPageListForAutoCompleteList: new Array(),
    });
  };
  paymentTermEnterKeyEventHandler = (e) => {
    this.state.showAutoCompletePaymentTermList = false;
    let showAutoCompleteList = this.state.showAutoCompletePaymentTermList;
    let temp_salesOrderData = this.state.salesOrderData;
    temp_salesOrderData[e.target.name] = e.target.value;
    this.onPaymentTermCodeChange(e.target.value);
    this.setState({
      salesOrderData: temp_salesOrderData,
      paymentTermPageListForAutoCompleteList: new Array(),
    });
  };
  orderTypeEnterKeyEventHandler = (e) => {
    this.state.showAutoCompleteOrderTypeList = false;
    let showAutoCompleteList = this.state.showAutoCompleteOrderTypeList;
    let temp_salesOrderData = this.state.salesOrderData;
    temp_salesOrderData[e.target.name] = e.target.value;
    this.onOrderTypeCodeChange(e.target.value);
    this.setState({
      salesOrderData: temp_salesOrderData,
      orderTypePageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteCustomerList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  displayAutoCompleteOrderTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteOrderTypeList: showAutoCompleteList });
  };
  displayAutoCompleteShipToList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteShipToList: showAutoCompleteList });
  };
  displayAutoCompleteCsrList = (showAutoCompleteCSRList) => {
    this.setState({ showAutoCompleteCSRList: showAutoCompleteCSRList });
  };
  displayAutoCompleteSalesClerkList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSalesClerkList: showAutoCompleteList });
  };
  displayAutoCompletePaymentTermList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePaymentTermList: showAutoCompleteList });
  };
  displayAutoCompleteShipViaList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteShipViaList: showAutoCompleteList });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteList: showAutoCompleteList });
  };
  displayAutoCompleteFabricCodeList = (showAutoCompleteFabricCodeList) => {
    this.setState({
      showAutoCompleteFabricCodeList: showAutoCompleteFabricCodeList,
    });
  };
  displayAutoCompleteColourList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteColourList: showAutoCompleteList });
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.readByCustomerCodeResponse,
        this.readItemByCustomerCodeError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readItemByCustomerCodeError = (error) => {
    ShowError("Error : " + error);
  };

  readCustomerResponse = (response) => {
    let shipTos = [];
    let tempShipTo = [];
    const customerData = response.data.customer;
    if (customerData != null) {
      let summary = customerData.accountSummary;
      this.setState({ customerData: customerData, summaryData: summary });
      this.state.customerData = customerData;

      shipTos = customerData.shipTos;
      const isFound = this.isFound(customerData);
      if (isFound) {
        this.setState({ isCustomerNotFound: true });
        let errMsg = "Customer is InActive";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      } else {
        this.setState({ isCustomerNotFound: false, isShowAlert: false });
      }
      shipTos.forEach((data) => {
        let overAllData = this.flattenAddressField(data);
        tempShipTo.push(overAllData);
      });
      let shipToLookupHandler = new ShipToLookupHandler(
        tempShipTo,
        "Customer ShipTo",
        "ShipToType",
      );

      this.setState({
        shipTos: shipTos,
        isShowShipToLookup: true,
        shipToLookupHandler: shipToLookupHandler,
        isShowShipToLookup: true,
      });

      this.customerSelected();
    } else {
      this.setState({ isCustomerNotFound: true });
    }
  };

  readCustomerResponse_old = (response) => {
    const customerData = response.data.customer;
    if (customerData != null) {
      let summary = customerData.accountSummary;
      this.setState({ customerData: customerData, summaryData: summary });
      const isFound = this.isFound(customerData);
      if (isFound) {
        this.setState({ isCustomerNotFound: true });
        let errMsg = "Customer is InActive";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      } else {
        this.setState({ isCustomerNotFound: false });
      }
      this.customerSelected();
    } else {
      this.setState({ isCustomerNotFound: true });
    }
  };
  readCustomerError = (error) => {
    ShowError("Erro : " + error);
  };
  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      CustomerService.readCustomerWithChildren(
        readrestInput,
        this.readCustomerResponse,
        this.readCustomerError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  customerCleared() {
    let customerData = new CustomerBean();
    let soData = this.state.salesOrderData;
    this.setState({
      customerData: customerData,
    });
  }
  addDays = (date, days) => {
    const _date = new Date(date);
    _date.setDate(_date.getDate() + days);
    return _date;
  };
  setStopDateBasedOnDelivery = (code) => {
    Date.prototype.addDays = function (days) {
      const date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    };
    let customerDeliveries = this.state.customerDeliveries;

    if (!this.state.isTexco) {
      if (!isEmptyString(code)) {
        if (!isEmptyArray(customerDeliveries)) {
          const result = customerDeliveries.filter((ln) => ln.code === code);
          if (!isEmptyArray(result)) {
            const noOfDays = result[0].noOfDays;
            if (noOfDays != null && noOfDays != undefined) {
              const salesOrderData = this.state.salesOrderData;
              // salesOrderData.orderStopDate = new Date().addDays(noOfDays);
              salesOrderData.orderStopDate = this.addDays(
                salesOrderData.orderStartDate,
                noOfDays,
              );
              salesOrderData.orderStopDate =
                salesOrderData.orderStopDate.toLocaleDateString("sv-SE");
              this.setState({
                salesOrderData: salesOrderData,
              });
            }
          }
        }
      } else {
        if (!isEmptyArray(customerDeliveries)) {
          const result = customerDeliveries.filter(
            (ln) => ln.code === DEFAULT_CUSTOMER_DELIVERY_CODE,
          );
          if (!isEmptyArray(result)) {
            const noOfDays = result[0].noOfDays;
            if (noOfDays != null && noOfDays != undefined) {
              const salesOrderData = this.state.salesOrderData;
              // salesOrderData.orderStopDate = new Date().addDays(noOfDays);
              salesOrderData.orderStopDate = this.addDays(
                salesOrderData.orderStartDate,
                noOfDays,
              );
              salesOrderData.orderStopDate =
                salesOrderData.orderStopDate.toLocaleDateString("sv-SE");
              this.setState({
                salesOrderData: salesOrderData,
              });
            }
          }
        }
      }
    }
  };

  customerSelected() {
    let soData = this.state.salesOrderData;
    let customerData = this.state.customerData;
    this.state.showAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    let shipTos = [];
    let tempString = "";
    if (!isEmpty(customerData)) {
      let customerAddress = customerData.address;
      let address = new AddressBean();
      address.address1 = customerAddress.address1;
      address.address2 = customerAddress.address2;
      address.address3 = customerAddress.address3;
      address.address4 = customerAddress.address4;
      address.city = customerAddress.city;
      address.state = customerAddress.state;
      address.country = customerAddress.country;
      address.zip = customerAddress.zip;
      soData.address = customerData.address;
      soData.customerCode = customerData.code;
      soData.customerName = customerData.description;
      soData.paymentTermCode = customerData.paymentTermsCode;
      soData.salesOrderCurrencyCode = customerData.currencyCode;
      soData.companyCurrencyCode = customerData.currencyCode;
      soData.divisionCode = customerData.divisionCode;
      soData.customerDivisionCode = customerData.divisionCode;
      soData.businessDivision = customerData.businessDivision;
      soData.customerType = customerData.customerTypeCode;
      soData.customerDeliveryTypeCode = customerData.customerDeliveryTypeCode;
      if (!isEmpty(soData.billToCode))
        soData.billToCode = customerData.billTos.code;
      // if (!isEmpty(soData.shipToCode))
      //   soData.shipToCode = customerData.shipTos.code;
      if (isEmptyString(soData.billToCode)) soData.billToCode = "B1001";
      // if (isEmptyString(soData.shipToCode))
      soData.shipToCode = "S1001";
      if (isEmptyString(soData.businessDivision))
        soData.businessDivision = "$$$";
      soData.divisionCode = "N/A";
      if (
        !isEmpty(customerData.shipTos) &&
        !isEmptyArray(customerData.shipTos)
      ) {
        shipTos = customerData.shipTos;
      }
      soData.address.address1 = customerAddress.address1;
      soData.address.address2 = customerAddress.address2;
      soData.address.address3 = customerAddress.address3;
      soData.address.city = customerAddress.city;
      soData.address.country = customerAddress.country;
      soData.address.state = customerAddress.state;
      soData.address.zip = customerAddress.zip;
      soData.address.phone1 = customerAddress.phone1;
      soData.address.phone2 = customerAddress.phone2;
      soData.address.mobilePhone = customerAddress.mobilePhone;
      soData.lines = new Array();
      if (soData.lines !== null && soData.lines.length > 0) {
        soData.lines.map((line) => {
          if (isEmptyString(line.customerCode)) {
            line.customerCode = customerData.code;
          }
          if (isEmptyString(line.customerName)) {
            line.customerName = customerData.description;
          }
        });
      }
      soData.taxRequiredFlag = customerData.salesTaxRequiredFlag;
      if (soData.taxRequiredFlag) {
        let taxPercentage = ConfigManager.getSalesTaxPercentage();
        soData.taxPercentage = taxPercentage;
      } else {
        soData.taxPercentage = 0;
      }
      // let shipToLookupHandler = new GenericAttributeLookupHandler(
      //   shipTos,
      //   "Customer ShipTo"
      // );
      // this.setState({ shipToLookupHandler: shipToLookupHandler });

      if (!isEmptyArray(customerData.salesCommissions)) {
        var lineNumber = this.getSalesCommissionMaxLineNumber();
        var displayLineNumber = this.getMaxCommissionLineNumber();

        for (let commision of customerData.salesCommissions) {
          let commissionData = new SalesOrderCommissionBean();
          commissionData.companyCode = this.companyCode;
          commissionData.lineNumber = ++lineNumber;
          commissionData.displayLineNumber = ++displayLineNumber;
          commissionData.salesPersonCode = commision.salesPersonCode;
          commissionData.salesPersonName = commision.salesPersonName;
          commissionData.commissionPercentage = commision.commissionPercentage;
          commissionData.salesOrderNumber = soData.code;
          soData.commissions.push(commissionData);
        }

        //   let primaryCommission = customerData.salesCommissions.find(
        //     (item) => item.primary === true,
        //   );
        //   if (primaryCommission !== null && primaryCommission !== undefined) {
        //     const formattedCommission =
        //       primaryCommission.commissionPercentage.toFixed(2);
        //     const maxNameLength = 12;
        //     let name = "";
        //     if (!isEmptyString(primaryCommission.salesPersonName)) {
        //       name = this.truncateString(
        //         primaryCommission.salesPersonName,
        //         maxNameLength,
        //       );
        //     }

        //     tempString = `${primaryCommission.salesPersonCode} : ${name} : ${formattedCommission} %`;
        //   }
      }
      tempString = this.getSalesCommissionString(customerData.salesCommissions);
    }

    this.setState(
      {
        salesOrderData: soData,
        salesCommisionDeatils: tempString,
        // shipTos: shipTos,
        // isShowShipToLookup: true,
      },
      () => {
        // this.setStopDateBasedOnDelivery(customerData.customerDeliveryTypeCode);
        // this.getShiptToList();
      },
    );
    this.setStopDateBasedOnDelivery(customerData.customerDeliveryTypeCode);
  }
  updateForSalesCommision = (tempString) => {
    this.setState({
      salesCommisionDeatils: tempString,
    });
  };

  getSalesCommissionString = (salesCommissions) => {
    if (!Array.isArray(salesCommissions) || salesCommissions.length === 0) {
      return "";
    }

    const maxNameLength = 12;

    return salesCommissions
      .filter((commission) => !commission.isDeleted) // Ignore deleted lines
      .map((commission) => {
        const formattedCommission = Number(
          commission.commissionPercentage || 0,
        ).toFixed(2);

        const name = !isEmptyString(commission.salesPersonName)
          ? this.truncateString(commission.salesPersonName, maxNameLength)
          : "";

        return `${commission.salesPersonCode} : ${name} : ${formattedCommission} %`;
      })
      .join(", "); // Change separator if needed
  };

  truncateString = (str, maxLength) => {
    return str.length > maxLength ? str.slice(0, maxLength - 1) + "â€¦" : str;
  };

  getShiptToList = () => {
    let soData = this.state.salesOrderData;
    let shipTosearchCriteria = new CustomerShipToSearchCriteria();
    shipTosearchCriteria.companyCode = this.companyCode;
    shipTosearchCriteria.customerCode = soData.customerCode;
    shipTosearchCriteria.customerName = soData.customerName;
    let cust_ShipTo_pageList = new PageListBean();
    let listRequest = new RestCustomerShipToListRequest();
    listRequest.searchCriteria = shipTosearchCriteria;
    listRequest.pageInput = cust_ShipTo_pageList;

    CustomerService.getCustomerShipTosAndAttributeShipTos(
      listRequest,
      this.getShiptToListResponse,
      this.errorCallBack,
    );
  };

  flattenAddressField = (data) => {
    if (data.address && typeof data.address === "object") {
      // Merge address fields into the main object
      const flattened = {
        ...data,
        ...data.address,
      };
      // Remove the nested address object
      delete flattened.address;
      return flattened;
    }
    return data; // Return as-is if no address field
  };

  //   const flattenedData = flattenAddressField(originalData);
  getShiptToListResponse = (response) => {
    let shipTos = [];
    let tempShipTo = [];
    if (response.data != null && response.data.customerShipToPageList != null) {
      if (!isEmptyArray(response.data.customerShipToPageList.customerShipTos)) {
        shipTos = ModuleUtils.isActiveAttribute(
          response.data.customerShipToPageList.customerShipTos,
        );
        shipTos.forEach((data) => {
          let overAllData = this.flattenAddressField(data);
          tempShipTo.push(overAllData);
        });
      }
    }
    let shipToLookupHandler = new ShipToLookupHandler(
      tempShipTo,
      "Customer ShipTo",
      "ShipToType",
    );
    this.setState({
      // shipTos: shipTos,
      // isShowShipToLookup: true,
      // shipToLookupHandler: shipToLookupHandler,
      // isShowShipToLookup: true,
    });
  };

  customerSelected_bkup_09Aug2025() {
    let soData = this.state.salesOrderData;
    let customerData = this.state.customerData;
    this.state.showAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    let shipTos = [];
    if (!isEmpty(customerData)) {
      let customerAddress = customerData.address;
      let address = new AddressBean();
      address.address1 = customerAddress.address1;
      address.address2 = customerAddress.address2;
      address.address3 = customerAddress.address3;
      address.address4 = customerAddress.address4;
      address.city = customerAddress.city;
      address.state = customerAddress.state;
      address.country = customerAddress.country;
      address.zip = customerAddress.zip;
      soData.address = customerData.address;
      soData.customerCode = customerData.code;
      soData.customerName = customerData.description;
      soData.paymentTermCode = customerData.paymentTermsCode;
      soData.salesOrderCurrencyCode = customerData.currencyCode;
      soData.companyCurrencyCode = customerData.currencyCode;
      soData.divisionCode = customerData.divisionCode;
      soData.customerDivisionCode = customerData.divisionCode;
      soData.businessDivision = customerData.businessDivision;
      soData.customerType = customerData.customerTypeCode;
      soData.shipViaCode = customerData.shipViaCode;
      soData.customerDeliveryTypeCode = customerData.customerDeliveryTypeCode;
      if (!isEmpty(soData.billToCode))
        soData.billToCode = customerData.billTos.code;
      if (!isEmpty(soData.shipToCode))
        soData.shipToCode = customerData.shipTos.code;
      if (isEmptyString(soData.billToCode)) soData.billToCode = "B1001";
      if (isEmptyString(soData.shipToCode)) soData.shipToCode = "S1001";
      if (isEmptyString(soData.businessDivision))
        soData.businessDivision = "$$$";
      soData.divisionCode = "N/A";
      if (
        !isEmpty(customerData.shipTos) &&
        !isEmptyArray(customerData.shipTos)
      ) {
        shipTos = customerData.shipTos;
      }
      soData.address.address1 = customerAddress.address1;
      soData.address.address2 = customerAddress.address2;
      soData.address.address3 = customerAddress.address3;
      soData.address.city = customerAddress.city;
      soData.address.country = customerAddress.country;
      soData.address.state = customerAddress.state;
      soData.address.zip = customerAddress.zip;
      soData.address.phone1 = customerAddress.phone1;
      soData.address.phone2 = customerAddress.phone2;
      soData.address.mobilePhone = customerAddress.mobilePhone;
      soData.lines = new Array();
      if (soData.lines !== null && soData.lines.length > 0) {
        soData.lines.map((line) => {
          if (isEmptyString(line.customerCode)) {
            line.customerCode = customerData.code;
          }
          if (isEmptyString(line.customerName)) {
            line.customerName = customerData.description;
          }
        });
      }
      soData.taxRequiredFlag = customerData.salesTaxRequiredFlag;
      if (soData.taxRequiredFlag) {
        let taxPercentage = ConfigManager.getSalesTaxPercentage();
        soData.taxPercentage = taxPercentage;
      } else {
        soData.taxPercentage = 0;
      }
      let shipToLookupHandler = new GenericAttributeLookupHandler(
        shipTos,
        "Customer ShipTo",
      );
      this.setState({ shipToLookupHandler: shipToLookupHandler });
    }

    this.setState({
      salesOrderData: soData,
      shipTos: shipTos,
      isShowShipToLookup: true,
    });
    this.setStopDateBasedOnDelivery(customerData.customerDeliveryTypeCode);
  }
  customerSelected_old() {
    let soData = this.state.salesOrderData;
    let customerData = this.state.customerData;
    this.state.showAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    let shipTos = [];
    if (!isEmpty(customerData)) {
      let customerAddress = customerData.address;
      let address = new AddressBean();
      address.address1 = customerData.address1;
      address.address2 = customerData.address2;
      address.address3 = customerData.address3;
      address.address4 = customerData.address4;
      address.city = customerData.city;
      address.state = customerData.state;
      address.country = customerData.country;
      address.zip = customerData.zip;
      soData.address = customerData.address;
      soData.customerCode = customerData.code;
      soData.customerName = customerData.description;
      soData.paymentTermCode = customerData.paymentTermsCode;
      soData.salesOrderCurrencyCode = customerData.currencyCode;
      soData.companyCurrencyCode = customerData.currencyCode;
      soData.divisionCode = customerData.divisionCode;
      soData.customerDivisionCode = customerData.divisionCode;
      soData.businessDivision = customerData.businessDivision;
      soData.customerType = customerData.customerTypeCode;
      soData.customerDeliveryTypeCode = customerData.customerDeliveryTypeCode;
      if (!isEmpty(soData.billToCode))
        soData.billToCode = customerData.billTos.code;
      if (!isEmpty(soData.shipToCode))
        soData.shipToCode = customerData.shipTos.code;
      if (isEmptyString(soData.billToCode)) soData.billToCode = "B1001";
      if (isEmptyString(soData.shipToCode)) soData.shipToCode = "S1001";
      if (isEmptyString(soData.businessDivision))
        soData.businessDivision = "$$$";
      soData.divisionCode = "N/A";
      if (
        !isEmpty(customerData.shipTos) &&
        !isEmptyArray(customerData.shipTos)
      ) {
        shipTos = customerData.shipTos;
      }
      soData.address.address1 = customerAddress.address1;
      soData.address.address2 = customerAddress.address2;
      soData.address.address3 = customerAddress.address3;
      soData.address.city = customerAddress.city;
      soData.address.country = customerAddress.country;
      soData.address.state = customerAddress.state;
      soData.address.zip = customerAddress.zip;
      soData.address.phone1 = customerAddress.phone1;
      soData.address.phone2 = customerAddress.phone2;
      soData.address.mobilePhone = customerAddress.mobilePhone;
      soData.lines = new Array();
      if (soData.lines !== null && soData.lines.length > 0) {
        soData.lines.map((line) => {
          if (isEmptyString(line.customerCode)) {
            line.customerCode = customerData.code;
          }
          if (isEmptyString(line.customerName)) {
            line.customerName = customerData.description;
          }
        });
      }
      soData.taxRequiredFlag = customerData.salesTaxRequiredFlag;
      if (soData.taxRequiredFlag) {
        let taxPercentage = ConfigManager.getSalesTaxPercentage();
        soData.taxPercentage = taxPercentage;
      } else {
        soData.taxPercentage = 0;
      }
      let shipToLookupHandler = new GenericAttributeLookupHandler(
        shipTos,
        "Customer ShipTo",
      );
      this.setState({ shipToLookupHandler: shipToLookupHandler });
    }

    this.setState({
      salesOrderData: soData,
      shipTos: shipTos,
      isShowShipToLookup: true,
    });
    this.setStopDateBasedOnDelivery(customerData.customerDeliveryTypeCode);
  }
  onChange = (e) => {
    let temp_salesOrderData = this.state.salesOrderData;
    temp_salesOrderData[e.target.name] = e.target.value;
    if (e.target.name == "shipToCode") {
      this.onShipToCodeChange(e.target.value);
    }
    this.setState({ salesOrderData: temp_salesOrderData });
    if (e.target.name == "orderStartDate") {
      this.setStopDateBasedOnDelivery(
        temp_salesOrderData.customerDeliveryTypeCode,
      );
    }
  };
  onOrderTypeChange = (e) => {
    let orderType = e.target.value;
    this.state.showAutoCompleteOrderTypeList = true;
    let temp_salesOrderData = this.state.salesOrderData;
    let showAutoCompleteList = this.state.showAutoCompleteOrderTypeList;
    if (isEmpty(orderType)) {
      this.state.showAutoCompletePaymentTermList = false;
      let showAutoCompleteList = this.state.showAutoCompleteOrderTypeList;
      let soLine = this.state.salesOrderData;
      soLine.orderTypeCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        salesOrderLineData: soLine,
        orderTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && orderType !== "") {
      this.readOrderTypeBySearchString(orderType);
    }
    temp_salesOrderData[e.target.name] = e.target.value;
    this.setState({ salesOrderData: temp_salesOrderData });
    //this.onShipToCodeChange(orderType);
  };
  readOrderTypeBySearchString(searchString) {
    let orderTypeList = this.state.salesOrderTypes;
    let simpleAutoCompleteList = new Array();
    if (orderTypeList.length > 0 && orderTypeList != null) {
      orderTypeList.map((orderTypes) => {
        let simpleItemBean = {
          code: orderTypes.code,
          description: orderTypes.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipToLists) =>
        simpleAutoCompleteShipToLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      orderTypePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  onShipToChange = (e) => {
    let shipTo = e.target.value;
    this.state.showAutoCompleteShipToList = true;
    let temp_salesOrderData = this.state.salesOrderData;
    let showAutoCompleteList = this.state.showAutoCompleteShipToList;
    if (isEmpty(shipTo)) {
      this.state.showAutoCompleteShipToList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipToList;
      let soLine = this.state.salesOrderData;
      soLine.shipToCode = "";
      soLine.shipToName = "";
      soLine.shipViaCode = "";
      let suggestion = [];
      this.setState(
        {
          showAutoCompleteList: showAutoCompleteList,
          salesOrderLineData: soLine,
          shipToPageListForAutoCompleteList: suggestion,
        },
        () => {
          this.onShipToCodeChange(shipTo);
        },
      );
    } else if (showAutoCompleteList === true && shipTo !== "") {
      this.readShipToBySearchString(shipTo);
    }
    temp_salesOrderData[e.target.name] = e.target.value;
    this.setState({ salesOrderData: temp_salesOrderData });
  };
  readShipToBySearchString(searchString) {
    let shipToData = this.state.shipTos;
    let simpleAutoCompleteList = new Array();
    if (shipToData.length > 0 && shipToData != null) {
      shipToData.map((shipTos) => {
        let simpleItemBean = {
          code: shipTos.code,
          description: shipTos.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipToLists) =>
        simpleAutoCompleteShipToLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ shipToPageListForAutoCompleteList: filteredSuggestions });
  }
  onPaymentTermChange = (e) => {
    let paymentTerm = e.target.value;
    this.state.showAutoCompletePaymentTermList = true;
    let temp_salesOrderData = this.state.salesOrderData;
    let showAutoCompleteList = this.state.showAutoCompletePaymentTermList;
    if (isEmpty(paymentTerm)) {
      this.state.showAutoCompletePaymentTermList = false;
      let showAutoCompleteList = this.state.showAutoCompletePaymentTermList;
      let soLine = this.state.salesOrderData;
      soLine.paymentTermCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        salesOrderLineData: soLine,
        paymentTermPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && paymentTerm !== "") {
      this.readpaymentTermBySearchString(paymentTerm);
    }
    temp_salesOrderData[e.target.name] = e.target.value;
    this.setState({ salesOrderData: temp_salesOrderData });
    this.onPaymentTermCodeChange(paymentTerm);
  };
  readpaymentTermBySearchString(searchString) {
    let paymentTermData = this.state.paymentTerms;
    let simpleAutoCompleteList = new Array();
    if (paymentTermData.length > 0 && paymentTermData != null) {
      paymentTermData.map((paymentTerms) => {
        let simpleItemBean = {
          code: paymentTerms.code,
          description: paymentTerms.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipToLists) =>
        simpleAutoCompleteShipToLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      paymentTermPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  onCSRChange = (e) => {
    let cSR = e.target.value;
    this.state.showAutoCompleteCSRList = true;
    let temp_salesOrderData = this.state.salesOrderData;
    let showAutoCompleteCSRList = this.state.showAutoCompleteCSRList;
    if (isEmpty(cSR)) {
      this.state.showAutoCompleteCSRList = false;
      let showAutoCompleteCSRList = this.state.showAutoCompleteCSRList;
      let soLine = this.state.salesOrderLineData;
      soLine.salesRepresentativeCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCSRList: showAutoCompleteCSRList,
        salesOrderLineData: soLine,
        cSRPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteCSRList === true && cSR !== "") {
      this.readCSRBySearchString(cSR);
    }
    temp_salesOrderData[e.target.name] = e.target.value;
    this.setState({ salesOrderData: temp_salesOrderData });
    this.onCSRCodeChange(cSR);
  };
  readCSRBySearchString(searchString) {
    let cSRData = this.state.customerRepresentatives;
    let simpleAutoCompleteList = new Array();
    if (cSRData.length > 0 && cSRData != null) {
      cSRData.map((cSRs) => {
        let simpleItemBean = { code: cSRs.code, description: cSRs.description };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteCSRLists) =>
        simpleAutoCompleteCSRLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ cSRPageListForAutoCompleteList: filteredSuggestions });
  }
  onSalesClerkChange = (e) => {
    let salesClerk = e.target.value;
    this.state.showAutoCompleteSalesClerkList = true;
    let temp_salesOrderData = this.state.salesOrderData;
    let showAutoCompleteList = this.state.showAutoCompleteSalesClerkList;
    if (isEmpty(salesClerk)) {
      this.state.showAutoCompleteSalesClerkList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesClerkList;
      let soLine = new SalesOrderBean();
      soLine.salesClerkCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        salesOrderLineData: soLine,
        salesClerkPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && salesClerk !== "") {
      this.readSalesClerkBySearchString(salesClerk);
    }
    temp_salesOrderData[e.target.name] = e.target.value;
    this.setState({ salesOrderData: temp_salesOrderData });
    this.onSalesClerkCodeChange(salesClerk);
  };
  readSalesClerkBySearchString(searchString) {
    let salesClerkData = this.state.salesClerks;
    let simpleAutoCompleteList = new Array();
    if (salesClerkData.length > 0 && salesClerkData != null) {
      salesClerkData.map((salesClerks) => {
        let simpleItemBean = {
          code: salesClerks.code,
          description: salesClerks.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteSalesClerkLists) =>
        simpleAutoCompleteSalesClerkLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      salesClerkPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  onShipViaChange = (e) => {
    let shipVia = e.target.value;
    this.state.showAutoCompleteShipViaList = true;
    let temp_salesOrderData = this.state.salesOrderData;
    let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
    if (isEmpty(shipVia)) {
      this.state.showAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
      let soLine = this.state.salesOrderData;
      soLine.shipViaCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        salesOrderLineData: soLine,
        shipViaPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipVia !== "") {
      this.readShipViaBySearchString(shipVia);
    }
    temp_salesOrderData[e.target.name] = e.target.value;
    this.setState({ salesOrderData: temp_salesOrderData });
    this.onShipViaCodeChange(shipVia);
  };
  readShipViaBySearchString(searchString) {
    let shipViaData = this.state.shipVias;
    let simpleAutoCompleteList = new Array();
    if (shipViaData.length > 0 && shipViaData != null) {
      shipViaData.map((shipVias) => {
        let simpleItemBean = {
          code: shipVias.code,
          description: shipVias.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipViaLists) =>
        simpleAutoCompleteShipViaLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ shipViaPageListForAutoCompleteList: filteredSuggestions });
  }
  readItemByCustomerCodeError = (error) => {
    ShowError("Error : " + error);
  };
  onPaymentTermCodeChange = (paymentTermCode) => {
    let shipToBean = null;
    this.state.paymentTerms.map((ln) => {
      if (ln.code === paymentTermCode) {
        shipToBean = ln;
      }
    });
    if (!isEmpty(shipToBean)) {
      let temp_salesOrderData = this.state.salesOrderData;
      temp_salesOrderData.paymentTermCode = shipToBean.code;
      this.state.showAutoCompletePaymentTermList = false;
      let showAutoCompleteList = this.state.showAutoCompletePaymentTermList;
      this.setState({
        salesOrderData: temp_salesOrderData,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
  };
  onShipViaCodeChange = (shipViaCode) => {
    let shipToBean = null;
    this.state.shipVias.map((ln) => {
      if (ln.code === shipViaCode) {
        shipToBean = ln;
      }
    });
    if (!isEmpty(shipToBean)) {
      let temp_salesOrderData = this.state.salesOrderData;
      temp_salesOrderData.shipViaCode = shipToBean.code;
      this.state.showAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
      this.setState({
        salesOrderData: temp_salesOrderData,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
  };
  onOrderTypeCodeChange = (orderTypeCode) => {
    let shipToBean = null;
    const salesOrderTypes = this.state.salesOrderTypes;
    if (!isEmptyArray(salesOrderTypes))
      salesOrderTypes.map((ln) => {
        if (ln.code === orderTypeCode) {
          shipToBean = ln;
        }
      });
    if (!isEmpty(shipToBean)) {
      let temp_salesOrderData = this.state.salesOrderData;
      temp_salesOrderData.orderTypeCode = shipToBean.code;
      this.state.showAutoCompleteOrderTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteOrderTypeList;
      this.setState({
        salesOrderData: temp_salesOrderData,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
  };
  onCSRCodeChange = (salesRepresentativeCode) => {
    let shipToBean = null;
    this.state.customerRepresentatives.map((ln) => {
      if (ln.code === salesRepresentativeCode) {
        shipToBean = ln;
      }
    });
    if (!isEmpty(shipToBean)) {
      let temp_salesOrderData = this.state.salesOrderData;
      temp_salesOrderData.salesRepresentativeCode = shipToBean.code;
      this.setState({
        salesOrderData: temp_salesOrderData,
      });
    }
  };
  onSalesClerkCodeChange = (salesClerkCode) => {
    let shipToBean = null;
    this.state.salesClerks.map((ln) => {
      if (ln.code === salesClerkCode) {
        shipToBean = ln;
      }
    });
    if (!isEmpty(shipToBean)) {
      let temp_salesOrderData = this.state.salesOrderData;
      temp_salesOrderData.salesClerkCode = shipToBean.code;
      this.setState({
        salesOrderData: temp_salesOrderData,
      });
    }
  };
  onShipToCodeChange = (shipToCode) => {
    let shipToBean = null;
    this.state.shipTos.map((ln) => {
      if (ln.code === shipToCode) {
        shipToBean = ln;
      }
    });
    let address = new AddressBean();
    let temp_salesOrderData = this.state.salesOrderData;

    if (!isEmpty(shipToBean)) {
      temp_salesOrderData.shipToCode = shipToBean.code;
      temp_salesOrderData.shipToName = shipToBean.description;
      // temp_salesOrderData.billToCode = shipToBean.billToCode;
      temp_salesOrderData.shipViaCode = shipToBean.shipViaCode;
      if (!isEmpty(shipToBean.address)) {
        // let address = new AddressBean();
        address.address1 = shipToBean.address.address1;
        address.address1 = shipToBean.address.address1;
        address.address2 = shipToBean.address.address2;
        address.address3 = shipToBean.address.address3;
        address.city = shipToBean.address.city;
        address.country = shipToBean.address.country;
        address.state = shipToBean.address.state;
        address.zip = shipToBean.address.zip;
        address.phone1 = shipToBean.address.phone1;
        address.phone2 = shipToBean.address.phone2;
        address.mobilePhone = shipToBean.address.mobilePhone;
        address.email = shipToBean.address.email;
        address.website = shipToBean.address.website;
      }

      // this.state.showAutoCompleteShipToList = false;
      // let showAutoCompleteList = this.state.showAutoCompleteShipToList;
      // this.state.showAutoCompleteOrderTypeList = false;
      // let showAutoCompleteOrderTypeList =
      //   this.state.showAutoCompleteOrderTypeList;
    }
    temp_salesOrderData.address = address;
    this.setState({
      salesOrderData: temp_salesOrderData,
      showAutoCompleteShipToList: false,
      showAutoCompleteOrderTypeList: false,
    });
  };

  onHeaderAmountsChange = (e) => {
    let temp_salesOrderData = this.state.salesOrderData;
    temp_salesOrderData[e.target.name] = e.target.value;
    this.setState({ salesOrderData: temp_salesOrderData });
    this.state.salesOrderData = temp_salesOrderData;
    this.calculateGrandTotal();
  };
  onSalesOrderLineTableChange = (e, line) => {
    let temp_salesOrderData = this.state.salesOrderData;
    temp_salesOrderData.lines.map((ln) => {
      let isEditable = this.isEditPosible(ln);
      if (isEditable) {
        if (ln.skuNumber === line.skuNumber) {
          ln[e.target.name] = e.target.value;
          this.calculateLineTotal(ln);
        }
      }
    });
    this.state.salesOrderData = temp_salesOrderData;
  };
  isEditPosible = (inputLine) => {
    if (this.state.isTexco) {
      if (this.state.isInvoiceAvailable) {
        return false;
      } else {
        return true;
      }
    } else {
      if (LogicConstants.SALES_ORDER_LINE_OPEN_STATUS == inputLine.lineStatus) {
        return true;
      }
    }
  };
  onSalesOrderLineTableInputBlur = (e, line) => {
    this.calculateGrandTotal();
  };
  onCommissionChange = (e) => {
    let temp_salesCommissionData = this.state.salesCommissionData;
    temp_salesCommissionData[e.target.name] = e.target.value;
    if (e.target.name == "salesPersonCode") {
      if (!isEmptyArray(this.state.salesPersonList)) {
        this.state.salesPersonList.map((line) => {
          if (line.code === e.target.value) {
            temp_salesCommissionData.salesPersonName = line.description;
          }
        });
      }
    }
    this.setState({ salesCommissionData: temp_salesCommissionData });
  };
  validateCommission = (commission) => {
    let isValidCommission = false;
    let err_list = [];
    let errorMessage = "";
    if (commission == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(commission.salesPersonCode)) {
        let errMsg = "salesPerson is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(commission.salesPersonName)) {
        let errMsg = "SalesPersonName is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (commission.commissionPercentage == 0) {
        let errMsg = "CommissionPercentage is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      } else if (commission.commissionPercentage <= 0) {
        let errMsg = "CommissionPercentage is inValid";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
      isValidCommission = false;
      this.setState({ errorList: err_list });
    } else {
      isValidCommission = true;
    }
    return isValidCommission;
  };
  // getMaxCommissionLineNumber = () => {
  //   let maxCommissionLineNumber = 0;
  //   let salesOrderData = this.state.salesOrderData;
  //   if (!isEmpty(salesOrderData) && !isEmptyArray(salesOrderData.commissions)) {
  //     salesOrderData.commissions.map((line) => {
  //       if (line.displayLineNumber > maxCommissionLineNumber) {
  //         maxCommissionLineNumber = line.displayLineNumber;
  //       }
  //     });
  //   }
  //   return maxCommissionLineNumber;
  // };
  onAddorUpdateCommissionClick = (e) => {
    if (e.detail == 1) {
      const salesOrderData = { ...this.state.salesOrderData };
      let commissions = [];
      if (!isEmptyArray(this.state.salesOrderData.commissions))
        commissions = [...this.state.salesOrderData.commissions];
      const salesCommissionData = { ...this.state.salesCommissionData };
      salesCommissionData.companyCode = this.companyCode;
      let isValid = false;
      isValid = this.validateCommission(salesCommissionData);
      if (isValid) {
        let isLineFound = false;
        //   var lineNumber = this.getMaxCommissionLineNumber();
        let lineNumber = this.getSalesCommissionMaxLineNumber();
        let displayLineNumber = this.getMaxCommissionLineNumber();
        if (!isEmptyArray(commissions))
          commissions.map((line, i) => {
            if (line.salesPersonCode == salesCommissionData.salesPersonCode) {
              salesCommissionData.lineNumber = line.lineNumber;
              salesCommissionData.displayLineNumber = line.displayLineNumber;
              salesCommissionData.isFetched = line.isFetched;
              commissions[i] = salesCommissionData;
              isLineFound = true;
            }
          });
        if (!isLineFound) {
          salesCommissionData.lineNumber = ++lineNumber;
          //salesCommissionData.displayLineNumber = ++lineNumber;
          salesCommissionData.displayLineNumber = ++displayLineNumber;
          commissions.push(salesCommissionData);
        }
        salesOrderData.commissions = commissions;
        this.setState({ salesOrderData: salesOrderData });
      }
      this.onClearCommissionClick();
    }
  };
  onAddorUpdateCommissionClick_old = () => {
    let salesCommissionData = this.state.salesCommissionData;
    let isValidCommission = true;
    isValidCommission = this.validateCommission(salesCommissionData);
    if (isValidCommission) {
      let salesOrderData = this.state.salesOrderData;
      if (isEmptyArray(salesOrderData.commissions))
        salesOrderData.commissions = new Array();
      let existingLine = this.getSalesCommissionBySalesPerson(
        salesCommissionData.lineNumber,
      );
      if (existingLine === null) {
        var lineNumber = this.getSalesCommissionMaxLineNumber();
        salesCommissionData.lineNumber = ++lineNumber;
        salesOrderData.commissions.push(salesCommissionData);
      } else {
        const index = salesOrderData.commissions.findIndex(
          (ln) => ln.salesPersonCode === existingLine.salesPersonCode,
        );
        if (index != -1) {
          salesOrderData.commissions.splice(index, 1);
          salesOrderData.commissions.push(salesCommissionData);
        }
      }
      this.setState({ salesOrderData: salesOrderData });
      this.onClearCommissionClick();
    }
  };
  getSalesCommissionLineDetails = (val, rowData) => {
    let salesOrderData = this.state.salesOrderData;
    let salesCommissionData = new SalesOrderCommissionBean();
    salesCommissionData = { ...rowData };
    this.setState({ salesCommissionData: salesCommissionData });
  };

  onClearCommissionClick = () => {
    let salesCommissionData = new SalesOrderCommissionBean();
    this.setState({ salesCommissionData: salesCommissionData });
  };

  onSalesPersonCodeChange = (e) => {
    let salesPersonCode = e.target.value;
    this.state.showAutoCompleteSalesPersonList = true;
    let temp_salesCommissionData = this.state.salesCommissionData;
    let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
    if (isEmpty(salesPersonCode)) {
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      let temp_salesCommissionData = this.state.salesCommissionData;
      temp_salesCommissionData.salesPersonCode = "";
      temp_salesCommissionData.salesPersonName = "";
      temp_salesCommissionData.commissionPercentage = 0;
      let suggestion = [];
      this.setState({
        showAutoCompleteSalesPersonList: showAutoCompleteList,
        salesCommissionData: temp_salesCommissionData,
        salesPersonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && salesPersonCode !== "") {
      this.readSalesPersonCodeBySearchString(salesPersonCode);
    }
    if (e.target.name == "salesPersonCode") {
      temp_salesCommissionData["salesPersonCode"] = e.target.value;
      let salesPersonCode_List = this.state.salesPersonList;
      salesPersonCode_List.map((salesPersonCode) => {
        if (salesPersonCode.code == e.target.value) {
          temp_salesCommissionData["salesPersonCode"] = salesPersonCode.code;
          temp_salesCommissionData["salesPersonName"] =
            salesPersonCode.description;
        }
      });
    }
    this.setState({ salesCommissionData: temp_salesCommissionData });
  };
  readSalesPersonCodeBySearchString(searchString) {
    this.state.showAutoCompleteSalesPersonList = true;
    let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
    this.setState({ showAutoCompleteSalesPersonList: showAutoCompleteList });
    let salesPersonData = this.state.salesPersonList;
    let simpleAutoCompleteList = new Array();
    if (salesPersonData.length > 0 && salesPersonData != null) {
      salesPersonData.map((salesPersonDatas) => {
        let simpleItemBean = {
          code: salesPersonDatas.code,
          description: salesPersonDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteSalesPersonLists) =>
        simpleAutoCompleteSalesPersonLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      salesPersonPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  salesPersonEnterKeyEvent = (e) => {
    let temp_salesCommissionData = this.state.salesCommissionData;
    let salesPersonCode = e.target.value;
    temp_salesCommissionData["salesPersonCode"] = e.target.value;
    let salesPersonCode_List = this.state.salesPersonList;
    let salesPersonCodeBean = null;
    salesPersonCode_List.map((salesPersonCode) => {
      if (salesPersonCode.code == e.target.value) {
        salesPersonCodeBean = salesPersonCode;
      }
    });
    if (!isEmpty(salesPersonCodeBean)) {
      let temp_salesCommissionData = this.state.salesCommissionData;
      temp_salesCommissionData.salesPersonCode = salesPersonCodeBean.code;
      temp_salesCommissionData.salesPersonName =
        salesPersonCodeBean.description;
      temp_salesCommissionData.commissionPercentage =
        salesPersonCodeBean.commissionPercentage;
      this.setState({
        salesCommissionData: temp_salesCommissionData,
        salesPersonPageListForAutoCompleteList: new Array(),
      });
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      this.setState({ showAutoCompleteSalesPersonList: showAutoCompleteList });
    }
  };
  displayAutoCompleteSalesPersonList = (showAutoCompleteSalesPersonList) => {
    this.setState({
      showAutoCompleteSalesPersonList: showAutoCompleteSalesPersonList,
    });
  };
  getImageURL = () => {
    const { appData } = this.context;
    let serviceURL = appData.serviceURL;
    let imageURL = serviceURL + "/orderimages?file=";
    return imageURL;
  };
  getDocURL = () => {
    const { appData } = this.context;
    return appData.serviceURL + "/" + "salesOrderdocs?file=";
    // return appData.serviceURL + "/" + process.env.REACT_APP_ITEM_DOC_PATH;
  };
  getSalesCommissionBySalesPerson = (salesPerson) => {
    let salesCommission = null;
    if (this.state.salesOrderData === null) return salesCommission;
    else if (this.state.salesOrderData.commissions === null)
      return salesCommission;
    else {
      this.state.salesOrderData.commissions.map((line) => {
        // if (line.lineNumber === salesPerson) {
        //   salesCommission = line;
        //   return salesCommission;
        // }
        if (line.salesPersonCode === salesPerson) {
          salesCommission = line;
          return salesCommission;
        }
      });
    }
    return salesCommission;
  };
  onAddressChange = (e) => {
    let temp_salesOrderData = this.state.salesOrderData;
    let tempAddress = new AddressBean();
    if (
      !isEmpty(temp_salesOrderData) &&
      !isEmpty(temp_salesOrderData.address)
    ) {
      tempAddress = temp_salesOrderData.address;
      tempAddress[e.target.name] = e.target.value;
    }
    temp_salesOrderData.address = tempAddress;
    this.setState({ salesOrderData: temp_salesOrderData });
  };
  onNodeShipToChange = (e) => {
    let shipTo = e.target.value;
    this.state.showAutoCompleteShipToNodeList = true;
    let temp_salesOrderData = this.state.salesOrderData;
    let showAutoCompleteList = this.state.showAutoCompleteShipToNodeList;
    if (isEmpty(shipTo)) {
      this.state.showAutoCompleteShipToNodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipToNodeList;
      let temp_salesOrderData = this.state.salesOrderData;
      temp_salesOrderData.shipToCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteShipToNodeList: showAutoCompleteList,
        salesOrderLineData: temp_salesOrderData,
        shipToNodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipTo !== "") {
      this.readShipToNodeBySearchString(shipTo);
    }
    temp_salesOrderData[e.target.name] = e.target.value;
    this.setState({ salesOrderData: temp_salesOrderData });
    this.onShipToCodeChange(shipTo);
  };
  readShipToNodeBySearchString(searchString) {
    let shipToNodeData = this.state.shipTos;
    let simpleAutoCompleteList = new Array();
    if (shipToNodeData.length > 0 && shipToNodeData != null) {
      shipToNodeData.map((shipToNodes) => {
        let simpleItemBean = {
          code: shipToNodes.code,
          description: shipToNodes.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipToNodeLists) =>
        simpleAutoCompleteShipToNodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      shipToNodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  shipToNodeEnterKeyEventHandler = (e) => {
    let temp_salesOrderData = this.state.salesOrderData;
    temp_salesOrderData[e.target.name] = e.target.value;
    this.onShipToCodeChange(e.target.value);
    this.setState({
      salesOrderData: temp_salesOrderData,
      shipToNodePageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteShipToNodeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteShipToNodeList: showAutoCompleteList });
  };
  moduleExit = () => {
    let salesOrderData = this.state.salesOrderData;
    if (salesOrderData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unlockSalesOrder(salesOrderData.code);
      } else {
        this.isLocked = false;
      }
      // this.unlockSalesOrder(salesOrderData.code);
      this.props.onModuleExit();
    }
    this.hideAlertCallBack(false);
  };
  clearError = () => {
    this.clearErrors();
  };
  generatePDFResponse = (response) => {
    this.setState({
      isLoading: false,
    });
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    //   let downloadUrl = this.report_url + reportFilePath + "&is_attachment=true";
    
    // window.open(downloadUrl);
    }
  };



  generatePDFError = (error) => {
    this.setState({ isLoading: false });
    ShowError("Erro : " + error);
  };
  generatePDF = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating PDF ..",
    });
    let soData = this.state.salesOrderData;
    if (SecurityAccessManager.SalesOrderPrintReport_IsAccessible()) {
      ReportService.generateSalesOrderPrintReport(
        soData,
        this.generatePDFResponse,
        this.generatePDFError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  clearErrors = () => {
    let errList = [];
    this.setState({ errorList: errList });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ errorList: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let successMsg = [];
      let infoMsg = "";
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription),
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handlePopupResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: false,
        isShowMailAlert: true,
        isShowPtAdvPopupAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription),
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
        isShowMailAlert: false,
        isShowPtAdvPopupAlert: false,
      });
      success = true;
    }
    return success;
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowMailAlert: true,
        isShowPtAdvPopupAlert: true,
        //  isShowPopupAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription),
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
        isShowMailAlert: false,
      });
      success = true;
    }
    return success;
  };
  handleApproveResponse = (response) => {
    let success = false;
    let infoMsg = "";
    let errMsg = "";
    let errList = [];
    if (!isEmpty(response.mainOperationResponse)) {
      if (!isEmptyArray(response.mainOperationResponse.errors)) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );
        success = false;
      }
      if (!isEmptyArray(response.mainOperationResponse.infos)) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription),
        );
        success = true;
      }
    }
    if (!isEmpty(response.additionalOperationResponse)) {
      if (!isEmptyArray(response.additionalOperationResponse.errors)) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );
        success = false;
      }
      if (!isEmptyArray(response.additionalOperationResponse.infos)) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription),
        );
        success = true;
      }
    }
    if (!isEmptyArray(errList) && errList.length > 0) success = false;
    if (!isEmptyString(infoMsg) && !isEmptyString(errMsg)) {
      let msg = infoMsg + errMsg;
      let successMsg = [];
      successMsg.push(msg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(infoMsg)) {
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(errMsg)) {
      let errorMsg = [];
      errorMsg.push(errMsg);
      this.setState({
        alertMessage: errorMsg,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({ error_list: errList });
    return success;
  };
  handlePickTicketResponse = (response) => {
    let success = false;
    let infoMsg = "";
    let errMsg = "";
    let errList = [];
    if (!isEmpty(response.pickTicketResponse)) {
      if (!isEmptyArray(response.pickTicketResponse.errors)) {
        response.pickTicketResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );
        success = false;
      }
      if (!isEmptyArray(response.pickTicketResponse.infos)) {
        response.pickTicketResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription),
        );
        success = true;
      }
    }
    if (!isEmpty(response.pickTicketPrintReportResponse)) {
      if (!isEmptyArray(response.pickTicketPrintReportResponse.errors)) {
        response.pickTicketPrintReportResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );
        success = false;
      }
      if (!isEmptyArray(response.pickTicketPrintReportResponse.infos)) {
        response.pickTicketPrintReportResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription),
        );
        success = true;
      }
    }
    if (!isEmptyArray(errList) && errList.length > 0) success = false;
    if (!isEmptyString(infoMsg) && !isEmptyString(errMsg)) {
      let msg = infoMsg + errMsg;
      let successMsg = [];
      successMsg.push(msg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(infoMsg)) {
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(errMsg)) {
      let errorMsg = [];
      errorMsg.push(errMsg);
      this.setState({
        alertMessage: errorMsg,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({ error_list: errList });
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
    });
    return success;
  };
  filterSalesOrder = () => {
    this.loadPage(1);
  };
  resetFilteredSalesOrder = (criteria) => {
    criteria = new SalesOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.salesOrderCriteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };
  //#region Node Details
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let emptyObject = this.getEmptyView();
    let headerNode = new NodeData(
      "headerView",
      "Header",
      emptyObject,
      <AlignStartVertical size={16} />,
    );
    let soData = this.state.salesOrderData;
    let shipToandAddressNode = new NodeData(
      "shipToandAddressView",
      "ShipTo & Address",
      emptyObject,
      <Home size={16} />,
    );
    let commissionNode = new NodeData(
      "commissionView",
      "Commission",
      emptyObject,
      <DollarSign size={16} />,
    );
    let documentsNode = new NodeData(
      "documentsView",
      "Documents",
      emptyObject,
      <FolderOpen size={16} />,
    );
    let imageNode = new NodeData(
      "imageView",
      "Image",
      emptyObject,
      <ImageIcon size={16} />,
    );
    let multipleDocumentNode = new NodeData(
      "multipleDocumentView",
      "MultipleDocuments",
      emptyObject,
      <Copy size={16} />,
    );
    let webNode = new NodeData(
      "webOrderView",
      "Web Order Details",
      emptyObject,
      <Globe size={16} />,
    );
    let notesNode = new NodeData(
      "notesView",
      "Notes",
      emptyObject,
      <FileText size={16} />,
    );
    let lineDetailNode = new NodeData(
      "lineDetailView",
      "Line Details",
      emptyObject,
      <LayoutList size={16} />,
    );
    let purchaseOrdersNode = new NodeData(
      "purchaseOrdersView",
      "PO's",
      emptyObject,
      <ShoppingCart size={16} />,
    );
    let pickTicketsandInvoicesNode = new NodeData(
      "pickTicketsandInvoicesView",
      "PickTickets & Invoices",
      emptyObject,
      <Ticket size={16} />,
    );
    let changesHistoryNode = new NodeData(
      "changesHistoryView",
      "ChangesHistory",
      emptyObject,
      <History size={16} />,
    );
    nodeList["headerView"] = headerNode;
    nodeList["lineDetailView"] = lineDetailNode;
    nodeList["commissionView"] = commissionNode;
    nodeList["notesView"] = notesNode;
    nodeList["shipToandAddressView"] = shipToandAddressNode;
    if (soData.isFetched) {
      if (soData.orderStatus != LogicConstants.SALES_ORDER_UNAPPROVE_STATUS) {
        nodeList["webOrderView"] = webNode;
      }
      // nodeList["documentsView"] = documentsNode;
      // if (this.state.isTexco) {
      nodeList["imageView"] = imageNode;
      nodeList["multipleDocumentView"] = multipleDocumentNode;
      //  }
      nodeList["purchaseOrdersView"] = purchaseOrdersNode;
      nodeList["pickTicketsandInvoicesView"] = pickTicketsandInvoicesNode;
      nodeList["changesHistoryView"] = changesHistoryNode;
    }
    this.setState({ nodeList: nodeList });
  };

  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode }, () => {
      if (selectedNode == "headerView") {
        this.setSalesOrderHeaderView();
      } else if (selectedNode == "shipToandAddressView") {
        this.setShipToandAddressView();
      } else if (selectedNode == "commissionView") {
        this.setCommissionView();
      } else if (selectedNode == "webOrderView") {
        this.setWebOrderView();
      }
      // else if (selectedNode == "documentsView") {
      //   this.setDocumentsView();
      // }
      else if (selectedNode == "imageView") {
        this.setImageView();
      } else if (selectedNode == "multipleDocumentView") {
        this.setMultipleDocumentView();
      } else if (selectedNode == "notesView") {
        this.setNotesView();
      } else if (selectedNode == "purchaseOrdersView") {
        this.setPurchaseOrdersView();
      } else if (selectedNode == "pickTicketsandInvoicesView") {
        this.setPickTicketsandInvoicesView();
      } else if (selectedNode == "changesHistoryView") {
        this.setChangesHistoryView();
      } else if (selectedNode == "lineDetailView") {
        this.setLineDetailView();
      }
    });
  };
  setLineDetailView = () => {
    this.closeAllNodeViews();
    this.setState({
      // isShowSaveButton: true,
      isShowBackButton: false,
      isSalesLineDetailFormOpened: true,
    });
  };
  setSalesOrderHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      // isShowSaveButton: true,
      isShowBackButton: false,
      isEntryFormOpen: true,
    });
  };

  setShipToandAddressView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowBackButton: false,
      isShipToAddressFormOpened: true,
    });
  };

  setCommissionView = () => {
    this.closeAllNodeViews();
    this.setState({
      // isShowSaveButton: true,
      isShowBackButton: false,
      isCommissionFormOpened: true,
      selectedNodeKey: "commissionView",
    });
  };

  setWebOrderView = () => {
    this.closeAllNodeViews();
    this.setState({
      // isShowSaveButton: true,
      isShowBackButton: false,
      isWebOrderOpen: true,
    });
  };
  // setDocumentsView = () => {
  //   this.closeAllNodeViews();
  //   this.setState({
  //     isDocumentsFormOpened: true,
  //     isShowBackButton: false,
  //   });
  // };
  setImageView = () => {
    this.closeAllNodeViews();
    this.setState({
      isImageFormOpened: true,
      isShowBackButton: false,
    });
  };
  setMultipleDocumentView = () => {
    this.closeAllNodeViews();
    this.setState({
      isMultipleDocFormOpened: true,
      isShowBackButton: false,
    });
  };
  setNotesView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowBackButton: false,
      isNotesFormOpened: true,
    });
  };

  setPurchaseOrdersView = () => {
    this.closeAllNodeViews();
    this.getandSetPurchaseOrdersDetails();
    this.setState({
      isShowBackButton: false,
      isPurchaseOrdersFormOpened: true,
    });
  };
  setPickTicketsandInvoicesView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowBackButton: false,
      isPickTicketsandInvoicesFormOpened: true,
    });
  };
  setChangesHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isChangesHistoryFormOpened: true,
      isShowBackButton: false,
    });
  };

  closeAllNodeViews = () => {
    this.setState({
      isEntryFormOpen: false,
      isListFormOpen: false,
      isShipToAddressFormOpened: false,
      isCommissionFormOpened: false,
      isDocumentsFormOpened: false,
      isImageFormOpened: false,
      isNotesFormOpened: false,
      isPurchaseOrdersFormOpened: false,
      isPickTicketsandInvoicesFormOpened: false,
      isChangesHistoryFormOpened: false,
      isSalesLineDetailFormOpened: false,
      isWebOrderOpen: false,
      isMultipleDocFormOpened: false,
    });
  };

  editSalesOrderResponse = (response) => {
    let errMsg = "";
    let tempSalesCommission = "";
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.salesOrderResponse != null) {
      if (response.data.salesOrderResponse.errors != null) {
        response.data.salesOrderResponse.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }
    if (errMsg != "Sales Order [" + this.state.moduleKeyCode + "] NOT read!") {
      this.showErrorMessage(response.data.salesOrderResponse);
    }
    if (response.data.success == true) {
      this.setState({
        isLoading: false,
        loadingText: "",
        isDisableFields: false,
      });
      if (
        response.data.salesOrderResponse != null &&
        response.data.salesOrderResponse.salesOrder != null
      ) {
        const salesOrder = response.data.salesOrderResponse.salesOrder;
        let isDisableFields = false;
        let isDisableFieldUnApprove = false;

        let pageTitle = this.state.moduleCaption + " - EDIT";
        this.setState({
          isLoading: false,
        });
        if (salesOrder !== null) {
          let moduleKeyCode = salesOrder.code;

          if (
            salesOrder.orderStatus ==
            LogicConstants.SALES_ORDER_PARTIALLY_INVOICED_STATUS ||
            salesOrder.orderStatus ==
            LogicConstants.SALES_ORDER_INVOICED_STATUS ||
            salesOrder.orderStatus == LogicConstants.SALES_ORDER_CANCEL_STATUS
          ) {
            isDisableFields = true;
            pageTitle = this.state.moduleCaption + " - VIEW";
          }
          // if (!this.state.isTexco) {
          //   if (
          //     !isEmptyArray(
          //       response.data.salesOrderResponse.salesOrder.orderImages
          //     )
          //   ) {
          //     const imagesList =
          //       response.data.salesOrderResponse.salesOrder.orderImages;
          //     let url = this.getImageURL();
          //     url = url + imagesList[0].imageName;
          //     this.setImgUrl(url);
          //     this.setState({
          //       imgData: null,
          //     });
          //   } else {
          //     this.setState({
          //       imgUrl: "",
          //       imgData: null,
          //     });
          //   }
          // } else {

          if (
            !isEmptyArray(
              response.data.salesOrderResponse.salesOrder.orderImages,
            )
          ) {
            const imagesList =
              response.data.salesOrderResponse.salesOrder.orderImages;
            let url = this.getImageURL();
            let url_list = [];
            imagesList.map((urlIndex) => {
              let imgUrl = url + urlIndex.imageName;

              url_list.push(imgUrl);
            });
            this.setState({
              // imgData: imagesList,
              preview_Url: url_list,
              images: imagesList,
            });
          } else {
            this.setState({
              imgUrl: "",
              images: [],
              preview_Url: [],
            });
          }
          // }

          // if (
          //   !isEmptyString(
          //     response.data.salesOrderResponse.salesOrder.documentFilePath
          //   )
          // ) {
          //   let url = this.getDocURL();
          //   url =
          //     url +
          //     response.data.salesOrderResponse.salesOrder.documentFilePath;
          //   this.setDocUrl(url);
          //   this.setState({
          //     docData: null,
          //     docName: response.data.salesOrderResponse.salesOrder.documentName,
          //   });
          // } else {
          //   this.setState({
          //     docUrl: "",
          //     docName: "",
          //     docData: null,
          //   });
          // }

          let dependenciesBean = null;
          isDisableFieldUnApprove = true;
          if (
            response.data.dependenciesResponse != null &&
            response.data.dependenciesResponse.dependenciesBean != null
          ) {
            dependenciesBean =
              response.data.dependenciesResponse.dependenciesBean;
          }
          let shipTos = [];
          if (
            !isEmpty(dependenciesBean) &&
            !isEmpty(dependenciesBean.customer) &&
            !isEmptyArray(dependenciesBean.customer.shipTos)
          ) {
            shipTos = dependenciesBean.customer.shipTos;
          }

          if (!isEmptyArray(salesOrder.salesOrderDocument)) {
            const preview_Docs = salesOrder.salesOrderDocument;
            let url = this.getDocURL();
            let urlDoc_list = [];
            preview_Docs.map((urlIndex) => {
              urlDoc_list.push(url + urlIndex.documentName);
            });
            this.setState({
              // imgData: imagesList,
              documents: preview_Docs,
              preview_Docs: urlDoc_list,
            });
          } else {
            this.setState({
              // imgUrl: "",
              // images: [],
              preview_Docs: [],
              documents: [],
            });
          }
          if (!isEmptyArray(salesOrder.commissions)) {
            let displayLineNumber = 0;
            salesOrder.commissions.forEach((line) => {
              if (!line.isDeleted) {
                ++displayLineNumber;
                line.displayLineNumber = displayLineNumber;
              }
            });
          }
          tempSalesCommission = this.getSalesCommissionString(
            salesOrder.commissions,
          );
          this.state.salesOrderData = salesOrder;
          this.setState(
            {
              salesOrderData: salesOrder,
              pageTitle: pageTitle,
              isDisableFields: isDisableFields,
              isDisableFieldUnApprove: isDisableFieldUnApprove,
              isShowNodes: true,
              salesOrderListUpdateNeeded: true,
              moduleKeyCode: moduleKeyCode,
              dependenciesBean: dependenciesBean,
              shipTos: shipTos,
              isFocusLookup: false,
              // isLocked: true,
              isLoading: false,
              selectedNodeKey: "headerView",
              salesCommisionDeatils: tempSalesCommission,
            },
            () => {
              this.isLocked = true;
              this.getNodeList();
              this.loadVendorList();
              this.loadCustomerList();
              this.loadFabricStyleList();
              setTimeout(() => {
                this.checkingAvailableInvoices(salesOrder);
              }, 180);
              this.openEntryForm();
            },
          );
        }
      } else {
        this.addNewEntry();
      }
    }
  };
  checkingAvailableInvoices = (salesOrderData) => {
    //let salesOrderData =  {...this.state.salesOrderData};
    let requestInput = new RestEntityUnLockRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.entityCode = salesOrderData.code;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      SalesOrderService.checkInvoicesAvailableForSalesOrder(
        requestInput,
        this.handleAvalibleInvoiceDetailsResponse,
        this.errorCallBack,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  handleAvalibleInvoiceDetailsResponse = (response) => {
    let isInvoiceAvailable = false;
    if (response.data.dependenciesBean != null) {
      isInvoiceAvailable = response.data.dependenciesBean.invoiceAvailable;
    }
    this.setState(
      {
        isInvoiceAvailable: isInvoiceAvailable,
        //isCustomerDataLoding: false,
      },
      () => {
        this.initModuleButtons();
      },
    );
  };

  handleCustomerAutocompleteSearchResponse = (response) => {
    let customerList = [];
    if (
      response.data.customerPageList != null &&
      response.data.customerPageList.customers !== null
    ) {
      customerList = response.data.customerPageList.customers;
    }
    this.setState({
      customerList: customerList,
      isCustomerDataLoding: false,
    });
  };
  handleCustomerAutocompleteSearchError = (error) => {
    ShowError("Error : " + error);
  };
  handleCustomerAutocompleteSearch = (searchString) => {
    this.setState({ isCustomerDataLoding: true });
    let cust_criteria = new CustomerSearchCriteria();
    cust_criteria.companyCode = this.companyCode;
    cust_criteria.customerCodeStartsWith = searchString;
    cust_criteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;

    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = cust_criteria;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.handleCustomerAutocompleteSearchResponse,
        this.handleCustomerAutocompleteSearchError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  handleFabricStyleAutocompleteSearchResponse = (response) => {
    let fabricStyleList = [];
    if (
      response.data.fabricStylePageList != null &&
      response.data.fabricStylePageList.fabricStyles !== null
    ) {
      fabricStyleList = response.data.fabricStylePageList.fabricStyles;
    }
    this.setState({
      fabricStyleList: fabricStyleList,
      iaFabricStyleDataLoding: false,
    });
  };
  handleFabricStyleAutocompleteSearchError = (error) => {
    ShowError("Error : " + error);
  };
  handleFabricStyleAutocompleteSearch = (searchString) => {
    this.setState({ isFabricStyleDataLoding: true });
    let cust_criteria = new FabricStyleSearchCriteria();
    cust_criteria.companyCode = this.companyCode;
    cust_criteria.fabricStyleCodeStartsWith = searchString;
    cust_criteria.fabricStyleNameContainingText = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestFabricStyleListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = cust_criteria;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      FabricStyleService.getFabricStylePageList(
        cust_requestInput,
        this.handleFabricStyleAutocompleteSearchResponse,
        this.handleFabricStyleAutocompleteSearchError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  handleFabricAutocompleteSearch = (searchString) => {
    this.props.handleFabricAutocompleteSearch(searchString);
    this.focusFabricStyleCode();
  };
  addNewEntry = () => {
    let salesOrderData = new SalesOrderBean();
    let customerData = new CustomerBean();
    let isShowSaveButton = true;
    let isShowCopySOButton = true;
    let pageTitle = this.state.moduleCaption + " - " + NEW_ENTRY;
    salesOrderData.companyCode = this.companyCode;
    salesOrderData.orderStatus = LogicConstants.SALES_ORDER_UNAPPROVE_STATUS;
    salesOrderData.customerPurchaseOrderNumber = "";
    let currentDate = toFormattedDate_v1(new Date());
    //let currentDate = new Date();
    //currentDate = currentDate.toLocaleDateString("sv-SE");
    salesOrderData.orderDate = currentDate;
    salesOrderData.orderStartDate = currentDate;
    salesOrderData.orderStopDate = currentDate;
    salesOrderData.xDCDate = currentDate;
    salesOrderData.orderTypeCode = "STD";
    salesOrderData.paymentTermCode = " ";
    salesOrderData.shipToCode = " ";
    salesOrderData.shipViaCode = " ";
    if (!isEmpty(this.userCode)) {
      salesOrderData.salesRepresentativeCode = this.userCode;
    } else {
      salesOrderData.salesRepresentativeCode = " ";
    }
    salesOrderData.currencyExchangeRateCode = "1";
    salesOrderData.actualExchangeRate = "1";
    salesOrderData.adjustedExchangeRate = "1";
    // let isLocked = false;
    // let isLockRequired = false;
    if (!isEmptyString(this.state.moduleKeyCode)) {
      salesOrderData.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        // isLocked = false;
        // isLockRequired = false;
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    } else salesOrderData.code = NEW_ENTRY;
    this.setState({
      customerData: customerData,
      salesOrderData: salesOrderData,
      pageTitle: pageTitle,
      salesOrderListUpdateNeeded: false,
      isShowSaveButton: isShowSaveButton,
      disabled: false,
      // isLocked: isLocked,
      // isLockRequired: isLockRequired,
      isShowShipToLookup: false,
      isShowCopySOButton: isShowCopySOButton,
      selectedNodeKey: "headerView",
      isInvoiceAvailable: false,
    });
    this.state.salesOrderData = salesOrderData;
    this.openEntryForm();
  };
  editSalesOrderError = (error) => {
    this.setState({ isLoading: false });
    ShowError("Error : ", error);
  };
  editSalesOrder = (salesOrderCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = salesOrderCode;
    // let isLockRequired = NEW_ENTRY === salesOrderCode ? false : true;
    let isLockRequired = false;
    if (this.props.isSpecialViewMode) {
      isLockRequired = false;
    } else {
      isLockRequired = NEW_ENTRY === salesOrderCode ? false : true;
    }
    readrestInput.isLockRequired = isLockRequired;
    this.state.isDisableFields = true;
    this.setState({
      salesOrderListUpdateNeeded: false,
      isFocusPO: true,
      isLoading: true,
    });
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      SalesOrderService.initSalesOrderModule(
        readrestInput,
        this.editSalesOrderResponse,
        this.editSalesOrderError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadSalesOrders();
  };
  onUnApproveReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteUnApproveReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteUnApproveReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteUnApproveReasonList: showAutoCompleteList,
        reasonData: reason,
        unApproveReasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readUnApproveReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.unapprovalReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteUnApproveReasonList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteUnApproveReasonList;
          this.setState({
            showAutoCompleteUnApproveReasonList: showAutoCompleteList,
          });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readUnApproveReasonBySearchString(searchString) {
    let reasonData = this.state.unapprovalReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      unApproveReasonPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  unApproveReasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.unapprovalReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        unApproveReasonPageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteUnApproveReasonList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteUnApproveReasonList: showAutoCompleteList,
    });
  };
  unApproveSalesOrder = () => {
    this.openReasonCapture(2);
  };
  onUnApproveReasonContinue = () => {
    this.saveUnApproveSalesOrder();
    this.closeReasonModelCallBack();
  };
  saveUnApproveSalesOrderResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });

    this.handleResponse(response.data);
    if (!isEmpty(response.data) && !isEmpty(response.data.salesOrder)) {
      const salesOrderBean = response.data.salesOrder;
      if (salesOrderBean != null) {
        let pageTitle = this.state.moduleCaption + " - EDIT";
        this.setState({
          salesOrderData: salesOrderBean,
          pageTitle: pageTitle,
        });
        // this.code = salesOrderBean.code;

        if (this.isLocked) {
          this.code = salesOrderBean.code;
          this.unlockSalesOrder(salesOrderBean.code);
          // this.editSalesOrder(salesOrderBean.code);
        }
      }
    }
  };
  saveUnApproveSalesOrderError = (error) => {
    this.setState({ isLoading: false });
    ShowError("Error : " + error);
  };
  saveUnApproveSalesOrder = () => {
    this.setState({ isLoading: true, loadingText: "UnApproving .." });
    let soData = this.state.salesOrderData;
    let input = new RestSalesOrderRequest();
    input.salesOrderBean = soData;
    input.reason = this.state.reasonData;
    if (SecurityAccessManager.SalesOrderMaintenanceUnApprove_IsAccessible()) {
      SalesOrderService.unApproveSalesOrder(
        input,
        this.saveUnApproveSalesOrderResponse,
        this.saveUnApproveSalesOrderError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  approveSalesOrderResponse = (response) => {
    this.setState({ isLoading: false });
    let isSuccess = this.handleApproveResponse(response.data);
    if (isSuccess) {
      if (
        !isEmpty(response.data) &&
        !isEmpty(response.data.mainOperationResponse) &&
        !isEmpty(response.data.mainOperationResponse.salesOrder)
      ) {
        let salesOrderData = response.data.mainOperationResponse.salesOrder;
        if (!this.isLocked) {
          this.editSalesOrder(salesOrderData.code);
        } else {
          this.code = salesOrderData.code;
          this.unlockSalesOrder(salesOrderData.code);
          // this.editSalesOrder(salesOrderData.code);
        }
        // this.code = salesOrderData.code;
        // this.unlockSalesOrder(salesOrderData.code);
      }
    }
  };
  approveSalesOrderError = (error) => {
    this.setState({ isLoading: false });
    ShowError("Error : " + error);
  };
  approveSalesOrder = () => {
    this.setState({ isLoading: true, loadingText: "Approving .." });
    let soData = this.state.salesOrderData;
    let input = new RestSalesOrderRequest();
    input.companyCode = this.companyCode;
    input.salesOrderBean = soData;
    input.reason = this.state.reasonData;
    if (soData.isFetched) {
      if (SecurityAccessManager.SalesOrderMaintenanceEdit_IsAccessible()) {
        SalesOrderService.updateAndApproveSalesOrder(
          input,
          this.approveSalesOrderResponse,
          this.approveSalesOrderError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.SalesOrderMaintenanceAdd_IsAccessible()) {
        SalesOrderService.createAndApproveSalesOrder(
          input,
          this.approveSalesOrderResponse,
          this.approveSalesOrderError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  specialApproveSalesOrderResponse = (response) => {
    this.setState({ isLoading: false });
    let isSuccess = this.handleApproveResponse(response.data);
    if (isSuccess) {
      if (
        !isEmpty(response.data) &&
        !isEmpty(response.data.mainOperationResponse) &&
        !isEmpty(response.data.mainOperationResponse.salesOrder)
      ) {
        let salesOrderData = response.data.mainOperationResponse.salesOrder;
        if (!this.isLocked) {
          this.editSalesOrder(salesOrderData.code);
        } else {
          this.code = salesOrderData.code;
          this.unlockSalesOrder(salesOrderData.code);
          // this.editSalesOrder(salesOrderData.code);
        }
        // this.code = salesOrderData.code;
        // this.unlockSalesOrder(salesOrderData.code);
      }
    }
  };
  specialApproveSalesOrderError = (error) => {
    this.setState({ isLoading: false });
    ShowError("Error : " + error);
  };
  specialApproveSalesOrder = () => {
    this.setState({ isLoading: true, loadingText: "Approving .." });
    let soData = this.state.salesOrderData;
    let input = new RestSalesOrderRequest();
    input.companyCode = this.companyCode;
    input.salesOrderBean = soData;
    if (
      SecurityAccessManager.SalesOrderMaintenanceSpecialApprove_IsAccessible()
    ) {
      SalesOrderService.specialApproveSalesOrder(
        input,
        this.specialApproveSalesOrderResponse,
        this.specialApproveSalesOrderError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getModuleListView = () => {
    let salesOrderData = this.state.salesOrderData;
    if (salesOrderData.code === NEW_ENTRY) {
      this.closeSalesOrderEntryForm();
      this.loadSalesOrders();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unlockSalesOrder(salesOrderData.code);
      } else {
        this.isLocked = false;
      }
      this.closeSalesOrderEntryForm();
      this.loadSalesOrders();
    }
  };

  resetView = () => {
    let salesOrderData = this.state.salesOrderData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unlockSalesOrder(salesOrderData.code);
    } else {
      this.isLocked = false;
    }
    let _salesOrderData = new SalesOrderBean();
    this.setState(
      {
        salesOrderData: _salesOrderData,
        isResetModule: true,
        moduleKeyCode: NEW_ENTRY,
        disabled: false,
        isFocusPO: false,
        isFocusLookup: true,
        isDisableFields: false,
        isLoading: false,
        isDisabledFields: false,
        isDisableFieldUnApprove: false,
        copySONum: "",
        isShowAddIcon: true,
        customerPageListForAutoCompleteList: new Array(),
        isCustomerNotFound: false,
        isShowAutoCompleteDeliveryTypeList: false,
        deliveryTypePageListForAutoCompleteList: new Array(),
        isLineLevelEditable: false,
        isLineLevelDelete: false,
        salesCommisionDeatils: "",
        isViewMode: false,
        isInvoiceAvailable: false,
      },
      () => {
        this.code = NEW_ENTRY;
        this.addNewEntry();
        this.hideAlertCallBack(false);
      },
    );
    //this.state.moduleKeyCode = NEW_ENTRY;
    //this.code = NEW_ENTRY;
    // this.state.isViewMode = false;
    //this.addNewEntry();
    //this.hideAlertCallBack(false);
  };

  generatePickTicketResponse = (response) => {
    this.setState({ isLoading: false });
    let isSuccess = this.handleResponse(response.data);
    if (!isEmpty(response.data) && !isEmpty(response.data.pickTicket)) {
      if (isSuccess) {
        let pickticket = response.data.pickTicket;
        if (pickticket != null) {
          // this.code = pickticket.salesOrderNumber;
          // this.unlockSalesOrder(pickticket.salesOrderNumber);
          if (this.isLocked) {
            this.code = pickticket.salesOrderNumber;
            this.unlockSalesOrder(pickticket.salesOrderNumber);
          }
        }
      }
    }
  };

  generatePickTicketError = (error) => {
    this.setState({ isLoading: false });
    ShowError("Error : " + error);
  };
  generatePickTicket = () => {
    this.setState({
      isLoading: true,
      loadingText: "PickTicket Generation ..",
    });
    let soData = this.state.salesOrderData;
    let request = new RestPickTicket_v1Request();
    request.companyCode = this.companyCode;
    request.salesOrderBean = soData;
    request.isLockRequired = true;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      PickTicketService.generatePickTicketEntry(
        request,
        this.generatePickTicketResponse,
        this.generatePickTicketError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  generatePickTicketAdv = () => {
    this.setState({
      isLoading: true,
      loadingText: "PickTicket Generation ..",
    });
    let soData = this.state.salesOrderData;
    let request = new RestPickTicket_v1Request();
    request.companyCode = this.companyCode;
    request.salesOrderBean = soData;
    request.isLockRequired = true;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      PickTicketService.generateAdvancedPickTicketEntry(
        request,
        this.generateSelectedPickTicketResponse,
        this.generatePickTicketError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  generateSelectedPickTicketResponse = (response) => {
    // let isSuccess = this.handleResponse(response.data);
    if (response.data != null && response.data.pickTicket != null) {
      let pickticket = response.data.pickTicket;
      if (pickticket != null) {
        this.setState(
          {
            pickTicketBean: pickticket,
            isShowPickTicketAdvPopup: true,
          },
          () => {
            setTimeout(() => {
              if (this.pickTicketNumberCreateRef.current != null) {
                this.pickTicketNumberCreateRef.current.clear();
                this.pickTicketNumberCreateRef.current.focus();
              }
            }, 100);
          },
        );
      }
    }
    this.setState({
      isLoading: false,
    });
  };
  saveAdvancedPickTicketEntry = (e) => {
    if (e.detail == 1) {
      let selectedSOLineList = [...this.state.selectedSOLineList];
      let pickticket = { ...this.state.pickTicketBean };
      let request = new RestPickTicket_v1Request();
      // if (!isEmptyArray(selectedSOLineList)) {
      pickticket.pickTicketLines = selectedSOLineList;
      request.companyCode = this.companyCode;
      request.pickTicketBean = pickticket;
      request.isLockRequired = true;
      let isValidLine = false;
      isValidLine = this.validateGeneratePickTicketLine(pickticket);

      // } else {
      //   pickticket.pickTicketLines = [];
      //   request.companyCode = this.companyCode;
      //   request.pickTicketBean = pickticket;
      //   request.isLockRequired = true;
      // }
      if (isValidLine) {
        if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
          PickTicketService.saveAdvancedPickTicketEntry(
            request,
            this.saveAdvPickTicketResponse,
            this.saveAdvPickTicketError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };

  validateGeneratePickTicketLine = (pickTicket, selectedSOLineList) => {
    let isValidPOLine = false;
    let err_list = [];
    let errorMessage = "";

    if (!isEmptyString(pickTicket.code)) {
      if (this.state.isPickTicketNumberExist === true) {
        let errMsg = "PickTicketNumber  is Exist";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }

    if (this.state.selectedSOLineList.length === 0) {
      let errMsg = "Select Lines !";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }

    if (err_list.length > 0) {
      isValidPOLine = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowPtAdvPopupAlert: true,
      });
    } else {
      isValidPOLine = true;
      this.setState({ isShowPtAdvPopupAlert: false });
    }
    return isValidPOLine;
  };
  saveAdvPickTicketResponse = (response) => {
    // let isSuccess = this.handleResponse(response.data);

    let errMsg = "";
    let errList = [];
    let infoList = [];
 
    if (response.data != null) {
      if (response.data.errors != null) {
        response.data.errors.map((err) => {
          // errMsg = err.messageDescription;
          errList.push(err.messageDescription);
        });
        if (!isEmptyArray(errList)) {
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowPtAdvPopupAlert: true,
            //  isShowPopupAlert: true,
          });
        }
      }
      if (response.data.infos != null) {
        let infoMsg = "";
        let successMsg = [];
        response.data.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription),
        );
        successMsg.push(infoMsg);
        this.setState({
          alertMessage: successMsg,
          alertType: "success",
          isShowAlert: true,
          isShowMailAlert: false,
        });
      }
      if (!isEmpty(response.data.pickTicket)) {
        let pickticket = response.data.pickTicket;
        if (pickticket != null) {
          // this.code = pickticket.salesOrderNumber;
          // this.unlockSalesOrder(pickticket.salesOrderNumber);
          if (this.isLocked) {
            this.code = pickticket.salesOrderNumber;
            this.unlockSalesOrder(pickticket.salesOrderNumber);
          }
          this.setState({
            isShowPickTicketAdvPopup: false,
            selectedSOLineList: [],
          });
        }
      }
    }
    // if ()
  };

  ptEntryKey = (e) => {
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = e.target.value;

    PickTicketService.readPickTicket(
      request,

      this.pTCheckResponse,
      this.errorCallBack,
    );
  };
  pTCheckResponse = (response) => {
    const isPickTicketNumberExist = !isEmpty(response.data.pickTicket);

    if (isPickTicketNumberExist) {
      this.setState({
        isPickTicketNumberExist: true,
        alertMessage: ["PickTicketNumber  Already Exists!"],
        alertType: "danger",
        isShowPtAdvPopupAlert: true,
      });
    } else {
      this.setState({
        isPickTicketNumberExist: false,
      });
    }
  };

  // clearPTData = () => {
  //   alert("clearPTData");
  //   this.setState({ isShowPickTicketAdvPopup: false, selectedSOLineList: [] });
  // };
  saveAdvPickTicketError = (error) => { };
  proformaInvoice = () => {
    let salesOrderData = this.state.salesOrderData;
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = salesOrderData.code;
    if (
      SecurityAccessManager.SalesOrderMaintenanceProformaInvoice_IsAccessible()
    ) {
      ReportService.printProformaInvoice(
        request,
        this.generateProformaInvoiceResponse,
        this.generateProformaInvoiceError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isLoading: true,
      loadingText: "Printing Proforma Invoice ..",
    });
  };
  generateProformaInvoiceResponse = (response) => {
    let success = this.handleResponse(response.data);
    if (success) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
    this.setState({
      isLoading: false,
    });
  };
  generateProformaInvoiceError = (error) => {
    this.setState({ isLoading: false });
    ShowError("Error :", error);
  };
  generatePO = () => {
    let criteria = { ...this.state.criteria };
    criteria.purchaseOrderNumber = NEW_ENTRY;
    // this.purchaseOrderNumberCreateRef.current.focus();
    this.setState(
      {
        isShowGeneratePOPopup: true,
        criteria: criteria,
        isPurchaseNumberExist: false,
      },
      () => {
        setTimeout(() => {
          if (this.purchaseOrderNumberCreateRef.current != null) {
            this.purchaseOrderNumberCreateRef.current.clear();
            this.purchaseOrderNumberCreateRef.current.focus();
          }
        }, 0);

        // if (this.purchaseOrderNumberCreateRef.current != null) {
        //   this.purchaseOrderNumberCreateRef.current.clear();
        // }
      },
    );
  };
  onVendorCodeChange = (e) => {
    let vendorCode = e.target.value;
    let temp_Vendor_ref_data = this.state.criteria;
    temp_Vendor_ref_data[e.target.name] = e.target.value;
    let showAutoCompleteVendorList = this.state.showAutoCompleteVendorList;
    this.state.showAutoCompleteVendorList = true;
    if (isEmpty(vendorCode)) {
      this.state.showAutoCompleteVendorList = false;
      let showAutoCompleteVendorList = this.state.showAutoCompleteVendorList;
      let searchCriteria = this.state.criteria;
      searchCriteria.vendorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteVendorList: showAutoCompleteVendorList,
        criteria: searchCriteria,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteVendorList === true &&
      vendorCode !== ""
    ) {
      this.state.showAutoCompleteVendorList = true;
      this.readVendorBySearchString(e.target.value);
    }
    if (e.target.name == "vendorCode") {
      temp_Vendor_ref_data["vendorCode"] = e.target.value;
      let vendor_List = this.state.vendor_List;
      vendor_List.map((vendor) => {
        if (vendor.code == e.target.value) {
          temp_Vendor_ref_data["vendorCode"] = vendor.code;
          temp_Vendor_ref_data["vendorName"] = vendor.description;
        }
      });
      if (temp_Vendor_ref_data.fabricStyleColorVendorReferences != null) {
        temp_Vendor_ref_data.fabricStyleColorVendorReferences.map((line) => {
          line.vendorCode = e.target.value;
        });
      }
    }

    this.setState({
      criteria: temp_Vendor_ref_data,
    });
  };
  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      VendorService.getVendorPageList(
        input,
        this.readByVendorCodeResponse,
        this.readByVendorCodeResponseError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  }

  readByVendorCodeResponse = (response) => {
    let vendorCodeData = response.data.vendorPageList.vendors;
    let simpleAutoCompleteList = new Array();
    if (vendorCodeData.length > 0 && vendorCodeData != null) {
      vendorCodeData.map((vendorCode) => {
        let simpleItemBean = {
          code: vendorCode.code,
          description: vendorCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      vendorPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  displayAutoCompleteVendorList = (showAutoCompleteVendorList) => {
    this.setState({ showAutoCompleteVendorList: showAutoCompleteVendorList });
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    let searchCriteria = this.state.criteria;
    searchCriteria[e.target.name] = e.target.value;
    searchCriteria["vendorCode"] = e.target.value;
    let vendor_List = this.state.vendor_List;
    vendor_List.map((vendor) => {
      if (vendor.code == e.target.value) {
        searchCriteria["vendorCode"] = vendor.code;
        searchCriteria["vendorName"] = vendor.description;
      }
    });
    this.setState({ vendorPageListForAutoCompleteList: new Array() });
  };

  onLocationChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let soLine = this.state.criteria;
      soLine.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationList: showAutoCompleteList,
        criteria: soLine,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    if (e.target.name == "locationCode") {
      criteria["locationCode"] = e.target.value;
      let location_List = this.state.locations;
      location_List.map((locationCode) => {
        if (locationCode.code == e.target.value) {
          locationCode["locationCode"] = locationCode.code;
          this.state.showAutoCompleteLocationList = false;
          let showAutoCompleteList = this.state.showAutoCompleteLocationList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ criteria: criteria });
  };
  readLocationBySearchString(searchString) {
    let locationData = this.state.locations;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((locations) => {
        let simpleItemBean = {
          code: locations.code,
          description: locations.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ locationPageListForAutoCompleteList: filteredSuggestions });
  }
  locationEnterKeyEventHandler = (e) => {
    let criteria = this.state.criteria;
    let locationCode = e.target.value;
    criteria["locationCode"] = e.target.value;
    let locationCode_List = this.state.locations;
    let locationCodeBean = null;
    locationCode_List.map((locationCode) => {
      if (locationCode.code == e.target.value) {
        locationCodeBean = locationCode;
      }
    });
    if (!isEmpty(locationCodeBean)) {
      let criteria = this.state.criteria;
      criteria.locationCode = locationCodeBean.code;
      this.setState({
        criteria: criteria,
        locationPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteLocationList = (showAutoCompleteLocationList) => {
    this.setState({
      showAutoCompleteLocationList: showAutoCompleteLocationList,
    });
  };
  loadVendorList = () => {
    let ven_criteria = new VendorSearchCriteria();
    ven_criteria.companyCode = this.companyCode;
    let ven_pageList = new PageListBean();
    ven_pageList.pageSize = 100;
    let ven_requestInput = new RestVendorListRequest();
    ven_requestInput.pageInput = ven_pageList;
    ven_requestInput.searchCriteria = ven_criteria;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      VendorService.getVendorPageList(
        ven_requestInput,
        this.loadVendorListResponse,
        this.loadVendorListError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadVendorListResponse = (response) => {
    let vendor_List = [];
    if (
      response.data.vendorPageList != null &&
      response.data.vendorPageList.vendors !== null
    ) {
      vendor_List = response.data.vendorPageList.vendors;
    }
    this.setState({
      vendor_List: vendor_List,
    });
  };
  loadVendorListError = (error) => {
    ShowError("Error : " + error);
  };

  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };
  onReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.cancelReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.cancelReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.cancelReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowUnApproveReasonPopup: false,
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
      isShowLineCancelReasonPopup: false,
    });
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    } else if (type === 2) {
      this.setState({
        isShowUnApproveReasonPopup: true,
      });
    } else if (type == 3) {
      this.setState({
        isShowLineCancelReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  cancelSalesOrder = () => {
    this.openReasonCapture(1);
  };

  onLineCancelReasonContinue = () => {
    const soline = this.state.salesOrderLineData;
    const salesOrderData = this.state.salesOrderData;

    const index = salesOrderData.lines.findIndex(
      (ln) => ln.skuNumber === soline.skuNumber,
    );
    if (index != -1) {
      salesOrderData.lines.splice(index, 1);
    }
    this.setState({ salesOrderData: salesOrderData });
    this.state.salesOrderData = salesOrderData;
    this.saveSalesOrderLineCancel();
    this.closeReasonModelCallBack();
  };
  onCancelReasonContinue = () => {
    this.saveCancelSalesOrder();
    this.closeReasonModelCallBack();
  };
  saveCancelSalesOrderResponse = (response) => {
    this.setState({ isLoading: false });
    let isSuccess = this.handleResponse(response.data);
    let soData = this.state.salesOrderData;
    if (!isEmpty(response.data)) {
      if (isSuccess) {
        if (!isEmpty(response.data.salesOrder))
          if (this.isLocked) {
            //   this.code = response.data.salesOrder.code;
            // this.unlockSalesOrder(response.data.salesOrder.code);
            this.code = response.data.salesOrder.code;
            this.unlockSalesOrder(response.data.salesOrder.code);
          }
      }
    }
  };
  saveCancelSalesOrderError = (error) => {
    this.setState({ isLoading: false });
    ShowError("Error cancel : " + error);
  };
  saveCancelSalesOrder = () => {
    this.setState({ isLoading: true, loadingText: "Cancelling .." });
    let soData = this.state.salesOrderData;
    let input = new RestSalesOrderRequest();
    input.companyCode = this.companyCode;
    input.salesOrderBean = soData;
    input.reason = this.state.reasonData;
    if (SecurityAccessManager.SalesOrderMaintenanceCancel_IsAccessible()) {
      SalesOrderService.cancelSalesOrder(
        input,
        this.saveCancelSalesOrderResponse,
        this.saveCancelSalesOrderError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  isValidReason = () => {
    let isValid = true;
    let err_list = [];
    let errorMsg = "";
    if (isEmpty(this.state.reasonData)) {
      let errMsg = " Reason is Required";
      errorMsg = errorMsg + errMsg;
      err_list.push(errMsg);
    }
    if (isEmptyString(this.state.reasonData.code)) {
      let errMsg = " Reason is Required";
      errorMsg = errorMsg + errMsg;
      err_list.push(errMsg);
    }
    this.setState({ error_list: err_list });
    if (err_list.length > 0) isValid = false;
    return isValid;
  };
  unapproveSalesOrder = () => {
    this.openReasonCapture(2);
  };
  /* open SalesOrder entry form*/
  openEntryForm = () => {
    this.clearError();
    let salesOrderData = this.state.salesOrderData;
    this.closeAllNodeViews();
    this.setState({
      isListFormOpen: false,
      isEntryFormOpen: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: false,
      isShowPDFReportButton: true,
      isShowApproveButton: true,
      isShowSpecialApproveButton: false,
      isShowUnApproveButton: false,
      isShowGeneratePickTicketButton: false,
      isShowGeneratePickTicketAdvButton: false,
      isShowGeneratePOButton: false,
      isShowProformaInvButton: false,
      isShowAddSampleRollButton: false,
      isShowMailButton: false,
      isShowCancelButton: false,
      isShowModuleSearchContainer: true,
      salesOrderLineData: new SalesOrderLineBean(),
      isResetCustomerDynamicAutoComplete: false,
      isShowNodes: true,
      isResetView: false,
      // isShowAddIcon: false,
      isDeleteSoLine: false,
      isShowDocLabel: false,
      isShowAddSampleRollButton: false,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isListFormOpen: false,
        disabled: false,
        isDisableNodeFields: false,
        disableSalesOrderFormFields: false,
        showAutoCompleteCustomerList: false,
        isDisabledFields: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.state.moduleCaption + " - VIEW";
        this.setState({
          isDisabledFields: true,
          // disableSalesOrderFormFields: true,
          disabled: true,
          pageTitle: pageTitle,
          isDisableFields: true,
        });
      }
    } else {
      this.setState({
        isDisabledFields: true,
        disableSalesOrderFormFields: true,
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    this.initModuleButtons();
    this.getNodeList();
  };

  initModuleButtons = () => {
    let salesOrderData = this.state.salesOrderData;
    //  let isInvoiceAvailable = this.checkingAvailableInvoices(salesOrder);
    let isInvoiceAvailable = this.state.isInvoiceAvailable;

    if (
      salesOrderData.code === NEW_ENTRY &&
      isEmptyString(salesOrderData.code)
    ) {
      this.setState({
        isShowMailButton: false,
        isShowProformaInvButton: false,
        isShowCancelButton: false,
        isShowAddIcon: true,
        isShowCopySOButton: true,
        isShowApproveButton: true,
        isDeleteSoLine: false,
        isShowDocLabel: false,
        isShowChangeCustomerButton: false,
      });
    }
    if (salesOrderData.isFetched) {
      if (
        salesOrderData.orderStatus ==
        LogicConstants.SALES_ORDER_UNAPPROVE_STATUS
      ) {
        this.setState({
          isShowApproveButton: true,
          isShowSpecialApproveButton: true,
          isShowCancelButton: true,
          isShowSaveButton: true,
          isShowGeneratePOButton: false,
          isShowAddSampleRollButton: false,
          isShowProformaInvButton: true,
          isShowMailButton: true,
          isShowUnApproveButton: false,
          isShowAddIcon: true,
          isShowCopySOButton: false,
          isDeleteSoLine: false,
          isShowDocLabel: false,
          isLineLevelEditable: false,
          isLineLevelDelete: false,
          isShowChangeCustomerButton: true,
        });
      } else if (
        salesOrderData.orderStatus == LogicConstants.SALES_ORDER_APPROVE_STATUS
      ) {
        let generatePickTicketPosible = true;
        let cancelPosible = true;
        let unApprovePosible = true;
        let isActivePickTicketExist = false;
        isActivePickTicketExist = this.isActivePickTicketExist();
        if (isActivePickTicketExist) {
          generatePickTicketPosible = false;
          unApprovePosible = false;
          cancelPosible = false;
        }
        this.setState({
          isShowApproveButton: false,
          isShowSpecialApproveButton: false,
          isShowUnApproveButton: unApprovePosible,
          isShowGeneratePickTicketButton: generatePickTicketPosible,
          isShowGeneratePickTicketAdvButton: generatePickTicketPosible,
          isShowCancelButton: cancelPosible,
          isShowSaveButton: true,
          isShowGeneratePOButton: true,
          isShowAddSampleRollButton: true,
          isShowProformaInvButton: true,
          isShowMailButton: true,
          isShowAddIcon: true,
          isDisableFields: true,
          isShowCopySOButton: false,
          isDeleteSoLine: false,
          isShowDocLabel: true,
          isLineLevelEditable: this.state.isTexco ? false : true,
          isLineLevelDelete: this.state.isTexco ? false : false,
        });
      } else if (
        salesOrderData.orderStatus == LogicConstants.SALES_ORDER_CANCEL_STATUS
      ) {
        this.setState({
          isShowSaveButton: false,
          isShowApproveButton: false,
          isShowSpecialApproveButton: false,
          isShowCancelButton: false,
          isShowUnApproveButton: false,
          isShowGeneratePickTicketButton: false,
          isShowGeneratePickTicketAdvButton: false,
          isShowGeneratePOButton: false,
          isShowAddSampleRollButton: false,
          isShowProformaInvButton: false,
          isShowMailButton: true,
          isShowAddIcon: false,
          isDisableFields: true,
          isShowCopySOButton: false,
          isDisabledFields: true,
          isDeleteSoLine: true,
          isShowDocLabel: true,
          isLineLevelEditable: true,
          isLineLevelDelete: true,
        });
      } else if (
        salesOrderData.orderStatus ==
        LogicConstants.SALES_ORDER_PARTIALLY_PICKED_STATUS
      ) {
        this.setState({
          isShowCancelButton: false,
          isShowSaveButton: true,
          isShowBackButton: false,
          isShowApproveButton: false,
          isShowSpecialApproveButton: false,
          isShowUnApproveButton: false,
          isShowGeneratePickTicketButton: false,
          isShowGeneratePickTicketAdvButton: false,
          isShowGeneratePOButton: true,
          isShowAddSampleRollButton: false,
          isShowProformaInvButton: false,
          isShowMailButton: true,
          isShowAddIcon: true,
          isDisableFields: true,
          isShowCopySOButton: false,
          isDeleteSoLine: true,
          isShowDocLabel: true,
          isLineLevelEditable: this.state.isTexco ? isInvoiceAvailable : true,
          isLineLevelDelete: this.state.isTexco ? true : true,
        });
      } else if (
        salesOrderData.orderStatus ==
        LogicConstants.SALES_ORDER_PARTIALLY_INVOICED_STATUS
      ) {
        this.setState({
          isShowCancelButton: false,
          isShowSaveButton: this.state.isTexco ? true : false,
          isShowBackButton: false,
          isShowApproveButton: false,
          isShowSpecialApproveButton: false,
          isShowUnApproveButton: false,
          isShowGeneratePickTicketButton: true,
          isShowGeneratePickTicketAdvButton: true,
          isShowGeneratePOButton: false,
          isShowAddSampleRollButton: false,
          isShowProformaInvButton: false,
          isShowMailButton: true,
          isShowAddIcon: true,
          isDisableFields: true,
          isShowCopySOButton: false,
          isDeleteSoLine: true,
          isShowDocLabel: true,
          isLineLevelEditable: this.state.isTexco ? true : true,
          isLineLevelDelete: this.state.isTexco ? true : true,
        });
      }
      //  else if (
      //   salesOrderData.orderStatus ==
      //     LogicConstants.SALES_ORDER_PARTIALLY_INVOICED_STATUS ||
      //   salesOrderData.orderStatus ==
      //     LogicConstants.SALES_ORDER_PARTIALLY_PICKED_STATUS
      // ) {
      //   this.setState({
      //     isShowCancelButton: false,
      //     isShowSaveButton: true,
      //     isShowBackButton: false,
      //     isShowApproveButton: false,
      //     isShowSpecialApproveButton: false,
      //     isShowUnApproveButton: false,
      //     isShowGeneratePickTicketButton: false,
      //     isShowGeneratePickTicketAdvButton: true,
      //     isShowGeneratePOButton: false,
      //     isShowProformaInvButton: false,
      //     isShowMailButton: true,
      //     isShowAddIcon: true,
      //     isDisableFields: true,
      //     isShowCopySOButton: false,
      //     isDeleteSoLine: true,
      //     isShowDocLabel: true,
      //   });
      // }
      else if (
        salesOrderData.orderStatus == LogicConstants.SALES_ORDER_PICKED_STATUS
      ) {
        this.setState({
          isShowCancelButton: false,
          isShowSaveButton: true,
          isShowBackButton: false,
          isShowApproveButton: false,
          isShowSpecialApproveButton: false,
          isShowUnApproveButton: false,
          isShowGeneratePickTicketButton: false,
          isShowGeneratePickTicketAdvButton: false,
          isShowGeneratePOButton: false,
          isShowAddSampleRollButton: false,
          isShowProformaInvButton: false,
          isShowMailButton: true,
          isShowAddIcon: true,
          isDisableFields: true,
          isShowCopySOButton: false,
          isDeleteSoLine: true,
          isShowDocLabel: true,
          isLineLevelEditable: this.state.isTexco ? isInvoiceAvailable : true,
          isLineLevelDelete: this.state.isTexco ? true : true,
        });
      } else if (
        salesOrderData.orderStatus == LogicConstants.SALES_ORDER_INVOICED_STATUS
      ) {
        this.setState({
          isShowCancelButton: false,
          isShowSaveButton: false,
          isShowBackButton: false,
          isShowApproveButton: false,
          isShowSpecialApproveButton: false,
          isShowUnApproveButton: false,
          isShowGeneratePickTicketButton: false,
          isShowGeneratePickTicketAdvButton: false,
          isShowGeneratePOButton: false,
          isShowAddSampleRollButton: false,
          isShowProformaInvButton: false,
          isShowMailButton: true,
          isShowAddIcon: false,
          isDisableFields: true,
          isShowCopySOButton: false,
          isDisabledFields: true,
          isDeleteSoLine: true,
          isShowDocLabel: true,
          isLineLevelEditable: true,
          isLineLevelDelete: true,
        });
      } else if (
        salesOrderData.orderStatus == LogicConstants.SALES_ORDER_CLOSE_STATUS
      ) {
        this.setState({
          isShowSaveButton: false,
          isShowApproveButton: false,
          isShowSpecialApproveButton: false,
          isShowCancelButton: false,
          isShowUnApproveButton: false,
          isShowGeneratePickTicketButton: false,
          isShowGeneratePickTicketAdvButton: false,
          isShowGeneratePOButton: false,
          isShowAddSampleRollButton: false,
          isShowProformaInvButton: false,
          isShowMailButton: true,
          isShowAddIcon: false,
          isDisableFields: true,
          isShowCopySOButton: false,
          isDisabledFields: true,
          isDeleteSoLine: true,
          isShowDocLabel: true,
          isLineLevelEditable: true,
          isLineLevelDelete: true,
        });
      }
    }
    if (this.isModifyPosible === true) {
      this.setState({
        isShowSaveButton: true,
        isShowAddIcon: true,
      });
      if (
        salesOrderData.orderStatus == LogicConstants.SALES_ORDER_INVOICED_STATUS
      ) {
        this.setState({
          isShowSaveButton: true,
          isShowAddIcon: false,
          isDeleteSoLine: true,
        });
      }
    }
    if (this.state.isViewMode || this.state.isSpecialViewMode) {
      this.setState({
        isDisableFields: true,
        isDisabledFields: true,
        isShowAddIcon: false,
        isDeleteSoLine: true,
        isShowDocLabel: true,
        isLineLevelEditable: true,
        isLineLevelDelete: true,
      });
    }
  };

  isActivePickTicketExist = () => {
    let isActivePickTicketExist = false;
    if (
      !isEmpty(this.state.dependenciesBean) &&
      !isEmptyArray(this.state.dependenciesBean.pickTickets)
    ) {
      this.state.dependenciesBean.pickTickets.map((pt) => {
        if (pt.status == LogicConstants.PICK_TICKET_APPROVE_STATUS)
          isActivePickTicketExist = true;
        else if (pt.status == LogicConstants.PICK_TICKET_PICKED_STATUS)
          isActivePickTicketExist = true;
        else if (
          pt.status == LogicConstants.PICK_TICKET_PARTIALLY_PICKED_STATUS
        )
          isActivePickTicketExist = true;
        else if (pt.status == LogicConstants.PICK_TICKET_UNAPPROVE_STATUS)
          isActivePickTicketExist = true;
      });
    }
    return isActivePickTicketExist;
  };
  /* close SalesOrder entry form*/
  closeSalesOrderEntryForm = () => {
    this.closeAllNodeViews();
    let pageTitle = this.state.moduleCaption;
    this.setState({
      isListFormOpen: true,
      isEntryFormOpen: false,
      isShowNewButton: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowPDFReportButton: false,
      isShowBackButton: false,
      isShowApproveButton: false,
      sShowCancelButton: false,
      isShowSpecialApproveButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      errorList: [],
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isResetView: false,
      isShowMailButton: false,
      isShowGeneratePickTicketAdvButton: false,
      isShowProformaInvButton: false,
      isShowGeneratePOButton: false,
      isShowAddSampleRollButton: false,
      salesOrderData: new SalesOrderBean(),
      salesOrderLineData: new SalesOrderLineBean(),
      salesOrderList: [],
      isLoading: false,
      isDisableFields: false,
      isDisabledFields: false,
      isDisableFieldUnApprove: false,
      priceBean: new FabricStyleColorPriceInfo(),
      adjustLineBean: new SalesOrderLineAdjustmentBean(),
      isShowShipToLookup: false,
      isMaintenanceMode: false,
      showAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      isShowCopySOButton: false,
      copySONum: "",
      isShowAddIcon: true,
      isDeleteSoLine: false,
      isShowDocLabel: false,
      isViewMode: false,
      isSpecialViewMode: false,
      isShowAutoCompleteDeliveryTypeList: false,
      deliveryTypePageListForAutoCompleteList: new Array(),
      salesCommisionDeatils: "",
      isShowChangeCustomerButton: false,
      isShowAutoCompleteNewCustomerList: false,
      newCustomerPageListForAutoCompleteList: new Array(),
    });
    this.hideAlertCallBack(false);
  };
  save = () => {
    this.saveSalesOrder();
  };
  saveSalesOrderResponse = (response) => {
    this.setState({ isLoading: false });
    let isSuccess = this.handleResponse(response.data);
    let soBean = response.data.salesOrder;
    if (isSuccess) {
      if (soBean != null) {
        let pageTitle = this.state.moduleCaption + " - EDIT";
        this.setState(
          {
            salesOrderData: soBean,
            pageTitle: pageTitle,
            isLoading: false,
            loadingText: "",
            // isLockRequired: true,
            // isLocked: true,
          },
          () => {
            this.uploadToServer();
            this.uploadMultiDocsToServer();
          },
        );

        // if (this.state.moduleKeyCode == NEW_ENTRY) {
        //   this.editSalesOrder(response.data.salesOrder.code);
        // } else {
        //   this.code = soBean.code;
        //   this.unlockSalesOrder(soBean.code);
        // }
        if (!this.isLocked) {
          this.editSalesOrder(soBean.code);
        } else {
          this.code = soBean.code;
          this.unlockSalesOrder(soBean.code);
          // this.editSalesOrder(soBean.code);
        }
      }
    }
  };
  isModifyPosible = () => {
    let isModify = false;
    let salesOrderData = this.state.salesOrderData;
    if (
      salesOrderData.orderStatus == LogicConstants.SALES_ORDER_APPROVE_STATUS ||
      salesOrderData.orderStatus ==
      LogicConstants.SALES_ORDER_PARTIALLY_PICKED_STATUS ||
      salesOrderData.orderStatus == LogicConstants.SALES_ORDER_PICKED_STATUS ||
      salesOrderData.orderStatus ==
      LogicConstants.SALES_ORDER_PARTIALLY_INVOICED_STATUS
    ) {
      isModify = true;
    } else {
      isModify = false;
    }
    return isModify;
  };
  // isEditValues = () => {
  //   let isEdit = false;
  //   let salesOrderData = this.state.salesOrderData;
  //   if (
  //     salesOrderData.orderStatus == LogicConstants.SALES_ORDER_UNAPPROVE_STATUS
  //   ) {
  //     isEdit = false;
  //   } else {
  //     isEdit = true;
  //   }
  //   return isEdit;
  // };
  isEditValues = () => {
    let isEdit = false;
    let salesOrderData = this.state.salesOrderData;

    if (this.state.isTexco) {
      if (this.state.isInvoiceAvailable) {
        isEdit = true;
      } else {
        isEdit = false;
      }
    } else {
      // Original logic
      if (
        salesOrderData.orderStatus ==
        LogicConstants.SALES_ORDER_UNAPPROVE_STATUS
      ) {
        isEdit = false;
      } else {
        isEdit = true;
      }
    }

    return isEdit;
  };

  isModifyLineEntryPosible = () => {
    let disableUpdatableFields = false;
    let salesOrderData = this.state.salesOrderData;
    if (this.state.isInvoiceAvailable) {
      disableUpdatableFields = true;
    }
    return disableUpdatableFields;
  };
  onCriteriaChange = (e) => {
    let criteria = this.state.salesOrderCriteria;
    criteria.companyCode = this.companyCode;
    criteria[e.target.name] = e.target.value;
    this.setState({ salesOrderCriteria: criteria });
  };
  validateSalesData = (salesOrderData) => {
    let isValidSalesData = false;
    let err_list = [];
    let errorMessage = "";
    if (salesOrderData == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(salesOrderData.customerCode)) {
        let errMsg = "Customer Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(salesOrderData.customerName)) {
        let errMsg = "CustomerName is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(salesOrderData.customerPurchaseOrderNumber)) {
        let errMsg = "Customer PO Number is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(salesOrderData.shipToCode)) {
        let errMsg = "Customer ShipTo Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(salesOrderData.paymentTermCode)) {
        let errMsg = "PaymentTerm is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyArray(salesOrderData.lines) || salesOrderData.lines == null) {
        let errMsg = "No SalesOrder Lines";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidSalesData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidSalesData = true;
      this.setState({ isShowAlert: false });
    }
    return isValidSalesData;
  };
  saveSalesOrderError = (error) => {
    this.setState({ isLoading: false });
    ShowError("Error : " + error);
  };
  saveSalesOrder = () => {
    this.setState({ isLoading: true, loadingText: "Saving .." });
    let salesOrderData = this.state.salesOrderData;
    let isValidData = false;
    isValidData = this.validateSalesData(salesOrderData);
    if (isValidData) {
      if (salesOrderData.isFetched) {
        if (
          salesOrderData.orderStatus ==
          LogicConstants.SALES_ORDER_UNAPPROVE_STATUS
        ) {
          if (SecurityAccessManager.SalesOrderMaintenanceEdit_IsAccessible()) {
            SalesOrderService.updateSalesOrder(
              salesOrderData,
              this.saveSalesOrderResponse,
              this.saveSalesOrderError,
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);
            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        } else if (
          salesOrderData.orderStatus ==
          LogicConstants.SALES_ORDER_APPROVE_STATUS ||
          salesOrderData.orderStatus ==
          LogicConstants.SALES_ORDER_PICKED_STATUS ||
          salesOrderData.orderStatus ==
          LogicConstants.SALES_ORDER_PARTIALLY_PICKED_STATUS ||
          salesOrderData.orderStatus ==
          LogicConstants.SALES_ORDER_PARTIALLY_INVOICED_STATUS
        ) {
          if (SecurityAccessManager.SalesOrderMaintenanceEdit_IsAccessible()) {
            SalesOrderService.updateSalesOrderAfterApproval(
              salesOrderData,
              this.saveSalesOrderResponse,
              this.saveSalesOrderError,
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);

            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        }
      } else {
        if (SecurityAccessManager.SalesOrderMaintenanceAdd_IsAccessible()) {
          SalesOrderService.createSalesOrder(
            salesOrderData,
            this.saveSalesOrderResponse,
            this.saveSalesOrderError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    } else {
      this.setState({
        isLoading: false,
      });
    }
  };
  // unlockSalesOrder_WithoutRead = (code) => {
  //   let salesOrderData = this.state.salesOrderData;
  //   let data = new RestEntityUnLockRequest();
  //   data.companyCode = this.companyCode;
  //   data.entityCode = code;
  //   if (code != NEW_ENTRY) {
  //     if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
  //       SalesOrderService.unLockSalesOrder(
  //         data,
  //         this.unlockSalesOrderWithoutResponse,
  //         this.errorCallBack
  //       );
  //     } else {
  //       let errMsg = "Access Denied";
  //       let errList = [];
  //       errList.push(errMsg);

  //       this.setState({
  //         alertMessage: errList,
  //         alertType: "danger",
  //         isShowAlert: true,
  //       });
  //     }
  //   }
  // };

  // unlockSalesOrderWithoutResponse = (response) => {
  //   if (!isEmpty(response.data)) {
  //     if (response.data.isSuccess) {
  //     } else {
  //       this.showErrorMessage(response.data);
  //     }
  //   }
  // };

  unlockSalesOrder = (code) => {
    let salesOrderData = this.state.salesOrderData;
    let data = new RestEntityUnLockRequest();
    data.companyCode = this.companyCode;
    data.entityCode = code;
    // if (code != NEW_ENTRY) {
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      SalesOrderService.unLockSalesOrder(
        data,
        this.unlockSalesOrderResponse,
        this.errorCallBack,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    // }
  };

  unlockSalesOrderResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editSalesOrder(this.code);
        } else {
          this.isLocked = false;
        }
        // this.isLocked = false;
      } else {
        // this.isLocked = true;
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };

  back = () => {
    if (this.state.salesOrderListUpdateNeeded) {
      this.loadPage(1);
    }
    this.closeSalesOrderEntryForm();
    this.handleCustomerAutocompleteSearch(
      this.state.salesOrderCriteria.customerCode,
    );
  };

  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };

  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
    // let salesOrderData = this.state.salesOrderData;
    // this.unlockSalesOrder(salesOrderData.code);
  };
  selectButtonClick = (e) => {
    if (!this.isLocked) {
      this.editSalesOrder(this.state.moduleKeyCode);
    }
    // else {
    //   this.unlockSalesOrder(this.state.moduleKeyCode);
    //   this.editSalesOrder(this.state.moduleKeyCode);
    // }
    // this.editSalesOrder(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  getCriteriaString = () => {
    let criteriaString = "";
    let moduleCaption = this.state.moduleCaption;
    if (this.state.salesOrderCriteria == null) {
      return <div />;
    } else {
      if (!isEmptyString(this.state.salesOrderCriteria.salesOrderNumber))
        criteriaString =
          criteriaString +
          moduleCaption +
          "# : " +
          this.state.salesOrderCriteria.salesOrderNumber +
          " ; ";
      if (
        !isEmptyString(this.state.salesOrderCriteria.salesOrderNumberStartsWith)
      )
        criteriaString =
          criteriaString +
          moduleCaption +
          "# StartsWith : " +
          this.state.salesOrderCriteria.salesOrderNumberStartsWith +
          " ; ";
      if (
        !isEmptyString(this.state.salesOrderCriteria.salesOrderNumberContains)
      )
        criteriaString =
          criteriaString +
          moduleCaption +
          "# Contains : " +
          this.state.salesOrderCriteria.salesOrderNumberContains +
          " ; ";

      if (!isEmptyString(this.state.salesOrderCriteria.customerCode))
        criteriaString =
          criteriaString +
          "Customer# : " +
          this.state.salesOrderCriteria.customerCode +
          " ; ";
      if (
        !isEmptyString(
          this.state.salesOrderCriteria.customerPurchaseOrderNumber,
        )
      )
        criteriaString =
          criteriaString +
          "Customer PO# : " +
          this.state.salesOrderCriteria.customerPurchaseOrderNumber +
          " ; ";
    }
    return <div>{criteriaString}</div>;
  };
  getHeaderView() {
    return (
      <SalesOrderEntryForm
        {...this.state}
        readAndSetFabricStyleImage={this.readAndSetFabricStyleImage}
        ref={this.entryFormRef}
        isFocusPO={this.state.isFocusPO}
        customerList={this.state.customerList}
        customerShipTos={this.state.shipTos}
        salesOrderData={this.state.salesOrderData}
        salesOrderLineData={this.state.salesOrderLineData}
        customerData={this.state.customerData}
        disableSalesOrderFormFields={this.state.isDisableFields}
        closeSalesOrderEntryForm={this.closeSalesOrderEntryForm}
        salesOrderTypes={this.state.salesOrderTypes}
        paymentTerms={this.state.paymentTerms}
        paymentMethods={this.state.paymentMethods}
        customerRepresentatives={this.state.customerRepresentatives}
        freightMethods={this.state.freightMethods}
        shipVias={this.state.shipVias}
        salesClerks={this.state.salesClerks}
        warehouses={this.state.warehouses}
        onChange={this.onChange}
        cancelSalesOrderLine={this.cancelSalesOrderLine}
        getLineDetails={this.getLineDetails}
        displayAutoCompleteCustomerList={this.displayAutoCompleteCustomerList}
        onCustomerCodeChange={this.onCustomerCodeChange}
        onShipToChange={this.onShipToChange}
        onShipViaChange={this.onShipViaChange}
        onPaymentTermChange={this.onPaymentTermChange}
        onOrderTypeChange={this.onOrderTypeChange}
        onCSRChange={this.onCSRChange}
        onSalesClerkChange={this.onSalesClerkChange}
        handleCustomerAutocompleteSearch={this.handleCustomerAutocompleteSearch}
        customerCleared={this.customerCleared}
        customerSelected={this.customerSelected}
        moduleCaption={this.state.moduleCaption}
        onLineChange={this.onLineChange}
        addNewSalesOrderLine={this.addNewSalesOrderLine}
        isModifyPosible={this.isModifyPosible}
        onHeaderAmountsChange={this.onHeaderAmountsChange}
        onSalesOrderLineTableChange={this.onSalesOrderLineTableChange}
        onSalesOrderLineTableInputBlur={this.onSalesOrderLineTableInputBlur}
        onModuleExit={() => this.moduleExit()}
        customerPageListForAutoCompleteList={
          this.state.customerPageListForAutoCompleteList
        }
        customerCodeEnterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
        orderTypePageListForAutoCompleteList={
          this.state.orderTypePageListForAutoCompleteList
        }
        orderTypeEnterKeyEventHandler={this.orderTypeEnterKeyEventHandler}
        shipToPageListForAutoCompleteList={
          this.state.shipToPageListForAutoCompleteList
        }
        shipToEnterKeyEventHandler={this.shipToEnterKeyEventHandler}
        shipViaPageListForAutoCompleteList={
          this.state.shipViaPageListForAutoCompleteList
        }
        shipViaEnterKeyEventHandler={this.shipViaEnterKeyEventHandler}
        paymentTermPageListForAutoCompleteList={
          this.state.paymentTermPageListForAutoCompleteList
        }
        paymentTermEnterKeyEventHandler={this.paymentTermEnterKeyEventHandler}
        cSRPageListForAutoCompleteList={
          this.state.cSRPageListForAutoCompleteList
        }
        cSREnterKeyEventHandler={this.cSREnterKeyEventHandler}
        salesClerkPageListForAutoCompleteList={
          this.state.salesClerkPageListForAutoCompleteList
        }
        salesClerkEnterKeyEventHandler={this.salesClerkEnterKeyEventHandler}
        displayAutoCompleteList={this.displayAutoCompleteList}
        displayAutoCompletePaymentTermList={
          this.displayAutoCompletePaymentTermList
        }
        displayAutoCompleteShipViaList={this.displayAutoCompleteShipViaList}
        displayAutoCompleteShipToList={this.displayAutoCompleteShipToList}
        displayAutoCompleteOrderTypeList={this.displayAutoCompleteOrderTypeList}
        displayAutoCompleteCsrList={this.displayAutoCompleteCsrList}
        displayAutoCompleteSalesClerkList={
          this.displayAutoCompleteSalesClerkList
        }
        showAutoCompleteList={this.state.showAutoCompleteList}
        showAutoCompleteCustomerList={this.state.showAutoCompleteCustomerList}
        showAutoCompleteOrderTypeList={this.state.showAutoCompleteOrderTypeList}
        showAutoCompletePaymentTermList={
          this.state.showAutoCompletePaymentTermList
        }
        showAutoCompleteShipToList={this.state.showAutoCompleteShipToList}
        showAutoCompleteShipViaList={this.state.showAutoCompleteShipViaList}
        showAutoCompleteCSRList={this.state.showAutoCompleteCSRList}
        showAutoCompleteSalesClerkList={
          this.state.showAutoCompleteSalesClerkList
        }
        addressClickHandler={this.addressClickHandler}
        closeModalCallBack={this.closeModalCallBack}
        openCustomerTransactionsInq={this.openCustomerTransactionsInq}
        openCustomerStatisticsInq={this.openCustomerStatisticsInq}
        openCustomerSalesHistoryInq={this.openCustomerSalesHistoryInq}
        openCustomerMostRecentFabricsInq={this.openCustomerMostRecentFabricsInq}
        openCustomerCurrentAgingInq={this.openCustomerCurrentAgingInq}
        openCustomerSalesDetailsInq={this.openCustomerSalesDetailsInq}
        onDeliveryTypeChange={this.onDeliveryTypeChange}
        deliveryTypeEnterKeyEventHandler={this.deliveryTypeEnterKeyEventHandler}
        displayAutoCompleteDeliveryTypeList={
          this.displayAutoCompleteDeliveryTypeList
        }
        openFabricAndCustomerDetailsInq={this.openFabricAndCustomerDetailsInq}
        lnkFabricStyleModule={this.lnkFabricStyleModule}
        openCustomerFabricSalesHistoryInq={
          this.openCustomerFabricSalesHistoryInq
        }
        openItemCurrentInvInq={this.openItemCurrentInvInq}
        openItemInvPositionInq={this.openItemInvPositionInq}
        openItemPurchaseHistoryInq={this.openItemPurchaseHistoryInq}
        openAtsInq={this.openAtsInq}
        openSalesPriceDetailsInq={this.openSalesPriceDetailsInq}
        openPriceWithOutCustomerDetailsInq={
          this.openPriceWithOutCustomerDetailsInq
        }
        openPriceWithCustomerDetailsInq={this.openPriceWithCustomerDetailsInq}
        commisionClickHandler={this.commisionClickHandler}
      />
    );
  }
  getListView() {
    return (
      <SalesOrderListForm
        {...this.state}
        salesOrderList={this.state.salesOrderList}
        pageList={this.state.pageList}
        salesOrderCriteria={this.state.salesOrderCriteria}
        filterSalesOrder={this.filterSalesOrder}
        loadFirst={this.loadFirst}
        loadNext={this.loadNext}
        loadPrevious={this.loadPrevious}
        loadLast={this.loadLast}
        editSalesOrder={this.editSalesOrder}
        resetFilteredSalesOrder={this.resetFilteredSalesOrder}
        isLoading={this.state.isLoading}
        getCriteriaString={this.getCriteriaString}
        moduleCaption={this.state.moduleCaption}
        onCriteriaChange={this.onCriteriaChange}
        handleSortingChange={this.handleSortingChange}
      />
    );
  }

  getShipToandAddressView() {
    return (
      <ShipToandAddressEntryForm
        {...this.state}
        salesOrderData={this.state.salesOrderData}
        onChange={this.onChange}
        onAddressChange={this.onAddressChange}
        cityList={this.state.cityList}
        stateList={this.state.stateList}
        countryList={this.state.countryList}
        disableSalesOrderFormFields={this.state.isDisableFields}
        isModifyPosible={this.isModifyPosible}
        shipTos={this.state.shipTos}
        onNodeShipToChange={this.onNodeShipToChange}
        shipToNodeEnterKeyEventHandler={this.shipToNodeEnterKeyEventHandler}
        displayAutoCompleteShipToNodeList={
          this.displayAutoCompleteShipToNodeList
        }
        displayAutoCompleteCityList={this.displayAutoCompleteCityList}
        cityEnterKeyEvent={this.cityEnterKeyEvent}
        onCityChange={this.onCityChange}
        displayAutoCompleteCountryList={this.displayAutoCompleteCountryList}
        countryEnterKeyEvent={this.countryEnterKeyEvent}
        onCountryChange={this.onCountryChange}
        displayAutoCompleteStateList={this.displayAutoCompleteStateList}
        stateEnterKeyEvent={this.stateEnterKeyEvent}
        onStateChange={this.onStateChange}
      />
    );
  }

  getCommissionFormView() {
    return (
      <CommissionEntryForm
        {...this.state}
        salesOrderData={this.state.salesOrderData}
        salesCommissionData={this.state.salesCommissionData}
        salesPersonList={this.state.salesPersonList}
        onChange={this.onChange}
        onCommissionChange={this.onCommissionChange}
        onAddorUpdateCommissionClick={this.onAddorUpdateCommissionClick}
        onClearCommissionClick={this.onClearCommissionClick}
        disableSalesOrderFormFields={this.state.isDisableFields}
        isModifyPosible={this.isModifyPosible}
        getSalesCommissionLineDetails={this.getSalesCommissionLineDetails}
        onSalesPersonCodeChange={this.onSalesPersonCodeChange}
        salesPersonEnterKeyEvent={this.salesPersonEnterKeyEvent}
        displayAutoCompleteSalesPersonList={
          this.displayAutoCompleteSalesPersonList
        }
        getSalesCommissionString={this.getSalesCommissionString}
        updateForSalesCommision={this.updateForSalesCommision}
      />
    );
  }

  getWebOrderView() {
    return (
      <WebOrderEntryForm
        {...this.state}
        salesOrderData={this.state.salesOrderData}
        disableSalesOrderFormFields={this.state.isDisableFields}
      />
    );
  }
  // getDocumentFormView = () => {
  //   return (
  //     <DocumentsForm
  //       {...this.state}
  //       setImgUrl={this.setImgUrl}
  //       setImgData={this.setImgData}
  //       uploadImage={this.uploadImage}
  //       uploadDoc={this.uploadDoc}
  //       deleteImage={this.deleteImage}
  //       deleteDoc={this.deleteDoc}
  //       showToast={this.showToast}
  //     />
  //   );
  // };
  getImageFormView = () => {
    return (
      <Images
        {...this.state}
        // setImgUrl={this.setImgUrl}
        // setImgData={this.setImgData}
        // uploadImage={this.uploadImage}
        // uploadDoc={this.uploadDoc}
        // deleteImage={this.deleteImage}
        // deleteDoc={this.deleteDoc}
        showToast={this.showToast}
        setMultiImageUrl={this.setMultiImageUrl}
        setMultiImgData={this.setMultiImgData}
        uploadMutiImage={this.uploadMutiImage}
        deleteMutipleImage={this.deleteMutipleImage}
        addImageLines={this.addImageLines}
        clearImageLines={this.clearImageLines}

      />
    );
  };

  getDocumentMutipleFormView = () => {
    return (
      <MutilpleDocuments
        {...this.state}
        salesOrderData={this.state.salesOrderData}
        documents={this.state.documents}
        // onChange={this.onChange}
        showToast={this.showToast}
        uploadMutiDouments={this.uploadMutiDouments}
        uploadMutiDoumentsUrl={this.uploadMutiDoumentsUrl}
        deleteMultiDocument={this.deleteMultiDocument}
        isTexco={this.state.isTexco}
      />
    );
  };
  uploadMutiDouments = (docs) => {
    let salesOrderData = this.state.salesOrderData;
    let documents = new Array();
    let docmentData = null;
    for (const doc of docs) {
      if (!doc.isFetched) {
        docmentData = new SalesOrderDocumentBean();
        docmentData.documentOriginalName = doc.name;
        docmentData.documentName = doc.name;
        docmentData.companyCode = this.companyCode;
        docmentData.invoiceNumber = salesOrderData.code;
        docmentData.documentPath = DOCUMENT_CHANGED;
        documents.push(docmentData);
      } else {
        documents.push(doc);
      }
    }
    salesOrderData.salesOrderDocument = documents;
    this.setState({
      salesOrderData: salesOrderData,
      documents: docs,
    });
  };
  uploadMutiDoumentsUrl = (url) => {
    setTimeout(() => {
      this.setState({
        preview_Docs: url,
      });
    }, 400);
  };

  deleteMultiDocument = (rowData) => {

    
    let docs = this.state.salesOrderData.salesOrderDocument;

    if (!isEmptyArray(docs)) {
      for (let j = 0; j < docs.length; j++) {
        if (docs[j].documentName === rowData.documentName) {
          if (docs[j].isFetched == true) {
            docs[j].deleted = true; // Change the value at index 2
            docs[j].isDeleted = true;
          } else {
            docs.splice(j, 1); // Change the value at index 2
            this.state.documents.splice(j, 1);
          }
        }
      }
    }

    this.state.salesOrderData.salesOrderDocument = docs;
  };
  getNoteFormView = () => {
    return (
      <NotesForm
        {...this.state}
        salesOrderData={this.state.salesOrderData}
        onChange={this.onChange}
      />
    );
  };
  getLineDetailView = () => {
    return (
      <SalesLineDetailsForm
        {...this.state}
        salesOrderData={this.state.salesOrderData}
        onChange={this.onChange}
      />
    );
  };
  getandSetPurchaseOrdersDetailsResponse = (response) => {
    if (
      !isEmpty(response) &&
      !isEmpty(response.data) &&
      !isEmpty(response.data.resultBean)
    ) {
      if (!isEmptyArray(response.data.resultBean.sourceSalesOrderDetailLines)) {
        let dependentPurchaseOrderList = [];
        dependentPurchaseOrderList =
          response.data.resultBean.sourceSalesOrderDetailLines;
        this.state.dependentPurchaseOrderList = dependentPurchaseOrderList;

        this.setState({
          dependentPurchaseOrderList: dependentPurchaseOrderList,
        });
      }
    }
  };
  getandSetPurchaseOrdersDetailsError = (error) => {
    ShowError("Error : " + error);
  };
  getandSetPurchaseOrdersDetails = () => {
    let soData = this.state.salesOrderData;
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = soData.code;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      PurchaseOrderService.getSalesOrderDependentPurchaseOrdersDetails(
        input,
        this.getandSetPurchaseOrdersDetailsResponse,
        this.getandSetPurchaseOrdersDetailsError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getPurchaseOrdersFormView = () => {
    return (
      <PurchaseOrdersForm
        salesOrderData={this.state.salesOrderData}
        dependentPurchaseOrderList={this.state.dependentPurchaseOrderList}
      />
    );
  };
  displayPickTicketModule = (val) => { };
  getPickTicketsandInvoicesFormView = () => {
    return (
      <PickticketsandInvoicesForm
        salesOrderData={this.state.salesOrderData}
        dependenciesBean={this.state.dependenciesBean}
        displayPickTicketModule={this.displayPickTicketModule}
      />
    );
  };
  getChangesHistoryFormView = () => {
    return (
      <ChangesHistoryForm
        salesOrderData={this.state.salesOrderData}
        uploadDocument={this.uploadDocument}
        getSOImagePath={this.getSOImagePath}
        lnkDocumentDetailClick={this.lnkDocumentDetailClick}
      />
    );
  };

  onKeyPress = (e) => {
    if (e.keyCode == 120) {
      this.addorUpdateMultipleSOLine();
    }
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowPopup: isShowPopup,
      isShowAlert: isShowPopup,
      isShowPickTicketAdvPopup: isShowPopup,
      isShowPricePopup: isShowPopup,
      isShowGeneratePOPopup: isShowPopup,
      isShowMailPopup: false,
      isAllowRead: true,
      isAllowReadColor: true,
      isShowCopySOPopup: isShowPopup,
      isShowChangeCustomerPopup: false,
      isShowAutoCompleteNewCustomerList: false,
      newCustomerPageListForAutoCompleteList: new Array(),
      copySONum: "",
      fabricStyleData: new FabricStyleBean(),
      isShowMailAlert: false,
      fabricInventoryList: new Array(),
      skuInventoryList: new Array(),

      colorList: new Array(),
    });
    // this.clearPoData();
  };
  closeAlertModalNewPoCallBack = (isShowPopup) => {
    this.setState({
      isShowGeneratePOPopup: isShowPopup,
    });
    this.clearPoData();
    this.hidePopupAlertNewPoCallBack();
  };
  hidePopupAlertNewPoCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowPopupAlert: isDisplayed }, () => {
      setTimeout(() => {
        if (this.purchaseOrderNumberCreateRef.current != null) {
          this.purchaseOrderNumberCreateRef.current.clear();
        }
      }, 0);
    });
  };
  closeAlertModalNewPTCallBack = (isShowPopup) => {
    this.setState({
      isShowPickTicketAdvPopup: isShowPopup,
    });
    this.hidePopupAlertNewPtCallBack();
  };

  hidePopupAlertNewPtCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowPtAdvPopupAlert: isDisplayed }, () => {
      setTimeout(() => {
        if (this.pickTicketNumberCreateRef.current != null) {
          this.pickTicketNumberCreateRef.current.clear();
          // this.pickTicketNumberCreateRef.current.focus();
        }
      }, 0);
    });
  };

  closeAlertProgressBarModalCallBack = (isShowPopup) => {
    this.setState({
      isShowProgressBarPopup: isShowPopup,
    });
  };
  closeAlertFabricModalCallBack = (isShowPopup) => {
    this.setState({
      isShowAlert: isShowPopup,
      // isShowCustomerFabricSalesPopup: isShowPopup,
      // isShowFabricCurrentInvPopup: isShowPopup,
      // isShowFabricInventoryPosPopup: isShowPopup,

      // isShowFabricPurchaseHistoryPopup: isShowPopup,
      // isShowFabricAtsPopup: isShowPopup,
    });
  };
  closeAlertSubModalCallBack = (isShowPopup) => {
    this.setState({
      isShowAlert: isShowPopup,

      isShowPricePopup: isShowPopup,
      isShowAdjustQtyPopup: isShowPopup,
      isShowOnHandQtyPopup: isShowPopup,
      isShowOnHandLotQtyPopup: isShowPopup,
    });
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    if (this.fabricStyleCodeRef.current != null) {
      this.fabricStyleCodeRef.current.clear();
      this.fabricStyleCodeRef.current.focus();
    }
    this.setState({
      isShowAlert: isDisplayed,
      isShowMailAlert: isDisplayed,
      isShowPtAdvPopupAlert: isDisplayed,
    });
  };
  hidePopupAlertCallBack = (msgType, isDisplayed) => {
    if (this.fabricStyleCodeRef.current != null) {
      this.fabricStyleCodeRef.current.clear();
      this.fabricStyleCodeRef.current.focus();
    }
    this.setState({ isShowPopupAlert: isDisplayed });
  };

  hideAlertCallBackLvl6 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl6: isDisplayed });
  };

  selectAllLine = (e) => {
    if (e.detail == 1) {
      let ptData = this.state.pickTicketBean;
      let list = ptData.pickTicketLines;
      let isSelectedAll; //= e.target.value == true;
      list.map((line, i) => {
        line.isActive = true;
      });
      this.setState({ selectedSOLineList: list });
    }
  };
  unSelectAllLine = (e) => {
    if (e.detail == 1) {
      let ptData = this.state.pickTicketBean;
      let list = ptData.pickTicketLines;
      list.map((line, i) => {
        line.isActive = false;
      });
      this.setState({ selectedSOLineList: [] });
    }
  };
  // ptLineCheck = (val, rowData) => {
  //   let selectedLine = this.state.selectedSOLineList;
  //   if (rowData.isActive === true) {
  //     selectedLine.push(rowData);
  //     this.setState({ selectedSOLineList: selectedLine });
  //   } else {
  //     // this.state.selectedRollSkuList.filter(sp => sp.isActive === rowData.isActive)
  //     let selectedSOLineList = this.state.selectedSOLineList;
  //     let ptList = [];
  //     for (let line of selectedSOLineList) {
  //       if (line.isActive != rowData.isActive) {
  //         ptList.push(line);
  //         this.setState({ selectedSOLineList: ptList });
  //       }
  //     }
  //   }
  // };

  ptLineCheck = (e, rowData) => {
    const selectedSOLineList = [...this.state.selectedSOLineList];

    if (e.target.value) {
      rowData.isActive = true;
      selectedSOLineList.push(rowData);
    } else {
      rowData.isActive = false;

      const index = selectedSOLineList.findIndex(
        (item) => item.SKUNumber === rowData.SKUNumber,
      );

      if (index > -1) {
        selectedSOLineList.splice(index, 1);
      }
    }

    this.setState({ selectedSOLineList });
  };

  ptColumnDefinitions = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", false)
        .setInputDetails(false, false, true, null, this.ptLineCheck, null)
        .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyleCode", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyleName", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SKU#", "skuNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("orderQuantity", "orderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ToBePickedQuantity", "orderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );

    return columns;
  };

  showPricePopup = (e, val, rowData) => {
    if (
      e.detail == 1 &&
      rowData.fabricStyleCode != null &&
      rowData.fabricStyleCode != ""
    ) {
      if (val > 0) {
        this.setState({
          isShowPricePopup: true,
          priceData: rowData,
          isLoading: true,
          loadingText: "Loading",
        });
        let input = new RestReadRequest();
        input.companyCode = this.companyCode;
        input.code = rowData.fabricStyleCode;
        input.isLoadChildren = true;
        if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
          FabricStyleService.readFabricStyle(
            input,
            this.readFabricResponse,
            this.readFabricError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  readFabricResponse = (response) => {
    let fabricStyle = response.data.fabricStyle;
    let priceData = this.state.priceData;
    let salesOrderData = this.state.salesOrderData;
    let priceBean = this.state.priceBean;
    priceBean.companyCode = this.companyCode;
    priceBean.fabricStyleCode = fabricStyle.code;
    priceBean.fabricStyleName = fabricStyle.description;
    priceBean.fabricStyleColorCode = priceData.colorCode;
    priceBean.customerCode = salesOrderData.customerCode;
    priceBean.customerName = salesOrderData.customerName;
    priceBean.customerTypeCode = salesOrderData.customerType;
    priceBean.itemWholeSalePrice = fabricStyle.wholesalePrice;
    priceBean.itemRetailPrice = fabricStyle.retailPrice;
    priceBean.itemCloseOutPrice = fabricStyle.closeOutPrice;
    priceBean.itemSamplePrice = fabricStyle.samplePrice;
    priceBean.itemSkuWholeSalePrice = priceData.price;
    priceBean.customerTypePrice = fabricStyle.customerTypePrice;
    priceBean.customerTypeSamplePrice = fabricStyle.customerTypeSamplePrice;
    priceBean.customerPrice = fabricStyle.customerPrice;

    this.setState({ priceBean: priceBean, isLoading: false, loadingText: "" });
  };
  readFabricError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : ", error);
  };
  lnkAdjustQtyClick = (e, val, rowData) => {
    if (e.detail == 1) {
      this.setState({ isShowAdjustQtyPopup: true });
      let salesOrderData = this.state.salesOrderData;
      let adjustLineBean = this.state.adjustLineBean;
      adjustLineBean.companyCode = this.companyCode;
      adjustLineBean.salesOrderNumber = rowData.salesOrderNumber;
      adjustLineBean.orderTypeCode = salesOrderData.orderTypeCode;
      adjustLineBean.salesOrderLineNumber = rowData.salesOrderLineNumber;
      adjustLineBean.fabricStyleCode = rowData.fabricStyleCode;
      adjustLineBean.fabricStyleName = rowData.fabricStyleName;
      adjustLineBean.colorCode = rowData.colorCode;
      adjustLineBean.widthCode = rowData.widthCode;
      adjustLineBean.uomCode = rowData.adjustedUomCode;
      adjustLineBean.orderQuantity = rowData.orderQuantity;
      adjustLineBean.adjustedQuantity = rowData.adjustedQuantity;
      let adjustmentLines = rowData.adjustmentLines;
      this.setState({
        adjustLineBean: adjustLineBean,
        adjustmentLines: adjustmentLines,
      });
    }
  };
  //Create PurchaseOrder Generate PO
  poOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria[e.target.name] = e.target.value;

    this.setState({ criteria: criteria });
  };

  selectAllSoLine = (e) => {
    let salesOrderDataLines = this.state.salesOrderData.lines;
    let list = salesOrderDataLines;
    let isSelectedAll; //= e.target.value == true;
    list.map((line, i) => {
      line.isActive = true;
    });
    this.setState({ selectedLineList: list });
  };
  unSelectAllSoLine = (e) => {
    let salesOrderDataLines = this.state.salesOrderData.lines;
    let list = salesOrderDataLines;
    list.map((line, i) => {
      line.isActive = false;
    });
    this.setState({ selectedLineList: [] });
  };
  // poLineCheck = (e,rowData,val) => {

  //   let selectedLine = this.state.selectedLineList;
  //   if (e.value === true) {
  //     rowData.isActive = e.value;
  //     selectedLine.push(rowData);
  //     this.setState({ selectedLineList: selectedLine });
  //   } else {
  //     let selectedLineList = this.state.selectedLineList;
  //     let list = [];
  //     for (let soLine of selectedLineList) {
  //       if (soLine.isActive != e.value) {
  //           soLine.isActive = e.value;
  //         list.push(soLine);
  //         this.setState({ selectedLineList: list });
  //       }
  //     }
  //   }
  // };

  poLineCheck = (e, rowData) => {
    const selectedLineList = [...this.state.selectedLineList];

    if (e.target.value) {
      rowData.isActive = true;
      selectedLineList.push(rowData);
    } else {
      rowData.isActive = false;

      const index = selectedLineList.findIndex(
        (item) => item.SKUNumber === rowData.SKUNumber,
      );

      if (index > -1) {
        selectedLineList.splice(index, 1);
      }
    }

    this.setState({ selectedLineList });
  };

  validateGeneratePOLine = (criteria) => {
    let isValidPOLine = false;
    let err_list = [];
    let errorMessage = "";
    if (criteria == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(criteria.vendorCode)) {
        let errMsg = "Vendor is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(criteria.locationCode)) {
        let errMsg = "Location is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(criteria.orderStartDate)) {
        let errMsg = "StartDate is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(criteria.orderStopDate)) {
        let errMsg = "StopDate is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (!isEmptyString(criteria.purchaseOrderNumber)) {
        if (this.state.isPurchaseNumberExist === true) {
          let errMsg = "PurchaseOrderNumber  is Exist";
          errorMessage = errorMessage + errMsg;
          err_list.push(errMsg);
        }
      }
      if (this.state.selectedLineList.length === 0) {
        let errMsg = "Select Lines !";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidPOLine = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    } else {
      isValidPOLine = true;
      this.setState({ isShowPopupAlert: false });
    }
    return isValidPOLine;
  };

  createPurchaseOrder = (e) => {
    if (e.detail == 1) {
      let salesOrderData = { ...this.state.salesOrderData };
      let selectedLineList = this.state.selectedLineList;
      let criteria = this.state.criteria;
      criteria.salesOrderNumber = salesOrderData.code;
      if (isEmpty(criteria.purchaseOrderNumber)) {
        criteria.purchaseOrderNumber = NEW_ENTRY;
      }
      // criteria.purchaseOrderNumber = NEW_ENTRY;
      criteria.orderStatus = "O";
      salesOrderData.lines = selectedLineList;
      let request = new RestPurchaseorderForSalesOrderRequest();
      request.companyCode = this.companyCode;
      request.criteria = criteria;
      request.salesOrderBean = salesOrderData;
      let isValidLine = false;
      isValidLine = this.validateGeneratePOLine(criteria);
      if (isValidLine) {
        if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
          SalesOrderService.generatePurchaseorderForSalesOrder(
            request,
            this.createPOResponse,
            this.createPOError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowPopupAlert: true,
          });
        }
      }
      this.setState({
        isLoading: true,
        loadingText: "Generating Purchase Order ..",
      });
    }
  };
  poCreateEntryKey = (e) => {
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = e.target.value;

    PurchaseOrderService.readPurchaseOrder(
      request,

      this.poCheckResponse,
      this.errorCallBack,
    );
  };
  // poCheckResponse = (response) =>{

  //   let isExisting = false;
  //   if(!isEmpty(response.data.purchaseOrder)) {

  //         isExisting = true

  //      let errMsg = "Purchase Number Already Exist!";
  //     let errList = [];
  //     errList.push(errMsg);
  //      this.setState({
  //       isPurchaseNumberExist:isExisting,
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowPopupAlert: true,
  //     });

  //   }  else {

  //       isExisting = false;
  //         this.setState({
  //       isPurchaseNumberExist:isExisting,

  //     });
  //   }

  // }
  poCheckResponse = (response) => {
    const isExisting = !isEmpty(response.data.purchaseOrder);

    if (isExisting) {
      this.setState({
        isPurchaseNumberExist: true,
        alertMessage: ["Purchase Number Already Exists!"],
        alertType: "danger",
        isShowPopupAlert: true,
      });
    } else {
      this.setState({
        isPurchaseNumberExist: false,
      });
    }
  };

  createPOResponse = (response) => {
    let success = this.handleResponse(response.data);
    if (success === true) {
      this.clearPoData();
    }
    this.setState({
      isLoading: false,
    });
  };
  createPOError = (error) => {
    this.setState({ isLoading: false });
    ShowError("Error :", error);
  };
  clearPoData = () => {
    let criteria = new PurchaseOrderSearchCriteria();
    let salesOrderData = { ...this.state.salesOrderData };
    if (salesOrderData.lines != null) {
      salesOrderData.lines.map((line, i) => {
        line.isActive = false;
      });
    }
    this.setState({ criteria: criteria, salesOrderData: salesOrderData });
    this.setState({ isShowGeneratePOPopup: false });
  };
  mailOnChange = (e) => {
    let mailInfoBean = this.state.mailInfoBean;
    mailInfoBean[e.target.name] = e.target.value;
    this.setState({ mailInfoBean: mailInfoBean });
  };
  createMail = () => {
    this.setState({
      isShowMailPopup: true,
      isLoading: true,
      loadingText: "Creating Mail ..",
    });
    let salesOrderData = this.state.salesOrderData;
    let request = new RestPackingListMailRequest();
    request.companyCode = this.companyCode;
    request.entityCode = salesOrderData.code;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      SalesOrderService.fetchSalesOrderMailCustomerDefaultInfoBean(
        request,
        this.fetchMailResponse,
        this.fetchMailError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  fetchMailResponse = (response) => {
    if (response.data != null) {
      let mailInfo = response.data.mailDefaultInfo;
      if (mailInfo != null) {
        this.setState({ mailInfoBean: mailInfo });
      }
    }
    this.setState({
      isLoading: false,
    });
  };
  fetchMailError = (error) => {
    this.setState({ isLoading: false });
    ShowError("Error :", error);
  };
  sendMail = (e) => {
    let mailInfoBean = this.state.mailInfoBean;
    let salesOrderData = this.state.salesOrderData;
    let reportBean = new RestReportBean();
    let request = new RestPackingListMailRequest();
    request.companyCode = this.companyCode;
    request.entityCode = salesOrderData.code;
    request.infoBean = mailInfoBean;
    request.inputReportBean = reportBean;
    if (SecurityAccessManager.SalesOrderMaintenanceSendMail_IsAccessible()) {
      SalesOrderService.sendSalesOrderCustomerMail(
        request,
        this.sendMailResponse,
        this.sendMailError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  sendMailResponse = (response) => {
    let success = this.handlePopupResponse(response.data);
    if (success == true) {
      this.setState({
        isShowMailPopup: false,
      });
    }
  };
  sendMailError = (error) => {
    ShowError("error :", error);
  };
  lnkFabricStyleModule = (e, data) => {
    if (e.detail === 1) {
      if (data) {
        let fabricStyleCode = data;
        // let salesOrderLineData = this.state.salesOrderLineData;
        //let fabricStyleCode = salesOrderLineData.fabricStyleCode;
        if (fabricStyleCode !== "" && fabricStyleCode !== undefined) {
          this.setState({
            isShowFabricStyleModule: true,
            moduleForPopup: (
              <PopupFabricStyleModule
                fabricStyleCode={fabricStyleCode}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      }
    } else {
      let salesOrderLineData = this.state.salesOrderLineData;
      let fabricStyleCode = salesOrderLineData.fabricStyleCode;
      if (fabricStyleCode !== "" && fabricStyleCode !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={fabricStyleCode}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowCustomerSalesHistoryInq: isOpen,
      isShowItemInventoryPositionInq: isOpen,
      isShowItemCurrentInventoryInq: isOpen,
      isShowFabricPurchaseHistoryInq: isOpen,
      isShowAtsInq: isOpen,
      isShowCustomerOnOrderInq: isOpen,
      isShowCustomerTransactionsInq: isOpen,
      isShowCustomerStatisticsInq: isOpen,
      isShowCustomerMostRecentFabricsInq: isOpen,
      isCustomerCurrentAgingInq: isOpen,
      isCustomerSalesAndPurchaseDetailsInq: isOpen,
      isShowfabricAndCustomerSalesDetails: isOpen,
      isShowItemSalesDetails: isOpen,
      moduleForPopup: [],
    });
  };

  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  // lnkCustomerFabricSalesModule = (e) => {
  //   this.setState({ isShowCustomerFabricSalesPopup: true });
  // };
  // pdfCustomerFabricSalesHistory = () => {
  //   this.generateFabricSalesReport(1);
  // };
  // excelCustomerFabricSalesHistory = () => {
  //   this.generateFabricSalesReport(2);
  // };
  // generateFabricSalesReport = (reportType) => {
  //   let reportBean = new RestReportBean();
  //   reportBean.reportType = reportType;
  //   let salesOrderData = this.state.salesOrderData;
  //   let salesOrderLineData = this.state.salesOrderLineData;
  //   let criteria = new CustomerInvoiceInquiryCriteriaBean();
  //   criteria.companyCode = this.companyCode;
  //   criteria.customerCode = salesOrderData.customerCode;
  //   criteria.fabricStyleCode = salesOrderLineData.fabricStyleCode;

  //   let requestInput = new CustomerAndFabricSalesDetailPrintRequest();
  //   requestInput.criteria = criteria;
  //   requestInput.input = reportBean;
  //   if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
  //     ReportService.generateCustomerAndFabricSalesDetailPrintReport(
  //       requestInput,
  //       this.generateCustomerFabricSalesReportResponse,
  //       this.generateCustomerFabricSalesReportError
  //     );
  //   } else {
  //     let errMsg = "Access Denied";
  //     let errList = [];
  //     errList.push(errMsg);
  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowAlert: true,
  //     });
  //   }
  // };
  // generateCustomerFabricSalesReportResponse = (response) => {
  //   let reportFilePath = response.data.reportResult.reportFileID;
  //   window.open(this.report_url + reportFilePath);
  // };
  // generateCustomerFabricSalesReportError = (error) => {
  //   ShowError("Error : " + error);
  // };
  //Fabric Current Inventory Level
  // lnkFabricCurrentInvModule = (e) => {
  //   this.setState({ isShowFabricCurrentInvPopup: true });
  // };
  //Fabric Inventory Position
  // lnkFabricInventoryPosition = (e) => {
  //   this.setState({ isShowFabricInventoryPosPopup: true });
  // };
  openItemPurchaseHistoryInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowFabricPurchaseHistoryInq: true,
          moduleForPopup: (
            <PopupFabricPurchaseHistoryInq
              fabricCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  openCustomerFabricSalesHistoryInq = (e, code, lineData) => {
    let salesOrderData = this.state.salesOrderData;
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowCustomerSalesHistoryInq: true,
          moduleForPopup: (
            <PopupCustomerSalesHistoryInq
              fabricCode={code}
              onModuleExit={this.onPopupModalExit}
              customerCode={salesOrderData.customerCode}
            />
          ),
        });
      }
    }
  };

  openItemInvPositionInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowItemInventoryPositionInq: true,
          moduleForPopup: (
            <PopupFabricInventoryPositionInq
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  openItemCurrentInvInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowItemCurrentInventoryInq: true,
          moduleForPopup: (
            <PopupItemCurrentInventoryInq
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  openAtsInq = (e, code, name, colorCode) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowAtsInq: true,
          moduleForPopup: (
            <PopupAtsInq
              code={code}
              fabricName={name}
              colorCode={colorCode}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  openFabricAndCustomerDetailsInq = (e, code, customerCode) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowfabricAndCustomerSalesDetails: true,
          moduleForPopup: (
            <PopupPurchaseAndSlesDetailsInq
              fabricStyleCode={code}
              customerCode={customerCode}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  openSalesPriceDetailsInq = (e, code, customerCode) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowItemSalesDetails: true,
          moduleForPopup: (
            <PopupSalesPriceInq
              fabricStyleCode={code}
              customerCode={customerCode}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  openPriceWithOutCustomerDetailsInq = (e, code, rowData) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowItemSalesDetails: true,
          moduleForPopup: (
            <PopupSalesPriceInq
              fabricStyleCode={code}
              // customerCode={rowData.customerCode}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  openPriceWithCustomerDetailsInq = (e, code, rowData) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowItemSalesDetails: true,
          moduleForPopup: (
            <PopupSalesPriceInq
              fabricStyleCode={code}
              customerCode={rowData.customerCode}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  openCustomerTransactionsInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowCustomerTransactionsInq: true,
          moduleForPopup: (
            <PopupCustomerTransactionsInq
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  openCustomerStatisticsInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowCustomerStatisticsInq: true,
          moduleForPopup: (
            <PopupCustomerStatisticsInq
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  openCustomerSalesHistoryInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowCustomerSalesHistoryInq: true,
          moduleForPopup: (
            <PopupCustomerSalesHistoryInq
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  openCustomerMostRecentFabricsInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowCustomerMostRecentFabricsInq: true,
          moduleForPopup: (
            <PopupCustomerMostRecentFabricsInq
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  openCustomerCurrentAgingInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isCustomerCurrentAgingInq: true,
          moduleForPopup: (
            <PopupCustomerCurrentAgingInq
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  //openCustomerSalesDetailsInq
  openCustomerSalesDetailsInq = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isCustomerSalesAndPurchaseDetailsInq: true,
          moduleForPopup: (
            <PopupPurchaseAndSlesDetailsInq
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  // pdfFabricInventoryPosition = () => {
  //   this.generateFabricInventory(1);
  // };
  // excelFabricInventoryPosition = () => {
  //   this.generateFabricInventory(2);
  // };
  // generateFabricInventory = (reportType) => {
  //   let reportBean = new RestReportBean();
  //   reportBean.reportType = reportType;
  //   let salesOrderLineData = this.state.salesOrderLineData;
  //   let criteria = new CustomerInvoiceInquiryCriteriaBean();
  //   criteria.companyCode = this.companyCode;
  //   criteria.fabricStyleCode = salesOrderLineData.fabricStyleCode;
  //   let requestInput = new SalesPurchasePositionCriteriaBeanRequest();
  //   requestInput.criteria = criteria;
  //   requestInput.reportBean = reportBean;
  //   if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
  //     ReportService.generateInventorySalesPurchasePositionReport(
  //       requestInput,
  //       this.generatFabricInventoryReportResponse,
  //       this.generateFabricInventoryReportError
  //     );
  //   } else {
  //     let errMsg = "Access Denied";
  //     let errList = [];
  //     errList.push(errMsg);
  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowAlert: true,
  //     });
  //   }
  // };
  // generatFabricInventoryReportResponse = (response) => {
  //   let reportFilePath = response.data.reportResult.reportFileID;
  //   window.open(this.report_url + reportFilePath);
  // };
  // generateFabricInventoryReportError = (error) => {
  //   ShowError("Error :", error);
  // };
  //Fabric Purchase History
  // lnkFabricPurchaseHistory = (e) => {
  //   this.setState({ isShowFabricPurchaseHistoryPopup: true });
  // };
  // pdfFabricPurchaseHistory = () => {
  //   this.generateFabricPurchaseHistory(1);
  // };
  // excelFabricPurchaseHistory = () => {
  //   this.generateFabricPurchaseHistory(2);
  // };
  // generateFabricPurchaseHistory = (reportType) => {
  //   let salesOrderLineData = this.state.salesOrderLineData;
  //   let criteria = new FabricStylePurchaseHistoryCriteriaBean();
  //   criteria.companyCode = this.companyCode;
  //   criteria.fabricStyleCode = salesOrderLineData.fabricStyleCode;
  //   let reportBean = new RestReportBean();
  //   reportBean.reportType = reportType;
  //   let listRequest = new FabricStylePurchaseOrderHistoryPrintRequest();
  //   listRequest.criteria = criteria;
  //   listRequest.reportBean = reportBean;
  //   if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
  //     ReportService.generateFabricStylePurchaseOrderHistoryPrintReport(
  //       listRequest,
  //       this.generateFabricStylePurchaseOrderHistoryPageResponse,
  //       this.generateFabricStylePurchaseOrderHistoryPageError
  //     );
  //   } else {
  //     let errMsg = "Access Denied";
  //     let errList = [];
  //     errList.push(errMsg);
  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowAlert: true,
  //     });
  //   }
  // };
  // generateFabricStylePurchaseOrderHistoryPageResponse = (response) => {
  //   let reportFilePath = response.data.reportResult.reportFileID;
  //   window.open(this.report_url + reportFilePath);
  // };
  // generateFabricStylePurchaseOrderHistoryPageError = (error) => {
  //   ShowError("Erro : " + error);
  // };
  //Fabric Ats
  // lnkFabricAts = (e) => {
  //   this.setState({ isShowFabricAtsPopup: true });
  // };
  //ShipToAddressEntry
  onCityChange = (e) => {
    let temp_salesOrderData = this.state.salesOrderData;
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let tempAddress = this.state.soAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let tempAddress = this.state.soAddressData;
      tempAddress.city = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        soAddressData: tempAddress,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    if (
      !isEmpty(temp_salesOrderData) &&
      !isEmpty(temp_salesOrderData.address) &&
      e.target.name == "city"
    ) {
      tempAddress = temp_salesOrderData.address;
      tempAddress["city"] = e.target.value;
      let city_List = this.state.cityList;
      city_List.map((city) => {
        if (city.code == e.target.value) {
          tempAddress["city"] = city.code;
          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ salesOrderData: temp_salesOrderData });
  };
  readcityBySearchString(searchString) {
    let cityData = this.state.cityList;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEvent = (e) => {
    let temp_salesOrderData = this.state.salesOrderData;
    let tempAddress = new AddressBean();
    if (
      !isEmpty(temp_salesOrderData) &&
      !isEmpty(temp_salesOrderData.address)
    ) {
      tempAddress = temp_salesOrderData.address;
      tempAddress[e.target.name] = e.target.value;
    }

    this.setState({
      salesOrderData: temp_salesOrderData,
      cityPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };
  onStateChange = (e) => {
    let temp_salesOrderData = this.state.salesOrderData;
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;
    let tempAddress = this.state.soAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;
    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let tempAddress = this.state.soAddressData;
      tempAddress.state = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteStateList: showAutoCompleteList,
        soAddressData: tempAddress,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readstateBySearchString(state);
    }
    if (
      !isEmpty(temp_salesOrderData) &&
      !isEmpty(temp_salesOrderData.address) &&
      e.target.name == "state"
    ) {
      tempAddress = temp_salesOrderData.address;
      tempAddress["state"] = e.target.value;
      let state_List = this.state.stateList;
      state_List.map((state) => {
        if (state.code == e.target.value) {
          tempAddress["state"] = state.code;
          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteStateList: showAutoCompleteList });
        }
      });
    }

    this.setState({ salesOrderData: temp_salesOrderData });
  };
  readstateBySearchString(searchString) {
    let stateData = this.state.stateList;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletestateLists) =>
        simpleAutoCompletestateLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEvent = (e) => {
    let temp_salesOrderData = this.state.salesOrderData;
    let tempAddress = new AddressBean();
    if (
      !isEmpty(temp_salesOrderData) &&
      !isEmpty(temp_salesOrderData.address)
    ) {
      tempAddress = temp_salesOrderData.address;
      tempAddress[e.target.name] = e.target.value;
    }

    this.setState({
      salesOrderData: temp_salesOrderData,
      statePageListForAutoCompleteList: new Array(),
    });
  };

  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };
  onCountryChange = (e) => {
    let temp_salesOrderData = this.state.salesOrderData;
    let country = e.target.value;
    this.state.showAutoCompleteCountryList = true;
    let tempAddress = this.state.soAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryList;
      let tempAddress = this.state.soAddressData;
      tempAddress.country = "";

      let suggestion = [];
      this.setState({
        showAutoCompleteCountryList: showAutoCompleteList,
        soAddressData: tempAddress,
        countryPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readcountryBySearchString(country);
    }
    if (
      !isEmpty(temp_salesOrderData) &&
      !isEmpty(temp_salesOrderData.address) &&
      e.target.name == "country"
    ) {
      tempAddress = temp_salesOrderData.address;
      tempAddress["country"] = e.target.value;
      let country_List = this.state.countryList;
      country_List.map((country) => {
        if (country.code == e.target.value) {
          tempAddress["country"] = country.code;
          this.state.showAutoCompleteCountryList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryList;
          this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
        }
      });
    }
    this.setState({ salesOrderData: temp_salesOrderData });
  };
  readcountryBySearchString(searchString) {
    let countryData = this.state.countryList;
    let simpleAutoCompleteList = new Array();
    if (countryData.length > 0 && countryData != null) {
      countryData.map((countryDatas) => {
        let simpleItemBean = {
          code: countryDatas.code,
          description: countryDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecountryLists) =>
        simpleAutoCompletecountryLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ countryPageListForAutoCompleteList: filteredSuggestions });
  }
  countryEnterKeyEvent = (e) => {
    let temp_salesOrderData = this.state.salesOrderData;
    let tempAddress = new AddressBean();
    if (
      !isEmpty(temp_salesOrderData) &&
      !isEmpty(temp_salesOrderData.address)
    ) {
      tempAddress = temp_salesOrderData.address;
      tempAddress[e.target.name] = e.target.value;
    }
    this.setState({
      salesOrderData: temp_salesOrderData,
      countryPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteCountryList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
  };
  getSoLineImagePathMain = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let mainImage = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Main" &&
          fabricStyle.fabricStyleImages[i].deleted == false
        ) {
          mainImage = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getFabricImageURL();
      let imageName = mainImage.imageName;
      let imageURL = serviceURL + imageName;

      if (mainImage.deleted) {
        imageURL = "";
      }
      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };
  getSoLineImagePathWeb = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let mainImage = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Web" &&
          fabricStyle.fabricStyleImages[i].deleted == false
        ) {
          mainImage = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getFabricImageURL();
      let imageName = mainImage.imageName;
      let imageURL = serviceURL + imageName;
      if (mainImage.deleted) {
        imageURL = "";
      }
      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };
  getSoLineImagePathFront = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let mainImage = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Front" &&
          fabricStyle.fabricStyleImages[i].deleted == false
        ) {
          mainImage = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getFabricImageURL();
      let imageName = mainImage.imageName;
      let imageURL = serviceURL + imageName;

      if (mainImage.deleted) {
        imageURL = "";
      }

      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };
  getSoLineImagePathBack = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let mainImage = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Back" &&
          fabricStyle.fabricStyleImages[i].deleted == false
        ) {
          mainImage = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getFabricImageURL();
      let imageName = mainImage.imageName;
      let imageURL = serviceURL + imageName;

      if (mainImage.deleted) {
        imageURL = "";
      }

      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };

  getFabricImageURL = () => {
    const { appData } = this.context;
    let serviceURL = appData.serviceURL;
    let imageURL = serviceURL + "/image?file=";
    return imageURL;
  };

  validateNewCustomer = () => {
    let isValid = true;
    let err_list = [];
    let newCustomerData = this.state.changeCustomerBaseBean;
    if (isEmptyString(newCustomerData.code)) {
      let errMsg = "Customer is Required";
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl6: true,
      });
      isValid = false;
    }
    return isValid;
  };
  continueToChangeNewCustomer = () => {
    let isValid = this.validateNewCustomer();
    let warningMessage = "";
    if (isValid) {
      warningMessage =
        "[Warning] Customer Change Detected." +
        "\n" +
        "The current sale contains item details." +
        "\n" +
        "Do you want to proceed by keeping the existing items or clearing them for the selected customer?";

      this.setState({
        warningMessage: warningMessage,
      });
      this.warningMessageForChangeItems();
    }
  };
  warningMessageForChangeItems = () => {
    this.setState({
      isShowWarningMsgPopup: true,
    });
  };
  onYesButtonClick = (isSavedWithWarning) => {
    this.isSavedWithWarning(true);
  };
  onNoButtonClick = (isSavedWithWarning) => {
    this.isSavedWithWarning(false);
  };
  isSavedWithWarning = (isSavedWithWarning) => {
    this.state.isSavedWithWarning = isSavedWithWarning;
    this.setState({
      isSavedWithWarning: isSavedWithWarning,
    });
    if (isSavedWithWarning) {
      this.saveChangesCustomerAndItems();
    } else {
      this.saveChangesCustomer();
    }
    this.closeMessageModelCallBack();
  };
  closeMessageModelCallBack = () => {
    this.setState({ isShowWarningMsgPopup: false });
  };
  saveChangesCustomerAndItems = () => {
    let salesOrderData = this.state.salesOrderData;
    let newCustomerData = this.state.changeCustomerBaseBean;
    salesOrderData.customerCode = newCustomerData.code;
    salesOrderData.customerName = newCustomerData.description;
    if (!isEmptyArray(salesOrderData.lines)) {
      salesOrderData.lines.map((ln) => {
        ln.isDeleted = true;
      });
    }
    this.setState({
      salesOrderData: salesOrderData,
      isShowChangeCustomerPopup: false,
    });
  };
  saveChangesCustomer = () => {
    let salesOrderData = this.state.salesOrderData;
    let newCustomerData = this.state.changeCustomerBaseBean;
    salesOrderData.customerCode = newCustomerData.code;
    salesOrderData.customerName = newCustomerData.description;
    this.setState({
      salesOrderData: salesOrderData,
      isShowChangeCustomerPopup: false,
    });
  };
  changeCustomer = () => {
    this.setState({
      isShowChangeCustomerPopup: true,
      changeCustomerBaseBean: new BaseBean(),
    });

    setTimeout(() => {
      if (this.newCustomerRef.current != null) {
        this.newCustomerRef.current.focus();
      }
    }, 100);
  };
  newCustomerCodeOnChange = (e) => {
    let newCustomerCode = e.target.value;
    this.state.isShowAutoCompleteNewCustomerList = true;
    let tempData = this.state.changeCustomerBaseBean;
    let showAutoCompleteList = this.state.isShowAutoCompleteNewCustomerList;
    if (isEmpty(newCustomerCode)) {
      this.state.isShowAutoCompleteNewCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteNewCustomerList;
      let tempData = this.state.changeCustomerBaseBean;
      tempData.code = "";
      tempData.description = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteNewCustomerList: showAutoCompleteList,
        changeCustomerBaseBean: tempData,
        newCustomerPageListForAutoCompleteList: suggestion,
        isShowAlertLvl6: false,
        isNewCustomerNotFound: false,
      });
    } else if (
      e.target.name == "code" &&
      showAutoCompleteList === true &&
      newCustomerCode !== ""
    ) {
      setTimeout(() => {
        this.readNewCustomerBySearchString(e.target.value);
      }, 200);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ changeCustomerBaseBean: tempData });
  };
  newCustomerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readNewCustomerByCustomerCode(customerCode);
    this.state.isShowAutoCompleteNewCustomerList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteNewCustomerList;
    this.setState({
      newCustomerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteNewCustomerList: showAutoCompleteList,
    });
  };
  displayAutoNewCustomerCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteNewCustomerList: showAutoCompleteList,
    });
  };
  readNewCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByNewCustomerCodeResponse,
      this.errorCallBack,
    );
  }
  readByNewCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      newCustomerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };

  readNewCustomerByCustomerCodeResponse = (response) => {
    let customerData = response.data.customer;
    if (customerData != null) {
      const isFound = this.isFound(customerData);
      if (isFound) {
        this.setState({ isNewCustomerNotFound: true });
        let errMsg = "Customer is InActive";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlertLvl6: true,
        });
      } else {
        this.setState({ isNewCustomerNotFound: false, isShowAlert: false });
        let newCustomerData = this.state.changeCustomerBaseBean;
        newCustomerData.code = customerData.code;
        newCustomerData.description = customerData.description;
        this.setState({
          changeCustomerBaseBean: newCustomerData,
        });
      }
    } else {
      this.setState({ isNewCustomerNotFound: true });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  readNewCustomerByCustomerCode = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;

    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "loading Customer",
    });

    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readNewCustomerByCustomerCodeResponse,
      this.errorCallBack,
    );
  };

  copySO = () => {
    this.setState({
      isShowCopySOPopup: true,
      copySONum: "",
    });
  };
  // onCopySOChange = (e) => {
  //   let tempCopySONum = this.state.copySONum;
  //   tempCopySONum = e.target.value;
  //   this.setState({
  //     copySONum: tempCopySONum,
  //   });
  // };
  onCopySOChange = (e) => {
    let copySONum = this.state.copySONum;
    this.state.showAutoCompleteSalesOrderList = true;
    copySONum = e.target.value;
    let showAutoCompleteList = this.state.showAutoCompleteSalesOrderList;
    if (isEmpty(copySONum)) {
      let salesOrder = this.state.copySONum;
      let suggestion = [];
      this.setState({
        copySONum: salesOrder,
        salesOrderPageListForAutoCompleteList: suggestion,
        showAutoCompleteSalesOrderList: false,
      });
    } else if (
      e.target.name == "copySONum" &&
      showAutoCompleteList === true &&
      copySONum !== ""
    ) {
      this.readsalesOrderBySearchString(e.target.value);
    }
    this.setState({
      copySONum: copySONum,
    });
  };
  readsalesOrderBySearchString(searchString) {
    let searchCriteria = new SalesOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.salesOrderNumberStartsWith = searchString;
    searchCriteria.salesOrderNumberContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestSalesOrderListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    SalesOrderService.getSalesOrderPageList(
      cust_requestInput,
      this.readsalesOrderBySearchStringResponse,
      this.errorCallBack,
    );
  }

  readsalesOrderBySearchStringResponse = (response) => {
    let salesOrderData = response.data.salesOrderPageList.salesOrders;
    let simpleAutoCompleteList = new Array();
    if (salesOrderData.length > 0 && salesOrderData != null) {
      salesOrderData.map((so) => {
        let simpleItemBean = {
          code: so.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      salesOrderPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };

  salesOrderEnterKeyEventHandler = (e) => {
    let copySONum = this.state.copySONum;
    copySONum = e.target.value;
    this.setState({
      copySONum: copySONum,
    });
    this.setState({
      salesOrderPageListForAutoCompleteList: new Array(),
    });
  };

  displayAutoCompletesalesOrderList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteSalesOrderList: showAutoCompleteList,
    });
  };

  copySOContinue = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Copying SO",
      });
      let soNum = this.state.copySONum;
      if (!isEmptyString(soNum)) {
        let readrestInput = new RestReadRequest();
        readrestInput.companyCode = this.companyCode;
        readrestInput.code = soNum;
        readrestInput.isLoadChildren = true;
        SalesOrderService.readSalesOrder(
          readrestInput,
          this.copySoContinueResponse,
          this.copySOContinueError,
        );
      } else {
        let errMsg = "Invalid SalesOrder";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlertLvl6: true,
          isLoading: false,
          loadingText: "",
        });
      }
    }
  };
  copySoContinueResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let soDatas = new SalesOrderBean();
    let soData = response.data.salesOrder;
    soDatas.companyCode = this.companyCode;
    soDatas.code = NEW_ENTRY;
    soDatas.customerCode = soData.customerCode;
    soDatas.customerName = soData.customerName;
    soDatas.customerPurchaseOrderNumber = soData.customerPurchaseOrderNumber;
    soDatas.billToCode = soData.billToCode;
    soDatas.factoryCode = soData.factoryCode;
    soDatas.companyCurrencyCode = soData.companyCurrencyCode;
    soDatas.createdDate = new Date();
    soDatas.orderDate = new Date();
    soDatas.customerType = soData.customerType;
    soDatas.locationCode = soData.locationCode;
    if ((soData.orderStatus = LogicConstants.SALES_ORDER_UNAPPROVE_STATUS)) {
      soDatas.orderStatus = soData.orderStatus;
    }
    soDatas.orderTypeCode = soData.orderTypeCode;
    soDatas.orderStartDate = soData.orderStartDate;
    soDatas.orderStopDate = soData.orderStopDate;
    soDatas.originalOrderType = soData.originalOrderType;
    soDatas.paymentTermCode = soData.paymentTermCode;
    soDatas.revisedLatestShipDate = soData.revisedLatestShipDate;
    soDatas.salesOrderCurrencyCode = soData.salesOrderCurrencyCode;
    soDatas.salesClerkCode = soData.salesClerkCode;
    soDatas.shipToCode = soData.shipToCode;
    soDatas.shipToName = soData.shipToName;
    soDatas.shipViaCode = soData.shipViaCode;
    soDatas.shipmentChargesAmount = soData.shipmentChargesAmount;
    soDatas.standardDiscountAmount = soData.standardDiscountAmount;
    soDatas.sourceSalesOrderNumber = soData.sourceSalesOrderNumber;
    soDatas.standardExtraChargesAmount = soData.standardExtraChargesAmount;
    soDatas.standardGrandTotalAmount = soData.standardGrandTotalAmount;
    soDatas.standardShipmentChargesAmount =
      soData.standardShipmentChargesAmount;
    soDatas.standardSubTotalAmount = soData.standardSubTotalAmount;
    soDatas.standardTotalTariffAmount = soData.standardTotalTariffAmount;
    soDatas.standardTotalTaxAmount = soData.standardTotalTaxAmount;
    soDatas.subTotalAmount = soData.subTotalAmount;
    soDatas.createdBy = soData.createdBy;
    soDatas.updatedBy = soData.updatedBy;
    soDatas.updatedDate = soData.updatedDate;
    soDatas.targetWebsite = soData.targetWebsite;
    soDatas.tariffPercentage = soData.tariffPercentage;
    soDatas.taxPercentage = soData.taxPercentage;
    soDatas.totalOrderedQuantity = soData.totalOrderedQuantity;
    soDatas.totalTariffAmount = soData.totalTariffAmount;
    soDatas.totalTaxAmount = soData.totalTaxAmount;
    soDatas.websiteType = soData.websiteType;
    soDatas.xDCDate = soData.xDCDate;
    soDatas.webOrderFlag = soData.webOrderFlag;
    soDatas.taxRequiredFlag = soData.taxRequiredFlag;
    soDatas.grandTotalAmount = soData.grandTotalAmount;
    let lineData = soData.lines;
    if (lineData != null) {
      let soLnData = lineData;
      soLnData.map((so, i) => {
        let soLnDatas = new SalesOrderLineBean();
        soLnDatas.companyCode = so.companyCode;
        soLnDatas.salesOrderNumber = NEW_ENTRY;
        soLnDatas.salesOrderLineNumber = so.salesOrderLineNumber;
        if ((so.lineStatus = LogicConstants.SALES_ORDER_LINE_OPEN_STATUS)) {
          soLnDatas.lineStatus = so.lineStatus;
        }
        soLnDatas.fabricStyleCode = so.fabricStyleCode;
        soLnDatas.fabricStyleName = so.fabricStyleName;
        soLnDatas.colorCode = so.colorCode;
        soLnDatas.customerCode = so.customerCode;
        soLnDatas.orderStartDate = so.orderStartDate;
        soLnDatas.orderStopDate = so.orderStopDate;
        soLnDatas.widthCode = so.widthCode;
        soLnDatas.skuNumber = so.skuNumber;
        soLnDatas.upcCode = so.upcCode;
        soLnDatas.uomCode = so.uomCode;
        soLnDatas.inventoryUomCode = so.inventoryUomCode;
        soLnDatas.uomConversionRate = so.uomConversionRate;
        soLnDatas.cost = so.cost;
        soLnDatas.price = so.price;
        soLnDatas.openQuantity = so.orderQuantity;
        soLnDatas.orderQuantity = so.orderQuantity;
        soLnDatas.adjustedQuantity = 0;
        soLnDatas.orderUomCode = so.orderUomCode;
        soLnDatas.lineTotalAmount = so.lineTotalAmount;
        soLnDatas.discountPercentage = so.discountPercentage;
        soLnDatas.lineNetAmount = so.lineNetAmount;
        soLnDatas.lineDiscountAmount = so.lineDiscountAmount;
        soLnDatas.tariffPercentage = so.tariffPercentage;
        soLnDatas.tariffAmount = so.tariffAmount;
        soLnDatas.taxAmount = so.taxAmount;
        soLnDatas.standardCost = so.standardCost;
        soLnDatas.standardLineNetAmount = so.standardLineNetAmount;
        soLnDatas.standardLineTotalAmount = so.standardLineTotalAmount;
        soLnDatas.standardPrice = so.standardPrice;
        soLnDatas.isFetched = false;
        soDatas.lines.push(soLnDatas);
      });
    }
    soDatas.isFetched = false;
    this.setState(
      {
        salesOrderData: soDatas,
      },
      () => {
        this.setAddress(soData);
        this.closeAlertModalCallBack(false);
      },
    );
  };
  copySOContinueError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  setAddress(soData) {
    let salesOrderData = this.state.salesOrderData;
    if (soData != null && soData != undefined) {
      let soAddress = soData.address;
      if (soAddress != null && soAddress != undefined) {
        let address = new RestAddressBean();
        address.address1 = soAddress.address1;
        address.address2 = soAddress.address2;
        address.address3 = soAddress.address3;
        address.address4 = soAddress.address4;
        address.city = soAddress.city;
        address.state = soAddress.state;
        address.country = soAddress.country;
        address.zip = soAddress.zip;
        if (!address.zip) address.zip = "36";
        address.email = soAddress.email;
        address.mobilePhone = soAddress.mobilePhone;
        address.phone1 = soAddress.phone1;
        address.phone2 = soAddress.phone2;
        address.fax = soAddress.fax;
        address.website = soAddress.website;
        address.contactPerson = soAddress.code;
        address.ccEmail = soAddress.ccEmail;
        address.county = soAddress.county;
        salesOrderData.address = address;
      }
      this.setState({
        salesOrderData: salesOrderData,
      });
    }
  }

  toServer = (file, fileName) => {
    let image = new File([file], `${fileName}`, { type: file.type });
    let formData = new FormData();
    formData.append("file", image);
    SalesOrderService.salesOrderImageUpload(
      formData,
      this.uploadImageServerResponse,
      this.uploadImageServerError,
    );
  };

  uploadImageServerResponse = (response) => {
    if (response.data.success) {
    }
  };
  uploadImageServerError = (error) => {
    ShowError("Error :", error);
  };
  uploadToServer = () => {
    const salesOrderData = { ...this.state.salesOrderData };
    const temp_OrderImages = this.state.temp_OrderImages;
    const imgData = this.state.imgData;
    const docData = this.state.docData;
    const images = this.state.images;
    if (!isEmptyArray(salesOrderData.orderImages)) {
      salesOrderData.orderImages.map((img) => {
        if (img.isDeleted != true && img.isFetched != true) {
          images.map((imgData) => {
            if (img.imageOritinalname == imgData.name) {
              this.toServer(imgData, img.imageName);
            }
          });
        } else if (img.isFetched == true && img.isApplied == true) {
          images.map((imgData) => {
            if (img.imageOritinalname == imgData.name) {
              this.toServer(imgData, img.imageName);
            }
          });
        }
      });
    }
  };

  uploadMultiDocsToServer = () => {
    const salesOrderData = { ...this.state.salesOrderData };
    const documents = this.state.documents;
    if (!isEmptyArray(salesOrderData.salesOrderDocument)) {
      salesOrderData.salesOrderDocument.map((doc) => {
        if (doc.isDeleted != true && doc.isFetched != true) {
          documents.map((docData) => {
            if (doc.documentOriginalName == docData.name) {
              this.docToServer(docData, doc.documentName);
            }
          });
        }
      });
    }
  };
  docToServer = (file, fileName) => {
    let document = new File([file], `${fileName}`, { type: file.type });
    const formData = new FormData();
    formData.append("file", document);
    SalesOrderService.salesOrderDocUpload(
      formData,
      this.documentUploadResponse,
      this.errorCallBack,
    );
  };
  documentUploadResponse = (response) => { };
  setImgUrl = (url) => {
    setTimeout(() => {
      this.setState({
        imgUrl: url,
      });
    }, 2000);
  };
  setDocUrl = (url) => {
    setTimeout(() => {
      this.setState({
        docUrl: url,
      });
    }, 2000);
  };
  setImgData = (data) => {
    this.setState({
      imgData: data,
    });
  };
  setMultiImageUrl = (url) => {
    setTimeout(() => {
      this.setState({
        preview_Url: url,
      });
    }, 300);
  };
  setMultiImgData = (data) => {
    setTimeout(() => {
      this.setState({
        images: data,
      });
    }, 400);
  };
  addImageLines = (imageEntity) => {
    let salesData = this.state.salesOrderData;
    salesData.orderImages.map((det) => {
      if (det.imageName == imageEntity.imageName) {
        det.tags = imageEntity.tags;
        det.notesCommunication = imageEntity.notesCommunication;
      }
    });
    this.setState({
      salesOrderData: salesData,
    });
  };
  // clearImageLines
  clearImageLines = (imageEntity) => {
    let salesData = this.state.salesOrderData;
    salesData.orderImages.map((det) => {
      if (det.imageName == imageEntity.imageName) {
        det.tags = "";
        det.notesCommunication = "";
      }
    });
    this.setState({
      salesOrderData: salesData,
    });
  };
  deleteMutipleImage = (tempIndex) => {
    let orderImages = this.state.salesOrderData.orderImages;
    if (!isEmptyArray(orderImages)) {
      for (let j = 0; j < orderImages.length; j++) {
        if (j === tempIndex) {
          if (orderImages[j].isFetched == true) {
            orderImages[j].deleted = true; // Change the value at index 2
            orderImages[j].isDeleted = true;
          } else {
            orderImages.splice(j, 1); // Change the value at index 2
            this.state.images.splice(j, 1);
          }
        }
      }
    }
    this.state.salesOrderData.orderImages = orderImages;
  };

  // deleteMutipleImage = (tempIndex) => {
  //   let orderImages = this.state.salesOrderData.orderImages;
  //   if (!isEmptyArray(orderImages)) {
  //     for (let j = 0; j < orderImages.length; j++) {
  //       if (j === tempIndex) {
  //         if (orderImages[j].isFetched == true) {
  //           orderImages[j].deleted = true; // Change the value at index 2
  //           orderImages[j].isDeleted = true;
  //         } else {
  //           orderImages.splice(j, 1); // Change the value at index 2
  //         }
  //       }
  //     }
  //   }
  //   this.state.salesOrderData.orderImages = orderImages;
  // }
  uploadMutiImage = (images) => {
    let salesOrderData = this.state.salesOrderData;
    let orderImages = new Array();
    let imageData = null;
    for (const img of images) {
      if (!img.isFetched && !img.isDeleted) {
        imageData = new SalesOrderImageBean();
        if (!isEmpty(img.imageCode)) {
          imageData.imageCode = img.imageCode;
          imageData.imageName = img.name;
          imageData.imageOritinalname = img.name;
          imageData.isFetched = true;
          imageData.isApplied = true;
        } else {
          imageData.imageOritinalname = img.name;
          imageData.imageName = img.name;
        }
        imageData.companyCode = this.companyCode;
        imageData.salesOrderNumber = salesOrderData.code;
        orderImages.push(imageData);
      } else {
        if (img.isFetched == true) {
          orderImages.push(img);
        }
      }
    }
    salesOrderData.orderImages = orderImages;
    this.setState({
      salesOrderData: salesOrderData,
      images: images,
    });
  };
  uploadImage = (file) => {
    let salesOrderData = { ...this.state.salesOrderData };
    let orderImages = new Array();
    let imageData = null;
    if (!isEmptyArray(salesOrderData.orderImages)) {
      imageData = salesOrderData.orderImages[0];
      if (imageData.isDeleted == true) imageData.isDeleted = false;
      imageData.imageOritinalname = file.name;
      this.setState({ salesOrderData: salesOrderData });
    } else {
      imageData = new SalesOrderImageBean();
      imageData.imageOritinalname = file.name;
      imageData.imageName = file.name;
      imageData.companyCode = this.companyCode;
      imageData.salesOrderNumber = salesOrderData.code;
      orderImages.push(imageData);
      salesOrderData.orderImages = orderImages;
      this.setState({
        salesOrderData: salesOrderData,
      });
    }
  };
  deleteImage = () => {
    let salesOrderData = this.state.salesOrderData;

    salesOrderData.orderImages[0].imageOritinalname = null;
    salesOrderData.orderImages[0].deleted = true;
    salesOrderData.orderImages[0].isDeleted = true;

    this.setImgUrl("");

    this.setState({ salesOrderData: salesOrderData });
  };
  uploadDoc = (file) => {
    let salesOrderData = { ...this.state.salesOrderData };
    salesOrderData.documentName = file.name;
    salesOrderData.documentFilePath = "$$$CHANGED$$$";

    this.setState({
      salesOrderData: salesOrderData,
    });
  };
  deleteDoc = () => {
    let salesOrderData = { ...this.state.salesOrderData };
    salesOrderData.documentName = "";
    salesOrderData.documentFilePath = "";
    this.setState({
      salesOrderData: salesOrderData,
    });
  };
  showToast = (msg, type) => {
    let errList = [];
    if (type === 1) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (type === 2) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let salesOrderList = this.state.salesOrderList;
    if (sortField && !isEmptyArray(salesOrderList)) {
      const sorted = [...salesOrderList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ salesOrderList: sorted });
    }
  };
  addressClickHandler = (e) => {
    if (e.detail == 1) {
      let salesOrderData = this.state.salesOrderData;
      let soAddressData = new AddressBean();
      soAddressData = { ...salesOrderData.address };
      this.setState({ isShowAddressPopup: true, soAddressData: soAddressData });
    }
  };
  commisionClickHandler = (e) => {
    if (e.detail == 1) {
      this.setCommissionView();
    }
  };
  closeAlertAddressModalCallBack = () => {
    this.setState({
      isShowAddressPopup: false,
      soAddressData: new AddressBean(),
    });
  };
  addressSoOnChange = (e) => {
    let soAddressData = this.state.soAddressData;
    soAddressData[e.target.name] = e.target.value;
    this.setState({ soAddressData: soAddressData });
  };
  addressOnClick = () => {
    let salesOrderData = this.state.salesOrderData;
    let soAddressData = { ...this.state.soAddressData };
    salesOrderData.address = soAddressData;
    this.setState({ salesOrderData: salesOrderData });
    this.closeAlertAddressModalCallBack();
  };
  onSoCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let soAddressData = this.state.soAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let soAddressData = this.state.soAddressData;
      soAddressData.city = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCityList: showAutoCompleteList,
        soAddressData: soAddressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readSoCityBySearchString(city);
    }
    // if (e.target.name == "city") {
    //   soAddressData["city"] = e.target.value;
    //   let cityList = this.state.cityList;

    //   cityList.map((pdtType) => {
    //     if (pdtType.code == e.target.value) {
    //       soAddressData["city"] = pdtType.code;
    //       this.state.showAutoCompleteCityList = false;
    //       let showAutoCompleteList = this.state.showAutoCompleteCityList;
    //       this.setState({ showAutoCompleteCityList: showAutoCompleteList });
    //     }
    //   });
    // }
    soAddressData["city"] = e.target.value;
    this.setState({
      soAddressData: soAddressData,
    });
  };
  readSoCityBySearchString(searchString) {
    let cityData = this.state.cityList;

    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }

    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );

    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  soCityEnterKeyEventHandler = (e) => {
    let city = e.target.value;
    let city_List = this.state.cityList;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let soAddressData = this.state.soAddressData;
      soAddressData.city = cityBean.code;
      this.setState({
        soAddressData: soAddressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteSoCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };

  onSoStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;

    let soAddressData = this.state.soAddressData;

    let showAutoCompleteList = this.state.showAutoCompleteStateList;
    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let soAddressData = this.state.soAddressData;

      soAddressData.state = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteStateList: showAutoCompleteList,
        soAddressData: soAddressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readSoStateBySearchString(state);
    }
    if (e.target.name == "state") {
      soAddressData["state"] = e.target.value;
      let stateList = this.state.stateList;
      stateList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          soAddressData["state"] = pdtType.code;
          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteStateList: showAutoCompleteList });
        }
      });
    }

    this.setState({
      soAddressData: soAddressData,
    });
  };
  readSoStateBySearchString(searchString) {
    let stateData = this.state.stateList;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  soStateEnterKeyEventHandler = (e) => {
    let state = e.target.value;
    let state_List = this.state.stateList;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let soAddressData = this.state.soAddressData;
      soAddressData.state = stateBean.code;

      this.setState({
        soAddressData: soAddressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteSoStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };
  onSoCountryChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryList = true;

    let soAddressData = this.state.soAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryList;
      let soAddressData = this.state.soAddressData;
      soAddressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCountryList: showAutoCompleteList,
        soAddressData: soAddressData,
        countryPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readSoCountryBySearchString(country);
    }
    if (e.target.name == "country") {
      soAddressData["country"] = e.target.value;
      let countryList = this.state.countryList;
      countryList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          soAddressData["country"] = pdtType.code;
          this.state.showAutoCompleteCountryList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryList;
          this.setState({
            showAutoCompleteCountryList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({
      soAddressData: soAddressData,
    });
  };
  readSoCountryBySearchString(searchString) {
    let stateData = this.state.countryList;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      countryPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  soCountryEnterKeyEventHandler = (e) => {
    let country = e.target.value;
    let country_List = this.state.countryList;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let soAddressData = this.state.soAddressData;
      soAddressData.country = countryBean.code;
      this.setState({
        soAddressData: soAddressData,
        countryPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteSoCountryList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
  };

  /***delivery type ***/
  onDeliveryTypeChange = (e) => {
    let customerDeliveryTypeCode = e.target.value;
    this.state.isShowAutoCompleteDeliveryTypeList = true;
    let tempData = this.state.salesOrderData;
    let showAutoCompleteList = this.state.isShowAutoCompleteDeliveryTypeList;
    if (isEmpty(customerDeliveryTypeCode)) {
      this.state.isShowAutoCompleteDeliveryTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteDeliveryTypeList;
      let tempData = this.state.salesOrderData;
      tempData.customerDeliveryTypeCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteDeliveryTypeList: showAutoCompleteList,
        salesOrderData: tempData,
        deliveryTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerDeliveryTypeCode" &&
      showAutoCompleteList === true &&
      customerDeliveryTypeCode !== ""
    ) {
      this.readDeliveryTypeBySearchString(e.target.value);
      // this.readDeliveryType(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ salesOrderData: tempData });
  };
  deliveryTypeEnterKeyEventHandler = (e) => {
    this.readDeliveryType(e.target.value);
    this.state.isShowAutoCompleteDeliveryTypeList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteDeliveryTypeList;
    this.setState({
      deliveryTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };

  readDeliveryTypeBySearchString = (searchString) => {
    let deliveryTypeData = this.state.customerDeliveries;
    let simpleAutoCompleteList = new Array();
    if (deliveryTypeData.length > 0 && deliveryTypeData != null) {
      deliveryTypeData.map((obj) => {
        let deliveryTypeBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(deliveryTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      deliveryTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readDeliveryType = (customerDeliveryTypeCode) => {
    let tempData = this.state.salesOrderData;
    let deliveryTypeBean = null;
    let deliveryTypeData = null;
    this.state.customerDeliveries.map((ln) => {
      if (ln.code === customerDeliveryTypeCode) {
        deliveryTypeBean = ln;
        deliveryTypeData = new BaseBean();
        deliveryTypeData.code = ln.code;
        deliveryTypeData.description = ln.description;
      }
    });
    if (!isEmpty(deliveryTypeBean)) {
      tempData.customerDeliveryTypeCode = deliveryTypeBean.code;
      this.state.isShowAutoCompleteDeliveryTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteDeliveryTypeList;
      this.setState({
        salesOrderData: tempData,
        isShowAutoCompleteDeliveryTypeList: showAutoCompleteList,
      });
    }
    this.setStopDateBasedOnDelivery(tempData.customerDeliveryTypeCode);
  };

  displayAutoCompleteDeliveryTypeList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteDeliveryTypeList: isShowAutoCompleteList,
    });
  };

  onUOMCodeChange = (e) => {
    let orderUomCode = e.target.value;
    this.state.showAutoCompleteUOMList = true;
    let salesOrderLineData = this.state.salesOrderLineData;
    let showAutoCompleteList = this.state.showAutoCompleteUOMList;
    if (isEmpty(orderUomCode)) {
      this.state.showAutoCompleteUOMList = false;
      let showAutoCompleteList = this.state.showAutoCompleteUOMList;
      let salesOrderLineData = this.state.salesOrderLineData;
      salesOrderLineData.orderUomCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        salesOrderLineData: salesOrderLineData,
        uomPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && orderUomCode !== "") {
      this.readUomCodeBySearchString(orderUomCode);
    }
    if (e.target.name == "orderUomCode") {
      salesOrderLineData["orderUomCode"] = e.target.value;
      let uom_List = this.state.uoms;
      uom_List.map((uom) => {
        if (uom.code == e.target.value) {
          salesOrderLineData["orderUomCode"] = uom.code;
          this.state.showAutoCompleteUOMList = false;
          let showAutoCompleteList = this.state.showAutoCompleteUOMList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ salesOrderLineData: salesOrderLineData });
  };
  readUomCodeBySearchString(searchString) {
    let uom_List = this.state.uoms;

    let simpleAutoCompleteList = new Array();
    if (uom_List.length > 0 && uom_List != null) {
      uom_List.map((uom) => {
        let simpleItemBean = {
          code: uom.code,
          description: uom.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteUomCodeLists) =>
        simpleAutoCompleteUomCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ uomPageListForAutoCompleteList: filteredSuggestions });
  }

  uomEnterKeyEvent = (e) => {
    let salesOrderLineData = this.state.salesOrderLineData;
    salesOrderLineData["orderUomCode"] = e.target.value;
    let uom_List = this.state.uoms;
    let uomBean = null;
    uom_List.map((uom) => {
      if (uom.code == e.target.value) {
        uomBean = uom;
      }
    });
    if (!isEmpty(uomBean)) {
      let salesOrderLineData = this.state.salesOrderLineData;
      salesOrderLineData.orderUomCode = uomBean.code;
      salesOrderLineData.uomConversionRate = uomBean.conversionRate;
      this.setState({
        salesOrderLineData: salesOrderLineData,
        uomPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteUomList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteUomList: showAutoCompleteList });
  };
  showOnHandQty = (row) => {
    this.setState(
      {
        isShowOnHandQtyPopup: true,
      },
      () => {
        let soLine = new SalesOrderLineBean();
        soLine.fabricStyleCode = row.fabricStyleCode;
        soLine.colorCode = row.fabricStyleColorCode;
        soLine.skuNumber = row.skuNumber;
        soLine.locationCode = row.locationCode;
        this.readandSetOnHandQuantity(soLine);
      },
    );
  };
  showOnHandLotQty = (row) => {
    this.setState(
      {
        isShowOnHandLotQtyPopup: true,
        lotOnHandQtyData: row,
      },
      () => {
        let soLine = new SalesOrderLineBean();
        soLine.fabricStyleCode = row.fabricStyleCode;
        soLine.colorCode = row.fabricStyleColorCode;
        soLine.skuNumber = row.skuNumber;
        soLine.locationCode = row.locationCode;
        soLine.lotNumber = row.lotNumber;
        this.readandSetOnHandLotQuantity(soLine);
      },
    );
  };

  // inquiryColumns = () => {
  //   const columns = new Array();

  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("Location", "locationCode", true)
  //       .setStyleDetails("left", "", "4", "wt-2", "wt-2"),
  //   );

  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("Color", "fabricStyleColorCode", true)
  //       .setStyleDetails("left", "", "", "wt-2", "wt-2"),
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("OnHandQty", "onHandQuantity", true)
  //       .setStyleDetails("right", "", "", "wt-2", "wt-2")
  //       .setClickDetails(true, false, this.showOnHandQty, null),
  //   );

  //   return columns;
  // };

  handleonHandSortingChange = (e, accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleOnHandSorting(sortField, sortOrder);
  };
  handleOnHandSorting = (sortField, sortOrder) => {
    let fabricInventoryList = this.state.fabricInventoryList;
    if (sortField && !isEmptyArray(fabricInventoryList)) {
      const sorted = [...fabricInventoryList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ fabricInventoryList: sorted });
    }
  };
  inquiryColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "4", "wt-2", "wt-2"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.showOnHandQty, null),
    );

    return columns;
  };

  onPickTicketChange = (e) => {
    let criteria = this.state.pickTicketBean;
    criteria.companyCode = this.companyCode;
    criteria[e.target.name] = e.target.value;
    this.setState({ pickTicketBean: criteria });
  };

  closeAlertSampleRolllCallBack = (isShowPopup) => {
    this.setState({
      isShowSampleRollPopup: isShowPopup,
      isShowSampleRollAlert: false,
      sampleFabricStyleCode: "",
      sampleFabricStyleName: "",
      sampleColorCode: "",
      showAutoCompleteSampleFabricList: false,
      sampleFabricAutoCompleteList: new Array(),
      sampleFabricLookUpHandler: null,
      grouped_sample: [],

      showAutoCompleteSampleColorCodeList: false,
      sampleColorCodeAutoCompleteList: new Array(),
      sampleColorCodeLookUpHandler: null,
      isShowSampleColorCodeLookUp: false,
      sampleColorCodeList: [],

      sampleSkuBatchRollLines: [],
    });
    // this.clearPoData();
    this.hideSampleRollAlertCallBack();
  };
  hideSampleRollAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowSampleRollAlert: isDisplayed }, () => {
      //           setTimeout(() => {
      // if (this.purchaseOrderNumberCreateRef.current != null) {
      //   this.purchaseOrderNumberCreateRef.current.clear();
      // }
      // }, 0);
    });
  };

  createSampleOrderForInventory = (e) => {
    const sampleSkuBatchRollLines = this.state.sampleSkuBatchRollLines;

    // Check if another row is already selected
    // const alreadySelected = sampleSkuBatchRollLines.find(
    //   (line) => line.isSelected,
    // );

    const selectedLines = sampleSkuBatchRollLines.filter(
      (line) => line.isSelected,
    );

    if (!isEmpty(selectedLines)) {
      const input = new SalesOrderSampleInputBean();
      input.companyCode = this.companyCode;
      input.sampleLines = selectedLines;
      let isValidLine = false;
      isValidLine = this.validateGenerateSampleLine(selectedLines);

      if (isValidLine) {
        InventoryService.createInventoryAdjustmentForSalesOrderSampleLines(
          input,
          this.sampleInventoryCreatedResponse,
          this.errorCallBack,
        );
      }
    } else {
      let errMsg = "Select Roll!.";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowSampleRollAlert: true,
      });
    }
  };

  validateGenerateSampleLine = (criteria) => {
    let isValidPOLine = false;
    let err_list = [];
    let errorMessage = "";
    if (criteria[0].sampleQuantity === 0) {
      let errMsg = "Enter Sample Quantity ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      isValidPOLine = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowSampleRollAlert: true,
      });
    } else {
      isValidPOLine = true;
      this.setState({ isShowSampleRollAlert: false });
    }
    return isValidPOLine;
  };

  sampleInventoryCreatedResponse = (response) => {
    let success = this.handleResponse(response.data);

    if (success === true) {
      this.closeAlertSampleRolllCallBack(false);
      //  this.setState(
      //   {
      //     isShowSampleRollPopup: true,

      //   },
      //   () => {},
      // );
    }
  };

  getSampleRollLines = (e) => {
    const selectedStyle = this.state.grouped_sample.find(
      (item) => item.code === this.state.sampleFabricStyleCode,
    );

    const input = new SKUBatchInventorySearchCriteria();
    input.companyCode = this.companyCode;
    input.fabricStyleCode = selectedStyle.lines[0].fabricStyleCode;
    input.colorCode = selectedStyle.lines[0].colorCode;
    input.skuNumber = selectedStyle.lines[0].skuNumber;
    input.fetchQuantityAvailableLinesOnly = true;
    input.isExcludeNonWarehouseInventory = true;
    input.isExcludeReserveWarehouseInventory = true;
    // input.reserveCustomerCode = selectedStyle.lines[0].customerCode;
    // input.locationCode = selectedStyle.lines[0].prefferedLocationCode;
    // if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
    InventoryService.getAvailableSKUBatchInventoriesNotInInitialInventoryForPickTicket(
      input,
      this.getSampleRollLinesReponse,
      this.errorCallBack,
    );
    // } else {
    //   let errMsg = "Access Denied";
    //   let errList = [];
    //   errList.push(errMsg);

    //   this.setState({
    //     alertMessage: errList,
    //     alertType: "danger",
    //     isShowAlert: true,
    //   });
    // }

    // if (
    //   pickTicketData.status != LogicConstants.PICK_TICKET_UNAPPROVE_STATUS &&
    //   ptLine.lineStatus != LogicConstants.PICK_TICKET_LINE_OPEN_STATUS
    // ) {
    //   input.pickTicketNumber = pickTicketData.code;
    //   input.pickTicketLineNumber = ptLine.pickTicketLineNumber;
    // }
  };
  getSampleRollLinesReponse = (response) => {
    let rollLines = [];
    let salesOrderData = this.state.salesOrderData;
    if (response.data != null) {
      if (!isEmptyArray(response.data.skuBatchInventories)) {
        let skuBatchInventories = response.data.skuBatchInventories;

        for (const inventory of skuBatchInventories) {
          const rollLine = new SalesOrderSampleRollLineBean();
          rollLine.companyCode = this.companyCode;
          rollLine.salesOrderNumber = salesOrderData.code;
          rollLine.rollSkuNumber = inventory.rollSkuNumber;
          rollLine.rollNumber = inventory.rollNumber;
          rollLine.skuNumber = inventory.skuNumber;
          rollLine.fabricStyleCode = inventory.fabricStyleCode;
          rollLine.fabricStyleName = inventory.fabricStyleName;
          rollLine.colorCode = inventory.fabricStyleColorCode;
          rollLine.widthCode = inventory.skuNumber;
          rollLine.orderUomCode = inventory.uomCode;
          rollLine.locationCode = inventory.locationCode;
          rollLine.inventoryUomCode = inventory.uomCode;
          //  rollLine.uomConversionRate = inventory.widthCode;
          rollLine.boxNumber = inventory.boxNumber;
          rollLine.vendorCode = inventory.vendorCode;
          rollLine.vendorBatchNumber = inventory.vendorBatchNumber;
          rollLine.purchaseOrderNumber = inventory.purchaseOrderNumber;
          rollLine.purchaseOrderReceiptNumber =
            inventory.purchaseOrderReceiptNumber;
          rollLine.binLocation = inventory.aisleInfoText;
          rollLine.upcNumber = inventory.upcNumberBarCode;
          rollLine.palletNumber = inventory.palletNumber;
          rollLine.imeiNumber = inventory.imeiNumber;
          rollLine.containerNumber = inventory.containerNumber;
          rollLine.warehousePurchaseOrderNumber =
            inventory.warehousePurchaseOrderNumber;
          rollLine.projectNumber = inventory.projectNumber;
          rollLine.onHandQuantity = inventory.onHandQuantity;
          //  rollLine.serialNumber = inventory.projectNumber;
          rollLine.receiptDate = inventory.receivedDate;
          rollLine.isSelected = false;
          rollLines.push(rollLine);
        }
      }
    }
    this.setState({ sampleSkuBatchRollLines: rollLines });
  };

  // onRollSelectedChange = (evt, rollLine) => {
  //     const sampleSkuBatchRollLines = this.state.sampleSkuBatchRollLines.map(line => {
  //         if (
  //             line.rollSkuNumber === rollLine.rollSkuNumber &&
  //             line.skuNumber === rollLine.skuNumber
  //         ) {
  //             return {
  //                 ...line,
  //                 isSelected: evt.target.value
  //             };
  //         }
  //         return line;
  //     });

  //     this.setState({ sampleSkuBatchRollLines });
  // };

  onRollSelectedChange = (evt, rollLine) => {
    const sampleSkuBatchRollLines = [...this.state.sampleSkuBatchRollLines];

    // Check if another row is already selected
    const alreadySelected = sampleSkuBatchRollLines.find(
      (line) =>
        line.isSelected &&
        !(
          line.rollSkuNumber === rollLine.rollSkuNumber &&
          line.skuNumber === rollLine.skuNumber
        ),
    );

    if (alreadySelected && evt.target.value) {
      // alert("Only one roll can be selected.");
      let errMsg = "Only one roll can be selected.";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowSampleRollAlert: true,
      });
      return;
    }

    sampleSkuBatchRollLines.forEach((line) => {
      if (
        line.rollSkuNumber === rollLine.rollSkuNumber &&
        line.skuNumber === rollLine.skuNumber
      ) {
        line.isSelected = evt.target.value;
      }
    });

    this.setState({ sampleSkuBatchRollLines });
  };

  onLineSampleQtyChange = (evt, data) => {
    const value = Number(evt.target.value);
    const sampleSkuBatchRollLines = [...this.state.sampleSkuBatchRollLines];

    sampleSkuBatchRollLines.forEach((line) => {
      if (
        line.rollSkuNumber === data.rollSkuNumber &&
        line.skuNumber === data.skuNumber
      ) {
        if (value > line.onHandQuantity) {
          alert("Sample Qty cannot be greater than On Hand Quantity.");
          line.sampleQuantity = 0;
        } else {
          line.sampleQuantity = value;
        }
      }
    });

    this.setState({ sampleSkuBatchRollLines });
  };
  onLineSampleQtyBlur = (evt, row) => {
    // alert("onLineSampleQtyBlur")
    //   const value = Number(evt.target.value);
    //   if (value > row.onHandQuantity) {
    //       alert("Sample Qty cannot be greater than On Hand Quantity.");
    //       const sampleSkuBatchRollLines = this.state.sampleSkuBatchRollLines.map(line =>
    //           line.rollSkuNumber === row.rollSkuNumber &&
    //           line.skuNumber === row.skuNumber
    //               ? {
    //                     ...line,
    //                     sampleQty: row.onHandQuantity // or 0
    //                 }
    //               : line
    //       );
    //       this.setState({ sampleSkuBatchRollLines });
    //   }
  };
  addSampleRoll = () => {
    let salesOrderData = this.state.salesOrderData;
    const grouped_sample = Object.values(
      salesOrderData.lines.reduce((acc, line) => {
        if (!acc[line.fabricStyleCode]) {
          acc[line.fabricStyleCode] = {
            fabricStyleCode: line.fabricStyleCode,
            fabricStyleName: line.fabricStyleName,
            colorCodes: {},
            lines: [],
          };
        }

        acc[line.fabricStyleCode].lines.push(line);

        if (!acc[line.fabricStyleCode].colorCodes[line.colorCode]) {
          acc[line.fabricStyleCode].colorCodes[line.colorCode] = {
            code: line.colorCode,
            description: line.colorCode, // Replace with line.colorName if available
          };
        }

        return acc;
      }, {}),
    ).map((style) => ({
      code: style.fabricStyleCode,
      description: style.fabricStyleName,
      colorCodes: Object.values(style.colorCodes),
      lines: style.lines,
    }));
    let sampleFabricLookUpHandler = new GenericAttributeLookupHandler(
      grouped_sample,
      "FabricStyle",
    );

    this.setState(
      {
        isShowSampleRollPopup: true,
        sampleFabricLookUpHandler: sampleFabricLookUpHandler,
        grouped_sample: grouped_sample,
      },
      () => { },
    );
  };

  onSampleFabricChange = (e) => {
    let sampleFabricStyleCode = e.target.value;
    this.state.showAutoCompleteSampleFabricList = true;
    let temp_salesOrderData = this.state.sampleFabricStyleCode;
    let showAutoCompleteList = this.state.showAutoCompleteSampleFabricList;
    if (isEmpty(sampleFabricStyleCode)) {
      this.state.showAutoCompleteSampleFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSampleFabricList;
      let soLine = this.state.sampleFabricStyleCode;
      soLine = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        sampleFabricStyleCode: soLine,
        sampleFabricAutoCompleteList: suggestion,

        sampleFabricLookUpHandler: null,
        isShowColorCodeLookUp: false,
        sampleColorCodeList: [],
        sampleColorCode: "",
      });
    } else if (showAutoCompleteList === true && sampleFabricStyleCode !== "") {
      this.readSampleFabricStyleBySearchString(sampleFabricStyleCode);
    }
    temp_salesOrderData = e.target.value;
    this.setState({ sampleFabricStyleCode: temp_salesOrderData });
  };
  readSampleFabricStyleBySearchString(searchString) {
    let sampleFabricStyleCode = this.state.grouped_sample;
    let simpleAutoCompleteList = new Array();
    if (sampleFabricStyleCode.length > 0 && sampleFabricStyleCode != null) {
      sampleFabricStyleCode.map((data) => {
        let simpleItemBean = {
          code: data.code,
          description: data.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipToLists) =>
        simpleAutoCompleteShipToLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      sampleFabricAutoCompleteList: filteredSuggestions,
    });
  }

  sampleFabricEnterKeyEventHandler = (e) => {
    this.state.showAutoCompleteSampleFabricList = false;
    let sampleColorCodeList = [];
    let isShowColorCodeLookUp = false;
    let sampleFabricLookUpHandler = null;
    let showAutoCompleteList = this.state.showAutoCompleteSampleFabricList;
    let sampleFabricStyleCode = this.state.sampleFabricStyleCode;
    sampleFabricStyleCode = e.target.value;
    if (!isEmptyString(sampleFabricStyleCode)) {
      isShowColorCodeLookUp = true;

      const selectedStyle = this.state.grouped_sample.find(
        (item) => item.code === sampleFabricStyleCode,
      );

      sampleColorCodeList = selectedStyle ? selectedStyle.colorCodes : [];
      sampleFabricLookUpHandler = new GenericAttributeLookupHandler(
        sampleColorCodeList,
        "colorCodes",
      );
    }
    // this.onPaymentTermCodeChange(e.target.value);
    this.setState({
      sampleFabricStyleCode: sampleFabricStyleCode,
      sampleFabricAutoCompleteList: new Array(),
      isShowSampleColorCodeLookUp: isShowColorCodeLookUp,
      sampleColorCodeList: sampleColorCodeList,
      sampleColorCodeLookUpHandler: sampleFabricLookUpHandler,
    });
  };

  displayAutoCompleteSampleFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSampleFabricList: showAutoCompleteList });
  };

  onSampleColorCodeChange = (e) => {
    let sampleColorCode = e.target.value;
    this.state.showAutoCompleteSampleColorCodeList = true;
    let temp_salesOrderData = this.state.sampleColorCode;
    let showAutoCompleteList = this.state.showAutoCompleteSampleColorCodeList;
    if (isEmpty(sampleColorCode)) {
      this.state.showAutoCompleteSampleColorCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSampleColorCodeList;
      let soLine = this.state.sampleColorCode;
      soLine = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        sampleColorCode: soLine,
        sampleColorCodeAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && sampleColorCode !== "") {
      this.readSampleColorCodeSearchString(sampleColorCode);
    }
    temp_salesOrderData = e.target.value;
    this.setState({ sampleColorCode: temp_salesOrderData });
  };
  readSampleColorCodeSearchString(searchString) {
    let sampleColorCode = this.state.sampleColorCodeList;

    let simpleAutoCompleteList = new Array();
    if (sampleColorCode.length > 0 && sampleColorCode != null) {
      sampleColorCode.map((data) => {
        let simpleItemBean = {
          code: data.code,
          description: data.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }

    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipToLists) =>
        simpleAutoCompleteShipToLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      sampleColorCodeAutoCompleteList: filteredSuggestions,
    });
  }

  sampleColorCodeventHandler = (e) => {
    this.state.showAutoCompleteSampleColorCodeList = false;
    let showAutoCompleteList = this.state.showAutoCompleteSampleColorCodeList;
    let sampleColorCode = this.state.sampleColorCode;
    sampleColorCode = e.target.value;
    // this.onPaymentTermCodeChange(e.target.value);
    this.setState({
      sampleColorCode: sampleColorCode,
      sampleColorCodeAutoCompleteList: new Array(),
    });
  };

  displayAutoCompleteSampleColorCodeList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteSampleColorCodeList: showAutoCompleteList,
    });
  };

  rollLineColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("", "isSelected", false)
        .setInputDetails(
          false,
          false,
          true,
          null,
          this.onRollSelectedChange,
          null,
        )
        .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Inventory#" : "RollSKU#",
          "rollSkuNumber",
          true,
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Allocated", "isAllocated", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    //     .setInputDetails(
    //       false,
    //       false,
    //       true,
    //       null,
    //       // this.closeOutCheck,
    //       null
    //     )
    //     .setDisabled(true)
    // )
    columns.push(
      new ColumnDefinition()
        .setDetails("Box#", "boxNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Roll#", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("AvailQty", "availableQuantity", true, true)
    //     .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("PickedToDate", "pickedQuantity", true, true)
    //     .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sample Qty", "sampleQuantity", true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
        .setInputDetails(
          false,
          true,
          false,
          this.onLineSampleQtyChange,
          null,
          this.onLineSampleQtyBlur,
        ),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UPC#", "upcNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "SERIAL#" : "LOT#",
          "vendorBatchNumber",
          true,
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    if (this.state.is3PL) {
      columns.push(
        new ColumnDefinition()
          .setDetails("Conatiner", "containerNumber", true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2"),
      );

      columns.push(
        new ColumnDefinition()
          .setDetails("WhPo", "warehousePurchaseOrderNumber", true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2"),
      );

      columns.push(
        new ColumnDefinition()
          .setDetails("Project#", "projectNumber", true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2"),
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("IMEI#", "imeiNumber", true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2"),
      );

      columns.push(
        new ColumnDefinition()
          .setDetails("PALLET#", "palletNumber", true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2"),
      );
    }
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "LO#" : "PO#",
          "purchasOrderNumber",
          true,
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "LR#" : "PR#",
          "purchaseOrderReceiptNumber",
          true,
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Bin#", "binLocation", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("", "", true)
    //     .setGraphDetails(true, this.graphValueProvider)
    //     .setStyleDetails("left", "", "", "wt-2 ", "wt-2 ")
    // );

    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("", "ExtraOrderQty", false)

    //     .setClickDetails(
    //       false,
    //       true,
    //       this.extraOrderQtyOnClick,
    //       "ExtraOrderQty"
    //     )
    //     .setStyleDetails("", "", "", "wt-2 ", "wt-2 ")
    // );

    return columns;
  };

  render() {
    let salesOrderList = this.state.salesOrderList;
    let isTexco = this.state.isTexco;
    let isFabricCurrentATS = this.state.isFabricCurrentATS;

    // Find the matching ATS record for the currently selected line

    let salesOrderLineData = this.state.salesOrderLineData;
    if (salesOrderLineData != null || salesOrderLineData != "undefined") {
      if (
        salesOrderLineData.onHandQuantity === null ||
        salesOrderLineData.onHandQuantity === "undefined"
      ) {
        salesOrderLineData.onHandQuantity = 0;
      }
    }
    let isLoading = this.state.isLoading;
    let disableSalesOrderFormFields = this.state.isDisableFields;
    let isDisablefabric = this.state.isDisablefabric;
    let isDisableColor = this.state.isDisableColor;
    let salesOrderData = this.state.salesOrderData;
    let priceBean = this.state.priceBean;
    let adjustLineBean = this.state.adjustLineBean;
    let onHandQtyLineBean = this.state.salesOrderLineData;
    let lines = salesOrderData.lines;
    let pickTicketBean = this.state.pickTicketBean;

    let pickTicketLines = pickTicketBean.pickTicketLines;
    let isModify = false;
    isModify = this.isModifyPosible();
    let isEdit = false;
    isEdit = this.isEditValues();

    let currentAtsInfo = {};
    if (Array.isArray(isFabricCurrentATS) && isFabricCurrentATS.length > 0) {
      currentAtsInfo =
        isFabricCurrentATS.find(
          (ats) =>
            ats.fabricStyleCode === salesOrderLineData.fabricStyleCode &&
            ats.colorCode === salesOrderLineData.colorCode,
        ) || isFabricCurrentATS[0]; // fallback to first record if no match
    }

    /***doubt ramtex */
    if (salesOrderLineData.isFetched) {
      isModify = false;
    }
    /* end*/

    let isDisabledFields = this.state.isDisabledFields;
    let disableUpdatableFields = false;
    if (!this.state.isViewMode) {
      if (disableSalesOrderFormFields) {
        if (isModify) {
          disableUpdatableFields = false;
        } else {
          disableUpdatableFields = true;
        }
      }
    } else {
      disableUpdatableFields = true;
    }
    let inventories = [];

    let disableLineEntryPopUp = false;

    if (!this.state.isViewMode) {
      if (disableSalesOrderFormFields) {
        if (isTexco) {
          disableLineEntryPopUp = this.isModifyLineEntryPosible();
        } else {
          if (isModify) {
            disableLineEntryPopUp = false;
          } else {
            disableLineEntryPopUp = true;
          }
        }
      }
    } else {
      disableLineEntryPopUp = true;
    }

    if (
      !isEmpty(this.state.inventoryData) &&
      !isEmptyArray(this.state.inventoryData.inventoryDataDetails)
    ) {
      inventories = this.state.inventoryData.inventoryDataDetails;
    }
    const textAreaStyle = {
      maxHeight: "30px",
      minHeight: "10em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    let moduleOrderStatus = "";
    let orderStatus = ModuleUtils.getSalesOrderStatusCaption(
      this.state.salesOrderData.orderStatus,
    );
    if (orderStatus !== undefined && orderStatus !== null) {
      moduleOrderStatus = orderStatus;
    }
    let isShowColorLookup = this.state.isShowColorLookup;
    let fabricStyleData = this.state.fabricStyleData;
    if (salesOrderData.address == null) {
      salesOrderData.address = new AddressBean();
    }
    let is3PL = this.state.is3PL;
    let fabricInventoryList = new Array();
    if (!isEmptyArray(this.state.fabricInventoryList)) {
      fabricInventoryList = this.state.fabricInventoryList;
    }

    let fabricLookupHandler = this.state.fabricLookupHandler;

    let sampleFabricStyleCode = this.state.sampleFabricStyleCode;

    let isShowSampleColorCodeLookUp = this.state.isShowSampleColorCodeLookUp;
    let skuInventoryList = this.state.skuInventoryList;

    let inventoryLotData = this.state.inventoryLotData;

    let lotOnHandQtyData = this.state.lotOnHandQtyData;

    return (
      <div>
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editSalesOrder}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.salesOrderLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
          isFocusLookup={this.state.isFocusLookup}
        />
        {!this.state.isListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              extend_toolbar={
                <SalesOrderModuleToolBar
                  approveSalesOrder={this.approveSalesOrder}
                  specialApproveSalesOrder={
                    !this.state.isTexco ? this.specialApproveSalesOrder : null
                  }
                  unApproveSalesOrder={this.unApproveSalesOrder}
                  cancelSalesOrder={this.cancelSalesOrder}
                  generatePickTicket={this.generatePickTicket}
                  generatePickTicketAdv={this.generatePickTicketAdv}
                  generatePO={this.generatePO}
                  // proformaInvoice={this.proformaInvoice}
                  createMail={this.createMail}
                  copySO={this.copySO}
                  isShowCopySOButton={this.state.isShowCopySOButton}
                  isShowApproveButton={this.state.isShowApproveButton}
                  //  {if(!this.state.isTexco ){
                  //   isShowSpecialApproveButton={
                  //     this.state.isShowSpecialApproveButton
                  //   }
                  //  }}
                  isShowSpecialApproveButton={
                    !this.state.isTexco
                      ? this.state.isShowSpecialApproveButton
                      : false
                  }
                  isShowUnApproveButton={this.state.isShowUnApproveButton}
                  isShowGeneratePickTicketButton={
                    this.state.isShowGeneratePickTicketButton
                  }
                  isShowGeneratePickTicketAdvButton={
                    this.state.isShowGeneratePickTicketAdvButton
                  }
                  isShowCancelButton={this.state.isShowCancelButton}
                  isShowGeneratePOButton={this.state.isShowGeneratePOButton}
                  //isShowProformaInvButton={this.state.isShowProformaInvButton}
                  isShowMailButton={this.state.isShowMailButton}
                  isShowAddSampleRollButton={
                    this.state.isShowAddSampleRollButton
                  }
                  addSampleRoll={this.addSampleRoll}
                  changeCustomer={this.changeCustomer}
                  isShowChangeCustomerButton={
                    this.state.isShowChangeCustomerButton
                  }
                />
              }
              back={this.back}
              save={this.save}
              clearError={this.clearError}
              generatePDF={this.generatePDF}
              isLoading={this.state.isLoading}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              isShowBackButton={false}
              isShowPDFButton={this.state.isShowPDFReportButton}
              pageTitle={this.state.pageTitle}
              isSpecialViewMode={this.state.isSpecialViewMode}
            />
          )}
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedModuleKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={moduleOrderStatus}
          />
        )}
        {!this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isShipToAddressFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isNotesFormOpened &&
          !this.state.isPurchaseOrdersFormOpened &&
          !this.state.isPickTicketsandInvoicesFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isWebOrderOpen &&
          !this.state.isImageFormOpened &&
          this.state.isEntryFormOpen &&
          !this.state.isMultipleDocFormOpened &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isShipToAddressFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isNotesFormOpened &&
          !this.state.isPurchaseOrdersFormOpened &&
          !this.state.isPickTicketsandInvoicesFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isWebOrderOpen &&
          !this.state.isImageFormOpened &&
          this.state.isEntryFormOpen &&
          !this.state.isMultipleDocFormOpened &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isShipToAddressFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isNotesFormOpened &&
          !this.state.isPurchaseOrdersFormOpened &&
          !this.state.isPickTicketsandInvoicesFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isEntryFormOpen &&
          this.state.isSalesLineDetailFormOpened &&
          !this.state.isWebOrderOpen &&
          !this.state.isImageFormOpened &&
          !this.state.isMultipleDocFormOpened &&
          this.getLineDetailView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isCommissionFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isNotesFormOpened &&
          !this.state.isPurchaseOrdersFormOpened &&
          !this.state.isPickTicketsandInvoicesFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isWebOrderOpen &&
          this.state.isShipToAddressFormOpened &&
          !this.state.isImageFormOpened &&
          !this.state.isMultipleDocFormOpened &&
          this.getShipToandAddressView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isShipToAddressFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isNotesFormOpened &&
          !this.state.isPurchaseOrdersFormOpened &&
          !this.state.isPickTicketsandInvoicesFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isWebOrderOpen &&
          this.state.isCommissionFormOpened &&
          !this.state.isImageFormOpened &&
          !this.state.isMultipleDocFormOpened &&
          this.getCommissionFormView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isShipToAddressFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isNotesFormOpened &&
          !this.state.isPurchaseOrdersFormOpened &&
          !this.state.isPickTicketsandInvoicesFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          this.state.isWebOrderOpen &&
          !this.state.isImageFormOpened &&
          !this.state.isMultipleDocFormOpened &&
          this.getWebOrderView()}
        {/* {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isShipToAddressFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isNotesFormOpened &&
          !this.state.isPurchaseOrdersFormOpened &&
          !this.state.isPickTicketsandInvoicesFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isWebOrderOpen &&
          this.state.isDocumentsFormOpened &&
          !this.state.isImageFormOpened &&
          !this.state.isMultipleDocFormOpened &&
          this.getDocumentFormView()} */}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isShipToAddressFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isNotesFormOpened &&
          !this.state.isPurchaseOrdersFormOpened &&
          !this.state.isPickTicketsandInvoicesFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isWebOrderOpen &&
          !this.state.isDocumentsFormOpened &&
          this.state.isImageFormOpened &&
          !this.state.isMultipleDocFormOpened &&
          this.getImageFormView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isShipToAddressFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isPurchaseOrdersFormOpened &&
          !this.state.isPickTicketsandInvoicesFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isWebOrderOpen &&
          this.state.isNotesFormOpened &&
          !this.state.isImageFormOpened &&
          !this.state.isMultipleDocFormOpened &&
          this.getNoteFormView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isShipToAddressFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isNotesFormOpened &&
          !this.state.isPickTicketsandInvoicesFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isWebOrderOpen &&
          this.state.isPurchaseOrdersFormOpened &&
          !this.state.isImageFormOpened &&
          !this.state.isMultipleDocFormOpened &&
          this.getPurchaseOrdersFormView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isShipToAddressFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isNotesFormOpened &&
          !this.state.isPurchaseOrdersFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isWebOrderOpen &&
          this.state.isPickTicketsandInvoicesFormOpened &&
          !this.state.isImageFormOpened &&
          !this.state.isMultipleDocFormOpened &&
          this.getPickTicketsandInvoicesFormView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isShipToAddressFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isNotesFormOpened &&
          !this.state.isPurchaseOrdersFormOpened &&
          !this.state.isPickTicketsandInvoicesFormOpened &&
          !this.state.isWebOrderOpen &&
          this.state.isChangesHistoryFormOpened &&
          !this.state.isImageFormOpened &&
          !this.state.isMultipleDocFormOpened &&
          this.getChangesHistoryFormView()}

        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isShipToAddressFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isNotesFormOpened &&
          !this.state.isPurchaseOrdersFormOpened &&
          !this.state.isPickTicketsandInvoicesFormOpened &&
          !this.state.isWebOrderOpen &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isImageFormOpened &&
          this.state.isMultipleDocFormOpened &&
          this.getDocumentMutipleFormView()}
        {this.state.isListFormOpen &&
          !this.state.isSpecialViewMode &&
          this.getListView()}
        <AddressComponent
          {...this.state}
          isShowPopup={this.state.isShowAddressPopup}
          addressData={this.state.soAddressData}
          title={"Address"}
          closeAlertAddressModalCallBack={this.closeAlertAddressModalCallBack}
          onChange={this.addressSoOnChange}
          onClick={this.addressOnClick}
          disabled={this.state.isDisabledFields}
          // cityList={this.state.cityList}
          onCityChange={this.onSoCityChange}
          cityEnterKeyEventHandler={this.soCityEnterKeyEventHandler}
          displayAutoCompleteCityList={this.displayAutoCompleteSoCityList}
          onStateChange={this.onSoStateChange}
          stateEnterKeyEventHandler={this.soStateEnterKeyEventHandler}
          displayAutoCompleteStateList={this.displayAutoCompleteSoStateList}
          onCountryChange={this.onSoCountryChange}
          countryEnterKeyEventHandler={this.soCountryEnterKeyEventHandler}
          displayAutoCompleteCountryList={this.displayAutoCompleteSoCountryList}
        />
        <div>
          {" "}
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel1"}
            isModulePopup={false}
            isShowPopup={this.state.isShowSampleRollPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertSampleRolllCallBack}
            title={"Sample Details"}
            // loadingText={this.state.loadingText}
            // isLoading={this.state.isLoading}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={false}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowSampleRollAlert}
                hideAlertCallBack={this.hideSampleRollAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.createSampleOrderForInventory(e)}
                >
                  Create Sample
                </Button>
              </div>
            }
            content={
              <div className="sales_line_pop">
                <Row>
                  <Col sm="1">
                    {" "}
                    <FormLabel>SalesOrder</FormLabel>{" "}
                  </Col>
                  <Col sm="1">
                    <InputTextbox
                      name="code"
                      value={salesOrderData.code}
                      disable={true}
                    ></InputTextbox>
                  </Col>
                  <Col sm="1">
                    {" "}
                    <FormLabel>FabricStyle</FormLabel>{" "}
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      onChange={this.onSampleFabricChange}
                      name="sampleFabricStyleCode"
                      placeholder="sampleFabricStyleCode"
                      value={this.state.sampleFabricStyleCode}
                      lookupRequired={true}
                      lookupHandler={this.state.sampleFabricLookUpHandler}
                      enterKeyEventHandler={
                        this.sampleFabricEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.state.sampleFabricAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompleteSampleFabricList
                      }
                      showAutoCompleteList={
                        this.state.showAutoCompleteSampleFabricList
                      }
                      isMandatory={true}
                    ></InputTextbox>
                  </Col>

                  <Col sm="1">
                    {" "}
                    <FormLabel>Color</FormLabel>{" "}
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      onChange={this.onSampleColorCodeChange}
                      name="sampleColorCode"
                      placeholder="sampleColorCode"
                      value={this.state.sampleColorCode}
                      lookupRequired={isShowSampleColorCodeLookUp}
                      lookupHandler={this.state.sampleColorCodeLookUpHandler}
                      enterKeyEventHandler={this.sampleColorCodeventHandler}
                      autoCompleteListData={
                        this.state.sampleColorCodeAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompleteSampleColorCodeList
                      }
                      showAutoCompleteList={
                        this.state.showAutoCompleteSampleColorCodeList
                      }
                      isMandatory={true}
                    ></InputTextbox>
                  </Col>

                  <Col sm="1">
                    <Button
                      id="fabric_Add_Button"
                      size="sm"
                      onClick={(e) => this.getSampleRollLines(e)}
                    >
                      {" "}
                      Roll Lines
                    </Button>
                  </Col>
                </Row>

                <div className="mt-3">
                  <CustomTable
                    data={this.state.sampleSkuBatchRollLines}
                    columns={this.rollLineColumns()}
                    //isSortedData={true}
                    label={
                      this.state.is3PL ? "Choose Inventory Lines" : "RollLines"
                    }
                  // onSortComplete={(sortedData, sortConfig) => {
                  //   this.setState({ pt_rollLines: sortedData });
                  // }}
                  />
                </div>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel0"}
            isModulePopup={false}
            isShowPopup={this.state.isShowPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"LINE DETAIL"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={true}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowPopupAlert}
                hideAlertCallBack={this.hidePopupAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.addorUpdateSOLine(e)}
                  disabled={
                    this.state.isTexco
                      ? disableLineEntryPopUp
                      : disableUpdatableFields
                  }
                >
                  Add/Update
                </Button>

                {this.state.isShowAddButton && (
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.addorUpdateMultipleSOLine(e)}
                    disabled={
                      this.state.isTexco
                        ? disableLineEntryPopUp
                        : disableUpdatableFields
                    }
                  >
                    Add+ [f9]
                  </Button>
                )}
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.clearLineValues(e)}
                  disabled={
                    this.state.isTexco
                      ? disableLineEntryPopUp
                      : disableUpdatableFields
                  }
                >
                  Clear
                </Button>
              </div>
            }
            content={
              <div
                className="sales_line_pop"
                tabIndex="0"
                onKeyDown={this.onKeyPress}
              >
                <div className="sales_line_pop">
                  <Row>
                    <Col sm="1">
                      {" "}
                      <FormLabel>CompanyCode</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="companyCode"
                        type="text"
                        readOnly={true}
                        value={salesOrderData.companyCode}
                      />{" "}
                    </Col>
                    <Col className="so-align-items-left" sm="1">
                      <FormLabel>OrderNumber</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="code"
                        type="text"
                        readOnly={true}
                        value={salesOrderData.code}
                      />{" "}
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>Customer</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="customerCode"
                        type="text"
                        readOnly={true}
                        value={salesOrderData.customerCode}
                      />{" "}
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>CustomerPO</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="customerPurchaseOrderNumber"
                        type="text"
                        readOnly={true}
                        value={salesOrderData.customerPurchaseOrderNumber}
                      />{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      {" "}
                      <FormLabel>Ln#</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="customerName"
                        type="text"
                        onChange={this.onLineChange}
                        readOnly={true}
                        value={salesOrderLineData.salesOrderLineNumber}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />{" "}
                    </Col>
                    <Col className="so-align-items-left" sm="1">
                      {is3PL ? (
                        <FormLabel
                          className="hyperlinklabel"
                          onClick={(e) => this.lnkFabricStyleModule(e)}
                        >
                          Item#
                        </FormLabel>
                      ) : (
                        <FormLabel
                          className="hyperlinklabel"
                          onClick={(e) => this.lnkFabricStyleModule(e)}
                        >
                          Fabric#
                        </FormLabel>
                      )}
                      <Col className="so-align-items-left">
                        <ShortCutMenuPopup
                          value={salesOrderLineData.fabricStyleCode}
                          menuItems={
                            <ul>
                              <li
                                className="shortcut-menu-item"
                                onClick={(e) =>
                                  this.lnkFabricStyleModule(
                                    e,
                                    salesOrderLineData.fabricStyleCode,
                                  )
                                }
                              >
                                Item Info
                              </li>

                              <li
                                className="shortcut-menu-item"
                                onClick={(e) =>
                                  this.openCustomerFabricSalesHistoryInq(
                                    e,
                                    salesOrderLineData.fabricStyleCode,
                                    salesOrderLineData,
                                  )
                                }
                              >
                                Customer Item Sales History{" "}
                              </li>

                              <li
                                className="shortcut-menu-item"
                                onClick={(e) =>
                                  this.openSalesPriceDetailsInq(
                                    e,
                                    salesOrderLineData.fabricStyleCode,
                                    //row.customerCode
                                  )
                                }
                              >
                                Item Sales History
                              </li>

                              <li
                                className="shortcut-menu-item"
                                // onClick={this.lnkFabricCurrentInvModule}
                                onClick={(e) =>
                                  this.openItemCurrentInvInq(
                                    e,
                                    salesOrderLineData.fabricStyleCode,
                                  )
                                }
                              >
                                {" "}
                                Item Current Inventory Level{" "}
                              </li>

                              <li
                                className="shortcut-menu-item"
                                // onClick={this.lnkFabricInventoryPosition}
                                onClick={(e) =>
                                  this.openItemInvPositionInq(
                                    e,
                                    salesOrderLineData.fabricStyleCode,
                                  )
                                }
                              >
                                {" "}
                                Item Inventory Position{" "}
                              </li>
                              {!this.state.is3PL ? (
                                <li
                                  className="shortcut-menu-item"
                                  // onClick={this.lnkFabricPurchaseHistory}
                                  onClick={(e) =>
                                    this.openItemPurchaseHistoryInq(
                                      e,
                                      salesOrderLineData.fabricStyleCode,
                                    )
                                  }
                                >
                                  {" "}
                                  Item Purchase History{" "}
                                </li>
                              ) : null}
                              <li
                                className="shortcut-menu-item"
                                // onClick={this.lnkFabricAts}
                                onClick={(e) =>
                                  this.openAtsInq(
                                    e,
                                    salesOrderLineData.fabricStyleCode,
                                    salesOrderLineData.fabricStyleName,
                                    salesOrderLineData.colorCode,
                                  )
                                }
                              >
                                {" "}
                                Item ATS{" "}
                              </li>

                              <li
                                className="shortcut-menu-item"
                                // onClick={this.lnkFabricAts}
                                onClick={(e) =>
                                  this.openFabricAndCustomerDetailsInq(
                                    e,
                                    salesOrderLineData.fabricStyleCode,
                                    salesOrderLineData.customerCode,
                                  )
                                }
                              >
                                {" "}
                                FabricAndCustomerDetails{" "}
                              </li>
                            </ul>
                          }
                        />
                      </Col>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onKeyDown={this.onfabricKeyDown}
                        onValueChangeOnBlur={this.onfabricBlur}
                        valueChangeOnBlur={true}
                        ref={this.fabricStyleCodeRef}
                        name="fabricStyleCode"
                        onChange={this.onFabricCodeChange}
                        readOnly={isDisablefabric}
                        disabled={disableUpdatableFields}
                        value={salesOrderLineData.fabricStyleCode}
                        lookupRequired={true}
                        lookupHandler={this.state.fabricLookupHandler}
                        showCriteriaDialog={true}
                        enterKeyEventHandler={this.fabricenterKeyEventHandler}
                        autoCompleteListData={
                          this.state.fabricPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteFabricCodeList
                        }
                        showAutoCompleteList={
                          this.state.showAutoCompleteFabricCodeList
                        }
                        isMandatory={true}
                      />{" "}
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name="fabricStyleName"
                        type="text"
                        onChange={this.onLineChange}
                        readOnly={true}
                        value={salesOrderLineData.fabricStyleName}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />{" "}
                    </Col>
                    {!this.state.is3PL ? (
                      <>
                        <Col sm="1">
                          {" "}
                          <FormLabel>Width</FormLabel>{" "}
                        </Col>
                        <Col sm="2">
                          <InputTextbox
                            name="widthCode"
                            type="text"
                            onChange={this.onLineChange}
                            readOnly={true}
                            value={salesOrderLineData.widthCode}
                            disabled={isDisabledFields}
                            isMandatory={true}
                          />{" "}
                        </Col>
                      </>
                    ) : null}
                  </Row>
                  <Row>
                    {" "}
                    <Col sm="1">
                      {" "}
                      <FormLabel>Color</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        onKeyDown={this.onfabricColorKeyDown}
                        onValueChangeOnBlur={this.onfabricColorBlur}
                        valueChangeOnBlur={true}
                        ref={this.fabricStyleColorCodeRef}
                        name="colorCode"
                        type="text"
                        placeholder="Enter ColorCode"
                        onChange={this.onFabricColourCodeChange}
                        value={salesOrderLineData.colorCode}
                        lookupRequired={this.state.isShowColorLookup}
                        lookupHandler={
                          this.state.salesLineColorCodeLookupHandler
                        }
                        enterKeyEventHandler={
                          this.fabricColourEnterKeyEventHandler
                        }
                        autoCompleteListData={
                          this.state.fabricColourPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteColourList
                        }
                        showAutoCompleteList={
                          this.state.showAutoCompleteColourList
                        }
                        isMandatory={true}
                        readOnly={!this.state.isShowColorLookup}
                        disabled={!this.state.isShowColorLookup}
                      />{" "}
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>UOM</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="orderUomCode"
                        type="text"
                        onChange={this.onUOMCodeChange}
                        value={salesOrderLineData.orderUomCode}
                        lookupRequired={this.state.isShowUomLookup}
                        lookupHandler={this.state.uomLookupHandler}
                        enterKeyEventHandler={this.uomEnterKeyEvent}
                        autoCompleteListData={
                          this.state.uomPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteUomList
                        }
                        showAutoCompleteList={
                          this.state.showAutoCompleteUOMList
                        }
                        disabled={
                          !this.state.isShowUomLookup
                          //  && this.props.isDisabledFields
                        }
                        isMandatory={this.state.isShowUomLookup}
                      />{" "}
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>OrdQty</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        value={salesOrderLineData.orderQuantity}
                        onChange={this.onLineChange}
                        className="text-right"
                        decimalScale={2}
                        name={"orderQuantity"}
                        disabled={isEdit}
                        isModifyEditable={salesOrderLineData.isFetched}
                        //  isModifyView={true}
                        isMandatory={true}
                      />
                    </Col>
                    {!this.state.is3PL ? (
                      <>
                        <Col className="so-align-items-left" sm="1">
                          <FormLabel
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.showPricePopup(
                                e,
                                salesOrderLineData.price,
                                salesOrderLineData,
                              )
                            }
                          >
                            Price
                          </FormLabel>
                          <Col className="so-align-items-left">
                            <ShortCutMenuPopup
                              value={salesOrderLineData.fabricStyleCode}
                              menuItems={
                                <ul>
                                  <li
                                    className="shortcut-menu-item"
                                    onClick={(e) =>
                                      this.openPriceWithOutCustomerDetailsInq(
                                        e,
                                        salesOrderLineData.fabricStyleCode,
                                        salesOrderLineData,

                                        //row.customerCode
                                      )
                                    }
                                  >
                                    All Customer Price Sales Details{" "}
                                  </li>

                                  <li
                                    className="shortcut-menu-item"
                                    onClick={(e) =>
                                      this.openPriceWithCustomerDetailsInq(
                                        e,
                                        salesOrderLineData.fabricStyleCode,
                                        salesOrderLineData,
                                        //row.customerCode
                                      )
                                    }
                                  >
                                    Customer Price Sales Details
                                  </li>
                                </ul>
                              }
                            />
                          </Col>
                        </Col>
                        <Col sm="2">
                          <NumberFormatInputbox
                            value={salesOrderLineData.price}
                            onChange={this.onLineChange}
                            className=" text-right"
                            decimalScale={2}
                            name={"price"}
                            disabled={
                              this.state.isTexco
                                ? disableLineEntryPopUp
                                : isDisabledFields
                            }
                            //  disabled={isDisabledFields}
                            isMandatory={true}
                          />
                        </Col>
                      </>
                    ) : null}
                  </Row>
                  <Row>
                    {!this.state.is3PL ? (
                      <>
                        <Col sm="1">
                          {" "}
                          <FormLabel>No.Rolls</FormLabel>{" "}
                        </Col>
                        <Col sm="2">
                          <NumberFormatInputbox
                            value={salesOrderLineData.numberOfRollsPreferred}
                            onChange={this.onLineChange}
                            className=" text-right"
                            decimalScale={2}
                            name={"numberOfRollsPreferred"}
                            disabled={disableUpdatableFields}
                            isModifyEditable={salesOrderLineData.isFetched}
                            isModifyView={isModify}
                            isMandatory={true}
                          />
                        </Col>
                      </>
                    ) : null}
                    <Col sm="1">
                      {" "}
                      <FormLabel
                        className="hyperlinklabel"
                        onClick={(e) =>
                          this.lnkOnHandQuantityDetailsClick(
                            e,
                            salesOrderLineData.onHandQuantity,
                          )
                        }
                      >
                        OnHand
                      </FormLabel>
                    </Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        value={salesOrderLineData.onHandQuantity}
                        onChange={this.onLineChange}
                        className="text-right"
                        decimalScale={2}
                        name={"onHandQuantity"}
                        disabled={true}
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel
                      // className="hyperlinklabel"
                      // onClick={(e) =>
                      //   this.lnkAdjustQtyClick(
                      //     e,
                      //     isFabricCurrentATS.totalAtsYardage,
                      //     salesOrderLineData,
                      //   )
                      // }
                      >
                        ATS Qty
                      </FormLabel>
                    </Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        value={currentAtsInfo?.atsYardage ?? ""}
                        onChange={this.onAtsChange}
                        className="text-right"
                        decimalScale={2}
                        name={"atsYardage"}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel
                        className="hyperlinklabel"
                        onClick={(e) =>
                          this.lnkAdjustQtyClick(
                            e,
                            salesOrderLineData.adjustedQuantity,
                            salesOrderLineData,
                          )
                        }
                      >
                        Adjust Qty
                      </FormLabel>
                    </Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        value={salesOrderLineData.adjustedQuantity}
                        onChange={this.onLineChange}
                        className="text-right"
                        decimalScale={2}
                        name={"adjustedQuantity"}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      {" "}
                      <FormLabel>StartDate</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <DatePickerComponent_adv
                        name="orderStartDate"
                        value={salesOrderLineData.orderStartDate}
                        onChange={this.onLineChange}
                        disabled={isDisabledFields}
                        isModifyView={isModify}
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>StopDate</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <DatePickerComponent_adv
                        name="orderStopDate"
                        value={salesOrderLineData.orderStopDate}
                        onChange={this.onLineChange}
                        disabled={isDisabledFields}
                        isModifyView={isModify}
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>Lot Number</FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="lotNumber"
                        type="text"
                        onChange={this.onLineChange}
                        value={salesOrderLineData.lotNumber}
                        disabled={isDisabledFields}
                      />{" "}
                    </Col>
                  </Row>

                  <div
                  // className="div_inline"
                  >
                    {this.state.isTexco ? (
                      <div>
                        <div className="div_100_no_overflow flex">
                          {/* <div className="flex"> */}

                          <div className="div_40_no_overflow">
                            <Col className="so-align-items-left">
                              <FormLabel>LotOnHandQty</FormLabel>{" "}
                            </Col>
                            <div className="">
                              <div className="div_Custom_10">
                                {/* <CustomTable
                                        data={fabricInventoryList}
                                        columns={this.inquiryColumns()}
                                       // label={"Inquiry Data List"}
                              /> */}
                                <Table id="fabrics_tables">
                                  <thead>
                                    <tr>
                                      <th
                                        onClick={(e) =>
                                          this.handleonHandSortingChange(
                                            e,
                                            "locationCode",
                                          )
                                        }
                                      >
                                        Location
                                        {this.state.order === "desc" &&
                                          this.state.sortField ===
                                          "locationCode" ? (
                                          <span className="drp-dwn-cntr">
                                            <DropDwnUp />
                                          </span>
                                        ) : (
                                          <span className="drp-dwn-cntr">
                                            <DropDwnDown />
                                          </span>
                                        )}
                                      </th>

                                      <th
                                        onClick={(e) =>
                                          this.handleonHandSortingChange(
                                            e,
                                            "locationCode",
                                          )
                                        }
                                      >
                                        Lot
                                        {this.state.order === "desc" &&
                                          this.state.sortField ===
                                          "locationCode" ? (
                                          <span className="drp-dwn-cntr">
                                            <DropDwnUp />
                                          </span>
                                        ) : (
                                          <span className="drp-dwn-cntr">
                                            <DropDwnDown />
                                          </span>
                                        )}
                                      </th>
                                      <th
                                        onClick={(e) =>
                                          this.handleonHandSortingChange(
                                            e,
                                            "fabricStyleColorCode",
                                          )
                                        }
                                      >
                                        Color
                                        {this.state.order === "desc" &&
                                          this.state.sortField ===
                                          "fabricStyleColorCode" ? (
                                          <span className="drp-dwn-cntr">
                                            <DropDwnUp />
                                          </span>
                                        ) : (
                                          <span className="drp-dwn-cntr">
                                            <DropDwnDown />
                                          </span>
                                        )}
                                      </th>
                                      <th
                                        onClick={(e) =>
                                          this.handleonHandSortingChange(
                                            e,
                                            "fabricStyleColorCode",
                                          )
                                        }
                                      >
                                        PO
                                        {this.state.order === "desc" &&
                                          this.state.sortField ===
                                          "fabricStyleColorCode" ? (
                                          <span className="drp-dwn-cntr">
                                            <DropDwnUp />
                                          </span>
                                        ) : (
                                          <span className="drp-dwn-cntr">
                                            <DropDwnDown />
                                          </span>
                                        )}
                                      </th>
                                      <th
                                        onClick={(e) =>
                                          this.handleonHandSortingChange(
                                            e,
                                            "fabricStyleColorCode",
                                          )
                                        }
                                      >
                                        PR
                                        {this.state.order === "desc" &&
                                          this.state.sortField ===
                                          "fabricStyleColorCode" ? (
                                          <span className="drp-dwn-cntr">
                                            <DropDwnUp />
                                          </span>
                                        ) : (
                                          <span className="drp-dwn-cntr">
                                            <DropDwnDown />
                                          </span>
                                        )}
                                      </th>
                                      <th
                                        onClick={(e) =>
                                          this.handleonHandSortingChange(
                                            e,
                                            "onHandQuantity",
                                          )
                                        }
                                      >
                                        OnHandQty
                                        {this.state.order === "desc" &&
                                          this.state.sortField ===
                                          "onHandQuantity" ? (
                                          <span className="drp-dwn-cntr">
                                            <DropDwnUp />
                                          </span>
                                        ) : (
                                          <span className="drp-dwn-cntr">
                                            <DropDwnDown />
                                          </span>
                                        )}
                                      </th>
                                    </tr>
                                  </thead>

                                  {skuInventoryList != null ? (
                                    <tbody>
                                      {skuInventoryList.map((ln, index) => (
                                        <tr key={index}>
                                          <td>{ln.locationCode}</td>
                                          <td>{ln.lotNumber}</td>
                                          <td>{ln.fabricStyleColorCode}</td>
                                          <td>{ln.purchaseOrderNumber}</td>
                                          <td>
                                            {ln.purchaseOrderReceiptNumber}
                                          </td>
                                          <td className="text-end">
                                            <Button
                                              variant="secondry"
                                              className="hyperLinkText"
                                              onClick={() =>
                                                this.showOnHandLotQty(ln)
                                              }
                                            // disabled={isDisableFields}
                                            >
                                              {ln.totalOnHandQuantity}
                                            </Button>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  ) : null}
                                </Table>
                                {fabricInventoryList.length != 0 ? null : (
                                  <div className="no_Data_small">
                                    {"NO DATA"}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="div_60_no_overflow">
                            <div className="alignoverflow">
                              <div className="div_50_no_overflow">
                                <Col className="so-align-items-left">
                                  <FormLabel>Images</FormLabel>{" "}
                                </Col>
                                <div className="">
                                  <Row>
                                    <Col></Col>
                                    <Col sm="4">
                                      <img
                                        src={`${this.getSoLineImagePathMain(
                                          fabricStyleData,
                                        )}&a=${new Date().getTime()}`}
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = noImage;
                                        }}
                                        alt="Click to Add"
                                        width={90}
                                        height={90}
                                        mode="fit"
                                      />{" "}
                                    </Col>
                                    <Col sm="4">
                                      <img
                                        src={`${this.getSoLineImagePathWeb(
                                          fabricStyleData,
                                        )}&a=${new Date().getTime()}`}
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = noImage;
                                        }}
                                        alt="Click to Add"
                                        width={90}
                                        height={90}
                                        mode="fit"
                                      />{" "}
                                    </Col>
                                    <Col></Col>
                                  </Row>
                                  <Row>
                                    <Col></Col>
                                    <Col sm="4">
                                      <img
                                        src={`${this.getSoLineImagePathFront(
                                          fabricStyleData,
                                        )}&a=${new Date().getTime()}`}
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = noImage;
                                        }}
                                        alt="Click to Add"
                                        width={90}
                                        height={90}
                                        mode="fit"
                                      />{" "}
                                    </Col>
                                    <Col sm="4">
                                      <img
                                        src={`${this.getSoLineImagePathBack(
                                          fabricStyleData,
                                        )}&a=${new Date().getTime()}`}
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = noImage;
                                        }}
                                        alt="Click to Add"
                                        width={90}
                                        height={90}
                                        mode="fit"
                                      />{" "}
                                    </Col>
                                    <Col></Col>
                                  </Row>
                                </div>
                              </div>
                              <div className="div_50_no_overflow">
                                <Col className="so-align-items-left">
                                  <FormLabel>Amount Details</FormLabel>
                                </Col>
                                <div className="header_div">
                                  <Row>
                                    <Col sm="">
                                      {" "}
                                      <FormLabel>Extension</FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <NumberFormatInputbox
                                        value={
                                          salesOrderLineData.lineTotalAmount
                                        }
                                        onChange={this.onLineChange}
                                        className="qty_input text-right summary_input"
                                        decimalScale={2}
                                        name={"lineTotalAmount"}
                                        disabled={true}
                                      />
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col sm="">
                                      {" "}
                                      <FormLabel>Disc%</FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <NumberFormatInputbox
                                        value={
                                          salesOrderLineData.discountPercentage
                                        }
                                        onChange={this.onLineChange}
                                        className="qty_input text-right summary_input"
                                        decimalScale={2}
                                        name={"discountPercentage"}
                                        disabled={disableUpdatableFields}
                                        isModifyEditable={
                                          salesOrderLineData.isFetched
                                        }
                                        isModifyView={isModify}
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col sm="">
                                      {" "}
                                      <FormLabel>DiscAmt</FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <NumberFormatInputbox
                                        value={
                                          salesOrderLineData.lineDiscountAmount
                                        }
                                        onChange={this.onLineChange}
                                        className="qty_input text-right summary_input"
                                        decimalScale={2}
                                        name={"lineDiscountAmount"}
                                        disabled={true}
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col sm="">
                                      {" "}
                                      <FormLabel>NetAmt</FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <NumberFormatInputbox
                                        value={salesOrderLineData.lineNetAmount}
                                        onChange={this.onLineChange}
                                        className="qty_input text-right summary_input"
                                        decimalScale={2}
                                        name={"lineNetAmount"}
                                        disabled={true}
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col sm="">
                                      {" "}
                                      <FormLabel>Tariff%</FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <NumberFormatInputbox
                                        value={
                                          salesOrderLineData.tariffPercentage
                                        }
                                        onChange={this.onLineChange}
                                        className="qty_input text-right summary_input"
                                        decimalScale={2}
                                        name={"tariffPercentage"}
                                        disabled={disableUpdatableFields}
                                        isModifyEditable={
                                          salesOrderLineData.isFetched
                                        }
                                        isModifyView={isModify}
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col sm="">
                                      {" "}
                                      <FormLabel>Tariff.Amt</FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <NumberFormatInputbox
                                        value={salesOrderLineData.tariffAmount}
                                        onChange={this.onLineChange}
                                        className="qty_input text-right summary_input"
                                        decimalScale={2}
                                        name={"tariffAmount"}
                                        disabled={true}
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </div>
                            <div className="aligntextarea">
                              <Row>
                                <Col sm="1">
                                  {" "}
                                  <FormLabel>Remarks</FormLabel>
                                </Col>
                                <Col sm="10">
                                  <textarea
                                    style={textAreaStyle}
                                    className="form-control"
                                    name="remarks"
                                    type="text"
                                    placeholder="Remarks"
                                    onChange={this.onLineChange}
                                    value={salesOrderLineData.remarks}
                                    disabled={isDisabledFields}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col sm="1">
                                  {" "}
                                  <FormLabel>Comments</FormLabel>
                                </Col>
                                <Col sm="10">
                                  <textarea
                                    style={textAreaStyle}
                                    className="form-control"
                                    name="comments"
                                    type="text"
                                    placeholder="Comments"
                                    onChange={this.onLineChange}
                                    value={salesOrderLineData.comments}
                                    disabled={isDisabledFields}
                                    rows="1"
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                          {/* </div> */}
                        </div>
                      </div>
                    ) : (
                      <div className="div_100_no_overflow flex">
                        <div className="div_30_no_overflow_v1">
                          <Col className="so-align-items-left">
                            <FormLabel>OnHandQty</FormLabel>{" "}
                          </Col>
                          <div className="">
                            <div className="div_Custom_10">
                              {/* <CustomTable
                                        data={fabricInventoryList}
                                        columns={this.inquiryColumns()}
                                       // label={"Inquiry Data List"}
                              /> */}
                              <Table id="fabrics_tables">
                                <thead>
                                  <tr>
                                    <th
                                      onClick={(e) =>
                                        this.handleonHandSortingChange(
                                          e,
                                          "locationCode",
                                        )
                                      }
                                    >
                                      Location
                                      {this.state.order === "desc" &&
                                        this.state.sortField ===
                                        "locationCode" ? (
                                        <span className="drp-dwn-cntr">
                                          <DropDwnUp />
                                        </span>
                                      ) : (
                                        <span className="drp-dwn-cntr">
                                          <DropDwnDown />
                                        </span>
                                      )}
                                    </th>
                                    <th
                                      onClick={(e) =>
                                        this.handleonHandSortingChange(
                                          e,
                                          "fabricStyleColorCode",
                                        )
                                      }
                                    >
                                      Color
                                      {this.state.order === "desc" &&
                                        this.state.sortField ===
                                        "fabricStyleColorCode" ? (
                                        <span className="drp-dwn-cntr">
                                          <DropDwnUp />
                                        </span>
                                      ) : (
                                        <span className="drp-dwn-cntr">
                                          <DropDwnDown />
                                        </span>
                                      )}
                                    </th>
                                    <th
                                      onClick={(e) =>
                                        this.handleonHandSortingChange(
                                          e,
                                          "onHandQuantity",
                                        )
                                      }
                                    >
                                      OnHandQty
                                      {this.state.order === "desc" &&
                                        this.state.sortField ===
                                        "onHandQuantity" ? (
                                        <span className="drp-dwn-cntr">
                                          <DropDwnUp />
                                        </span>
                                      ) : (
                                        <span className="drp-dwn-cntr">
                                          <DropDwnDown />
                                        </span>
                                      )}
                                    </th>
                                  </tr>
                                </thead>

                                {fabricInventoryList != null ? (
                                  <tbody>
                                    {fabricInventoryList.map((ln, index) => (
                                      <tr key={index}>
                                        <td>{ln.locationCode}</td>
                                        <td>{ln.fabricStyleColorCode}</td>
                                        <td className="text-end">
                                          <Button
                                            variant="secondry"
                                            className="hyperLinkText"
                                            onClick={() =>
                                              this.showOnHandQty(ln)
                                            }
                                          // disabled={isDisableFields}
                                          >
                                            {ln.onHandQuantity}
                                          </Button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                ) : null}
                              </Table>
                              {fabricInventoryList.length != 0 ? null : (
                                <div className="no_Data_small">{"NO DATA"}</div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="div_70_no_overflow">
                          <div className="alignoverflow">
                            <div className="div_50_no_overflow">
                              <Col className="so-align-items-left">
                                <FormLabel>Images</FormLabel>{" "}
                              </Col>
                              <div className="">
                                <Row>
                                  <Col></Col>
                                  <Col sm="4">
                                    <img
                                      src={`${this.getSoLineImagePathMain(
                                        fabricStyleData,
                                      )}&a=${new Date().getTime()}`}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = noImage;
                                      }}
                                      alt="Click to Add"
                                      width={90}
                                      height={90}
                                      mode="fit"
                                    />{" "}
                                  </Col>
                                  <Col sm="4">
                                    <img
                                      src={`${this.getSoLineImagePathWeb(
                                        fabricStyleData,
                                      )}&a=${new Date().getTime()}`}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = noImage;
                                      }}
                                      alt="Click to Add"
                                      width={90}
                                      height={90}
                                      mode="fit"
                                    />{" "}
                                  </Col>
                                  <Col></Col>
                                </Row>
                                <Row>
                                  <Col></Col>
                                  <Col sm="4">
                                    <img
                                      src={`${this.getSoLineImagePathFront(
                                        fabricStyleData,
                                      )}&a=${new Date().getTime()}`}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = noImage;
                                      }}
                                      alt="Click to Add"
                                      width={90}
                                      height={90}
                                      mode="fit"
                                    />{" "}
                                  </Col>
                                  <Col sm="4">
                                    <img
                                      src={`${this.getSoLineImagePathBack(
                                        fabricStyleData,
                                      )}&a=${new Date().getTime()}`}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = noImage;
                                      }}
                                      alt="Click to Add"
                                      width={90}
                                      height={90}
                                      mode="fit"
                                    />{" "}
                                  </Col>
                                  <Col></Col>
                                </Row>
                              </div>
                            </div>
                            <div className="div_50_no_overflow">
                              <Col className="so-align-items-left">
                                <FormLabel>Amount Details</FormLabel>
                              </Col>
                              <div className="header_div">
                                <Row>
                                  <Col sm="">
                                    {" "}
                                    <FormLabel>Extension</FormLabel>
                                  </Col>
                                  <Col sm="8">
                                    <NumberFormatInputbox
                                      value={salesOrderLineData.lineTotalAmount}
                                      onChange={this.onLineChange}
                                      className="qty_input text-right summary_input"
                                      decimalScale={2}
                                      name={"lineTotalAmount"}
                                      disabled={true}
                                    />
                                  </Col>
                                </Row>

                                <Row>
                                  <Col sm="">
                                    {" "}
                                    <FormLabel>Disc%</FormLabel>
                                  </Col>
                                  <Col sm="8">
                                    <NumberFormatInputbox
                                      value={
                                        salesOrderLineData.discountPercentage
                                      }
                                      onChange={this.onLineChange}
                                      className="qty_input text-right summary_input"
                                      decimalScale={2}
                                      name={"discountPercentage"}
                                      disabled={disableUpdatableFields}
                                      isModifyEditable={
                                        salesOrderLineData.isFetched
                                      }
                                      isModifyView={isModify}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col sm="">
                                    {" "}
                                    <FormLabel>DiscAmt</FormLabel>
                                  </Col>
                                  <Col sm="8">
                                    <NumberFormatInputbox
                                      value={
                                        salesOrderLineData.lineDiscountAmount
                                      }
                                      onChange={this.onLineChange}
                                      className="qty_input text-right summary_input"
                                      decimalScale={2}
                                      name={"lineDiscountAmount"}
                                      disabled={true}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col sm="">
                                    {" "}
                                    <FormLabel>NetAmt</FormLabel>
                                  </Col>
                                  <Col sm="8">
                                    <NumberFormatInputbox
                                      value={salesOrderLineData.lineNetAmount}
                                      onChange={this.onLineChange}
                                      className="qty_input text-right summary_input"
                                      decimalScale={2}
                                      name={"lineNetAmount"}
                                      disabled={true}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col sm="">
                                    {" "}
                                    <FormLabel>Tariff%</FormLabel>
                                  </Col>
                                  <Col sm="8">
                                    <NumberFormatInputbox
                                      value={
                                        salesOrderLineData.tariffPercentage
                                      }
                                      onChange={this.onLineChange}
                                      className="qty_input text-right summary_input"
                                      decimalScale={2}
                                      name={"tariffPercentage"}
                                      disabled={disableUpdatableFields}
                                      isModifyEditable={
                                        salesOrderLineData.isFetched
                                      }
                                      isModifyView={isModify}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col sm="">
                                    {" "}
                                    <FormLabel>Tariff.Amt</FormLabel>
                                  </Col>
                                  <Col sm="8">
                                    <NumberFormatInputbox
                                      value={salesOrderLineData.tariffAmount}
                                      onChange={this.onLineChange}
                                      className="qty_input text-right summary_input"
                                      decimalScale={2}
                                      name={"tariffAmount"}
                                      disabled={true}
                                    />
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </div>
                          <div className="aligntextarea">
                            <Row>
                              <Col sm="1">
                                {" "}
                                <FormLabel>Remarks</FormLabel>
                              </Col>
                              <Col sm="10">
                                <textarea
                                  style={textAreaStyle}
                                  className="form-control"
                                  name="remarks"
                                  type="text"
                                  placeholder="Remarks"
                                  onChange={this.onLineChange}
                                  value={salesOrderLineData.remarks}
                                  disabled={isDisabledFields}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col sm="1">
                                {" "}
                                <FormLabel>Comments</FormLabel>
                              </Col>
                              <Col sm="10">
                                <textarea
                                  style={textAreaStyle}
                                  className="form-control"
                                  name="comments"
                                  type="text"
                                  placeholder="Comments"
                                  onChange={this.onLineChange}
                                  value={salesOrderLineData.comments}
                                  disabled={isDisabledFields}
                                  rows="1"
                                />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            }
          />
          <ProgressBar
            closeAlertModalCallBack={this.closeAlertProgressBarModalCallBack}
            progressLoadingText={this.state.progressLoadingText}
            isShowPopup={this.state.isShowProgressBarPopup}
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={false}
            isShowPopup={this.state.isShowPricePopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertSubModalCallBack}
            title={"Price"}
            loadingText={this.state.loadingText}
            isLoading={this.state.isLoading}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={false}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlert}
                hideAlertCallBack={this.hideAlertCallBack}
              />
            }
            content={
              <div className="sales_line_pop">
                <Row>
                  <Col sm="1">
                    <FormLabel>CompanyCode</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={priceBean.companyCode}
                      disabled={true}
                    />
                  </Col>
                  {is3PL ? (
                    <Col sm="1">
                      <FormLabel>Item</FormLabel>
                    </Col>
                  ) : (
                    <Col sm="1">
                      <FormLabel>Fabric</FormLabel>
                    </Col>
                  )}
                  <Col sm="2">
                    <InputTextbox
                      value={priceBean.fabricStyleCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      value={priceBean.fabricStyleName}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Color</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={priceBean.fabricStyleColorCode}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Customer</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={priceBean.customerCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      value={priceBean.customerName}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>CustomerType</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={priceBean.customerTypeCode}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <FormLabel>Price Details</FormLabel>
                </Row>
                <Row>
                  {is3PL ? (
                    <Col sm="1">
                      <FormLabel>Item WholeSalesPrice</FormLabel>
                    </Col>
                  ) : (
                    <Col sm="1">
                      <FormLabel>Fabric WholeSalesPrice</FormLabel>
                    </Col>
                  )}
                  <Col sm="2">
                    <InputTextbox
                      value={priceBean.itemWholeSalePrice}
                      disabled={true}
                    />
                  </Col>
                  {is3PL ? (
                    <Col sm="1">
                      <FormLabel>Fabric RetailPrice</FormLabel>
                    </Col>
                  ) : (
                    <Col sm="1">
                      <FormLabel>Item RetailPrice</FormLabel>
                    </Col>
                  )}
                  <Col sm="2">
                    <InputTextbox
                      value={priceBean.itemRetailPrice}
                      disabled={true}
                    />
                  </Col>
                  {is3PL ? (
                    <Col sm="1">
                      <FormLabel>Item SamplePrice</FormLabel>
                    </Col>
                  ) : (
                    <Col sm="1">
                      <FormLabel>Fabric SamplePrice</FormLabel>
                    </Col>
                  )}
                  <Col sm="2">
                    <InputTextbox
                      value={priceBean.itemSamplePrice}
                      disabled={true}
                    />
                  </Col>
                  {is3PL ? (
                    <Col sm="1">
                      <FormLabel>Item CloseOutPrice</FormLabel>
                    </Col>
                  ) : (
                    <Col sm="1">
                      <FormLabel>Fabric CloseOutPrice</FormLabel>
                    </Col>
                  )}
                  <Col sm="2">
                    <InputTextbox
                      value={priceBean.itemCloseOutPrice}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>SKU WholeSale Price</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={priceBean.itemSkuWholeSalePrice}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>CustomerType Price</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={priceBean.customerTypePrice}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>CustomerType SamplePrice</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={priceBean.customerTypeSamplePrice}
                      disabled={true}
                    />
                  </Col>
                </Row>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel3"}
            isModulePopup={false}
            isShowPopup={this.state.isShowAdjustQtyPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertSubModalCallBack}
            title={"Adjust Qty"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={false}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlert}
                hideAlertCallBack={this.hideAlertCallBack}
              />
            }
            content={
              <div className="sales_line_pop">
                <Row>
                  <Col sm="1">
                    <FormLabel>CompanyCode</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={adjustLineBean.companyCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>SalesOrder</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={adjustLineBean.salesOrderNumber}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>OrderType</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={adjustLineBean.orderTypeCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Line</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={adjustLineBean.salesOrderLineNumber}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  {is3PL ? (
                    <Col sm="1">
                      <FormLabel>Item</FormLabel>
                    </Col>
                  ) : (
                    <Col sm="1">
                      <FormLabel>FabricStyle</FormLabel>
                    </Col>
                  )}
                  <Col sm="2">
                    <InputTextbox
                      value={adjustLineBean.fabricStyleCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      value={adjustLineBean.fabricStyleName}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Color</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={adjustLineBean.colorCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Width</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={adjustLineBean.widthCode}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>OrderQty</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={adjustLineBean.orderQuantity}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Adjusted Qty</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={adjustLineBean.adjustedQuantity}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>UOM</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={adjustLineBean.adjustedUomCode}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <FormLabel>OnHand Quantity On Rolls</FormLabel>
                </Row>
                <Row>
                  <Table>
                    <thead>
                      <th>Ln#</th>
                      <th>Reason</th>
                      <th>Adjusted Qty</th>
                      <th>Remarks</th>
                    </thead>
                    {this.state.adjustmentLines != null && (
                      <tbody>
                        {this.state.adjustmentLines.map((list, i) => (
                          <tr key={1}>
                            <td>{list.adjustmentLineNumber}</td>
                            <td>{list.reasonCode}</td>
                            <td className="text-end">
                              {list.adjustedQuantity}
                            </td>
                            <td>{list.remarks}</td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                  </Table>
                </Row>
              </div>
            }
          />
          <MessageBoxComponent
            isShowPopup={this.state.isShowWarningMsgPopup}
            warningMesage={this.state.warningMessage}
            title="Warning Message"
            onYesButtonClick={this.onYesButtonClick}
            onNoButtonClick={this.onNoButtonClick}
            closeMessageModelCallBack={this.closeMessageModelCallBack}
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel6"}
            isModulePopup={false}
            isShowPopup={this.state.isShowChangeCustomerPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"ChangeCustomer"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={true}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl6}
                hideAlertCallBack={this.hideAlertCallBackLvl6}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.continueToChangeNewCustomer(e)}
                >
                  Continue
                </Button>
              </div>
            }
            content={
              <div className="text-center">
                <div>
                  <Row>
                    <Col sm="2">
                      <FormLabel>Customer#</FormLabel>
                    </Col>
                    <Col sm="7">
                      <InputTextbox
                        onChange={this.newCustomerCodeOnChange}
                        ref={this.newCustomerRef}
                        name="code"
                        placeholder="customer"
                        value={this.state.changeCustomerBaseBean.code}
                        lookupRequired={true}
                        lookupHandler={this.state.customerLookupHandler}
                        enterKeyEventHandler={
                          this.newCustomerCodeEnterKeyEventHandler
                        }
                        autoCompleteListData={
                          this.state.newCustomerPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompletesalesOrderList
                        }
                        showAutoCompleteList={
                          this.state.isShowAutoCompleteNewCustomerList
                        }
                        isNotFound={this.state.isNewCustomerNotFound}
                        isMandatory={true}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="2">
                      <FormLabel>Name#</FormLabel>
                    </Col>
                    <Col sm="7">
                      <InputTextbox
                        onChange={this.onNewCustomerChange}
                        // ref={this.salesOrderRef}
                        name="description"
                        placeholder="customerName"
                        value={this.state.changeCustomerBaseBean.description}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel6"}
            isModulePopup={false}
            isShowPopup={this.state.isShowCopySOPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"Copy SO"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={true}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl6}
                hideAlertCallBack={this.hideAlertCallBackLvl6}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.copySOContinue(e)}
                >
                  Continue
                </Button>
              </div>
            }
            content={
              <div className="SalesOrderPopup">
                <div>
                  <Row>
                    <Col sm="1">
                      <FormLabel>SO#</FormLabel>
                    </Col>
                    <Col sm="4">
                      <InputTextbox
                        onChange={this.onCopySOChange}
                        ref={this.salesOrderRef}
                        name="copySONum"
                        placeholder="copySONum"
                        value={this.state.copySONum}
                        lookupRequired={true}
                        lookupHandler={this.state.salesOrderLookupHandler}
                        enterKeyEventHandler={
                          this.salesOrderEnterKeyEventHandler
                        }
                        autoCompleteListData={
                          this.state.salesOrderPageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompletesalesOrderList
                        }
                        showAutoCompleteList={
                          this.state.showAutoCompleteSalesOrderList
                        }
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel1"}
            isModulePopup={false}
            isShowPopup={this.state.isShowGeneratePOPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalNewPoCallBack}
            title={"Create PurchaseOrder"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={true}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowPopupAlert}
                hideAlertCallBack={this.hidePopupAlertNewPoCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.createPurchaseOrder(e)}
                >
                  Create PO
                </Button>
              </div>
            }
            content={
              <GeneratePOPopup
                {...this.state}
                selectAllSoLine={this.selectAllSoLine}
                unSelectAllSoLine={this.unSelectAllSoLine}
                poLineCheck={this.poLineCheck}
                poOnChange={this.poOnChange}
                onVendorCodeChange={this.onVendorCodeChange}
                displayAutoCompleteVendorList={
                  this.displayAutoCompleteVendorList
                }
                vendorCodeEnterKeyEventHandler={
                  this.vendorCodeEnterKeyEventHandler
                }
                vendor_List={this.state.vendor_List}
                onLocationChange={this.onLocationChange}
                locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
                displayAutoCompleteLocationList={
                  this.displayAutoCompleteLocationList
                }
                poCreateEntryKey={this.poCreateEntryKey}
                purchaseOrderNumberCreateRef={this.purchaseOrderNumberCreateRef}
              />
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={false}
            isShowPopup={this.state.isShowMailPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"Mail SalesOrder"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={true}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowMailAlert}
                hideAlertCallBack={this.hideAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.sendMail(e)}
                >
                  Send
                </Button>
              </div>
            }
            content={
              <GenerateMailPopup
                {...this.state}
                mailOnChange={this.mailOnChange}
              />
            }
          />
          {/* <MailComponent
            mailData={this.state.mailInfoBean}
            title="Mail"
            onChange={this.mailOnChange}
            onClick={this.sendMail}
            isShowPopup={this.state.isShowMailPopup}
            closeModelCallBack={this.closeAlertModalCallBack}
            msgList={this.state.alertMessage}
            msgType={this.state.alertType}
            isShowAlert={this.state.isShowMailAlert}
            isDisabled={this.state.is3PL ? false : this.state.isDisabledFields}
          /> */}
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={false}
            isShowPopup={this.state.isShowPickTicketAdvPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalNewPTCallBack}
            title={"PICKTICKET DETAIL"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={true}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowPtAdvPopupAlert}
                hideAlertCallBack={this.hidePopupAlertNewPtCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.saveAdvancedPickTicketEntry(e)}
                >
                  Create PT
                </Button>
              </div>
            }
            content={
              <div className="sales_line_pop">
                <Row>
                  <Col sm="1">
                    {" "}
                    <FormLabel>PickTicket#</FormLabel>{" "}
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      ref={this.pickTicketNumberCreateRef}
                      name="code"
                      type="text"
                      // readOnly={true}
                      className="qty_input summary_input"
                      onChange={this.onPickTicketChange}
                      value={pickTicketBean.code}
                      disabled={isDisabledFields}
                      enterKeyEventHandler={this.ptEntryKey}
                      isMandatory={true}
                    />{" "}
                  </Col>

                  <Col sm="1">
                    {" "}
                    <FormLabel>CustomerCode</FormLabel>{" "}
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="customerCode"
                      type="text"
                      readOnly={true}
                      value={salesOrderData.customerCode}
                      disabled={isDisabledFields}
                      isMandatory={true}
                    />{" "}
                  </Col>

                  <Col sm="3">
                    <InputTextbox
                      name="customerName"
                      type="text"
                      readOnly={true}
                      value={pickTicketBean.customerName}
                      disabled={isDisabledFields}
                      isMandatory={true}
                    />{" "}
                  </Col>

                  <Col sm="1">
                    {" "}
                    <FormLabel>SO#</FormLabel>{" "}
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="salesOrderNumber"
                      type="text"
                      readOnly={true}
                      value={pickTicketBean.salesOrderNumber}
                      disabled={isDisabledFields}
                      isMandatory={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <Button
                      id="fabric_Add_Button"
                      size="sm"
                      onClick={(e) => this.selectAllLine(e)}
                    >
                      {" "}
                      Select All
                    </Button>
                  </Col>

                  <Col sm="1">
                    <Button
                      id="fabric_Add_Button"
                      size="sm"
                      onClick={(e) => this.unSelectAllLine(e)}
                    >
                      {" "}
                      UnSelect All
                    </Button>
                  </Col>
                </Row>

                <Row>
                  {/* <EditableDataGrid
                    columnsList={this.ptColumnDefinitions()}
                    dataList={pickTicketLines}
                  /> */}

                  <div className="mt-3">
                    <CustomTable
                      data={pickTicketLines}
                      columns={this.ptColumnDefinitions()}
                    />
                  </div>
                </Row>
              </div>
            }
          />
          {/* Fabric Shortcut Menu Popup :*/}
          {/* <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={false}
            isShowPopup={this.state.isShowCustomerFabricSalesPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertFabricModalCallBack}
            title={"Customer Item Sales History"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlert}
                hideAlertCallBack={this.hideAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  onClick={this.pdfCustomerFabricSalesHistory}
                >
                  PDF
                </Button>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={this.excelCustomerFabricSalesHistory}
                >
                  EXCEL
                </Button>
              </div>
            }
            content={<CustomerFabricSalesPopup {...this.state} />}
          /> */}
          {/* <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={false}
            isShowPopup={this.state.isShowFabricCurrentInvPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertFabricModalCallBack}
            title={"Fabric Current Inventory Level"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlert}
                hideAlertCallBack={this.hideAlertCallBack}
              />
            }
            content={<FabricCurrentInventoryLevel {...this.state} />}
          /> */}
          {/* <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={false}
            isShowPopup={this.state.isShowFabricInventoryPosPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertFabricModalCallBack}
            title={"Fabric Inventory Position"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlert}
                hideAlertCallBack={this.hideAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  onClick={this.pdfFabricInventoryPosition}
                >
                  PDF
                </Button>

                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={this.excelFabricInventoryPosition}
                >
                  EXCEL
                </Button>
              </div>
            }
            content={<FabricInventoryPosition {...this.state} />}
          /> */}
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel1"}
            isModulePopup={true}
            id="modulePopup"
            isShowPopup={this.state.isShowCustomerSalesHistoryInq}
            closeModalCallBack={this.closeModalCallBack}
            module={this.state.moduleForPopup}
            lockScroll={false}
          ></MultiViewPopup>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel1"}
            isModulePopup={true}
            id="modulePopup"
            isShowPopup={this.state.isShowItemInventoryPositionInq}
            closeModalCallBack={this.closeModalCallBack}
            module={this.state.moduleForPopup}
            lockScroll={false}
          ></MultiViewPopup>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel1"}
            isModulePopup={true}
            id="modulePopup"
            isShowPopup={this.state.isShowItemCurrentInventoryInq}
            closeModalCallBack={this.closeModalCallBack}
            module={this.state.moduleForPopup}
            lockScroll={false}
          ></MultiViewPopup>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel1"}
            isModulePopup={true}
            id="modulePopup"
            isShowPopup={this.state.isShowAtsInq}
            closeModalCallBack={this.closeModalCallBack}
            module={this.state.moduleForPopup}
            lockScroll={false}
          ></MultiViewPopup>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel1"}
            isModulePopup={true}
            id="modulePopup"
            isShowPopup={this.state.isShowFabricPurchaseHistoryInq}
            closeModalCallBack={this.closeModalCallBack}
            module={this.state.moduleForPopup}
            lockScroll={false}
          ></MultiViewPopup>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel1"}
            isModulePopup={true}
            id="modulePopup"
            isShowPopup={this.state.isShowfabricAndCustomerSalesDetails}
            closeModalCallBack={this.closeModalCallBack}
            module={this.state.moduleForPopup}
            lockScroll={false}
          ></MultiViewPopup>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel1"}
            isModulePopup={true}
            id="modulePopup"
            isShowPopup={this.state.isShowItemSalesDetails}
            closeModalCallBack={this.closeModalCallBack}
            module={this.state.moduleForPopup}
            lockScroll={false}
          ></MultiViewPopup>
          {/* <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={false}
            isShowPopup={this.state.isShowFabricPurchaseHistoryPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertFabricModalCallBack}
            title={"Fabric Purchase History"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlert}
                hideAlertCallBack={this.hideAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  onClick={this.pdfFabricPurchaseHistory}
                >
                  PDF
                </Button>

                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={this.excelFabricPurchaseHistory}
                >
                  EXCEL
                </Button>
              </div>
            }
            content={<FabricPurchaseHistory {...this.state} />}
          /> */}
          {/* <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={false}
            isShowPopup={this.state.isShowFabricAtsPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertFabricModalCallBack}
            title={"Fabric Ats"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlert}
                hideAlertCallBack={this.hideAlertCallBack}
              />
            }
            content={<FabricAts {...this.state} />}
          /> */}
        </div>
        <div>
          {" "}
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={false}
            isShowPopup={this.state.isShowOnHandQtyPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertSubModalCallBack}
            title={"OnHandQuantity"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={false}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlert}
                hideAlertCallBack={this.hideAlertCallBack}
              />
            }
            content={
              <div>
                <Row>
                  <Col sm="1">
                    <FormLabel>CompanyCode</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.companyCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>SalesOrder</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox value={salesOrderData.code} disabled={true} />
                  </Col>
                  <Col sm="1">
                    <FormLabel>OrderType</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={salesOrderData.orderTypeCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Line</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.salesOrderLineNumber}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  {is3PL ? (
                    <Col sm="1">
                      <FormLabel>Item</FormLabel>
                    </Col>
                  ) : (
                    <Col sm="1">
                      <FormLabel>FabricStyle</FormLabel>
                    </Col>
                  )}
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.fabricStyleCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      value={onHandQtyLineBean.fabricStyleName}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Color</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.colorCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Width</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.widthCode}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>OrderQty</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.orderQuantity}
                      disabled={true}
                    />
                  </Col>

                  <Col sm="1">
                    <FormLabel>OnHand Qty</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.onHandQuantity}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>UOM</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.inventoryUomCode}
                      disabled={true}
                    />
                  </Col>
                  {/* <Col sm="1">
                    <FormLabel>TotalRolls</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.totalNumberOfRolls}
                      disabled={true}
                    />
                  </Col> */}
                </Row>
                <div className="div_Custom_3">
                  <Table id="fabrics_tables_default">
                    <thead>
                      <tr>
                        <th>Location</th>
                        <th>BinLoc</th>
                        <th>{this.state.is3PL ? "Inventory#" : "RollSKU#"}</th>
                        <th>Batch</th>
                        <th>Roll</th>
                        {/* <th>PO#</th>
                         <th>PR#</th> */}
                        {/* <th>Lot#</th> */}
                        <th>OnHandQty</th>
                      </tr>
                    </thead>
                    {inventories != null ? (
                      <tbody>
                        {inventories.map((ln, index) => (
                          <tr key={index}>
                            <td>{ln.locationCode}</td>
                            <td>{ln.aisleInfoText}</td>
                            <td>{ln.rollSkuNumber}</td>
                            <td>{ln.vendorBatchNumber}</td>
                            <td>{ln.rollNumber}</td>
                            {/* <td>{ln.purchaseOrderNumber}</td>
                                    <td>{ln.purchaseOrderReceiptNumber}</td> */}

                            <td className="text-end">{ln.onHandQuantity}</td>
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                  </Table>
                  {inventories.length != 0 ? null : (
                    <div className="no_Data">{"NO DATA"}</div>
                  )}
                </div>
              </div>
            }
          />
        </div>
        <div>
          {" "}
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={false}
            isShowPopup={this.state.isShowOnHandLotQtyPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertSubModalCallBack}
            title={"LotOnHandQuantity"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={false}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlert}
                hideAlertCallBack={this.hideAlertCallBack}
              />
            }
            content={
              <div>
                <Row>
                  <Col sm="1">
                    <FormLabel>CompanyCode</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.companyCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>SalesOrder</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox value={salesOrderData.code} disabled={true} />
                  </Col>
                  <Col sm="1">
                    <FormLabel>OrderType</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={salesOrderData.orderTypeCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Line</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.salesOrderLineNumber}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  {is3PL ? (
                    <Col sm="1">
                      <FormLabel>Item</FormLabel>
                    </Col>
                  ) : (
                    <Col sm="1">
                      <FormLabel>FabricStyle</FormLabel>
                    </Col>
                  )}
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.fabricStyleCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      value={onHandQtyLineBean.fabricStyleName}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Color</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.colorCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Width</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.widthCode}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>OrderQty</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.orderQuantity}
                      disabled={true}
                    />
                  </Col>

                  <Col sm="1">
                    <FormLabel>TotalOnHand Qty</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={lotOnHandQtyData.totalOnHandQuantity}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>UOM</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.inventoryUomCode}
                      disabled={true}
                    />
                  </Col>
                  {/* <Col sm="1">
                    <FormLabel>TotalRolls</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={onHandQtyLineBean.totalNumberOfRolls}
                      disabled={true}
                    />
                  </Col> */}
                </Row>
                <div className="div_Custom_3">
                  <Table id="fabrics_tables_default">
                    <thead>
                      <tr>
                        <th>Location</th>
                        {/* <th>BinLoc</th> */}
                        <th>{this.state.is3PL ? "Inventory#" : "RollSKU#"}</th>
                        <th>Batch</th>
                        <th>Roll</th>
                        <th>PO#</th>
                        <th>PR#</th>
                        {/* <th>Lot#</th> */}
                        <th>OnHandQty</th>
                      </tr>
                    </thead>
                    {inventoryLotData != null ? (
                      <tbody>
                        {inventoryLotData.map((ln, index) => (
                          <tr key={index}>
                            <td>{ln.locationCode}</td>
                            {/* <td>{ln.aisleInfoText}</td> */}
                            <td>{ln.rollSkuNumber}</td>
                            <td>{ln.vendorBatchNumber}</td>
                            <td>{ln.rollNumber}</td>
                            <td>{ln.purchaseOrderNumber}</td>
                            <td>{ln.purchaseOrderReceiptNumber}</td>

                            <td className="text-end">{ln.onHandQuantity}</td>
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                  </Table>
                  {inventoryLotData.length != 0 ? null : (
                    <div className="no_Data">{"NO DATA"}</div>
                  )}
                </div>
              </div>
            }
          />
        </div>
        <ReasonCaptureComponent
          ref={this.lineCancelReasonDialogRef}
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="SalesOrder Line Cancel"
          onChange={this.onReasonChange}
          onClick={this.onLineCancelReasonContinue}
          isShowPopup={this.state.isShowLineCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        <ReasonCaptureComponent
          ref={this.cancelReasonDialogRef}
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="SalesOrder Cancel"
          onChange={this.onReasonChange}
          onClick={this.onCancelReasonContinue}
          isShowPopup={this.state.isShowCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        <ReasonCaptureComponent
          ref={this.unapproveReasonDialogRef}
          reasons={this.state.unapprovalReasons}
          reasonData={this.state.reasonData}
          title="SalesOrder UnApprove"
          onChange={this.onUnApproveReasonChange}
          onClick={this.onUnApproveReasonContinue}
          isShowPopup={this.state.isShowUnApproveReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.unApproveReasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.unApproveReasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={
            this.displayAutoCompleteUnApproveReasonList
          }
          showAutoCompleteReasonList={
            this.state.showAutoCompleteUnApproveReasonList
          }
          onReasonDescChange={this.onReasonDescChange}
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
      </div>
    );
  }
}
class SalesOrderListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      salesOrderCriteria: new SalesOrderSearchCriteria(),
      filter: "",
      pageList: this.props.pageList,
    };
    this.searchRef = React.createRef();
  }
  onChange = (e) => {
    this.props.onCriteriaChange(e);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterSalesOrder();
    }
  };
  filterSalesOrder = (e) => {
    if (e.detail == 1) this.props.filterSalesOrder();
  };
  resetFilteredSalesOrder = (e) => {
    if (e.detail == 1) {
      let salesOrderCriteria = this.props.salesOrderCriteria;
      if (this.searchRef.current != null) {
        this.searchRef.current.clear();
      }
      this.props.resetFilteredSalesOrder(salesOrderCriteria);
    }
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  handleSalesOrderCodeChange = (event) => {
    this.setState({ filter: event.target.value });
  };
  handleHyperLinkClick = (e, val, rowData) => {
    if (e.detail == 1) this.props.editSalesOrder(val);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };

  highlightText = (text, search) => {
    if (!search) return text;
    const parts = String(text).split(new RegExp(`(${search})`, "gi"));
    return parts.map((part, index) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <span key={index} style={{ backgroundColor: "yellow" }}>
          {part}
        </span>
      ) : (
        part
      ),
    );
  };
  highlightText1 = (text, search) => {
    if (!search) return text;

    // Convert non-string types like numbers and dates into strings for consistent processing
    const fieldText = String(text);

    // Split the string and wrap the matching parts with a span to highlight them
    const parts = fieldText.split(new RegExp(`(${search})`, "gi"));
    return parts.map((part, index) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <span key={index} style={{ backgroundColor: "yellow" }}>
          {part}
        </span>
      ) : (
        part
      ),
    );
  };



  salesOrderPageColumns = () => {

    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("SO#", "code", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.handleHyperLinkClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerCode", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.props.is3PL ? "Item" : "FabricStyle", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderDate", "orderDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")

    );
    columns.push(
      new ColumnDefinition()
        .setDetails("orderType", "orderTypeCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")

    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "orderStatus", true,)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getCaption)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "customerPurchaseOrderNumber", true,)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalAmount", "grandTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    return columns;
  }

  getCaption = (status) => {
    return ModuleUtils.getSalesOrderStatusCaption(status);
  };


  render() {
    let salesOrderList = new Array();
    if (!isEmptyArray(this.props.salesOrderList)) {
      salesOrderList = this.props.salesOrderList;
    }
    let salesOrderCriteria = this.props.salesOrderCriteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    if (!isEmpty(pageList)) {
      let pageSize = pageList.pageSize;
      let totalCount = pageList.totalCount;
      totalPages = totalCount / pageSize;
      totalPages += totalCount % pageSize == 0 ? 0 : 1;
    }
    let isLoading = this.props.isLoading;
    let criteriaString = this.props.getCriteriaString();
    let isAdvanceSearch = this.props.isAdvanceSearch;
    return (
      <div>
        <div className="secondary_module_header">
          {/* <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="searchName"
                type="text"
                value={salesOrderCriteria.searchName}
                placeholder="Enter Value to Filter.."
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
            </span>
            <span className="px-2"></span>

            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.filterSalesOrder(e)}>
              Filter
            </Button>
            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.resetFilteredSalesOrder(e)}>
              Reset
            </Button>
          </div> */}

          <div className="mdle-criteria-wrap">
            <div className="">
              <FormLabel className="criteria-labl">Status</FormLabel>
            </div>
            <div className="criteria-val">
              <FormControl
                as="select"
                custom
                onChange={this.onChange}
                name="orderStatus"
                value={salesOrderCriteria.orderStatus}
              >
                <option value={""}>All</option>
                <option value={"A"}>Approved</option>
                <option value={"U"}>UnApproved</option>
                <option value={"M"}>Picked</option>
                <option value={"L"}>Partially Picked</option>
                <option value={"F"}>Invoiced / Finished</option>
                <option value={"G"}>Partially Invoiced</option>
                <option value={"X"}>Cancelled</option>
              </FormControl>
            </div>
            <div className="">
              <FormLabel className="criteria-labl">Search</FormLabel>
            </div>
            <div className="criteria-val">
              <InputTextbox
                ref={this.searchRef}
                name="searchName"
                type="text"
                value={salesOrderCriteria.searchName}
                placeholder="Enter Value to Filter.."
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
            </div>
            <div className="criteria-btn-wrap ">
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.filterSalesOrder(e)}
              >
                Filter
              </Button>
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.resetFilteredSalesOrder(e)}
              >
                Reset
              </Button>
            </div>
          </div>

          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>

            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>

        {isAdvanceSearch && (
          <div className="secondary_module_header">{criteriaString}</div>
        )}
        <div className="mt-3">
          <CustomTable
            data={salesOrderList}
            columns={this.salesOrderPageColumns()}
            enableHighlight={true} // Boolean flag controlling highlight execution
            searchText={salesOrderCriteria.searchName} // Search input text
          />
        </div>

      </div>
    );
  }
}

class SalesOrderEntryForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.itemCodeRef = React.createRef();
    this.customerCodeRef = React.createRef();
    this.paymentDialogRef = React.createRef();
    this.paymentTermCodeRef = React.createRef();
    this.discountPercentageRef = React.createRef();
    this.itemShortNameRef = React.createRef();
    this.orderTypeCodeRef = React.createRef();
    this.customerShipToCodeRef = React.createRef();
    this.customerModuleRef = React.createRef();
    this.shipViaCodeRef = React.createRef();
    this.customerRepCodeRef = React.createRef();
    this.salesClerkCodeRef = React.createRef();
    this.poRef = React.createRef();
    this.orderTypeRef = React.createRef();
    this.state = {
      salesOrderData: this.props.salesOrderData,
      customerData: this.props.customerData,
      isSalesOrderLineAddOpen: false,
      salesOrderLineData: new SalesOrderLineBean(),
      isItemDataLoding: false,
      itemList: [],
      isCustomerDataLoding: false,
      customerList: [],
      isLineEditMode: false,
      customerData: new CustomerBean(),
      orderTypes: this.props.salesOrderTypes,
      paymentTerms: this.props.paymentTerms,
      warehouses: this.props.warehouses,
      selected_item_data: new FabricStyleBean(),
      open: false,
      isLineEditable: false,
      customerShipTos: [],

      isShowCustomerModule: false,
      isShowInvoiceModule: false,
      isShowARModule: false,
      isShowCreditMemoModule: false,
      moduleForPopup: [],
      isShowAlert: false,
      alertMsg: "",
      isCollapsible_open: this.props.isCollapsible_open,
      isBlur: true,

      isShowARModule: false,
      invoiceList: [],
      agingInvoiceList: [],
      creditMemoList: [],
      customerCreditMemoList: [],
      customerSalesDataList: [],
      readARAppliedList: [],
      recentFabricList: [],
      recentInvoiceList: [],
      customerStatisticsList: [],
      customerAgingList: [],
      recentInvoiceList: [],
      readARCreditMemoList: [],
      stAgingBucketList: [],
      stAgingHistoryBean: [],
      onOrderInfoDetail: [],
      salesDetail: [],
      returnCreditMemo: [],
      agingHistoryBean: new BaseCustomerPaymentAgingHistoryBean(),
      agingDataList: [],
      statisticData: "",
      criteria: new CustomerSearchCriteria(),
      tempPopUpData: null,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.report_url = appData.reportURL;
    this.companyCode = appData.companyCode;

    this.initLookupHandlers();
    this.setInputFocusPO();
    this.focusCustomerCode();
  }

  componentDidUpdate() { }

  initLookupHandlers = () => {
    let orderTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.orderTypes,
      "Order Type",
    );
    this.setState({ orderTypeLookupHandler: orderTypeLookupHandler });
    let paymentTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.paymentTerms,
      "PaymentTerm",
    );
    this.setState({ paymentTermLookupHandler: paymentTermLookupHandler });
    let shipViaLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipVias,
      "ShipVia",
    );
    this.setState({ shipViaLookupHandler: shipViaLookupHandler });
    let customerRepLookupHandler = new GenericAttributeLookupHandler(
      this.props.customerRepresentatives,
      "Custome Representative",
    );
    this.setState({ customerRepLookupHandler: customerRepLookupHandler });
    let salesClerkLookupHandler = new GenericAttributeLookupHandler(
      this.props.salesClerks,
      "Sales Clerk",
    );
    this.setState({ salesClerkLookupHandler: salesClerkLookupHandler });
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let deliveryTypeLookupHandler = new GenericAttributeLookupHandler(
      this.props.customerDeliveries,
      this.props.is3PL ? "Service Type" : "Delivery Type",
    );
    this.setState({ deliveryTypeLookupHandler: deliveryTypeLookupHandler });
  };
  closeSalesOrderEntryForm() {
    this.props.closeSalesOrderEntryForm();
  }
  onSalesOrderLineTableChange = (e, line) => {
    this.props.onSalesOrderLineTableChange(e, line);
  };
  calculateGrandTotalAfterLineQtyChanged(temp_salesOrderLinedata) {
    this.props.calculateGrandTotalAfterLineQtyChanged(temp_salesOrderLinedata);
  }
  onHeaderAmountsChange = (e) => {
    this.props.onHeaderAmountsChange(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  onBlur = (e) => { };
  addNewSalesOrderLine = (e) => {
    if (e.detail == 1) this.props.addNewSalesOrderLine();
  };
  onLineAmountsChange = (e) => {
    this.props.onLineAmountsChange(e);
  };
  calculateLineTaxAmount(temp_salesOrderLineData) {
    this.props.calculateLineTaxAmount(temp_salesOrderLineData);
  }
  calculateSalesOrderHeaderTaxAmount(temp_salesOrderData) {
    this.props.calculateSalesOrderHeaderTaxAmount(temp_salesOrderData);
  }
  grandTotalAmountCalc() {
    this.props.grandTotalAmountCalc();
  }
  cancelSalesOrderLine = (salesOrderDeleteLineData) => {
    this.props.cancelSalesOrderLine(salesOrderDeleteLineData);
  };
  getLineDetails = (invocieLinedata) => {
    this.props.getLineDetails(invocieLinedata);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };
  displayAutoCompleteCustomerList = (e) => {
    this.props.displayAutoCompleteCustomerList(e);
  };
  onCustomerCodeChange = (e) => {
    this.props.onCustomerCodeChange(e);
  };
  onCSRChange = (e) => {
    this.props.onCSRChange(e);
  };
  onShipToChange = (e) => {
    this.props.onShipToChange(e);
  };
  onShipViaChange = (e) => {
    this.props.onShipViaChange(e);
  };

  onPaymentTermChange = (e) => {
    this.props.onPaymentTermChange(e);
  };
  onOrderTypeChange = (e) => {
    this.props.onOrderTypeChange(e);
  };
  onSalesClerkChange = (e) => {
    this.props.onSalesClerkChange(e);
  };
  cSREnterKeyEventHandler = (e) => {
    this.props.cSREnterKeyEventHandler(e);
  };
  salesClerkEnterKeyEventHandler = (e) => {
    this.props.salesClerkEnterKeyEventHandler(e);
  };

  orderTypeEnterKeyEventHandler = (e) => {
    this.props.orderTypeEnterKeyEventHandler(e);
  };
  shipToEnterKeyEventHandler = (e) => {
    this.props.shipToEnterKeyEventHandler(e);
  };
  shipViaEnterKeyEventHandler = (e) => {
    this.props.shipViaEnterKeyEventHandler(e);
  };
  paymentTermEnterKeyEventHandler = (e) => {
    this.props.paymentTermEnterKeyEventHandler(e);
  };
  /**
   *
   * @param {boolean} showAutoCompleteList
   * return boolean
   */
  displayAutoCompleteShipViaList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteShipViaList(showAutoCompleteList);
  };
  displayAutoCompleteShipToList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteShipToList(showAutoCompleteList);
  };
  displayAutoCompleteOrderTypeList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteOrderTypeList(showAutoCompleteList);
  };
  displayAutoCompleteCsrList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteCsrList(showAutoCompleteList);
  };
  displayAutoCompleteSalesClerkList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteSalesClerkList(showAutoCompleteList);
  };
  displayAutoCompletePaymentTermList = (showAutoCompleteList) => {
    this.props.displayAutoCompletePaymentTermList(showAutoCompleteList);
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteList(showAutoCompleteList);
  };
  handleCustomerAutocompleteSearch = (searchString) => {
    this.props.handleCustomerAutocompleteSearch(searchString);
    this.focusCustomerCode();
  };
  readCustomerByCustomerCode = (customerCode) => {
    this.props.readCustomerByCustomerCode(customerCode);
  };
  customerCleared() {
    this.props.customerCleared();
  }
  customerSelected() {
    this.props.customerSelected();
    setTimeout(() => {
      this.customerShipToCodeRef.current.focus();
    }, 400);
  }
  handleItemAutocompleteSearch = (searchString) => {
    this.props.handleItemAutocompleteSearch(searchString);
  };
  clearCustomerCodeRef = () => {
    this.customerCodeRef.current.clear();
  };
  clearItemCodeRef = () => {
    this.itemCodeRef.current.clearValue();
  };
  focusCustomerCode = () => {
    this.customerCodeRef.current.focus();
  };
  onShipmentChargesAmountKeydown = (event) => {
    if (event.keyCode == 13) {
      this.customerCodeRef.current.focus();
    }
  };
  setInputFocusPO() {
    if (this.props.isFocusPO == true) {
      this.poRef.current.focus();
    }
  }
  handleLineNumberClick = (e, val, rowData) => {
    this.props.readAndSetFabricStyleImage(rowData.fabricStyleCode);
    this.getLineDetails(rowData);
  };
  inputChangeCallback = (e, rowData) => {
    this.onSalesOrderLineTableChange(e, rowData);
  };
  inputBoxonBlurCallBack = (e, rowData) => {
    this.props.onSalesOrderLineTableInputBlur(e, rowData);
  };
  buttonClickCallback = (e, val, rowData) => {
    if (rowData.lineStatus != LogicConstants.SALES_ORDER_LINE_CANCEL_STATUS)
      this.cancelSalesOrderLine(rowData);
  };
  headerButtonClickCallback = (e) => { };
  editPriceClickCallback = (e, rowData) => {
    this.editLinePrice(rowData);
  };
  // imageLinkCallBack = (rowData) => {
  //   let serviceURL = this.image_src_url;
  //   if (rowData == null) {
  //     return null;
  //   } else if (rowData.imageName != null || rowData.imageName != "") {
  //     let imageName = rowData.imageName;
  //     let imageURL = serviceURL + imageName;
  //     return imageURL;
  //   } else if (rowData.itemImages != null || rowData.itemImages.length <= 0) {
  //     let imageName = rowData.itemImages[0].imageName;
  //     let imageURL = serviceURL + imageName;
  //     return imageURL;
  //   } else {
  //     return null;
  //   }
  // };
  addButtonClickCallback = (e) => {
    this.addNewSalesOrderLine();
  };

  getCaption = (status) => {
    return ModuleUtils.getSalesOrderLineStatusCaption(status);
  };

  getShortcutComponent = (row) => {
    return (
      <ShortCutMenuPopup
        value={row.fabricStyleCode}
        // popupData = {this.state.tempPopUpData }
        menuItems={
          <ul>
            <li
              className="shortcut-menu-item"
              onClick={(e) =>
                this.props.lnkFabricStyleModule(e, row.fabricStyleCode)
              }
            >
              Item Info
            </li>

            <li
              className="shortcut-menu-item"
              onClick={(e) =>
                this.props.openCustomerFabricSalesHistoryInq(
                  e,
                  row.fabricStyleCode,
                  row,
                )
              }
            >
              Customer Item Sales History{" "}
            </li>

            <li
              className="shortcut-menu-item"
              onClick={(e) =>
                this.props.openSalesPriceDetailsInq(
                  e,
                  row.fabricStyleCode,
                  //row.customerCode
                )
              }
            >
              Item Sales History
            </li>

            <li
              className="shortcut-menu-item"
              onClick={(e) =>
                this.props.openItemCurrentInvInq(e, row.fabricStyleCode)
              }
            >
              Item Current Inventory Level
            </li>

            <li
              className="shortcut-menu-item"
              onClick={(e) =>
                this.props.openItemInvPositionInq(e, row.fabricStyleCode)
              }
            >
              Item Inventory Position
            </li>
            {!this.props.is3PL ? (
              <li
                className="shortcut-menu-item"
                onClick={(e) =>
                  this.props.openItemPurchaseHistoryInq(e, row.fabricStyleCode)
                }
              >
                Item Purchase History
              </li>
            ) : null}
            <li
              className="shortcut-menu-item"
              onClick={(e) =>
                this.props.openAtsInq(
                  e,
                  row.fabricStyleCode,
                  row.fabricStyleName,
                  row.colorCode,
                )
              }
            >
              Item ATS
            </li>

            <li
              className="shortcut-menu-item"
              onClick={(e) =>
                this.props.openFabricAndCustomerDetailsInq(
                  e,
                  row.fabricStyleCode,
                  row.customerCode,
                )
              }
            >
              Fabric and Customer Details
            </li>
          </ul>
        }
      />
    );
  };

  // getDisabled = (column, row, index, val) => {
  //   let lineDisabled = false;

  //   if (
  //     row.lineStatus === LogicConstants.SALES_ORDER_LINE_SHIPPED_STATUS ||
  //     row.lineStatus ===
  //       LogicConstants.SALES_ORDER_LINE_PARTIALLY_SHIPPED_STATUS
  //   ) {
  //     lineDisabled = true;
  //   }
  //   return lineDisabled;
  //   // return true;
  // };
  soLineColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setHeaderDetails(true, <AddIcon />, this.addNewSalesOrderLine, false)
        .setStyleDetails("", "", "", "wt-4", "wt-4")

        .setShortCutPopDetails(this.getShortcutComponent, true),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Ln#", "salesOrderLineNumber", true)

        .setStyleDetails("right", "", "", "wt-2", " wt-2")

        .setClickDetails(true, false, this.handleLineNumberClick, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "min-wt-5", "min-wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "min-wt-5 ", "min-wt-5 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "min-wt-5 ", "min-wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderQty", "orderQuantity", true)
        // .setHeaderDetails( )
        .setStyleDetails("right", "", "", "wt-5 ", "wt-5")
        .setInputDetails(
          false,
          true,
          false,
          this.inputChangeCallback,
          null,
          this.inputBoxonBlurCallBack,
        )
        //  .setSpecialDisabled(true, this.getDisabled),
        .setDisabled(this.props.isLineLevelEditable),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "orderUomCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true)
        // .setHeaderDetails( )
        .setStyleDetails("right", "", "", "wt-5 ", "wt-5")
        .setInputDetails(
          false,
          true,
          false,
          this.inputChangeCallback,
          null,
          this.inputBoxonBlurCallBack,
        )
        .setDisabled(this.props.isLineLevelEditable),
      //.setSpecialDisabled(true, this.getDisabled),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ShipdQty", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotAmt", "lineTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-5", ""),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "lineStatus", true)
        .setStatusDetails(true, this.getCaption)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Disc%", "discountPercentage", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("DiscAmt", "lineDiscountAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)
        // .setHeaderDetails(true, <AddIcon />, this.addNewSalesOrderLine, false)
        // .setStyleDetails("", "", "", "wt-2", "wt-2")

        .setClickDetails(false, true, this.buttonClickCallback, <DeleteIcon />)
        .setDisabled(this.props.isLineLevelDelete),
    );
    return columns;
  };
  toSalesLineStatus = (e, rowData) => {
    let _lineStatus = "";
    _lineStatus = ModuleUtils.getSalesOrderLineStatusCaption(
      rowData.lineStatus,
    );
    return _lineStatus;
  };
  toSalesOrderState = (salesOrderdata) => {
    let orderState = "Open";
    if (salesOrderdata == null) return orderState;
    if (
      salesOrderdata.orderStatus == LogicConstants.SALES_ORDER_APPROVE_STATUS ||
      salesOrderdata.orderStatus == LogicConstants.SALES_ORDER_UNAPPROVE_STATUS
    ) {
      orderState = "Open";
    } else if (
      salesOrderdata.orderStatus == LogicConstants.SALES_ORDER_PICKED_STATUS
    ) {
      orderState = "In Pick";
    } else if (
      salesOrderdata.orderStatus ==
      LogicConstants.SALES_ORDER_PARTIALLY_PICKED_STATUS
    ) {
      orderState = "In Pick";
    } else if (
      salesOrderdata.orderStatus == LogicConstants.SALES_ORDER_CANCEL_STATUS
    ) {
      orderState = "Cancelled";
    }
    return orderState;
  };
  isModifyPosible = () => {
    return this.props.isModifyPosible();
  };
  onKeyPress = (e) => {
    if (e.keyCode == 119) {
      this.addNewSalesOrderLine();
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  lnkCustomerModule = (e) => {
    if (e.detail == 1) {
      let salesOrderdata = this.props.salesOrderData;
      let customerCode = salesOrderdata.customerCode;
      if (customerCode !== "" && customerCode !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={customerCode}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  // lnkCustomerCurrentAging = (e) => {
  //   this.setState({
  //     isShowCustomerCurrentAgingPopup: true,
  //   });
  //   this.loadCustomerCurrentAging();
  // };
  // lnkCustomerRecentFabrics = (e) => {
  //   this.setState({
  //     isShowCustomerRecentFabricPopup: true,
  //   });
  //   this.loadCustomerRecentFabrics();
  // };
  // loadCustomerRecentFabrics = () => {
  //   let salesOrderData = this.state.salesOrderData;
  //   let criteria = new MostRecentFabricInquiryCriteriaBean();
  //   criteria.companyCode = salesOrderData.companyCode;
  //   criteria.customerCode = salesOrderData.customerCode;
  //   if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
  //     ReportService.inquireMostRecentFabricDetailsForCustomer(
  //       criteria,
  //       this.loadCustomerRecentFabricPageResponse,
  //       this.loadCustomerRecentFabricPageError
  //     );
  //   } else {
  //     let errMsg = "Access Denied";
  //     let errList = [];
  //     errList.push(errMsg);
  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowAlert: true,
  //     });
  //   }
  // };
  // loadCustomerRecentFabricPageResponse = (response) => {
  //   let inquiryDataList = response.data.resultBean;
  //   if (inquiryDataList != null) {
  //     let recentFabricList = response.data.resultBean.fabricInfos;
  //     this.setState({
  //       recentFabricList: recentFabricList,
  //       recentFabricData: inquiryDataList,
  //     });
  //   }
  // };
  // loadCustomerRecentFabricPageError = (error) => {
  //   ShowError("error :" + error);
  // };

  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowARModule: isOpen,
      isShowCreditMemoModule: isOpen,
      moduleForPopup: [],
    });
  };

  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      // isShowCustomerTransactionPopup: isShowPopup,
      // isShowCustomerSalesHistoryPopup: isShowPopup,
      // isShowCustomerCurrentAgingPopup: isShowPopup,
      // isShowCustomerRecentFabricPopup: isShowPopup,
      // isShowCustomerStatisticsPopup: isShowPopup,
      isShowAlert: isShowPopup,
    });
  };
  closeAlertSubModalCallBack = (isShowPopup) => {
    this.setState({
      // isShowInvoiceAmountPopup: isShowPopup,
      // isShowInvoiceAppliedAmountPopup: isShowPopup,
      // isShowInvoiceAppliedCMAmountPopup: isShowPopup,
      // isShowRecentInvoicePopup: isShowPopup,
      isShowAlert: isShowPopup,
      // isShowCreditMemoAppliedAmountPopup: isShowPopup,
    });
  };
  viewInvoiceModule = (code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowInvoiceModule: true,
        moduleForPopup: (
          <PopupInvoiceModule
            invoiceCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewCreditMemoModule = (code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowCreditMemoModule: true,
        moduleForPopup: (
          <PopupCreditMemoModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewARModule = (code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowARModule: true,
        moduleForPopup: (
          <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
        ),
      });
    }
  };
  // viewCreditMemoDetails = (val, rowData) => {
  //   if (val > 0) {
  //     let readrestInput = new RestReadRequest();
  //     readrestInput.companyCode = this.companyCode;
  //     readrestInput.code = rowData.entryEntityNumber;
  //     if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
  //       AccountReceivableService.readAccountReceivablePaymentLinesForCreditMemo(
  //         readrestInput,
  //         this.readAccountReceivableCreditMemoPageResponse,
  //         this.readAccountReceivableCreditMemoPageError
  //       );
  //     } else {
  //       let errMsg = "Access Denied";
  //       let errList = [];
  //       errList.push(errMsg);
  //       this.setState({
  //         alertMessage: errList,
  //         alertType: "danger",
  //         isShowAlert: true,
  //       });
  //     }
  //   }
  // };
  // readAccountReceivableCreditMemoPageResponse = (response) => {
  //   let readARCreditMemoList =
  //     response.data.accountReceivablePaymentDetailPageList
  //       .accountReceivablePaymentDetails;
  //   if (readARCreditMemoList != null && !isEmptyArray(readARCreditMemoList)) {
  //     this.setState({ isShowCreditMemoAppliedAmountPopup: true });
  //     this.setState({ readARCreditMemoList: readARCreditMemoList });
  //   }
  // };
  // readAccountReceivableCreditMemoPageError = (error) => {
  //   ShowError("error :" + error);
  // };
  // generateMemoPdfReport = () => {
  //   this.generateCreditMemoReport(1);
  // };
  // generateMemoExcelReport = () => {
  //   this.generateCreditMemoReport(2);
  // };
  // generateCreditMemoReport = (reportType) => {
  //   let reportBean = new RestReportBean();
  //   reportBean.reportType = reportType;
  //   let creditNumber = "";
  //   this.state.readARCreditMemoList.map((list) => {
  //     creditNumber = list.documentNumber;
  //   });
  //   let listrequest =
  //     new PopupCustomerTransactionCreditMemoDetailsPrintRequest();
  //   listrequest.companyCode = this.companyCode;
  //   listrequest.creditNumber = creditNumber;
  //   listrequest.reportBean = reportBean;
  //   if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
  //     ReportService.generatePopupCustomerTransactionCreditMemoDetailsPrintReport(
  //       listrequest,
  //       this.generateCreditMemoPageResponse,
  //       this.generateCreditMemoPageError
  //     );
  //   } else {
  //     let errMsg = "Access Denied";
  //     let errList = [];
  //     errList.push(errMsg);
  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowAlert: true,
  //     });
  //   }
  // };
  // generateCreditMemoPageResponse = (response) => {
  //   let reportFilePath = response.data.reportResult.reportFileID;
  //   window.open(this.report_url + reportFilePath);
  // };
  // generateCreditMemoPageError = (error) => {
  //   ShowError("Erro : " + error);
  // };
  // viewInvoiceDetails = (val, rowData) => {
  //   if (val > 0) {
  //     this.setState({ isShowInvoiceAmountPopup: true });
  //     let readrestInput = new RestReadRequest();
  //     readrestInput.companyCode = this.companyCode;
  //     readrestInput.code = rowData.entryEntityNumber;
  //     if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
  //       InvoiceService.readInvoice(
  //         readrestInput,
  //         this.readInvoicePageResponse,
  //         this.readInvoicePageError
  //       );
  //     } else {
  //       let errMsg = "Access Denied";
  //       let errList = [];
  //       errList.push(errMsg);
  //       this.setState({
  //         alertMessage: errList,
  //         alertType: "danger",
  //         isShowAlert: true,
  //       });
  //     }
  //   }
  // };
  // readInvoicePageResponse = (response) => {
  //   let readInvoiceData = response.data.invoice;
  //   if (readInvoiceData != null) {
  //     this.setState({ readInvoiceData: readInvoiceData });
  //   }
  // };
  // readInvoicePageError = (error) => {
  //   ShowError("readInvoicePageError :", error);
  // };
  // viewInvoiceAppliedCMAmountDetails = (val, rowData) => {
  //   if (val > 0) {
  //     this.setState({ isShowInvoiceAppliedCMAmountPopup: true });
  //     let readrestInput = new RestReadRequest();
  //     readrestInput.companyCode = this.companyCode;
  //     readrestInput.code = rowData.entryEntityNumber;
  //     if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
  //       AccountReceivableService.readAccountReceivablePaymentLinesForInvoice(
  //         readrestInput,
  //         this.readAccountReceivablePageResponse,
  //         this.readAccountReceivablePageError
  //       );
  //     } else {
  //       let errMsg = "Access Denied";
  //       let errList = [];
  //       errList.push(errMsg);
  //       this.setState({
  //         alertMessage: errList,
  //         alertType: "danger",
  //         isShowAlert: true,
  //       });
  //     }
  //   }
  // };

  // viewInvoiceAppliedAmountDetails = (val, rowData) => {
  //   if (val > 0) {
  //     this.setState({ isShowInvoiceAppliedAmountPopup: true });
  //     let readrestInput = new RestReadRequest();
  //     readrestInput.companyCode = this.companyCode;
  //     readrestInput.code = rowData.entryEntityNumber;
  //     if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
  //       AccountReceivableService.readAccountReceivablePaymentLinesForInvoice(
  //         readrestInput,
  //         this.readAccountReceivablePageResponse,
  //         this.readAccountReceivablePageError
  //       );
  //     } else {
  //       let errMsg = "Access Denied";
  //       let errList = [];
  //       errList.push(errMsg);
  //       this.setState({
  //         alertMessage: errList,
  //         alertType: "danger",
  //         isShowAlert: true,
  //       });
  //     }
  //   }
  // };
  // readAccountReceivablePageResponse = (response) => {
  //   let readARAppliedList =
  //     response.data.accountReceivablePaymentDetailPageList
  //       .accountReceivablePaymentDetails;
  //   if (readARAppliedList != null) {
  //     let readArList = [];
  //     for (let list of readARAppliedList) {
  //       if (list.paymentType == 1) {
  //         list.paymentType = "CHECK";
  //       } else if (list.paymentType == 2) {
  //         list.paymentType = "CREDIT_MEMO";
  //       } else if (list.paymentType == 3) {
  //         list.paymentType = "CREDIT_CARD";
  //       } else if (list.paymentType == 4) {
  //         list.paymentType = "DEBIT_CARD";
  //       } else if (list.paymentType == 5) {
  //         list.paymentType = "CASH";
  //       } else if (list.paymentType == 6) {
  //         list.paymentType = "CHARGE_BACK";
  //       } else if (list.paymentType == 8) {
  //         list.paymentType = "WIRE_TRANSFER";
  //       } else if (list.paymentType == 9) {
  //         list.paymentType = "ACH";
  //       }
  //       readArList.push(list);
  //     }
  //     readARAppliedList = readArList;
  //     this.setState({ readARAppliedList: readARAppliedList });
  //   }
  // };
  // readAccountReceivablePageError = (error) => {
  //   ShowError("readAccountReceivablePageError :", error);
  // };
  // viewRecentInvoiceDetails = (val, rowData) => {
  //   if (val > 0) {
  //     this.setState({
  //       isShowRecentInvoicePopup: true,
  //       recentFabricLineData: rowData,
  //     });
  //     let salesOrderData = this.state.salesOrderData;
  //     let readrestInput = new MostRecentCustomerSalesInvoiceRequest();
  //     readrestInput.companyCode = salesOrderData.companyCode;
  //     readrestInput.customerCode = salesOrderData.customerCode;
  //     readrestInput.fabricStyleCode = rowData.fabricStyleCode;
  //     if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
  //       ReportService.inquireMostRecentCustomerSalesInvoiceInfo(
  //         readrestInput,
  //         this.loadRecentInvoicePageResponse,
  //         this.loadRecentInvoicePageError
  //       );
  //     } else {
  //       let errMsg = "Access Denied";
  //       let errList = [];
  //       errList.push(errMsg);
  //       this.setState({
  //         alertMessage: errList,
  //         alertType: "danger",
  //         isShowAlert: true,
  //       });
  //     }
  //   }
  // };
  // loadRecentInvoicePageResponse = (response) => {
  //   let inquiryList = response.data.salesInvoiceInfos;
  //   if (inquiryList != null) {
  //     this.setState({ recentInvoiceList: inquiryList });
  //   }
  // };
  // loadRecentInvoicePageError = (error) => {
  //   ShowError("readInvoicloadRecentInvoicePageErrorePageError :", error);
  // };
  //Customer Current Aging OpenInvoice Report
  // openInvoiceAgingReport = () => {
  //   let salesOrderData = this.state.salesOrderData;
  //   let reportBean = new RestReportBean();
  //   reportBean.reportType = 1;
  //   let listRequest = new CustomerAgingOpenInvoicesPrintRequest();
  //   listRequest.companyCode = this.companyCode;
  //   listRequest.customerCode = salesOrderData.customerCode;
  //   listRequest.input = reportBean;
  //   if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
  //     ReportService.generateCustomerAgingOpenInvoicesPrintReport(
  //       listRequest,
  //       this.generateOpenInvoiceCustomerAgingPageResponse,
  //       this.generateOpenInvoiceCustomerAgingPageError
  //     );
  //   } else {
  //     let errMsg = "Access Denied";
  //     let errList = [];
  //     errList.push(errMsg);

  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowAlert: true,
  //     });
  //   }
  // };
  // generateOpenInvoiceCustomerAgingPageResponse = (response) => {
  //   let reportFilePath = response.data.reportResult.reportFileID;
  //   window.open(this.report_url + reportFilePath);
  // };
  // generateOpenInvoiceCustomerAgingPageError = (error) => {
  //   ShowError("Erro : " + error);
  // };
  //#endRegion
  //Customer Statistics  Full Popup Details
  // lnkCustomerStatistics = (e) => {
  //   this.setState({
  //     isShowCustomerStatisticsPopup: true,
  //   });
  //   this.loadCustomerStatisticsList();
  // };
  // loadCustomerStatisticsList = () => {
  //   let salesOrderData = this.state.salesOrderData;
  //   let criteria = new CustomerStatisticsInquiryCriteriaBean();
  //   criteria.companyCode = salesOrderData.companyCode;
  //   criteria.customerCode = salesOrderData.customerCode;
  //   if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
  //     ReportService.inquireCustomerStatisticsData(
  //       criteria,
  //       this.loadCustomerStatisticsPageResponse,
  //       this.loadCustomerStatisticsPageError
  //     );
  //   } else {
  //     let errMsg = "Access Denied";
  //     let errList = [];
  //     errList.push(errMsg);

  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowAlert: true,
  //     });
  //   }
  // };
  // loadCustomerStatisticsPageResponse = (response) => {
  //   let inquiryDataList = response.data.result;
  //   if (inquiryDataList != null) {
  //     let inquiryData = response.data.result;
  //     let agingBucketList = [];
  //     let agingHistoryBean = null;
  //     let onOrderInfoDetail = [];
  //     let salesDetail = [];
  //     let returnCreditMemo = [];
  //     if (inquiryDataList.agingBucketGroupBean != null)
  //       agingBucketList = response.data.result.agingBucketGroupBean.buckets;

  //     if (inquiryDataList.agingHistoryBean != null)
  //       agingHistoryBean = response.data.result.agingHistoryBean;

  //     if (inquiryDataList.onOrderInfoDetails != null)
  //       onOrderInfoDetail = response.data.result.onOrderInfoDetails;

  //     if (inquiryDataList.salesDetails != null)
  //       salesDetail = response.data.result.salesDetails;

  //     if (inquiryDataList.returnCreditMemos != null)
  //       returnCreditMemo = response.data.result.returnCreditMemos;

  //     this.setState({
  //       stAgingBucketList: agingBucketList,
  //       stAgingHistoryBean: agingHistoryBean,
  //       onOrderInfoDetail: onOrderInfoDetail,
  //       salesDetail: salesDetail,
  //       returnCreditMemo: returnCreditMemo,
  //       statisticData: inquiryData,
  //     });
  //   } else {
  //     let errMsg = "No data Found";
  //     let errList = this.state.error_list;
  //     errList.push(errMsg);
  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowAlert: true,
  //     });
  //   }
  // };
  // loadCustomerStatisticsPageError = (error) => {
  //   ShowError("Error : " + error);
  // };
  showHideSecondHeader = (e) => {
    if (e.detail == 1) {
      let tempIsCollapsible_open = !this.state.isCollapsible_open;
      this.setState({ isCollapsible_open: tempIsCollapsible_open });
    }
  };

  render() {
    let salesOrderdata = new SalesOrderBean();
    let customerData = this.props.customerData;
    let orderState = this.toSalesOrderState(salesOrderdata);
    let customerList = this.props.customerList;
    let customerShipTos = this.props.customerShipTos;
    let customerSalesDataList = this.state.customerSalesDataList;
    let inquiryData = this.state.inquiryData;
    let readInvoiceData = this.state.readInvoiceData;
    let readARAppliedList = this.state.readARAppliedList;
    let recentFabricList = this.state.recentFabricList;
    let recentFabricData = this.state.recentFabricData;
    let recentFabricLineData = this.state.recentFabricLineData;
    let summaryData = this.props.summaryData;
    let stAgingHistoryBean = this.state.stAgingHistoryBean;
    let statisticData = this.state.statisticData;
    let isDisabledFields = this.props.isDisabledFields;
    if (customerList == null) {
      customerList = [];
    }
    if (customerShipTos == null) {
      customerShipTos = [];
    }
    let isModify = false;
    isModify = this.props.isModifyPosible();
    let disableSalesOrderFormFields = this.props.disableSalesOrderFormFields;
    let disableUpdatableFields = false;
    if (disableSalesOrderFormFields) {
      if (isModify) {
        disableUpdatableFields = false;
      } else {
        disableUpdatableFields = true;
      }
    }
    salesOrderdata = this.props.salesOrderData;

    let lines = [];
    if (salesOrderdata != null) {
      salesOrderdata.lines.map((line) => {
        lines.push(line);
      });
      lines.reverse();
    }
    let salesOrderLinedata = this.props.salesOrderLineData;
    let address = salesOrderdata.address;
    if (address == null) {
      address = new AddressBean();
    }
    let status = "TEST";
    let agingHistoryBean = this.state.agingHistoryBean;
    let agingDataList = this.state.agingDataList;
    let agingData = this.state.agingData;
    let isDisableFieldUnApprove = this.props.isDisableFieldUnApprove;
    var dataTableStyles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "320px",
          maxHeight: "320px",
          overflowY: "auto",
        },
      },
    };
    const textAreaStyle = {
      maxHeight: "8rem",
      width: "100%",
      minHeight: "19rem",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    // const textAreaStyle = {
    //   maxHeight: "10px",
    //   width: "30%",
    //   minHeight: "5em",
    //   resize: "none",
    //   padding: "9px",
    //   boxSizing: "border-box",
    //   fontSize: "15px",
    // };
    let totalOrderQty = 0;
    let totalPickedQty = 0;
    if (!isEmptyArray(salesOrderdata.lines)) {
      totalOrderQty = salesOrderdata.lines.reduce((accumulator, line) => {
        return accumulator + parseFloat(line.orderQuantity) || 0;
      }, 0);
      totalPickedQty = salesOrderdata.lines.reduce((accumulator, line) => {
        return accumulator + parseFloat(line.pickedQuantity) || 0;
      }, 0);
    }
    return (
      <div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerTransactionsInq}
          closeModalCallBack={this.props.closeModalCallBack}
          module={this.props.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerStatisticsInq}
          closeModalCallBack={this.props.closeModalCallBack}
          module={this.props.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerMostRecentFabricsInq}
          closeModalCallBack={this.props.closeModalCallBack}
          module={this.props.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isCustomerCurrentAgingInq}
          closeModalCallBack={this.props.closeModalCallBack}
          module={this.props.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isCustomerSalesAndPurchaseDetailsInq}
          closeModalCallBack={this.props.closeModalCallBack}
          module={this.props.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>

        {/* <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isShowRecentInvoicePopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertSubModalCallBack}
          title={"Customer Recent Invoice Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div className="sales_line_pop">
              <Row>
                <Col sm="1">
                  <FormLabel>CustomerCode</FormLabel>
                </Col>

                <Col sm="2">
                  <InputTextbox
                    value={salesOrderdata.customerCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>FabricCode</FormLabel>
                </Col>

                <Col sm="2">
                  {recentFabricLineData != null && (
                    <InputTextbox
                      value={recentFabricLineData.fabricStyleCode}
                      disabled={true}
                    />
                  )}
                </Col>

                <Col sm="3">
                  {recentFabricLineData != null && (
                    <InputTextbox
                      value={recentFabricLineData.fabricStyleName}
                      disabled={true}
                    />
                  )}
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>Total Sales Qty</FormLabel>
                </Col>
                {recentFabricData != null && (
                  <Col sm="2">
                    <InputTextbox
                      value={recentFabricData.allFabricTotalQuantity}
                      disabled={true}
                    />
                  </Col>
                )}

                <Col sm="1">
                  <FormLabel>Total Sales Amt</FormLabel>
                </Col>
                {recentFabricData != null && (
                  <Col sm="2">
                    <InputTextbox
                      value={recentFabricData.allFabricTotalSoldAmount}
                      disabled={true}
                    />
                  </Col>
                )}
              </Row>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Invoice</th>
                    <th>CustomerPO#</th>

                    <th>Price</th>
                    <th>Shipped Qty</th>
                  </tr>
                </thead>
                {this.state.recentInvoiceList != null && (
                  <tbody>
                    {this.state.recentInvoiceList.map((inquiryInfo, index) => (
                      <tr key={index}>
                        <td>
                          {this.getFormattedDate(inquiryInfo.invoiceDate)}
                        </td>
                        <td>
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={() =>
                              this.viewInvoiceModule(inquiryInfo.invoiceNumber)
                            }
                          >
                            {inquiryInfo.invoiceNumber}
                          </Button>
                        </td>
                        <td>{inquiryInfo.customerPurchaseOrderNumber}</td>
                        <td>{inquiryInfo.price}</td>
                        <td>{inquiryInfo.shippedQuantity}</td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </Table>
            </div>
          }
        /> */}
        {/* <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isShowInvoiceAmountPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertSubModalCallBack}
          title={"Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="sales_line_pop">
              {this.state.readInvoiceData != null && (
                <div>
                  <Row>
                    <FormLabel> Amount Details</FormLabel>
                  </Row>
                  <Row>
                    <Col sm="1">
                      {" "}
                      <FormLabel>SubTotal</FormLabel>
                    </Col>
                    <Col className="summary_text_box" sm="2">
                      <InputTextbox
                        value={readInvoiceData.subTotalAmount}
                        className="summary_input text-right"
                        disabled={true}
                      />
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        //value={cbData.openingBalance}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>TaxAmount</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        value={readInvoiceData.totalTaxAmount}
                        disabled={true}
                      />{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        //value={cbData.closingBalance}
                        disabled={true}
                      />{" "}
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="1">
                      <FormLabel>DiscountAmount</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        value={readInvoiceData.discountAmount}
                        disabled={true}
                      />{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        //value={cbData.closingBalance}
                        disabled={true}
                      />{" "}
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="1">
                      <FormLabel>ExtraCharges</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        value={readInvoiceData.extraChargesAmount}
                        disabled={true}
                      />{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        //value={cbData.closingBalance}
                        disabled={true}
                      />{" "}
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="1">
                      <FormLabel>GrandTotal</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        value={readInvoiceData.grandTotalAmount}
                        disabled={true}
                      />{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        //value={cbData.closingBalance}
                        disabled={true}
                      />{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>TotalPaid</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        value={readInvoiceData.paidAmount}
                        disabled={true}
                      />{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        //value={cbData.closingBalance}
                        disabled={true}
                      />{" "}
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="1">
                      <FormLabel>TotalDue</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        className="summary_input text-right"
                        value={readInvoiceData.totalDueAmount}
                        disabled={true}
                      />{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        //value={cbData.closingBalance}
                        disabled={true}
                      />{" "}
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          }
        /> */}
        {/* <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isShowInvoiceAppliedAmountPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertSubModalCallBack}
          title={"Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="sales_line_pop">
              <Row>
                <FormLabel> Details </FormLabel>
              </Row>
              <Table>
                <thead>
                  <tr>
                    <th>AR#</th>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Document#</th>
                    <th>AppliedAmount</th>
                    <th>Currency</th>
                    <th>Status</th>
                  </tr>
                </thead>
                {this.state.readARAppliedList != null && (
                  <tbody>
                    {this.state.readARAppliedList
                      .filter(
                        (li) =>
                          li.paymentType != "CREDIT_MEMO" &&
                          li.paymentType != "CHARGE_BACK"
                      )
                      .map((list, index) => (
                        <tr key={index}>
                          <td>
                            <Button
                              size="sm"
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={() =>
                                this.viewARModule(list.accountReceivableNumber)
                              }
                            >
                              {list.accountReceivableNumber}
                            </Button>
                          </td>
                          <td>{this.getFormattedDate(list.paymentPostDate)}</td>
                          <td>{list.paymentType}</td>
                          <td>{list.documentNumber}</td>
                          <td>{list.paymentAmount}</td>
                          <td>{list.currencyCode}</td>
                          <td>{list.status}</td>
                        </tr>
                      ))}
                  </tbody>
                )}
              </Table>
            </div>
          }
        /> */}
        {/* <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isShowCreditMemoAppliedAmountPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertSubModalCallBack}
          title={"Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={() => this.generateMemoPdfReport()}
              >
                PDF
              </Button>

              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={() => this.generateMemoExcelReport()}
              >
                EXCEL
              </Button>
            </div>
          }
          content={
            <div className="sales_line_pop">
              <Row>
                <FormLabel> Details </FormLabel>
              </Row>
              <Table>
                <thead>
                  <tr>
                    <th>Invoice#</th>
                    <th>AR#</th>
                    <th>PaidAmount</th>
                    <th>Currency</th>
                  </tr>
                </thead>
                {this.state.readARCreditMemoList != null && (
                  <tbody>
                    {this.state.readARCreditMemoList.map((list, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={() =>
                              this.viewInvoiceModule(list.invoiceNumber)
                            }
                          >
                            {list.invoiceNumber}
                          </Button>
                        </td>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={() =>
                              this.viewARModule(list.accountReceivableNumber)
                            }
                          >
                            {list.accountReceivableNumber}
                          </Button>
                        </td>
                        <td>{list.paymentAmount}</td>
                        <td>{list.currencyCode}</td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </Table>
            </div>
          }
        /> */}
        {/* <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isShowInvoiceAppliedCMAmountPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="sales_line_pop">
              <Row>
                <FormLabel> Details </FormLabel>
              </Row>
              <Table>
                <thead>
                  <tr>
                    <th>AR#</th>
                    <th>Date</th>
                    <th>Type</th>
                    <th>CreditMemo#</th>
                    <th>AppliedAmount</th>
                    <th>Currency</th>
                    <th>Status</th>
                  </tr>
                </thead>
                {this.state.readARAppliedList != null && (
                  <tbody>
                    {this.state.readARAppliedList
                      .filter((li) => li.paymentType == "CREDIT_MEMO")
                      .map((list, index) => (
                        <tr key={index}>
                          <td>
                            <Button
                              size="sm"
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={() =>
                                this.viewARModule(list.accountReceivableNumber)
                              }
                            >
                              {list.accountReceivableNumber}
                            </Button>
                          </td>
                          <td>{this.getFormattedDate(list.paymentPostDate)}</td>
                          <td>{list.paymentType}</td>
                          <td>{list.documentNumber}</td>
                          <td>{list.paymentAmount}</td>
                          <td>{list.currencyCode}</td>
                          <td>{list.status}</td>
                        </tr>
                      ))}
                  </tbody>
                )}
              </Table>
            </div>
          }
        /> */}
        <div className="header_div" tabIndex="0" onKeyDown={this.onKeyPress}>
          <div className="fabric_sku_ven_module_table">
            <Row>
              <Col className="so-align-items-left" sm="1">
                <FormLabel>OrderType </FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onOrderTypeChange}
                  ref={this.orderTypeRef}
                  // readOnly={disableSalesOrderFormFields}
                  // disabled={disableSalesOrderFormFields}
                  disabled={disableSalesOrderFormFields}
                  name="orderTypeCode"
                  placeholder="OrderTypeCode"
                  value={salesOrderdata.orderTypeCode}
                  // valueChangeOnBlur={true}
                  lookupRequired={true}
                  lookupHandler={this.state.orderTypeLookupHandler}
                  enterKeyEventHandler={this.orderTypeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.orderTypePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteOrderTypeList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompleteOrderTypeList
                  }
                  isMandatory={true}
                ></InputTextbox>
              </Col>
              <Col className="so-align-items-left" sm="1">
                <FormLabel>Date</FormLabel>
              </Col>
              <Col sm="2">
                <DatePickerComponent_adv
                  name="orderDate"
                  value={salesOrderdata.orderDate}
                  onChange={this.onChange}
                  disabled={disableSalesOrderFormFields}
                  isMandatory={true}
                //isModifyView={isModify}
                />
              </Col>
              <Col className="so-align-items-left" sm="1">
                <FormLabel>StartDate</FormLabel>
              </Col>
              <Col sm="2">
                <DatePickerComponent_adv
                  name="orderStartDate"
                  value={salesOrderdata.orderStartDate}
                  onChange={this.onChange}
                  disabled={isDisabledFields}
                  isModifyView={isModify}
                  isMandatory={true}
                />
              </Col>
              <Col className="so-align-items-left">
                {this.props.isTexco ? (
                  <FormLabel>CancelDate</FormLabel>
                ) : (
                  <FormLabel>StopDate</FormLabel>
                )}
              </Col>
              <Col sm="2">
                {this.props.isTexco ? (
                  <DatePickerComponent_adv
                    name="orderStopDate"
                    value={salesOrderdata.orderStopDate}
                    onChange={this.onChange}
                    // disabled={true}
                    isModifyView={isModify}
                    isMandatory={true}
                  />
                ) : (
                  <DatePickerComponent_adv
                    name="orderStopDate"
                    value={salesOrderdata.orderStopDate}
                    onChange={this.onChange}
                    disabled={true}
                    isModifyView={isModify}
                    isMandatory={true}
                  />
                )}
              </Col>
              <div>
                <Col md={0.9} className="custom_collapsible_container">
                  <CollapseComponent
                    isOpen={this.state.isCollapsible_open}
                    onClick={(e) => this.showHideSecondHeader(e)}
                  />
                </Col>{" "}
              </div>
            </Row>
            <div
              className="header_secondary_div"
              style={this.state.isCollapsible_open ? {} : { display: "none" }}
            >
              <Row>
                <Col className="so-align-items-left" sm="1">
                  <FormLabel
                    className="hyperlinklabel"
                    onClick={(e) => this.lnkCustomerModule(e)}
                  >
                    Customer
                  </FormLabel>{" "}
                  <Col>
                    <ShortCutMenuPopup
                      value={salesOrderdata.customerCode}
                      menuItems={
                        <ul>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) => this.lnkCustomerModule(e)}
                          >
                            {" "}
                            Customer Info{" "}
                          </li>

                          <li
                            className="shortcut-menu-item"
                            // onClick={this.lnkCustomerTransaction}
                            onClick={(e) =>
                              this.props.openCustomerTransactionsInq(
                                e,
                                salesOrderdata.customerCode,
                              )
                            }
                          >
                            {" "}
                            CustomerTransaction{" "}
                          </li>

                          <li
                            className="shortcut-menu-item"
                            // onClick={this.lnkCustomerSalesHistory}
                            onClick={(e) =>
                              this.props.openCustomerSalesHistoryInq(
                                e,
                                salesOrderdata.customerCode,
                              )
                            }
                          >
                            {" "}
                            CustomerSalesHistory{" "}
                          </li>

                          <li
                            className="shortcut-menu-item"
                            // onClick={this.lnkCustomerRecentFabrics}
                            onClick={(e) =>
                              this.props.openCustomerMostRecentFabricsInq(
                                e,
                                salesOrderdata.customerCode,
                              )
                            }
                          >
                            {" "}
                            CustomerRecentItems{" "}
                          </li>

                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.props.openCustomerStatisticsInq(
                                e,
                                salesOrderdata.customerCode,
                              )
                            }
                          >
                            {" "}
                            CustomerStatistics{" "}
                          </li>

                          <li
                            className="shortcut-menu-item"
                            // onClick={this.lnkCustomerCurrentAging}
                            onClick={(e) =>
                              this.props.openCustomerCurrentAgingInq(
                                e,
                                salesOrderdata.customerCode,
                              )
                            }
                          >
                            {" "}
                            CustomerCurrentAging{" "}
                          </li>

                          <li
                            className="shortcut-menu-item"
                            // onClick={this.lnkCustomerCurrentAging}
                            onClick={(e) =>
                              this.props.openCustomerSalesDetailsInq(
                                e,
                                salesOrderdata.customerCode,
                              )
                            }
                          >
                            {" "}
                            CustomerSalesDetails{" "}
                          </li>
                        </ul>
                      }
                    />
                  </Col>
                </Col>

                <Col sm="2">
                  <InputTextbox
                    onChange={this.onCustomerCodeChange}
                    ref={this.customerCodeRef}
                    // readOnly={disableSalesOrderFormFields}
                    disabled={isDisableFieldUnApprove}
                    name="customerCode"
                    placeholder="Customer"
                    value={salesOrderdata.customerCode}
                    lookupRequired={true}
                    lookupHandler={this.state.customerLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.customerPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteCustomerList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteCustomerList
                    }
                    isMandatory={true}
                    isNotFound={this.props.isCustomerNotFound}
                  />
                </Col>

                <Col sm="3">
                  <InputTextbox
                    name="customerName"
                    type="text"
                    onChange={this.onChange}
                    readOnly={true}
                    value={salesOrderdata.customerName}
                    isMandatory={true}
                  />{" "}
                </Col>

                <Col className="so-align-items-left" sm="1">
                  <FormLabel>CustType </FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="customerType"
                    placeholder="CustomerType"
                    onChange={this.onChange}
                    readOnly={disableSalesOrderFormFields}
                    value={salesOrderdata.customerType}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>

                <Col className="so-align-items-left" sm="1">
                  <FormLabel>ShipTo </FormLabel>{" "}
                </Col>

                <Col sm="2">
                  <InputTextbox
                    onChange={this.onShipToChange}
                    ref={this.customerShipToCodeRef}
                    readOnly={disableSalesOrderFormFields}
                    disabled={
                      this.props.isTexco
                        ? isDisabledFields
                        : disableSalesOrderFormFields
                    }
                    //disabled={disableSalesOrderFormFields}
                    name="shipToCode"
                    placeholder="ShipTo"
                    value={salesOrderdata.shipToCode}
                    lookupRequired={this.props.isShowShipToLookup}
                    lookupHandler={this.props.shipToLookupHandler}
                    enterKeyEventHandler={this.shipToEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.shipToPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayAutoCompleteShipToList}
                    showAutoCompleteList={this.props.showAutoCompleteShipToList}
                    isMandatory={true}
                  ></InputTextbox>
                </Col>
              </Row>

              <Row>
                <Col className="so-align-items-left" sm="1">
                  <FormLabel>PO#</FormLabel>
                </Col>

                <Col sm="2">
                  <InputTextbox
                    ref={this.poRef}
                    name="customerPurchaseOrderNumber"
                    placeholder="CustomerPurchaseOrderNumber"
                    onChange={this.onChange}
                    readOnly={disableUpdatableFields}
                    value={salesOrderdata.customerPurchaseOrderNumber}
                    isModifyView={isModify}
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />
                </Col>

                <Col className="so-align-items-left" sm="1">
                  <FormLabel>PaymentTerm </FormLabel>{" "}
                </Col>

                <Col sm="2">
                  <InputTextbox
                    onChange={this.onPaymentTermChange}
                    ref={this.paymentTermCodeRef}
                    readOnly={disableSalesOrderFormFields}
                    disabled={
                      this.props.isTexco
                        ? isDisabledFields
                        : disableSalesOrderFormFields
                    }
                    name="paymentTermCode"
                    placeholder="PaymentTerm"
                    value={salesOrderdata.paymentTermCode}
                    lookupRequired={true}
                    lookupHandler={this.state.paymentTermLookupHandler}
                    enterKeyEventHandler={this.paymentTermEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.paymentTermPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompletePaymentTermList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompletePaymentTermList
                    }
                    isMandatory={true}
                  ></InputTextbox>
                </Col>

                <Col className="so-align-items-left" sm="1">
                  <FormLabel>ShipVia </FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.onShipViaChange}
                    ref={this.shipViaCodeRef}
                    readOnly={disableUpdatableFields}
                    //disabled={disableSalesOrderFormFields}
                    name="shipViaCode"
                    placeholder="ShipVia"
                    value={salesOrderdata.shipViaCode}
                    lookupRequired={true}
                    lookupHandler={this.state.shipViaLookupHandler}
                    enterKeyEventHandler={this.shipViaEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.shipViaPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteShipViaList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteShipViaList
                    }
                    disabled={isDisabledFields}
                  ></InputTextbox>
                </Col>
                {this.props.isTexco && (
                  <Col sm="1">
                    <FormLabel
                      className="hyperlinklabel"
                      onClick={(e) => this.props.commisionClickHandler(e)}
                    >
                      SalesCommission{" "}
                    </FormLabel>{" "}
                  </Col>
                )}
                {this.props.isTexco && (
                  <Col sm="2">
                    <InputTextbox
                      name="salesCommisionDeatils"
                      // placeholder="OrderBy"
                      // onChange={this.onChange}
                      readOnly={true}
                      value={this.props.salesCommisionDeatils}
                      disabled={true}
                    />{" "}
                  </Col>
                )}
                {!this.props.isTexco && (
                  <Col className="so-align-items-left" sm="1">
                    <FormLabel>
                      {" "}
                      {this.props.is3PL ? "ServiceType" : "DeliveryType"}{" "}
                    </FormLabel>{" "}
                  </Col>
                )}
                {!this.props.isTexco && (
                  <Col sm="2">
                    {/* <InputTextbox
                    name="customerDeliveryTypeCode"
                    placeholder="DeliveryType"
                    onChange={this.onChange}
                    readOnly={disableSalesOrderFormFields}
                    value={salesOrderdata.customerDeliveryTypeCode}
                    disabled={isDisabledFields}
                    onBlur={this.onBlur}
                  />{" "} */}
                    <InputTextbox
                      onChange={this.props.onDeliveryTypeChange}
                      name="customerDeliveryTypeCode"
                      placeholder={
                        this.props.is3PL
                          ? "Service Type"
                          : "customerDeliveryTypeCode"
                      }
                      value={salesOrderdata.customerDeliveryTypeCode}
                      lookupRequired={true}
                      lookupHandler={this.state.deliveryTypeLookupHandler}
                      enterKeyEventHandler={
                        this.props.deliveryTypeEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.props.deliveryTypePageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.props.displayAutoCompleteDeliveryTypeList
                      }
                      showAutoCompleteList={
                        this.props.isShowAutoCompleteDeliveryTypeList
                      }
                      disabled={isDisabledFields}
                      isMandatory={true}
                    ></InputTextbox>
                  </Col>
                )}
              </Row>

              <Row>
                <Col className="so-align-items-left" sm="1">
                  <FormLabel>CSR </FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    // onChange={this.onCSRChange}
                    onChange={this.onChange}
                    ref={this.customerRepCodeRef}
                    readOnly={disableSalesOrderFormFields}
                    disabled={disableSalesOrderFormFields}
                    name="salesRepresentativeCode"
                    placeholder="CSR"
                    value={salesOrderdata.salesRepresentativeCode}
                    lookupRequired={false}
                  // lookupHandler={this.state.customerRepLookupHandler}
                  // enterKeyEventHandler={this.cSREnterKeyEventHandler}
                  // autoCompleteListData={
                  //   this.props.cSRPageListForAutoCompleteList
                  // }
                  // enableAutoCompleteTextBox={true}
                  // displayAutoCompleteList={this.displayAutoCompleteCsrList}
                  // showAutoCompleteList={this.props.showAutoCompleteCSRList}
                  ></InputTextbox>
                </Col>
                <Col className="so-align-items-left" sm="1">
                  <FormLabel>OrderBy </FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="orderRequestedBy"
                    placeholder="OrderBy"
                    onChange={this.onChange}
                    readOnly={disableSalesOrderFormFields}
                    value={salesOrderdata.orderRequestedBy}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>
                <Col className="so-align-items-left" sm="1">
                  <FormLabel>SalesClerk</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.onSalesClerkChange}
                    ref={this.salesClerkCodeRef}
                    readOnly={disableSalesOrderFormFields}
                    disabled={disableSalesOrderFormFields}
                    //disabled={disableSalesOrderFormFields}
                    name="salesClerkCode"
                    placeholder="SalesClerk"
                    value={salesOrderdata.salesClerkCode}
                    lookupRequired={true}
                    lookupHandler={this.state.salesClerkLookupHandler}
                    enterKeyEventHandler={this.salesClerkEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.salesClerkPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteSalesClerkList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteSalesClerkList
                    }
                  ></InputTextbox>
                </Col>

                <Col className="so-align-items-left" sm="1">
                  <FormLabel>Factor#</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="factorCode"
                    placeholder="FactorCode"
                    onChange={this.onChange}
                    readOnly={disableSalesOrderFormFields}
                    value={salesOrderdata.factorCode}
                    isModifyView={isModify}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col className="so-align-items-left" sm="1">
                  <FormLabel>FactorApp#</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="factorApprovalNumber"
                    placeholder="FactorApproval#"
                    onChange={this.onChange}
                    readOnly={disableSalesOrderFormFields}
                    value={salesOrderdata.factorApprovalNumber}
                    isModifyView={isModify}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>
                <Col sm="1" className="so-align-items-left">
                  <FormLabel>OrderState</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="orderState"
                    onChange={this.onChange}
                    readOnly={true}
                    value={orderState}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>

                {/* <Col  className="so-align-items-left">
                  <FormLabel>SalesTax</FormLabel>
                </Col>
                <Col >
                  <InputCheckbox
                    label={"SalesTax"}
                    name="taxRequiredFlag"
                    type="checkbox"
                    checked={salesOrderdata.taxRequiredFlag}
                    onChange={this.onChange}
                    disabled={true}
                   />
                </Col>*/}
                <Col sm="1">
                  <div>
                    <FormLabel>SalesTax</FormLabel>
                  </div>
                </Col>
                <Col sm="1">
                  <div>
                    <InputCheckbox
                      name="taxRequiredFlag"
                      type="checkbox"
                      checked={salesOrderdata.taxRequiredFlag}
                      onChange={this.onChange}
                      disabled={isDisabledFields}
                    />
                  </div>
                </Col>
                <Col sm="1">
                  <div>
                    <FormLabel>BackOrder</FormLabel>
                  </div>
                </Col>
                <Col sm="1">
                  <div>
                    <InputCheckbox
                      name="isBackOrderFlag"
                      type="checkbox"
                      checked={salesOrderdata.isBackOrderFlag}
                      onChange={this.onChange}
                      disabled={isDisabledFields}
                    />
                  </div>
                </Col>
                <Col sm="1">
                  <div>
                    <FormLabel>ForcePay</FormLabel>
                  </div>
                </Col>
                <Col sm="1">
                  <div>
                    <InputCheckbox
                      name="isPaidForceFlag"
                      type="checkbox"
                      checked={salesOrderdata.isPaidForceFlag}
                      onChange={this.onChange}
                      disabled={isDisabledFields}
                    />
                  </div>
                </Col>

                {/* <Col className="so-align-items-left" sm="2">
                  <div className="so_label_with_checkbox_div">
                    <FormLabel>BackOrder</FormLabel>
                    <div className="col-sm-2">
                      <InputCheckbox
                        label={"BackOrder"}
                        name="isBackOrderFlag"
                        type="checkbox"
                        checked={salesOrderdata.isBackOrderFlag}
                        onChange={this.onChange}
                        //disabled={disableSalesOrderFormFields}
                        disabled={isDisabledFields}
                      />
                    </div>
                  </div>
                </Col> */}
                {/* <Col className="so-align-items-left" sm="2">
                  <div className="so_label_with_checkbox_div">
                    <FormLabel>ForcePay</FormLabel>
                    <div className="col-sm-2">
                      <InputCheckbox
                        label={"ForcePay"}
                        name="isPaidForceFlag"
                        type="checkbox"
                        checked={salesOrderdata.isPaidForceFlag}
                        onChange={this.onChange}
                        disabled={isDisabledFields}
                      />
                    </div>
                  </div>
                </Col> */}
              </Row>
              <Row>
                {this.props.is3PL ? (
                  <>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>Expected Shipment Date</FormLabel>
                    </Col>
                    <Col sm="2">
                      <DatePickerComponent_adv
                        name="expectedShipmentDate"
                        value={salesOrderdata.expectedShipmentDate}
                        onChange={this.onChange}
                        disabled={isDisabledFields}
                      />
                    </Col>
                    <Col className="align-fabricStyles-left" sm="1">
                      <FormLabel>Expected Shipment Time</FormLabel>
                    </Col>
                    <Col sm="2">
                      <TimePickerComponent
                        onChange={this.onChange}
                        name="expectedShipmentTime"
                        value={salesOrderdata.expectedShipmentTime}
                        disabled={isDisabledFields}
                      />
                      {/* <InputTextbox
              onChange={this.props.onChange}
              name="expectedShipmentTime"
              value={logisticReceiptData.expectedShipmentTime}
              disabled={this.props.isDisabledFields}
            ></InputTextbox> */}
                    </Col>
                  </>
                ) : null}
                <Col sm="1">
                  <FormLabel
                    className="hyperlinklabel"
                    onClick={(e) => this.props.addressClickHandler(e)}
                  >
                    Address
                  </FormLabel>
                </Col>
              </Row>
              <Row>
                {/* <Col>
                  <AddressComponent
                    label={"Address"}
                    addressData={salesOrderdata.address}
                    onChange={this.onChange}
                  />
                </Col> */}
              </Row>
            </div>
          </div>
        </div>
        <div
        // className="header_div"
        >
          {/* <div className="sales-addline-wrp"> */}
          {/* <div className="sales-addline-label">SalesOrder Lines</div>
            <div className="sales-addline-icon">
              {this.props.isShowAddIcon && (
                <Button
                  size="sm"
                  onClick={(e) => this.addNewSalesOrderLine(e)}
                  disabled={disableUpdatableFields}
                  variant="primary"
                  className="header_buttons enterFocus"
                >
                  <AddIcon />
                </Button>
              )}
            </div> */}
          {/* </div> */}
          {/* <div className=""> */}
          {/* <EditableDataGrid
              // customStyles={dataTableStyles}
              columnsList={this.columnDefinitions()}
              dataList={lines}
            /> */}
          <div className="div_Custom_11">
            <CustomTable
              columns={this.soLineColumns()}
              data={lines}
              label={"SalesOrder Lines"}
              isResizable={true}
            />
          </div>
        </div>
        {/* </div>{" "} */}
        {/* <div className="header_div">
          <div>
            <div className="sales_addline_align1">         
              {this.props.isShowAddIcon && (
                <Button
                  size="sm"
                  onClick={() => this.addNewSalesOrderLine()}
                  disabled={disableUpdatableFields}
                  variant="primary"
                  className="header_buttons enterFocus"
                >
                  <AddIcon />
                </Button>
              )}
            </div>
            <div className="sales_addline_align2" sm="11">
              <EditableDataGrid
                // customStyles={dataTableStyles}
                columnsList={this.columnDefinitions()}
                dataList={lines}
              />
            </div>
          </div>{" "}
        </div> */}
        {/* <div className="total_amounts_div col-md-12 col-lg-5"> */}
        <div>
          {/* <div className="header_div"> */}
          {/* <Row>
            <Col sm="10">
              <FormLabel>Notes</FormLabel>
            </Col>
            
            <Col sm="2">
              <FormLabel>Totals</FormLabel>
            </Col>
          </Row> */}
          {/* <Row> */}
          <div className="div_inline">
            <div className="div_70_no_overflow">
              {" "}
              <Row>
                <Col sm="2">
                  <FormLabel className="label_head">Notes</FormLabel>
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left">
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    name="comments"
                    type="text"
                    placeholder="Notes"
                    onChange={this.onChange}
                    value={salesOrderdata.comments}
                    disabled={isDisabledFields}
                  />
                </Col>
              </Row>
            </div>
            {/* <Col sm="3"> */}
            <div className="div_30_no_overflow">
              <Row>
                <Col sm="2">
                  <FormLabel className="label_head">Totals</FormLabel>
                </Col>
              </Row>
              <div className="header_div">
                <Row>
                  <Col sm="3" className="so-align-items-left">
                    <FormLabel>TotalOrderQty </FormLabel>{" "}
                  </Col>

                  <Col sm="9" className="so-align-items-left">
                    <NumberFormatInputbox
                      value={totalOrderQty}
                      // onChange={this.onChange}
                      className="summary_input text-right"
                      decimalScale={2}
                      name={"totalOrderQty"}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="3" className="so-align-items-left">
                    <FormLabel>TotalPickedQty </FormLabel>{" "}
                  </Col>

                  <Col sm="9" className="so-align-items-left">
                    <NumberFormatInputbox
                      value={totalPickedQty}
                      onChange={this.onChange}
                      className="summary_input text-right"
                      decimalScale={2}
                      name={"totalPickedQty"}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="3" className="so-align-items-left">
                    <FormLabel>SubTotal </FormLabel>{" "}
                  </Col>

                  <Col sm="9" className="so-align-items-left">
                    <NumberFormatInputbox
                      value={salesOrderdata.subTotalAmount}
                      onChange={this.onChange}
                      className="summary_input text-right"
                      decimalScale={2}
                      name={"subTotalAmount"}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="3" className="so-align-items-left">
                    <FormLabel>Tax% </FormLabel>{" "}
                  </Col>
                  <Col sm="9" className="so-align-items-left">
                    <NumberFormatInputbox
                      value={salesOrderdata.taxPercentage}
                      className="summary_input text-right"
                      decimalScale={2}
                      name={"taxPercentage"}
                      disabled={true}
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="3" className="so-align-items-left">
                    <FormLabel>TaxAmt </FormLabel>{" "}
                  </Col>

                  <Col sm="9" className="so-align-items-left">
                    <NumberFormatInputbox
                      value={salesOrderdata.totalTaxAmount}
                      className="summary_input text-right"
                      decimalScale={2}
                      name={"totalTaxAmount"}
                      disabled={true}
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="so-align-items-left" sm="3">
                    <FormLabel>DiscAmt</FormLabel>{" "}
                  </Col>

                  <Col sm="9" className="so-align-items-left">
                    <NumberFormatInputbox
                      name={"discountAmount"}
                      onChange={this.onHeaderAmountsChange}
                      value={salesOrderdata.discountAmount}
                      className="summary_input text-right"
                      decimalScale={2}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="so-align-items-left" sm="3">
                    <FormLabel>ExtChrg</FormLabel>{" "}
                  </Col>

                  <Col sm="9" className="so-align-items-left">
                    <NumberFormatInputbox
                      name={"extraChargesAmount"}
                      onChange={this.onHeaderAmountsChange}
                      value={salesOrderdata.extraChargesAmount}
                      className="summary_input text-right"
                      decimalScale={2}
                      disabled={disableSalesOrderFormFields}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="so-align-items-left" sm="3">
                    <FormLabel>ShipChrg </FormLabel>{" "}
                  </Col>

                  <Col sm="9" className="so-align-items-left">
                    <NumberFormatInputbox
                      value={salesOrderdata.shipmentChargesAmount}
                      onChange={this.onHeaderAmountsChange}
                      className="summary_input text-right"
                      decimalScale={2}
                      name={"shipmentChargesAmount"}
                      isCustomHandledKeyDown={true}
                      customeOnKeyDown={this.onShipmentChargesAmountKeydown}
                      disabled={disableSalesOrderFormFields}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="3" className="so-align-items-left">
                    <FormLabel>TotalAmt</FormLabel>
                  </Col>

                  <Col sm="9" className="so-align-items-left">
                    <NumberFormatInputbox
                      value={salesOrderdata.grandTotalAmount}
                      onChange={this.onChange}
                      className="summary_input text-right"
                      decimalScale={2}
                      name={"grandTotalAmount"}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="3" className="so-align-items-left">
                    <FormLabel>Tariff</FormLabel>
                  </Col>

                  <Col sm="9" className="so-align-items-left">
                    <NumberFormatInputbox
                      value={salesOrderdata.totalTariffAmount}
                      onChange={this.onChange}
                      className="summary_input text-right"
                      decimalScale={2}
                      name={"totalTariffAmount"}
                      disabled={true}
                    />
                  </Col>
                </Row>
              </div>
            </div>
            {/* </Col> */}
            {/* </Row> */}
          </div>
          {/* </div> */}
        </div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCreditMemoModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
      </div>
    );
  }
}

class ShipToandAddressEntryForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.shipToCodeRef = React.createRef();
    this.cityRef = React.createRef();
    this.stateRef = React.createRef();
    this.countryRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
  }

  componentDidUpdate() { }

  initLookupHandlers = () => {
    let shipToLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipTos,
      "Ship To",
    );
    this.setState({ shipToLookupHandler: shipToLookupHandler });
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.props.cityList,
      "City",
    );
    this.setState({ cityLookupHandler: cityLookupHandler });
    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.props.stateList,
      "State",
    );
    this.setState({ stateLookupHandler: stateLookupHandler });
    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.props.countryList,
      "Country",
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
  };

  onChange = (e) => {
    this.props.onChange(e);
  };
  onAddressChange = (e) => {
    this.props.onAddressChange(e);
  };

  onNodeShipToChange = (e) => {
    this.props.onNodeShipToChange(e);
  };
  shipToNodeEnterKeyEventHandler = (e) => {
    this.props.shipToNodeEnterKeyEventHandler(e);
  };
  displayAutoCompleteShipToNodeList = (showAutoCompleteShipToNodeList) => {
    this.props.displayAutoCompleteShipToNodeList(
      showAutoCompleteShipToNodeList,
    );
  };

  onCityChange = (e) => {
    this.props.onCityChange(e);
  };
  cityEnterKeyEvent = (e) => {
    this.props.cityEnterKeyEvent(e);
  };
  displayAutoCompleteCityList = (e) => {
    this.props.displayAutoCompleteCityList(e);
  };
  onStateChange = (e) => {
    this.props.onStateChange(e);
  };
  stateEnterKeyEvent = (e) => {
    this.props.stateEnterKeyEvent(e);
  };
  displayAutoCompleteStateList = (e) => {
    this.props.displayAutoCompleteStateList(e);
  };
  onCountryChange = (e) => {
    this.props.onCountryChange(e);
  };
  countryEnterKeyEvent = (e) => {
    this.props.countryEnterKeyEvent(e);
  };
  displayAutoCompleteCountryList = (e) => {
    this.props.displayAutoCompleteCountryList(e);
  };

  render() {
    let salesOrderData = new SalesOrderBean();
    salesOrderData = this.props.salesOrderData;
    let soAddressData = new AddressBean();
    if (!isEmpty(salesOrderData) && !isEmpty(salesOrderData.address))
      soAddressData = salesOrderData.address;
    let disableSalesOrderFormFields = this.props.isDisableFields;
    let isDisabledFields = this.props.isDisabledFields;

    let isModify = false;
    isModify = this.props.isModifyPosible();
    let disableUpdatableFields = false;
    if (disableSalesOrderFormFields) {
      if (isModify) {
        disableUpdatableFields = false;
      } else {
        disableUpdatableFields = true;
      }
    }
    return (
      <div className="header_div">
        <div>
          <Row>
            <Col sm="1">
              <FormLabel>ShipTo</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.shipToCodeRef}
                readOnly={disableUpdatableFields}
                disabled={isDisabledFields}
                name="shipToCode"
                placeholder="ShipTo"
                onChange={this.onNodeShipToChange}
                value={salesOrderData.shipToCode}
                lookupRequired={true}
                lookupHandler={this.state.shipToLookupHandler}
                enterKeyEventHandler={this.shipToNodeEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.shipToNodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteShipToNodeList}
                showAutoCompleteList={this.props.showAutoCompleteShipToNodeList}
                isModifyView={isModify}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>ShipToName</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="shipToName"
                placeholder="ShipToName"
                onChange={this.onChange}
                readOnly={disableUpdatableFields}
                value={salesOrderData.shipToName}
                isModifyView={isModify}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>ContactPerson</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="contactPerson"
                placeholder="ContactPerson"
                onChange={this.onAddressChange}
                readOnly={disableUpdatableFields}
                value={soAddressData.contactPerson}
                isModifyView={isModify}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Address1</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address1"
                placeholder="Address1"
                onChange={this.onAddressChange}
                readOnly={disableUpdatableFields}
                value={soAddressData.address1}
                isModifyView={isModify}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Address2</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address2"
                placeholder="Address2"
                onChange={this.onAddressChange}
                readOnly={disableUpdatableFields}
                value={soAddressData.address2}
                isModifyView={isModify}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>City</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCityChange}
                ref={this.cityRef}
                readOnly={disableUpdatableFields}
                disabled={isDisabledFields}
                name="city"
                placeholder="City"
                value={soAddressData.city}
                lookupRequired={true}
                lookupHandler={this.state.cityLookupHandler}
                enterKeyEventHandler={this.cityEnterKeyEvent}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
                isModifyView={isModify}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>State</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onStateChange}
                ref={this.stateRef}
                readOnly={disableUpdatableFields}
                disabled={isDisabledFields}
                name="state"
                placeholder="State"
                value={soAddressData.state}
                lookupRequired={true}
                lookupHandler={this.state.stateLookupHandler}
                enterKeyEventHandler={this.stateEnterKeyEvent}
                autoCompleteListData={
                  this.props.statePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteStateList}
                showAutoCompleteList={this.props.showAutoCompleteStateList}
                isModifyView={isModify}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>Country</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCountryChange}
                ref={this.countryRef}
                readOnly={disableUpdatableFields}
                disabled={isDisabledFields}
                name="country"
                placeholder="Country"
                value={soAddressData.country}
                lookupRequired={true}
                lookupHandler={this.state.countryLookupHandler}
                enterKeyEventHandler={this.countryEnterKeyEvent}
                autoCompleteListData={
                  this.props.countryPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCountryList}
                showAutoCompleteList={this.props.showAutoCompleteCountryList}
                isModifyView={isModify}
              ></InputTextbox>
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Zip</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="zip"
                placeholder="Zip"
                onChange={this.onAddressChange}
                readOnly={disableUpdatableFields}
                value={soAddressData.zip}
                isModifyView={isModify}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Phone1#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone1"
                placeholder="Phone1"
                onChange={this.onAddressChange}
                readOnly={disableUpdatableFields}
                value={soAddressData.phone1}
                isModifyView={isModify}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Phone2#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone2"
                placeholder="Phone2"
                onChange={this.onAddressChange}
                readOnly={disableUpdatableFields}
                value={soAddressData.phone2}
                isModifyView={isModify}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Mobile#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="mobilePhone"
                placeholder="Mobile"
                onChange={this.onAddressChange}
                readOnly={disableUpdatableFields}
                value={soAddressData.mobilePhone}
                isModifyView={isModify}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>EMail</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="email"
                placeholder="EMail"
                onChange={this.onAddressChange}
                readOnly={disableUpdatableFields}
                value={soAddressData.email}
                isModifyView={isModify}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Website</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="website"
                placeholder="Website"
                onChange={this.onAddressChange}
                readOnly={disableUpdatableFields}
                value={soAddressData.website}
                isModifyView={isModify}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

class CommissionEntryForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.salesPersonRef = React.createRef();
    this.state = {};
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;

    this.initLookupHandlers();
  }
  componentDidUpdate() {
    //
  }
  initLookupHandlers = () => {
    let salesPersonLookupHandler = new GenericAttributeLookupHandler(
      this.props.salesPersonList,
      "Sales Person",
    );
    this.setState({ salesPersonLookupHandler: salesPersonLookupHandler });
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  onCommissionChange = (e) => {
    this.props.onCommissionChange(e);
  };
  onAddorUpdateCommissionClick = (e) => {
    if (e.detail <= 1) this.props.onAddorUpdateCommissionClick(e);
    if (this.salesPersonRef.current != null) {
      this.salesPersonRef.current.clear();
      this.salesPersonRef.current.focus();
    }
  };

  onClearCommissionClick = (e) => {
    if (e.detail <= 1) this.props.onClearCommissionClick(e);
  };
  reArrangeSalesCommissionLineNumbers_bkup = (LineList) => {
    let maxLineNumber = 0;
    LineList.forEach((line) => {
      if (!line.isDeleted) {
        ++maxLineNumber;
        line.lineNumber = maxLineNumber;
      }
    });
  };
  reArrangeSalesCommissionLineNumbers = (lineList) => {
    let maxDisplayLineNumber = 0;

    lineList.forEach((line) => {
      if (!line.isDeleted) {
        ++maxDisplayLineNumber;
        line.displayLineNumber = maxDisplayLineNumber; // always safe, UI-only, recalculated fresh

        if (!line.isFetched) {
          line.lineNumber = maxDisplayLineNumber; // only unsaved rows can have lineNumber shifted
        }
        // isFetched === true → lineNumber left completely untouched (permanent db key)
      }
      // deleted rows: left as-is (both lineNumber and stale displayLineNumber untouched)
    });
  };
  buttonClickCallback = (e, val, rowData) => {
    let salesOrderData = this.props.salesOrderData;
    let tempSalesCommission = this.props.tempSalesCommission;
    let lineData = salesOrderData.commissions;

    for (let j = 0; j < lineData.length; j++) {
      if (lineData[j].salesPersonCode === rowData.salesPersonCode) {
        if (lineData[j].isFetched == true) {
          // soft delete — stays in array (must go to backend), just hidden from view
          lineData[j].deleted = true; // Change the value at index 2
          lineData[j].isDeleted = true;
        } else {
          lineData.splice(j, 1); // Change the value at index 2
          //this.state.documents.splice(j, 1);
        }
      }
    }
    tempSalesCommission = this.props.getSalesCommissionString(lineData);
    this.props.updateForSalesCommision(tempSalesCommission);
    this.reArrangeSalesCommissionLineNumbers(lineData);

    this.setState(
      {
        salesOrderData: salesOrderData,
        salesCommisionDeatils: tempSalesCommission,
      },
      () => { },
    );
  };

  handleLineNumberClick = (val, rowData) => {
    this.props.getSalesCommissionLineDetails(val, rowData);
  };

  // salesCommissionColumnDefinitions = () => {
  //   let columnList = [];
  //   let disableSalesOrderFormFields = this.props.disableSalesOrderFormFields;

  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "Ln#",
  //       "lineNumber",
  //       0,
  //       true,
  //       this.handleLineNumberClick,
  //       false,
  //       null,
  //       "3px", //min-width
  //       "3%" //max-width
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "SalesPerson",
  //       "salesPersonCode",
  //       0,
  //       false,
  //       null,
  //       false,
  //       null,
  //       "8em", //min-width
  //       "15%" //max-width
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "SalesPersonName",
  //       "salesPersonName",
  //       0,
  //       false,
  //       null,
  //       false,
  //       null,
  //       "15em", //min-width
  //       "25%" //max-width
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "Commission%",
  //       "commissionPercentage",
  //       0,
  //       false,
  //       null,
  //       false,
  //       null,
  //       "5em", //min-width
  //       "9%" //max-width
  //     )
  //   );

  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails(
  //         "",
  //         <DeleteIcon />,
  //         // true,
  //         0,
  //         false,
  //         null,
  //         false,
  //         null, //image link call back
  //         "1em", //min-width
  //         "3%" //max-width
  //       )
  //       .setEditableDetails(
  //         false,
  //         "",
  //         null,
  //         true,
  //         this.buttonClickCallback,
  //         false,
  //         null
  //       )
  //       .setDisabled(disableSalesOrderFormFields)
  //   );
  //   return columnList;
  // };

  onSalesPersonCodeChange = (e) => {
    this.props.onSalesPersonCodeChange(e);
  };
  salesPersonEnterKeyEvent = (e) => {
    this.props.salesPersonEnterKeyEvent(e);
  };
  displayAutoCompleteSalesPersonList = (showAutoCompleteSalesPersonList) => {
    this.props.displayAutoCompleteSalesPersonList(
      showAutoCompleteSalesPersonList,
    );
  };
  handleLineNumberClick = (e, val, rowData) => {
    this.props.getSalesCommissionLineDetails(val, rowData);
  };

  salesCommissionColumn = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Ln#", "displayLineNumber", true)
        .setStyleDetails("left", "", "", "wt-2 ", "wt-2")
        .setClickDetails(true, false, this.handleLineNumberClick, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPerson", "salesPersonCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPersonName", "salesPersonName", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Commission%", "commissionPercentage", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)
        // .setHeaderDetails(true, <AddIcon />, this.addNewSalesOrderLine, false)
        .setStyleDetails("", "", "", "wt-2", "wt-2")

        .setClickDetails(false, true, this.buttonClickCallback, <DeleteIcon />),
    );

    return columns;
  };

  render() {
    let salesOrderData = new SalesOrderBean();
    salesOrderData = this.props.salesOrderData;
    let salesCommissionData = new SalesOrderCommissionBean();
    salesCommissionData = this.props.salesCommissionData;
    let commissions = [];
    if (!isEmpty(salesOrderData) && !isEmpty(salesOrderData.commissions)) {
      salesOrderData.commissions.map((line) => {
        if (!line.isDeleted) {
          commissions.push(line);
        }
      });
    }

    // commissions = salesOrderData.commissions;

    let disableSalesOrderFormFields = this.props.disableSalesOrderFormFields;
    let isLineLevelDelete = this.props.isLineLevelDelete;
    let salesPersonList = this.props.salesPersonList;
    let isModify = this.props.isModifyPosible();
    var dataTableStyles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "300px",
          maxHeight: "300px",
        },
      },
    };
    let isTexco = this.props.isTexco;
    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div>
        <div>
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />{" "}
          {/* <EditableDataGrid
            customStyles={dataTableStyles}
            columnsList={this.salesCommissionColumnDefinitions()}
            dataList={commissions}
          /> */}
          <div className="div_Custom_3">
            <CustomTable
              data={commissions}
              columns={this.salesCommissionColumn()}
              label={"Commission"}
            />
          </div>
        </div>
        <div className="header_div">
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Ln#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="lineNumber"
                type="text"
                onChange={this.onCommissionChange}
                readOnly={true}
                value={salesCommissionData.lineNumber}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>SalesPerson</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.salesPersonRef}
                onChange={this.onSalesPersonCodeChange}
                disabled={
                  isTexco ? isDisabledFields : disableSalesOrderFormFields
                }
                name="salesPersonCode"
                value={salesCommissionData.salesPersonCode}
                lookupRequired={true}
                lookupHandler={this.state.salesPersonLookupHandler}
                enterKeyEventHandler={this.salesPersonEnterKeyEvent}
                autoCompleteListData={
                  this.props.salesPersonPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteSalesPersonList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteSalesPersonList
                }
                isModifyView={isModify}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>SalesPersonName</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="salesPersonName"
                type="text"
                onChange={this.onCommissionChange}
                readOnly={true}
                value={salesCommissionData.salesPersonName}
                //disabled={isDisabledFields}
                disabled={
                  isTexco ? isDisabledFields : disableSalesOrderFormFields
                }
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Commission%</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                value={salesCommissionData.commissionPercentage}
                onChange={this.onCommissionChange}
                className="qty_input text-right"
                decimalScale={2}
                name={"commissionPercentage"}
                // disabled={disableSalesOrderFormFields}
                disabled={
                  isTexco ? isDisabledFields : disableSalesOrderFormFields
                }
                isModifyView={isModify}
                isMandatory={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <Button
                size="sm"
                id="fabric_Add_Button"
                className="enterFocus"
                onClick={(e) => this.onAddorUpdateCommissionClick(e)}
                disabled={isLineLevelDelete} //disabled={disableSalesOrderFormFields}

              //Old Code
              // disabled={
              //   isTexco ? isDisabledFields : disableSalesOrderFormFields
              // }
              >
                Add/Update
              </Button>
              <Button
                size="sm"
                id="fabric_Add_Button"
                className="enterFocus"
                onClick={(e) => this.onClearCommissionClick(e)}
                disabled={isLineLevelDelete} // disabled={disableSalesOrderFormFields}
              // disabled={
              //   isTexco ? isDisabledFields : disableSalesOrderFormFields
              // }
              >
                Clear
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

class WebOrderEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.sourceSalesOrderNumberRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  render() {
    let salesOrderData = new SalesOrderBean();
    salesOrderData = this.props.salesOrderData;
    let disableSalesOrderFormFields = this.props.isDisableFields;
    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel>Source S.O#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.sourceSalesOrderNumberRef}
                readOnly={disableSalesOrderFormFields}
                disabled={disableSalesOrderFormFields}
                name="sourceSalesOrderNumber"
                placeholder="sourceSalesOrderNumber"
                value={salesOrderData.sourceSalesOrderNumber}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>Target Website</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="targetWebsite"
                placeholder="targetWebsite"
                readOnly={disableSalesOrderFormFields}
                value={salesOrderData.targetWebsite}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Website Type</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="websiteType"
                placeholder="websiteType"
                readOnly={disableSalesOrderFormFields}
                value={salesOrderData.websiteType}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Original Order #</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="originalOrderNumber"
                placeholder="originalOrderNumber"
                onChange={this.onChange}
                readOnly={disableSalesOrderFormFields}
                value={salesOrderData.originalOrderNumber}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Order Type</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="originalOrderType"
                placeholder="originalOrderType"
                readOnly={disableSalesOrderFormFields}
                value={salesOrderData.originalOrderType}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
// export function DocumentsForm(props) {
//   const [file, setFile] = useState(null);
//   const [previewUrl, setPreviewUrl] = useState(props.imgUrl);
//   const [doc, setDoc] = useState(null);
//   const [docName, setDocName] = useState(props.docName);
//   const [docUrl, setDocUrl] = useState(props.docUrl);
//   const isShowDocLabel = props.isShowDocLabel;
//   const handleChange = (e) => {
//     let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
//     if (e.target.files[0].size <= max_size) {
//       setFile(e.target.files[0]);
//       setPreviewUrl(URL.createObjectURL(e.target.files[0]));
//     } else {
//       props.showToast("image size is greater", 2);
//     }
//   };
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (file != null) {
//       props.setImgUrl(URL.createObjectURL(file));
//       props.setImgData(file);
//       props.uploadImage(file);
//       props.showToast("Uploaded Sucessfully", 1);
//     }
//   };
//   const deleteImage = (e) => {
//     if (e.detail == 1) {
//       setFile(null);
//       setPreviewUrl("");
//       props.deleteImage();
//       props.showToast("Image deleted sucessfully", 1);
//     }
//   };
//   const docHandler = (e) => {
//     e.preventDefault();
//     setDoc(e.target.files[0]);
//     setDocName(e.target.files[0].name);
//     setDocUrl(URL.createObjectURL(e.target.files[0]));
//   };
//   const uploadDoc = (e) => {
//     if (e.detail == 1) {
//       props.uploadDoc(doc);
//       props.showToast("Uploaded Sucessfully", 1);
//     }
//   };
//   const deleteDoc = (e) => {
//     if (e.detail == 1) {
//       setDoc(null);
//       setDocName("");
//       props.deleteDoc();
//       props.showToast("Document deleted sucessfully", 1);
//     }
//   };

//   const docViewHandler = (e) => {
//     if (e.detail == 1) window.open(docUrl);
//   };
//   return (
//     <div className="header_div  div_default">
//       <div className="div_inline">
//         <div className="div_Equal_no_overflow">
//           <form onSubmit={handleSubmit}>
//             {/* {previewUrl && ( */}
//             <div className="d-flex justify-content-around ">
//               <img
//                 src={previewUrl}
//                 onError={(e) => {
//                   e.target.onerror = null;
//                   e.target.src = noImage;
//                 }}
//                 width={275}
//                 height={275}
//                 mode="fit"
//               />
//             </div>
//             {/* )} */}
//             <div className="d-flex justify-content-around ">
//               <div>
//                 <label for="imgTag" className="d-flex justify-content-around">
//                   <div className="img_label">
//                     Attach Image
//                     <span className="img_icon">
//                       <CameraIcon />
//                     </span>
//                   </div>

//                   <input
//                     type="file"
//                     className="img-input"
//                     id="imgTag"
//                     accept="image/*"
//                     onChange={handleChange}
//                     disabled={isShowDocLabel}
//                   />
//                 </label>
//               </div>
//               {!isEmptyString(previewUrl) && (
//                 <div className="d-flex justify-content-around align-middle">
//                   <div className="align-middle">
//                     <button
//                       id="fabric_Add_Button"
//                       type="submit"
//                       disabled={isShowDocLabel}
//                     >
//                       Upload
//                     </button>
//                   </div>
//                   <div className="align-middle">
//                     <Button
//                       id="fabric_Add_Button"
//                       onClick={(e) => deleteImage(e)}
//                       disabled={isShowDocLabel}
//                     >
//                       <DeleteIcon />
//                     </Button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </form>
//         </div>
//         <div className="div_Equal_no_overflow">
//           <div className="d-flex justify-content-around">
//             <div>
//               <label for="inputTag" className="d-flex justify-content-around">
//                 <div className="img_label">
//                   Attach Documents
//                   <span className="img_icon">
//                     <UploadDocIcon />
//                   </span>
//                 </div>
//                 <input
//                   type="file"
//                   className="img-input"
//                   id="inputTag"
//                   onChange={docHandler}
//                   accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
//                   disabled={isShowDocLabel}
//                 />
//               </label>
//             </div>
//             <div className="align-middle">
//               {/* {doc && ( */}
//               <FormLabel
//                 className="hyperlinklabel align-middle"
//                 onClick={(e) => docViewHandler(e)}
//               >
//                 {/* {salesOrderData.documentFilePath} */}
//                 {docName}
//               </FormLabel>
//               {/* )} */}
//             </div>
//             <div className="d-flex justify-content-around align-middle">
//               <div>
//                 <Button
//                   id="fabric_Add_Button"
//                   className="align-middle"
//                   onClick={(e) => uploadDoc(e)}
//                   disabled={isShowDocLabel}
//                 >
//                   Upload
//                 </Button>
//               </div>
//               <div>
//                 <Button
//                   id="fabric_Add_Button"
//                   className="align-middle"
//                   onClick={(e) => deleteDoc(e)}
//                   disabled={isShowDocLabel}
//                 >
//                   <DeleteIcon />
//                 </Button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
export function Images(props) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(props.imgUrl);
  const [images, setImages] = useState([...props.images]);
  const [img_Url, setImageUrl] = useState([...props.preview_Url]);
  const [tempIndex, setIndex] = useState(null);
  const [tempImage, setTempImages] = useState([]);
  const [tempImg_Url, setTempImageUrl] = useState([]);
  const [isImagePreview, setIsImagePreview] = useState(false);
  const [isImageMainPreview, setIsImageMainPreview] = useState(false);
  const isShowDocLabel = props.isShowDocLabel;
  const [imageEntity, setImagesEntity] = useState(new SalesOrderImageBean());
  const [imgDetails, setTempFile] = useState(null);
  const [hover, setHover] = useState(false);
  const [hoverData, setHoverData] = useState(new SalesOrderImageBean());
  const [aftUpload, setAftUpload] = useState(false);
  useEffect(() => {
    setImagesEntity(imageEntity);
  }, [imageEntity]);
  const handleChange = (e) => {
    let tempImages = e.target.files;
    if (!isEmptyArray(tempImages)) {
      setIsImageMainPreview(true);
    }
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    let img_list = [];
    let previewList = [];
    if (!isEmptyArray(images)) {
      img_list = [...images];
    }
    if (!isEmptyArray(img_Url)) {
      previewList = [...img_Url];
    }
    for (let index = 0; index < tempImages.length; index++) {
      // const element = tempImages[i];
      let imgUrl = "";
      if (tempImages[index].size <= max_size) {
        img_list.push(tempImages[index]);
        imgUrl = URL.createObjectURL(tempImages[index]);

        previewList.push(imgUrl);
      } else {
        props.showToast("image size is greater", 2);
      }
    }
    setImages(img_list);
    setImageUrl(previewList);
  };
  useEffect(() => {
    setImageUrl(img_Url);
  }, [img_Url]);

  useEffect(() => {
    setImages(images);
  }, [images]);
  useEffect(() => {
    setIsImageMainPreview(isImageMainPreview);
  }, [isImageMainPreview]);
  useEffect(() => {
    setTempImages(tempImage);
  }, [tempImage]);
  useEffect(() => {
    setTempImageUrl(tempImg_Url);
  }, [tempImg_Url]);
  const handleImageEditChange = (e) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;

    let images_temp = [];
    let url_temp = [];
    let imgUrl = "";
    if (e.target.files[0].size <= max_size) {
      images_temp = [...images];
      url_temp = [...img_Url];
      setIsImagePreview(true);
      setIsImageMainPreview(false);
      for (let i = 0; i < images_temp.length; i++) {
        if (i === tempIndex) {
          let file = e.target.files[0];
          setFile(file);
        }
      }
      for (let i = 0; i < url_temp.length; i++) {
        if (i === tempIndex) {
          imgUrl = URL.createObjectURL(e.target.files[0]);
          url_temp[i] = imgUrl; // Change the value at index 2
        }
      }
    } else {
      props.showToast("image size is greater", 2);
    }
    setPreviewUrl(imgUrl);
    setTempImages(images_temp);
    setTempImageUrl(url_temp);
  };
  useEffect(() => {
    setIsImagePreview(isImagePreview);
  }, [isImagePreview]);

  const handleSubmit = (e) => {
    e.preventDefault();
    props.setMultiImageUrl(img_Url);
    props.setMultiImgData(images);
    props.uploadMutiImage(images);
    props.showToast("Uploaded Sucessfully", 1);
    setIsImageMainPreview(false);
  };
  const handleEditSubmit = (e) => {
    e.preventDefault();
    let tempFile = file;
    for (let i = 0; i < tempImage.length; i++) {
      if (i === tempIndex) {
        tempFile.imageCode = tempImage[i].imageCode;
        tempImage[i] = tempFile;
      }
    }
    props.setMultiImageUrl(tempImg_Url);
    props.setMultiImgData(tempImage);
    props.uploadMutiImage(tempImage);
    setImageUrl(tempImg_Url);
    props.showToast("Uploaded Sucessfully", 1);
    setIndex(null);
    setIsImagePreview(false);
  };
  const deleteImage = (e) => {
    if (e.detail == 1) {
      setFile(null);
      setPreviewUrl("");
      props.showToast("Image deleted sucessfully", 1);
      setIsImageMainPreview(false);
      setImages(props.images);
      setImageUrl(props.preview_Url);
    }
  };
  // const imageview = (e, index) => {
  //   if (!isImageMainPreview) {
  //     const files = e.target.currentSrc;
  //     const urls = files;
  //     setPreviewUrl(urls);
  //     setIndex(index)
  //     setIsImagePreview(false)
  //   }

  // };

  const imageview = (e, index, image) => {
    if (!isImageMainPreview) {
      const files = e.target.currentSrc;
      let imgDetails = null;
      const urls = files;
      setPreviewUrl(urls);
      setIndex(index);
      setIsImagePreview(false);
      // for (let i = 0; i < images.length; i++) {
      //   if (i === index) {
      //     imgDetails = images[i];
      //   }
      // }

      for (let i = 0; i < props.salesOrderData.orderImages.length; i++) {
        if (i === index) {
          imgDetails = props.salesOrderData.orderImages[i];
        }
      }

      setTempFile(imgDetails);

      const updatedImageEntity = {
        ...imgDetails, // Spread the class instance to convert to plain object
        tags: imgDetails.tags !== "" ? imgDetails.tags : "",
        notesCommunication: imgDetails.notesCommunication || "",
      };

      // const tempEntity = {
      //   ...updatedImageEntity, // Spread the existing properties
      //   [e.target.name]: e.target.value, // Update the property based on input name
      // }
      setImagesEntity(updatedImageEntity);
      //
    }
  };

  const hoverview = (e, index) => {
    setAftUpload(true);

    if (!aftUpload) return; // Prevent hover logic if 'aftUpload' is false
    if (props.salesOrderData.isFetched) {
      const hoverDetails = props.salesOrderData.orderImages[index]; // Get the hovered image by index
      if (hoverDetails) {
        setHoverData(hoverDetails); // Set hover data for the hovered image
      } else {
        setHoverData(new SalesOrderImageBean()); // Fallback to default or empty data
      }
    }
    setHover(true); // Set hover state to true when mouse is over the image
  };
  const deleteUploadedImage = (e) => {
    if (e.detail === 1) {
      let url_temp = [];
      url_temp = [...img_Url];
      for (let i = 0; i < url_temp.length; i++) {
        if (i === tempIndex) {
          url_temp.splice(i, 1); // Change the value at index 2
        }
      }
      setImageUrl(url_temp);
      props.deleteMutipleImage(tempIndex);
      setPreviewUrl("");
      setTempImageUrl(url_temp);
      setIndex(null);
      setIsImagePreview(false);
    }
  };

  const onImageChange = (e) => {
    const updatedImageEntity = {
      ...imageEntity, // Spread the existing properties
      [e.target.name]: e.target.value, // Update the property based on input name
    };
    setImagesEntity(updatedImageEntity);
  };
  const addImageLines = (e) => {
    if (e.detail === 1) {
      props.addImageLines(imageEntity);
      props.showToast("Details Uploaded Sucessfully", 1);
    }
  };
  const clearImageLines = (e) => {
    if (e.detail === 1) {
      //props.clearImageLines(imageEntity)

      const updatedImageEntity = {
        ...imageEntity, // Spread the existing properties
        tags: "", // Reset tags
        notesCommunication: "", // Reset notesCommunication
      };
      setImagesEntity(updatedImageEntity);
      props.clearImageLines(updatedImageEntity);
    }
  };
  return (
    <div className="header_div  div_default">
      <div className="div_inline">
        <div className="div_30_no_overflow">
          <form onSubmit={handleSubmit}>
            <div className="d-flex justify-content-around ">
              <div>
                <label for="imgTag" className="d-flex justify-content-around">
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>

                  <input
                    type="file"
                    className="img-input"
                    id="imgTag"
                    multiple
                    accept="image/*"
                    onChange={handleChange}
                    disabled={isShowDocLabel}
                  />
                </label>
              </div>
              {isImageMainPreview && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle-icon">
                    <button
                      id="fabric_Add_Button"
                      type="submit"
                    //  disabled={isShowDocLabel}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteImage(e)}
                    //   disabled={isShowDocLabel}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.8rem" }}>
              {!isEmptyArray(img_Url) &&
                img_Url.map((image, index) => (
                  <div key={index} className="column">
                    <div className="effect">
                      <div className="effect-img">
                        <img
                          src={image}
                          alt={`upload-${index}`}
                          style={{
                            width: "100px",
                            height: "100px",
                            border: "1px solid black",
                            marginBottom: "5px", // Space between image and text
                            marginRight: "2px",
                            marginLeft: "2px",
                          }}
                          onClick={(e) => imageview(e, index)}
                          onMouseOver={(e) => hoverview(e, index)}
                          onMouseOut={() => setHover(false)} // Reset hover state on mouse out
                        />
                      </div>
                      {hover == true && (
                        <div className="effect-text">
                          <div class="inner">
                            <p
                            // style={{ fontSize: "12px", margin: 0 }}
                            >
                              {hoverData.imageName}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Index Text Below Image */}
                  </div>
                ))}
            </div>
          </form>
          {/* </div> */}
        </div>
        <div className="div_60_no_overflow">
          {/* <div className="image-preview"> */}

          <form onSubmit={handleEditSubmit}>
            {
              !isEmpty(previewUrl) && (
                <div
                  style={{
                    position: "relative",

                    display: "flex",
                  }}
                >
                  <div className="image_grid">
                    {previewUrl != null && (
                      <div
                      // style={{ display: "flex", backgroundColor: "green" }}
                      >
                        <div
                          style={{
                            padding: "10px",
                            width: "100%",
                          }}
                        >
                          <img
                            src={previewUrl}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "200%",
                              float: "left",
                            }}
                          />

                          <label className="d-flex justify-content-around">
                            <div className="d-flex justify-content-around">
                              <span className="img_icon">
                                <CameraIcon />
                              </span>

                              <input
                                type="file"
                                className="img-input"
                                id="imgTag"
                                accept="image/*"
                                onChange={handleImageEditChange}
                                disabled={isShowDocLabel}
                              />

                              <div className="d-flex justify-content-around align-middle">
                                <div className="align-middle">
                                  {isImagePreview && (
                                    <button
                                      id="fabric_Add_Button"
                                      type="submit"
                                      disabled={isShowDocLabel}
                                    >
                                      Upload
                                    </button>
                                  )}
                                </div>
                                <div className="align-middle">
                                  <Button
                                    id="fabric_Add_Button"
                                    onClick={(e) => deleteUploadedImage(e)}
                                    disabled={isShowDocLabel}
                                  >
                                    <DeleteIcon />
                                  </Button>
                                </div>
                              </div>

                              {/* <button
                              type="button"
                              id="fabric_Add_Button"

                            >
                              Remove
                            </button> */}
                            </div>
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      padding: "20px",
                    }}
                  >
                    <Row>
                      <Col sm="2">
                        <FormLabel>Name</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          //  value={imageEntity.imageName}
                          value={imageEntity.imageName || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Created By</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          //value={imageEntity.createdBy}
                          value={imageEntity.createdBy || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>created Date</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          // value={imageEntity.createdDate}
                          value={imageEntity.createdDate || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Tags</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          // value={imageEntity.tags}
                          value={imageEntity.tags || ""}
                          name="tags"
                          // type="text"
                          onChange={onImageChange}
                          disabled={isShowDocLabel}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Notes</FormLabel>
                      </Col>
                      <Col sm="9">
                        <textarea
                          style={{
                            maxHeight: "10px",
                            width: "100%",
                            minHeight: "5em",
                            resize: "none",
                            padding: "9px",
                            boxSizing: "border-box",
                            fontSize: "15px",
                          }}
                          // className="form-control"
                          name="notesCommunication"
                          //  type="text"
                          // placeholder="Notes"
                          onChange={onImageChange}
                          value={imageEntity.notesCommunication || ""}
                          // value={imageEntity.notesCommunication}
                          disabled={isShowDocLabel}
                        />
                        {/* <InputTextbox
                                  value={imgDetails.notesCommunication}
                                // disabled={true}
                                /> */}
                      </Col>
                    </Row>

                    <Row>
                      <Col className="text-center">
                        <Button
                          size="sm"
                          id="fabric_Add_Button"
                          className="header_buttons enterFocus"
                          onClick={(e) => addImageLines(e)}
                          disabled={isShowDocLabel}
                        >
                          Add/Update
                        </Button>
                        <Button
                          id="fabric_Add_Button"
                          size="sm1"
                          onClick={(e) => clearImageLines(e)}
                          disabled={isShowDocLabel}
                        >
                          Clear
                        </Button>
                      </Col>
                    </Row>

                    {/* <p>{`Tags        : ${imgDetails.tags}`}</p>
                              <p>{`Notes       : ${imgDetails.notesCommunication}`}</p> */}
                    {/* </Col> */}
                  </div>
                </div>
              )
              // ))
            }
          </form>
          {/* // </div> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

export function MutilpleDocuments(props) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewDocs] = useState(props.preview_Docs);
  const [documents, setDocuments] = useState([...props.documents]);
  const [tempIndex, setIndex] = useState(null);
  const documentData = props.salesOrderData.salesOrderDocument || [];
  const [isDocumentUpload, setIsDocumentUpload] = useState(false);
  const isShowDocLabel = props.isShowDocLabel;
  // const disabledImages =  props.isServiceLineDisablesFields;
  // useEffect(() => {
  //   setColumns(props.columns);
  // }, [props.columns]);

  const docHandler = (e) => {
    e.preventDefault();
    let tempDocs = e.target.files;
    let doc_list = [];
    let previewList = [];
    if (!isEmptyArray(documents)) {
      doc_list = [...documents];
    }
    if (!isEmptyArray(previewUrl)) {
      previewList = [...previewUrl];
    }
    for (let index = 0; index < tempDocs.length; index++) {
      let docUrl = "";
      doc_list.push(tempDocs[index]);
      docUrl = URL.createObjectURL(tempDocs[index]);
      previewList.push(docUrl);
    }
    setDocuments(doc_list);
    setPreviewDocs(previewList);
    setIsDocumentUpload(true);
  };

  useEffect(() => {
    setDocuments(documents);
  }, [documents]);

  const handleDocumentSubmit = (e) => {
    e.preventDefault();
    props.uploadMutiDouments(documents);
    props.uploadMutiDoumentsUrl(previewUrl);
    props.showToast("Uploaded Sucessfully", 1);
    setIsDocumentUpload(false);
  };
  const deleteDocs = (e) => {
    if (e.detail == 1) {
      setFile(null);
      setPreviewDocs("");
      props.showToast("Image deleted sucessfully", 1);
      setDocuments(props.documents);
      setIsDocumentUpload(false);
    }
  };

  const documentColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Document", "documentOriginalName", true)
        .setStyleDetails("left", "2", "", "wt-5", "wt-5")
        .setClickDetails(true, false, editDocument, null)
        .setDocument(true)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Document Name", "documentName", true)
        .setStyleDetails("left", "", "", "wt-10", "wt-10"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
        .setClickDetails(false, true, deleteDocuments, <DeleteIcon />)
    );

    return columns;
  };
  const deleteDocuments = (e, value, rowData, index) => {


    let documentDataList = documents;
    let fileUrl = previewUrl;
    documentDataList.map((list, index) => {
      if (list.documentName === rowData.documentName) {
        // list.deleted = true;
        // list.isDeleted = true;

        fileUrl.splice(index, 1);
      }
    });
    setPreviewDocs(fileUrl);
    props.uploadMutiDoumentsUrl(fileUrl);
    props.deleteMultiDocument(rowData);
    // setDocuments(documentDataList);
    // setPreviewDocs(fileUrl);
    // props.uploadMutiDouments(documentDataList);
    // props.uploadMutiDoumentsUrl(fileUrl);
  };
  const editDocument = (e, name, tempIndex, rowIndex) => {


    let docUrl = previewUrl;
    let tempUrl = "";
    if (!isEmptyArray(docUrl)) {
      for (let index = 0; index < docUrl.length; index++) {
        if (index === rowIndex) {
          tempUrl = docUrl[index];
        }
      }
      window.open(tempUrl);
    }
  };
  return (
    <div className="header_div  div_default">
      <div className="div_inline">
        {/* <div className="div_80_no_overflow"> */}
        <div className="div_60_no_overflow">
          <div className="div_Equal_no_overflow">
            <form onSubmit={handleDocumentSubmit}>
              <div className="d-flex justify-content-around ">
                <div>
                  <label for="imgTag" className="d-flex justify-content-around">
                    <div className="img_label">
                      Attach Documents
                      <span className="img_icon">
                        <UploadDocIcon />
                      </span>
                    </div>

                    <input
                      type="file"
                      className="img-input"
                      id="imgTag"
                      multiple
                      accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
                      onChange={docHandler}
                      disabled={isShowDocLabel}
                    />
                  </label>
                </div>
                {isDocumentUpload && (
                  <div className="d-flex justify-content-around align-middle">
                    <div className="align-middle">
                      <button
                        id="fabric_Add_Button"
                        type="submit"
                        disabled={isShowDocLabel}
                      >
                        Upload
                      </button>
                    </div>
                    <div className="align-middle">
                      <Button
                        id="fabric_Add_Button"
                        onClick={(e) => deleteDocs(e)}
                        disabled={isShowDocLabel}
                      >
                        <DeleteIcon />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="mt-3">
        <CustomTable
          data={documentData}
          columns={documentColumns()}

        />
      </div>
    </div>
  );
}

class NotesForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  render() {
    let salesOrderData = new SalesOrderBean();
    salesOrderData = this.props.salesOrderData;
    const textAreaStyle = {
      maxHeight: "75px",
      minHeight: "10em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div className="header_div">
        <Row>
          <Col sm="1">
            <FormLabel>salesOrderNumber</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox value={salesOrderData.code} disabled={true} />
          </Col>
          <Col sm="1">
            <FormLabel>Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              value={salesOrderData.orderStartDate}
              disabled={true}
            />
          </Col>
        </Row>
        <div className=" so_notes_main_div">
          <div className="so_notes_div">
            <Row>
              {" "}
              <Col sm="2">
                {" "}
                <FormLabel className="label_head">PickNotes</FormLabel>{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                {" "}
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  name="pickNotes"
                  type="text"
                  placeholder="PickNotes"
                  onChange={this.onChange}
                  value={salesOrderData.pickNotes}
                  disabled={isDisabledFields}
                />
              </Col>
            </Row>
          </div>
          <div className="so_notes_div">
            <Row>
              {" "}
              <Col sm="2">
                {" "}
                <FormLabel className="label_head">InvoiceNotes</FormLabel>{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                {" "}
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  name="invoiceNotes"
                  type="text"
                  placeholder="InvoiceNotes"
                  onChange={this.onChange}
                  value={salesOrderData.invoiceNotes}
                  disabled={isDisabledFields}
                />
              </Col>
            </Row>
          </div>
          <div className="so_notes_div">
            <Row>
              {" "}
              <Col sm="2">
                {" "}
                <FormLabel className="label_head">InternalNotes</FormLabel>{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                {" "}
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  name="internalNotes"
                  type="text"
                  placeholder="InternalNotes"
                  onChange={this.onChange}
                  value={salesOrderData.internalNotes}
                  disabled={isDisabledFields}
                />
              </Col>
            </Row>
          </div>

          <div className="so_notes_div">
            <Row>
              {" "}
              <Col sm="2">
                {" "}
                <FormLabel className="label_head">CustomerNotes</FormLabel>{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                {" "}
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  name="customerNotes"
                  type="text"
                  placeholder="CustomerNotes"
                  onChange={this.onChange}
                  value={salesOrderData.customerNotes}
                  disabled={isDisabledFields}
                />
              </Col>
            </Row>
          </div>
        </div>
        <div className="so_notes_main_div">
          <div className="so_notes_div">
            <Row>
              {" "}
              <Col sm="2">
                {" "}
                <FormLabel className="label_head">
                  CustomerWarningNotes
                </FormLabel>{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                {" "}
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  name="warningNotes"
                  type="text"
                  placeholder="WarningNotes"
                  onChange={this.onChange}
                  value={salesOrderData.warningNotes}
                  disabled={isDisabledFields}
                />
              </Col>
            </Row>
          </div>
          <div className="so_notes_div">
            <Row>
              {" "}
              <Col sm="2">
                {" "}
                <FormLabel className="label_head">Comments</FormLabel>{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                {" "}
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  name="comments"
                  type="text"
                  placeholder="Comments"
                  onChange={this.onChange}
                  value={salesOrderData.comments}
                  disabled={isDisabledFields}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

class SalesLineDetailsForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {};
  }
  onChange = (e) => {
    this.props.onChange(e);
  };

  render() {
    let salesOrderData = new SalesOrderBean();
    salesOrderData = this.props.salesOrderData;
    let lines = new Array();

    if (!isEmptyArray(salesOrderData.lines)) {
      lines = salesOrderData.lines;
    }

    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div className="header_div">
        <Row>
          {" "}
          <Col sm="1">
            {" "}
            <FormLabel>Customer</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="customerCode"
              type="text"
              onChange={this.onChange}
              value={salesOrderData.customerCode}
              disabled={true}
            />
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              name="customerName"
              type="text"
              onChange={this.onChange}
              value={salesOrderData.customerName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>S.O</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="code"
              type="text"
              onChange={this.onChange}
              value={salesOrderData.code}
              disabled={true}
            />
          </Col>
        </Row>
        <div className="div_Custom_1">
          <Table id="fabrics_tables_default">
            <thead>
              <th>Line</th>
              <th>Item</th>
              <th>Name</th>
              <th>Color</th>
              <th>Price</th>
              <th>Uom</th>
              <th>StopDate</th>
              {!this.props.is3PL ? <th>Rolls</th> : null}
              <th>OrderQty</th>
              <th>PickedQty</th>

              <th>OpenQty</th>

              <th>Status</th>
              <th>Disc%</th>
              <th>DiscAmt</th>
            </thead>
            {!isEmptyArray(lines) && (
              <tbody>
                {lines.map((line, index) => (
                  <tr key={index}>
                    <td>{line.salesOrderLineNumber}</td>
                    <td>{line.fabricStyleCode}</td>
                    <td>{line.fabricStyleName}</td>
                    <td>{line.colorCode}</td>
                    <td className="text-end">{line.price}</td>
                    <td>{line.orderUomCode}</td>
                    <td>{line.orderStopDate}</td>
                    {!this.props.is3PL ? (
                      <td>{line.numberOfRollsPreferred}</td>
                    ) : null}
                    <td className="text-end">{line.orderQuantity}</td>
                    <td className="text-end">{line.pickedQuantity}</td>
                    <td className="text-end">{line.openQuantity}</td>
                    <td>
                      {ModuleUtils.getSalesOrderLineStatusCaption(
                        line.lineStatus,
                      )}
                    </td>
                    <td className="text-end">{line.discountPercentage}</td>
                    <td className="text-end">{line.lineDiscountAmount}</td>
                  </tr>
                ))}
              </tbody>
            )}
          </Table>
          {lines.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class PurchaseOrdersForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {};
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  poColumnDefinitions = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor", "vendorCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("VendorName", "vendorName", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderStartDate", "orderStartDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderStopDate", "orderStopDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO Line#", "purchaseOrderLineNumber", true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Item", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("OrderQty", "orderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OpenQty", "openQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AlloQty", "allocatedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );

    return columns;
  };
  // poColumnDefinitions = () => {
  //   let columnList = [];

  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("PO#", "purchaseOrderNumber"),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Vendor", "vendorCode"),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("VendorName", "vendorName"),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "PO#",
  //       "customerPurchaseOrderNumber",
  //     ),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "OrderStartDate",
  //       "orderStartDate",
  //     ),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "OrderStopDate",
  //       "orderStopDate",
  //     ),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "PO Line#",
  //       "purchaseOrderLineNumber",
  //     ),
  //   );

  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Item", "fabricStyleCode"),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Color", "colorCode"),
  //   );

  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("OrderQty", "orderQuantity"),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("OpenQty", "openQuantity"),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("AlloQty", "allocatedQuantity"),
  //   );
  //   return columnList;
  // };
  render() {
    let poList = [];
    poList = this.props.dependentPurchaseOrderList;
    return (
      <div className="header_div">
        {/* <DataGrid columnsList={this.poColumnDefinitions()} dataList={poList} /> */}

        <CustomTable data={poList} columns={this.poColumnDefinitions()} />
      </div>
    );
  }
}

class PickticketsandInvoicesForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      isShowPopupModule: false,
      moduleForPopup: [],
    };
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  /* PickTicket */
  handleHyperLinkClick = (e, val, rowData) => {
    if (val !== "" && val !== undefined) {
      this.setState({
        isShowPopupModule: true,
        moduleForPopup: (
          <PopupPickTicketModule
            pickTicketCode={val}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };

  /** Invoice */
  invoiceHandleHyperLinkClick = (e, val, rowData) => {
    if (val !== "" && val !== undefined) {
      this.setState({
        isShowPopupModule: true,
        moduleForPopup: (
          <PopupInvoiceModule
            invoiceCode={val}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };

  closeModalCallBack = (isOpen) => {
    this.setState({ isShowPopupModule: isOpen, moduleForPopup: [] });
  };

  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };

  getCaption = (status) => {
    return ModuleUtils.getPickTicketStatusCaption(status);
  };
  getInvoiceCaption = (status) => {
    return ModuleUtils.getInvoiceStatusCaption(status);
  };
  //#endregion

  ptColumnDefinitions = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("PT#", "code", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true, false, this.handleHyperLinkClick, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "createdDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "status", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setStatusDetails(true, this.getCaption),
    );
    return columns;
  };

  invColumnDefinitions = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "code", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true, false, this.invoiceHandleHyperLinkClick, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "createdDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "invoiceStatus", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setStatusDetails(true, this.getInvoiceCaption),
    );
    return columns;
  };

  render() {
    let salesOrderData = new SalesOrderBean();
    salesOrderData = this.props.salesOrderData;

    let dependenciesBean = new SalesOrderModuleDependenciesBean();
    dependenciesBean = this.props.dependenciesBean;
    let ptList = [];
    if (
      !isEmpty(dependenciesBean) &&
      !isEmptyArray(dependenciesBean.pickTickets)
    )
      ptList = dependenciesBean.pickTickets;

    let invList = [];
    if (!isEmpty(dependenciesBean) && !isEmptyArray(dependenciesBean.invoices))
      invList = dependenciesBean.invoices;

    return (
      <div className="header_div">
        <div className="so_pt_inv_main_div">
          <div className="so_pt_div">
            {/* <Row>
              <Col sm="1" className="title_text_div">
                {" "}
                <FormLabel>PickTickets</FormLabel>{" "}
              </Col>
            </Row>

            <Row>
              <Col sm="12"> */}
            {/* <BootstrapDataGrid
                  id="PickTicketTable"
                  columnsList={this.ptColumnDefinitions()}
                  dataList={ptList}
                /> */}
            <CustomTable
              columns={this.ptColumnDefinitions()}
              data={ptList}
              label={"Picktickets"}
            />
            {/* </Col>
            </Row> */}
          </div>
          <div className="so_inv_div">
            {/* <Row>
              <Col sm="1" className="title_text_div">
                {" "}
                <FormLabel>Invoice</FormLabel>{" "}
              </Col>
            </Row>

            <Row>
              <Col sm="12"> */}
            {/* <BootstrapDataGrid
                  id="InvoiceTable"
                  columnsList={this.invColumnDefinitions()}
                  dataList={invList}
                /> */}
            <CustomTable
              columns={this.invColumnDefinitions()}
              data={invList}
              label={"Invoices"}
            />
            {/* </Col>
            </Row> */}
          </div>
        </div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={true}
          isShowPopup={this.state.isShowPopupModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
      </div>
    );
  }
}
class ChangesHistoryForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {};
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  statusTrackColumnDefinitions = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "createdDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "totalOrderAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "currentStatus", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setStatusDetails(true, this.getSalesOrderCaption),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Pre Status", "previousStatus", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setStatusDetails(true, this.getSalesOrderCaption),
    );
    return columns;
  };
  getSalesOrderCaption = (status) => {
    return ModuleUtils.getSalesOrderStatusCaption(status);
  };

  changesHistoryColumnDefinitions = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "updatedDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Done By", "updatedBy", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Changes", "description", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    return columns;
  };

  // statusTrackColumnDefinitions = () => {
  //   let columnList = [];

  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Date", "createdDate")
  //       .setSortColumn(true)
  //   );
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Amount", "totalOrderAmount")
  //       .setSortColumn(true)
  //   );

  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Status", "currentStatus")
  //       .setColumnType("statusColumn")
  //       .setStatusCaptionConverter(ModuleUtils.getSalesOrderStatusCaption)
  //       .setSortColumn(true)
  //   );
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Pre Status", "previousStatus")
  //       .setColumnType("statusColumn")
  //       .setStatusCaptionConverter(ModuleUtils.getSalesOrderStatusCaption)
  //       .setSortColumn(true)
  //   );

  //   return columnList;
  // };
  // changesHistoryColumnDefinitions = () => {
  //   let columnList = [];
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Date", "updatedDate")
  //       .setSortColumn(true)
  //   );
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Done By", "updatedBy")
  //       .setSortColumn(true)
  //   );
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Changes", "description")
  //       .setSortColumn(true)
  //   );

  //   return columnList;
  // };

  render() {
    let salesOrderData = new SalesOrderBean();
    salesOrderData = this.props.salesOrderData;
    let statusTracks = [];
    if (!isEmpty(salesOrderData) && !isEmptyArray(salesOrderData.statusTracks))
      statusTracks = salesOrderData.statusTracks;
    let changeHistoryTracks = [];
    if (
      !isEmpty(salesOrderData) &&
      !isEmptyArray(salesOrderData.changeHistoryTracks)
    )
      changeHistoryTracks = salesOrderData.changeHistoryTracks;

    return (
      <div className="header_div">
        <div className="so_changes_history_main_div">
          <div className="so_status_history_div">
            <CustomTable
              columns={this.statusTrackColumnDefinitions()}
              data={statusTracks}
              label={"statusTracks"}
            />
          </div>
          <div className="so_changes_history_div">
            <CustomTable
              columns={this.changesHistoryColumnDefinitions()}
              data={changeHistoryTracks}
              label={"changeHistoryTracks"}
            />
          </div>
        </div>
      </div>
    );
  }
}

class GeneratePOPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      criteria: new PurchaseOrderSearchCriteria(),
      selectedLineList: [],
    };
    this.vendorCodeRef = React.createRef();
    this.locationCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;

    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let locationLookupHandler = new GenericAttributeLookupHandler(
      this.props.locations,
      "Location",
    );
    this.setState({ locationLookupHandler: locationLookupHandler });

    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor",
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
  };
  selectAllSoLine = (e) => {
    if (e.detail == 1) this.props.selectAllSoLine(e);
  };
  unSelectAllSoLine = (e) => {
    if (e.detail == 1) this.props.unSelectAllSoLine(e);
  };
  poLineCheck = (e, val, rowData) => {
    this.props.poLineCheck(e, val, rowData);
  };
  poOnChange = (e) => {
    this.props.poOnChange(e);
  };
  poCreateEntryKey = (e) => {
    this.props.poCreateEntryKey(e);
  };
  // columnDefinitions = () => {
  //   let columnList = [];
  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails(
  //         "",
  //         "isActive",
  //         0,
  //         false, //set hyperlink false
  //         null, //set hyperLink call back null
  //         false,
  //         null,
  //       )
  //       .setEditableDetails(
  //         false,
  //         "",
  //         null,
  //         false,
  //         null,
  //         true,
  //         this.poLineCheck,
  //       ),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Item#", "fabricStyleCode"),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Name", "fabricStyleName"),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "Color",
  //       "fabricStyleColorCode",
  //     ),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Width", "widthCode"),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("SKU", "skuNumber"),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Price", "price"),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("StopDate", "orderStopDate"),
  //   );
  //   if (!this.props.is3PL) {
  //     columnList.push(
  //       new DataGridColumnDefinition().setDetails(
  //         "Rolls",
  //         "numberOfRollsPreferred",
  //       ),
  //     );
  //   }
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "OrderQuantity",
  //       "orderQuantity",
  //     ),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("OpenQuantity", "openQuantity"),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Extension", "extension"),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Status", "lineStatus"),
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Vendor#", "vendorCode"),
  //   );

  //   return columnList;
  // };

  columnDefinitions = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", false)
        .setInputDetails(false, false, true, null, this.poLineCheck, null)
        .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Item#", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SKU#", "skuNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StopDate", "orderStopDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );

    if (!this.props.is3PL) {
      columns.push(
        new ColumnDefinition()
          .setDetails("Rolls", "numberOfRollsPreferred", true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2"),
      );
      // columnList.push(
      //   new DataGridColumnDefinition().setDetails(
      //     "Rolls",
      //     "numberOfRollsPreferred",
      //   ),
      // );
    }
    columns.push(
      new ColumnDefinition()
        .setDetails("orderQuantity", "orderQuantity", true, true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OpenQuantity", "openQuantity", true, true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Extension", "extension", true, true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "lineStatus", true, false)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor#", "vendorCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );

    return columns;
  };

  onVendorCodeChange = (e) => {
    this.props.onVendorCodeChange(e);
  };
  displayAutoCompleteVendorList = (showAutoCompleteVendorList) => {
    this.props.displayAutoCompleteVendorList(showAutoCompleteVendorList);
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    this.props.vendorCodeEnterKeyEventHandler(e);
  };
  onLocationChange = (e) => {
    this.props.onLocationChange(e);
  };
  locationEnterKeyEventHandler = (e) => {
    this.props.locationEnterKeyEventHandler(e);
  };
  displayAutoCompleteLocationList = (showAutoCompleteLocationList) => {
    this.props.displayAutoCompleteLocationList(showAutoCompleteLocationList);
  };
  render() {
    let salesOrderData = this.props.salesOrderData;
    let criteria = this.props.criteria;
    // criteria.purchaseOrderNumber = NEW_ENTRY;
    let lines = [];
    if (salesOrderData.lines != null && !isEmptyArray(salesOrderData.lines)) {
      lines = salesOrderData.lines;
    }
    let isDisabledFields = this.props.isDisabledFields;

    return (
      <div>
        <Row>
          <Col sm="1">
            <FormLabel>Customer</FormLabel>
          </Col>
          <Col>
            <InputTextbox
              value={salesOrderData.customerCode}
              disabled={true}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Name</FormLabel>
          </Col>
          <Col>
            <InputTextbox
              value={salesOrderData.customerName}
              disabled={true}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>SalesOrder#</FormLabel>
          </Col>
          <Col>
            <InputTextbox
              value={salesOrderData.code}
              disabled={true}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>CancelDate</FormLabel>
          </Col>
          <Col>
            <DatePickerComponent
              value={salesOrderData.orderStopDate}
              disabled={true}
              isMandatory={true}
            />
          </Col>
        </Row>

        <Row>
          <FormLabel>Purchase Details</FormLabel>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>PO#</FormLabel>
          </Col>
          <Col>
            <InputTextbox
              ref={this.props.purchaseOrderNumberCreateRef}
              name="purchaseOrderNumber"
              value={criteria.purchaseOrderNumber}
              onChange={this.poOnChange}
              disabled={isDisabledFields}
              className="qty_input summary_input"
              isMandatory={true}
              enterKeyEventHandler={this.poCreateEntryKey}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Vendor#</FormLabel>
          </Col>
          <Col>
            <InputTextbox
              name="vendorCode"
              value={criteria.vendorCode}
              lookupRequired={true}
              lookupHandler={this.state.vendorLookupHandler}
              onChange={this.onVendorCodeChange}
              ref={this.vendorCodeRef}
              enterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
              autoCompleteListData={
                this.props.vendorPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteVendorList}
              showAutoCompleteList={this.props.showAutoCompleteVendorList}
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>Location</FormLabel>
          </Col>
          <Col>
            <InputTextbox
              name="locationCode"
              value={criteria.locationCode}
              lookupRequired={true}
              lookupHandler={this.state.locationLookupHandler}
              onChange={this.onLocationChange}
              ref={this.locationCodeRef}
              enterKeyEventHandler={this.locationEnterKeyEventHandler}
              autoCompleteListData={
                this.props.locationPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteLocationList}
              showAutoCompleteList={this.props.showAutoCompleteLocationList}
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>StartDate</FormLabel>
          </Col>
          <Col>
            <DatePickerComponent
              name="orderStartDate"
              value={criteria.orderStartDate}
              onChange={this.poOnChange}
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>StopDate</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="orderStopDate"
              value={criteria.orderStopDate}
              onChange={this.poOnChange}
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <Button
              id="fabric_Add_Button"
              size="sm"
              onClick={(e) => this.selectAllSoLine(e)}
            >
              SelectAll
            </Button>
          </Col>
          <Col sm="1">
            <Button
              id="fabric_Add_Button"
              size="sm"
              onClick={(e) => this.unSelectAllSoLine(e)}
            >
              UnSelectAll
            </Button>
          </Col>
        </Row>
        {/* <EditableDataGrid
          columnsList={this.columnDefinitions()}
          dataList={lines}
        /> */}

        <div className="mt-3">
          <CustomTable
            data={lines}
            columns={this.columnDefinitions()}
          // isSortedData={true}
          // label={
          //   this.state.is3PL ? "Choose Inventory Lines" : "RollLines"
          // }
          // onSortComplete={(sortedData, sortConfig) => {
          //   this.setState({ pt_rollLines: sortedData });
          // }}
          />
        </div>
      </div>
    );
  }
}

class GenerateMailPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }

  mailOnChange = (e) => {
    this.props.mailOnChange(e);
  };
  render() {
    let mailInfoBean = this.props.mailInfoBean;
    let isDisabledFields = this.props.isDisabledFields;
    if (this.props.is3PL) isDisabledFields = false;
    return (
      <div>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>From</FormLabel>
          </Col>
          <Col sm="6">
            <InputTextbox value={mailInfoBean.from} disabled={true} />
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>To</FormLabel>
          </Col>
          <Col sm="10">
            <InputTextbox
              name="tos"
              value={mailInfoBean.tos}
              onChange={this.mailOnChange}
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
        </Row>

        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>CCs</FormLabel>
          </Col>
          <Col sm="10">
            <InputTextbox
              name="ccs"
              value={mailInfoBean.ccs}
              onChange={this.mailOnChange}
              disabled={isDisabledFields}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>BCCs</FormLabel>
          </Col>
          <Col sm="6">
            <InputTextbox
              name="bccs"
              value={mailInfoBean.bccs}
              onChange={this.mailOnChange}
              disabled={isDisabledFields}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>Title</FormLabel>
          </Col>
          <Col sm="6">
            <InputTextbox
              name="title"
              value={mailInfoBean.title}
              onChange={this.mailOnChange}
              disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>Attachments</FormLabel>
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>

          <Col sm="6">
            <textarea
              rows={15}
              cols={72}
              name="message"
              value={mailInfoBean.message}
              onChange={this.mailOnChange}
              disabled={isDisabledFields}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

function SalesOrderMaintenanceModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <SalesOrderList {...props} name="" /> <br />
      </div>
    </div>
  );
}
export default SalesOrderMaintenanceModule;
